{
    "(2013 AY52)": [
        [
            97573941.64083041,
            12149100.354804847,
            -30945196.58857141
        ],
        [
            97041766.91099441,
            15345445.37282887,
            -31252194.56101621
        ],
        [
            96443582.35791974,
            18533456.065395158,
            -31538240.956505027
        ],
        [
            95779314.23400933,
            21713005.579637393,
            -31803295.226787455
        ],
        [
            95048828.27093323,
            24883954.832097318,
            -32047296.945034124
        ],
        [
            94251929.9360705,
            28046150.16701231,
            -32270165.54102585
        ],
        [
            93388364.65269317,
            31199420.97864967,
            -32471800.020259134
        ],
        [
            92457817.9871698,
            34343577.287452705,
            -32652078.66645546
        ],
        [
            91459915.80699539,
            37478407.25969068,
            -32810858.727109253
        ],
        [
            90394224.41402023,
            40603674.660202496,
            -32947976.081863947
        ],
        [
            89260250.65785548,
            43719116.22769408,
            -33063244.89366738
        ],
        [
            88057442.03508848,
            46824438.96189438,
            -33156457.242831048
        ],
        [
            86785186.78064989,
            49919317.31169655,
            -33227382.744303837
        ],
        [
            85442813.9584489,
            53003390.253212355,
            -33275768.148673404
        ],
        [
            84029593.55923837,
            56076258.246452495,
            -33301336.927629564
        ],
        [
            82544736.61459704,
            59137480.059117064,
            -33303788.844867658
        ],
        [
            80987395.33693205,
            62186569.44574326,
            -33282799.513678934
        ],
        [
            79356663.2965197,
            65222991.67021713,
            -33238019.942773234
        ],
        [
            77651575.64782721,
            68246159.85941944,
            -33169076.072211042
        ],
        [
            75871109.41870283,
            71255431.1755485,
            -33075568.301690694
        ],
        [
            74014183.87749922,
            74250102.79445478,
            -32957071.01384819
        ],
        [
            72079660.9948159,
            77229407.6771436,
            -32813132.095685333
        ],
        [
            70066346.01832263,
            80192510.12146237,
            -32643272.461753055
        ],
        [
            67972988.18107477,
            83138501.08090499,
            -32446985.583286636
        ],
        [
            65798281.5658589,
            86066393.2374491,
            -32223737.028123844
        ],
        [
            63540866.15043569,
            88975115.81541412,
            -31972964.01694319
        ],
        [
            61199329.06108327,
            91863509.12350717,
            -31694075.002144318
        ],
        [
            58772206.06460746,
            94730318.81253472,
            -31386449.276563812
        ],
        [
            56257983.33198564,
            97574189.83672754,
            -31049436.62018547
        ],
        [
            53655099.51006544,
            100393660.10728738,
            -30682356.994073145
        ],
        [
            50961948.141254835,
            103187153.82764697,
            -30284500.291934624
        ],
        [
            48176880.47493416,
            105952974.501088,
            -29855126.161027074
        ],
        [
            45298208.71839674,
            108689297.60282215,
            -29393463.905546386
        ],
        [
            42324209.779489994,
            111394162.91046536,
            -28898712.487214297
        ],
        [
            39253129.557789266,
            114065466.4890815,
            -28370040.639497664
        ],
        [
            36083187.84608412,
            116700952.3296998,
            -27806587.113771692
        ],
        [
            32812583.90918754,
            119298203.64350095,
            -27207461.077782586
        ],
        [
            29439502.812575355,
            121854633.81778844,
            -26571742.688980423
        ],
        [
            25962122.57909898,
            124367477.04451466,
            -25898483.867686585
        ],
        [
            22378622.257957082,
            126833778.63760346,
            -25186709.29763479
        ],
        [
            18687190.99620619,
            129250385.06171162,
            -24435417.6841803
        ],
        [
            14886038.209273502,
            131613933.70251733,
            -23643583.303406432
        ],
        [
            10973404.953119665,
            133920842.4172309,
            -22810157.87846175
        ],
        [
            6947576.606775627,
            136167298.9139294,
            -21934072.822722547
        ],
        [
            2806896.9798095413,
            138349250.01965183,
            -21014241.89277216
        ],
        [
            -1450216.0352985002,
            140462390.9101029,
            -20049564.297692094
        ],
        [
            -5825253.14109192,
            142502154.38843846,
            -19038928.314729497
        ],
        [
            -10319594.514656553,
            144463700.31709117,
            -17981215.464988697
        ],
        [
            -14934488.75720279,
            146341905.3250741,
            -16875305.30632461
        ],
        [
            -19671029.780895837,
            148131352.93379748,
            -15720080.904006615
        ],
        [
            -24530131.500718486,
            149826324.26725677,
            -14514435.042870458
        ],
        [
            -29512500.202115078,
            151420789.53757274,
            -13257277.247452939
        ],
        [
            -34618604.46102355,
            152908400.52432755,
            -11947541.678857645
        ],
        [
            -39848642.502257094,
            154282484.29592782,
            -10584195.978646517
        ],
        [
            -45202506.895731404,
            155536038.45325473,
            -9166251.130676348
        ],
        [
            -50679746.508489326,
            156661728.20995948,
            -7692772.411253505
        ],
        [
            -56279525.65468366,
            157651885.65965664,
            -6162891.495976325
        ],
        [
            -62000580.4165169,
            158498511.61753914,
            -4575819.787849566
        ],
        [
            -67841172.1475443,
            159193280.46202362,
            -2930863.0253256503
        ],
        [
            -73799038.21669114,
            159727548.44017345,
            -1227437.220453089
        ],
        [
            -79871340.10778946,
            160092365.9378574,
            534914.0341402963
        ],
        [
            -86054609.05634451,
            160278494.25066885,
            2356500.865592057
        ],
        [
            -92344689.48346794,
            160276427.42303905,
            4237467.023449069
        ],
        [
            -98736680.57718368,
            160076419.7489261,
            6177768.402787548
        ],
        [
            -105224876.47414261,
            159668519.545809,
            8177150.2340555675
        ],
        [
            -111802705.61039278,
            159042609.8219922,
            10235123.019243728
        ],
        [
            -118462669.93804915,
            158188456.45262486,
            12350937.332990482
        ],
        [
            -125196284.84479168,
            157095764.45923558,
            14523557.652116667
        ],
        [
            -131994020.76372948,
            155754242.9475867,
            16751635.427946921
        ],
        [
            -138845247.62016237,
            154153679.195681,
            19033481.672495946
        ],
        [
            -145738183.42607206,
            152284022.29413027,
            21367039.391791083
        ],
        [
            -152659848.49865907,
            150135476.62122202,
            23749856.266561322
        ],
        [
            -159596026.94059294,
            147698605.28156307,
            26179058.05114338
        ],
        [
            -166531237.1702971,
            144964443.44731566,
            28651323.23418624
        ],
        [
            -173448713.42269194,
            141924621.3127757,
            31162859.577520326
        ],
        [
            -180330400.24524415,
            138571496.10552275,
            33709383.2197902
        ],
        [
            -187156962.08068532,
            134898292.2912981,
            36286101.09597127
        ],
        [
            -193907810.0452299,
            130899248.76776381,
            38887697.478985995
        ],
        [
            -200561147.96790266,
            126569771.46932559,
            41508325.49110236
        ],
        [
            -207094039.64103442,
            121906589.4089081,
            44141604.456038564
        ],
        [
            -213482499.03315794,
            116907911.77355492,
            46780623.96289672
        ],
        [
            -219701604.92395774,
            111573583.28271641,
            49417955.48536818
        ],
        [
            -225725641.02961865,
            105905234.62788445,
            52045672.339557886
        ],
        [
            -231528262.19233084,
            99906424.4594934,
            54655378.66733874
        ],
        [
            -237082686.61087316,
            93582769.09367745,
            57238247.996473625
        ],
        [
            -242361913.39664653,
            86942055.90099946,
            59785071.75237222
        ],
        [
            -247338963.9641587,
            79994336.23540248,
            62286317.87966707
        ],
        [
            -251987144.92656866,
            72751993.78701839,
            64732199.47742293
        ],
        [
            -256280329.29230416,
            65229784.41691838,
            67112753.06485882
        ],
        [
            -260193251.88146663,
            57444843.87053945,
            69417925.78277558
        ],
        [
            -263701814.0399047,
            49416660.2779662,
            71637670.50989977
        ],
        [
            -266783391.96773037,
            41167009.03379668,
            73762047.54596575
        ],
        [
            -269417142.34275043,
            32719848.49763846,
            75781331.19940488
        ],
        [
            -271584298.4519468,
            24101175.94848579,
            77686119.33308958
        ],
        [
            -273268449.7858246,
            15338844.331811089,
            79467443.68312527
        ],
        [
            -274455798.03386676,
            6462341.516655501,
            81116878.58887506
        ],
        [
            -275135382.6666868,
            -2497465.017525576,
            82626645.671006
        ],
        [
            -275299269.810845,
            -11508613.97274775,
            83989711.97905803
        ],
        [
            -274942698.90971833,
            -20538361.32795314,
            85199879.20744298
        ],
        [
            -274064182.6965304,
            -29553510.62360023,
            86251861.75058201
        ],
        [
            -272665557.2464538,
            -38520755.57724552,
            87141351.63042231
        ],
        [
            -270751980.27267665,
            -47407027.666107,
            87865068.67378828
        ],
        [
            -268331877.32477152,
            -56179841.07460406,
            88420794.72883795
        ],
        [
            -265416837.06799507,
            -64807627.45012431,
            88807391.17104626
        ],
        [
            -262021458.29836643,
            -73260053.23811467,
            89024799.43831882
        ],
        [
            -258163152.7120891,
            -81508312.96133491,
            89074024.82915895
        ],
        [
            -253861908.63780138,
            -89525392.63620865,
            88957104.27434279
        ],
        [
            -249140021.90610176,
            -97286298.53767706,
            88677059.22988918
        ],
        [
            -244021800.73674473,
            -104768247.6797225,
            88237835.21872275
        ],
        [
            -238533251.94973317,
            -111950817.61344114,
            87644229.85580128
        ],
        [
            -232701755.94852555,
            -118816054.39877221,
            86901811.41683295
        ],
        [
            -226555737.79354927,
            -125348538.8230706,
            86016830.14931405
        ],
        [
            -220124341.30765873,
            -131535412.06921616,
            84996124.57674564
        ],
        [
            -213437112.56839895,
            -137366363.03630352,
            83847025.01732557
        ],
        [
            -206523698.38878807,
            -142833580.3562044,
            82577256.43575858
        ],
        [
            -199413564.51668856,
            -147931672.80984914,
            81194842.58254375
        ],
        [
            -192135737.3412627,
            -152657562.3196224,
            79708013.16248734
        ],
        [
            -184718571.9297012,
            -157010353.9808268,
            78125115.52736062
        ],
        [
            -177189548.26992267,
            -160991187.70661038,
            76454532.12058516
        ],
        [
            -169575096.70028186,
            -164603076.01491022,
            74704604.62764856
        ],
        [
            -161900452.69310823,
            -167850732.30557925,
            72883565.51620702
        ],
        [
            -154189540.44485238,
            -170740393.68655044,
            70999477.39415084
        ],
        [
            -146464884.1238587,
            -173279642.03625858,
            69060180.37979452
        ],
        [
            -138747545.14243993,
            -175477226.56159422,
            67073247.471135266
        ],
        [
            -131057083.45213376,
            -177342890.65054488,
            65045947.72405795
        ],
        [
            -123411540.60401176,
            -178887205.34775418,
            62985216.903849244
        ],
        [
            -115827442.16030262,
            -180121411.31753793,
            60897635.160239026
        ],
        [
            -108319816.97749159,
            -181057270.71689472,
            58789411.19196898
        ],
        [
            -100902230.89117597,
            -181706929.99162704,
            56666372.310208276
        ],
        [
            -93586832.40551715,
            -182082794.23937,
            54533959.7779752
        ],
        [
            -86384408.11157386,
            -182197413.4586205,
            52397228.79168287
        ],
        [
            -79304445.71644694,
            -182063380.72469395,
            50260852.477497876
        ],
        [
            -72355202.74747401,
            -181693242.10172015,
            48129129.29590401
        ],
        [
            -65543779.192621395,
            -181099417.91248602,
            46005993.2794224
        ],
        [
            -58876192.54124376,
            -180294134.84211126,
            43895026.567877114
        ],
        [
            -52357453.891534895,
            -179289368.24334177,
            41799473.75025758
        ],
        [
            -45991643.98685605,
            -178096793.93636698,
            39722257.56987092
        ],
        [
            -39781988.22859673,
            -176727748.74999374,
            37665995.59821181
        ],
        [
            -33730929.88542005,
            -175193199.0292745,
            35633017.53129263
        ],
        [
            -27840200.87586535,
            -173503716.33300743,
            33625382.8089093
        ],
        [
            -22110889.642321125,
            -171669459.55892688,
            31644898.30158747
        ],
        [
            -16543505.759110812,
            -169700162.76129144,
            29693135.851167973
        ],
        [
            -11138041.02610555,
            -167605127.96178114,
            27771449.488761112
        ],
        [
            -5894026.89257022,
            -165393222.2973808,
            25880992.187929384
        ],
        [
            -810588.1348493174,
            -163072878.8959397,
            24022732.041404225
        ],
        [
            4113507.2228770144,
            -160652100.9194159,
            22197467.776455015
        ],
        [
            8879801.70190306,
            -158138468.26488987,
            20405843.547366906
        ],
        [
            13490105.79059424,
            -155539146.46301568,
            18648362.96354589
        ],
        [
            17946458.87501035,
            -152860897.36172992,
            16925402.32880177
        ],
        [
            22251093.533997066,
            -150110091.22905517,
            15237223.081634087
        ],
        [
            26406403.03593702,
            -147292719.95221955,
            13583983.438129134
        ],
        [
            30414911.862042278,
            -144414411.05075407,
            11965749.248654164
        ],
        [
            34279249.07375632,
            -141480442.2585364,
            10382504.08716172
        ],
        [
            38002124.33861323,
            -138495756.46386456,
            8834158.597854875
        ],
        [
            41586306.42901742,
            -135464976.82758355,
            7320559.128441316
        ],
        [
            45034604.01117986,
            -132392421.92713161,
            5841495.682435698
        ],
        [
            48349848.54627754,
            -129282120.79926738,
            4396709.225155363
        ],
        [
            51534879.132314965,
            -126137827.77633409,
            2985898.379359875
        ],
        [
            54592529.12271198,
            -122963037.03041714,
            1608725.547071891
        ],
        [
            57525614.36598374,
            -119760996.75684278,
            264822.49411573634
        ],
        [
            60336922.91972011,
            -116534722.94335774,
            -1046204.566562118
        ],
        [
            63029206.10116474,
            -113287012.68422765,
            -2324770.357564131
        ],
        [
            65605170.74586352,
            -110020457.00958265,
            -3571306.3516020775
        ],
        [
            68067472.554928,
            -106737453.20982103,
            -4786256.985175353
        ],
        [
            70418710.42033549,
            -103440216.64292395,
            -5970076.240076788
        ],
        [
            72661421.62627295,
            -100130792.01930323,
            -7123224.563015562
        ],
        [
            74798077.83275342,
            -96811064.16445726,
            -8246166.09528045
        ],
        [
            76831081.75555883,
            -93482768.26437522,
            -9339366.186026126
        ],
        [
            78762764.46395116,
            -90147499.60244489,
            -10403289.164417693
        ],
        [
            80595383.22453447,
            -86806722.7996924,
            -11438396.347495772
        ],
        [
            82331119.82614106,
            -83461780.5726111,
            -12445144.262210913
        ],
        [
            83972079.32664858,
            -80113902.0247262,
            -13423983.061604392
        ],
        [
            85520289.16823336,
            -76764210.48945537,
            -14375355.116580522
        ],
        [
            86977698.61273235,
            -73413730.94284822,
            -15299693.766110877
        ],
        [
            88346178.45354334,
            -70063397.00547843,
            -16197422.210033093
        ],
        [
            89627520.9648642,
            -66714057.553167656,
            -17068952.529854048
        ],
        [
            90823440.05306892,
            -63366482.956407376,
            -17914684.82413554
        ],
        [
            91935571.57867515,
            -60021370.9683306,
            -18735006.446135662
        ],
        [
            92965473.82068619,
            -56679352.2809315,
            -19530291.33239703
        ],
        [
            93914628.05812374,
            -53340995.76894438,
            -20300899.411921144
        ],
        [
            94784439.24631812,
            -50006813.44042122,
            -21047176.08644555
        ],
        [
            95576236.76801847,
            -46677265.11259959,
            -21769451.773151234
        ],
        [
            96291275.24164689,
            -43352762.83114964,
            -22468041.50187759
        ],
        [
            96930735.37106209,
            -40033675.05035894,
            -23143244.55961003
        ],
        [
            97495724.82304676,
            -36720330.591251336,
            -23795344.17563969
        ],
        [
            97987279.120399,
            -33413022.394070968,
            -24424607.241375666
        ],
        [
            98406362.54001176,
            -30112011.080995347,
            -25031284.059322327
        ],
        [
            98753869.00668368,
            -26817528.344376676,
            -25615608.11622292
        ],
        [
            99030622.97462595,
            -23529780.17526866,
            -26177795.875815123
        ],
        [
            99237380.28973804,
            -20248949.946464524,
            -26718046.587052792
        ],
        [
            99374829.0267223,
            -16975201.36377121,
            -27236542.10401953
        ],
        [
            99443590.29601268,
            -13708681.298768621,
            -27733446.71409963
        ],
        [
            99444219.01631302,
            -10449522.515853923,
            -28208906.9712827
        ],
        [
            99377204.6492878,
            -7197846.3059620205,
            -28663051.531761456
        ],
        [
            99242971.89363237,
            -3953765.0389683805,
            -29095990.989242624
        ],
        [
            99041881.33637623,
            -717384.6464386657,
            -29507817.707628388
        ],
        [
            98774230.05985777,
            2511192.953919364,
            -29898605.648945305
        ],
        [
            98440252.20334819,
            5731867.4810225405,
            -30268410.19459977
        ],
        [
            98040119.47881891,
            8944537.949549418,
            -30617267.958226442
        ],
        [
            97573941.64083041,
            12149100.354804823,
            -30945196.588571407
        ]
    ],
    "(2013 TK4)": [
        [
            -76572076.34966318,
            -311381696.55173445,
            18743193.513120253
        ],
        [
            -66765231.27133511,
            -313709321.1884591,
            17621761.10346302
        ],
        [
            -56895712.009602636,
            -315750443.05763817,
            16484028.65865602
        ],
        [
            -46970896.29451658,
            -317503425.2572824,
            15330843.297088176
        ],
        [
            -36998197.803554244,
            -318966774.1895143,
            14163060.849125594
        ],
        [
            -26985066.603786364,
            -320139140.09745336,
            12981545.927124593
        ],
        [
            -16938989.604336478,
            -321019317.8566085,
            11787172.004408527
        ],
        [
            -6867491.00215669,
            -321606248.02270687,
            10580821.50120334
        ],
        [
            3221867.296030998,
            -321899018.1372321,
            9363385.875486007
        ],
        [
            13321485.292957962,
            -321896864.29128057,
            8135765.71665776
        ],
        [
            23423724.578708038,
            -321599172.9476563,
            6898870.8399114255
        ],
        [
            33520908.084989563,
            -321005483.0204243,
            5653620.379118161
        ],
        [
            43605319.933660686,
            -320115488.2104025,
            4400942.876014294
        ],
        [
            53669205.39757255,
            -318929039.5943216,
            3141776.363423789
        ],
        [
            63704770.9919734,
            -317446148.46458286,
            1877068.440206021
        ],
        [
            73704184.71488827,
            -315666989.415724,
            607776.3355726618
        ],
        [
            83659576.45505087,
            -313591903.67283547,
            -665133.0396283045
        ],
        [
            93563038.58611211,
            -311221402.6562669,
            -1940683.0571088344
        ],
        [
            103406626.76597857,
            -308556171.77601296,
            -3217887.353309227
        ],
        [
            113182360.96024254,
            -305597074.4481804,
            -4495749.832073614
        ],
        [
            122882226.70874372,
            -302345156.3248899,
            -5773264.690408757
        ],
        [
            132498176.65435052,
            -298801649.72788095,
            -7049416.469941156
        ],
        [
            142022132.3530579,
            -294967978.274947,
            -8323180.136723032
        ],
        [
            151445986.38446215,
            -290845761.6871317,
            -9593521.192069674
        ],
        [
            160761604.7815867,
            -286436820.7633781,
            -10859395.817137627
        ],
        [
            169960829.79888976,
            -281743182.50802124,
            -12119751.053975249
        ],
        [
            179035483.03707433,
            -276767085.3951709,
            -13373525.02579231
        ],
        [
            187977368.94304004,
            -271510984.75262874,
            -14619647.199203635
        ],
        [
            196778278.7029568,
            -265977558.24654433,
            -15857038.691201797
        ],
        [
            205429994.54598802,
            -260169711.44651848,
            -17084612.62360418
        ],
        [
            213924294.47564894,
            -254090583.44933075,
            -18301274.527700186
        ],
        [
            222252957.44513464,
            -247743552.53789902,
            -19505922.801793
        ],
        [
            230407768.99219143,
            -241132241.85047624,
            -20697449.224286057
        ],
        [
            238380527.34821996,
            -234260525.03345865,
            -21874739.524906628
        ],
        [
            246163050.03529018,
            -227132531.84953701,
            -23036674.016585656
        ],
        [
            253747180.9635943,
            -219752653.71126258,
            -24182128.290423647
        ],
        [
            261124798.0405749,
            -212125549.1084417,
            -25309973.97606518
        ],
        [
            268287821.30151266,
            -204256148.89612734,
            -26419079.56967882
        ],
        [
            275228221.5697574,
            -196149661.4083448,
            -27508311.331593245
        ],
        [
            281938029.6530121,
            -187811577.361103,
            -28576534.255473442
        ],
        [
            288409346.0801353,
            -179247674.5066925,
            -29622613.110731132
        ],
        [
            294634351.380815,
            -170464021.99979708,
            -30645413.55965173
        ],
        [
            300605316.9081627,
            -161466984.43454304,
            -31643803.35048233
        ],
        [
            306314616.2018021,
            -152263225.51031068,
            -32616653.58746423
        ],
        [
            311754736.8863668,
            -142859711.282945,
            -33562840.07850578
        ],
        [
            316918293.0974755,
            -133263712.956956,
            -34481244.7608774
        ],
        [
            321798038.4242343,
            -123482809.17340297,
            -35370757.204970784
        ],
        [
            326386879.35412097,
            -113524887.74744429,
            -36230276.19579753
        ],
        [
            330677889.2027365,
            -103398146.80901584,
            -37058711.39150876
        ],
        [
            334664322.50739145,
            -93111095.2998073,
            -37854985.057798386
        ],
        [
            338339629.859816,
            -82672552.77965537,
            -38618033.87660738
        ],
        [
            341697473.1494784,
            -72091648.49568689,
            -39346810.82707718
        ],
        [
            344731741.1850655,
            -61377819.66804899,
            -40040287.13620781
        ],
        [
            347436565.6576556,
            -50540808.94687942,
            -40697454.2961618
        ],
        [
            349806337.4050015,
            -39590660.99631143,
            -41317326.14462148
        ],
        [
            351835722.93218887,
            -28537718.162807353,
            -41898941.004056014
        ],
        [
            353519681.1397392,
            -17392615.18697624,
            -42441363.87518921
        ],
        [
            354853480.20604956,
            -6166272.920281112,
            -42943688.679382265
        ],
        [
            355832714.56691,
            5130108.989308864,
            -43405040.54406152
        ],
        [
            356453321.9307641,
            16485060.475608245,
            -43824578.12473272
        ],
        [
            356711600.264412,
            27886850.525857598,
            -44201495.95653634
        ],
        [
            356604224.680043,
            39323497.77122253,
            -44535026.82771627
        ],
        [
            356128264.1508539,
            50782782.21733275,
            -44824444.16680244
        ],
        [
            355281197.97913104,
            62252258.13129182,
            -45069064.43475303
        ],
        [
            354060931.93756294,
            73719268.09642623,
            -45268249.512767196
        ],
        [
            352465814.0017762,
            85170958.24047911,
            -45421409.07597396
        ],
        [
            350494649.5896826,
            96594294.63700187,
            -45528002.94272968
        ],
        [
            348146716.2212439,
            107976080.87338673,
            -45587543.38882489
        ],
        [
            345421777.51074487,
            119302976.77233967,
            -45599597.41551542
        ],
        [
            342320096.4026539,
            130561518.24664861,
            -45563788.959959716
        ],
        [
            338842447.5617045,
            141738138.25989544,
            -45479801.03637105
        ],
        [
            334990128.82795906,
            152819188.85834658,
            -45347377.79598494
        ],
        [
            330764971.64838076,
            163790964.23167044,
            -45166326.49380463
        ],
        [
            326169350.3978671,
            174639724.75243992,
            -44936519.35002823
        ],
        [
            321206190.5047943,
            185351721.9366436,
            -44657895.29408092
        ],
        [
            315878975.2989407,
            195913224.2597012,
            -44330461.57928505
        ],
        [
            310191751.5031835,
            206310543.75485253,
            -43954295.25639735
        ],
        [
            304149133.2946236,
            216530063.313309,
            -43529544.49453435
        ],
        [
            297756304.8657772,
            226558264.5983177,
            -43056429.738393165
        ],
        [
            291019021.4221807,
            236381756.4783555,
            -42535244.69115862
        ],
        [
            283943608.55916023,
            245987303.87813026,
            -41966357.11306787
        ],
        [
            276536959.96760845,
            255361856.93998265,
            -41350209.42628131
        ],
        [
            268806533.42634135,
            264492580.38274965,
            -40687319.11748031
        ],
        [
            260760345.04694283,
            273366882.94022536,
            -39978278.93047629
        ],
        [
            252406961.7458926,
            281972446.7571139,
            -39223756.84206742
        ],
        [
            243755491.92814904,
            290297256.6168878,
            -38424495.81541294
        ],
        [
            234815574.3761648,
            298329628.8732802,
            -37581313.32630644
        ],
        [
            225597365.34846127,
            306058239.9553315,
            -36695100.658907056
        ],
        [
            216111523.90231085,
            313472154.3150073,
            -35766821.96872795
        ],
        [
            206369195.46567112,
            320560851.6864463,
            -34797513.11196991
        ],
        [
            196381993.69420445,
            327314253.52691716,
            -33788280.24161837
        ],
        [
            186161980.65988588,
            333722748.5115773,
            -32740298.172079705
        ],
        [
            175721645.42827308,
            339777216.95712906,
            -31654808.515508775
        ],
        [
            165073881.0918606,
            345469054.0534833,
            -30533117.594359055
        ],
        [
            154231960.33698517,
            350790191.78751856,
            -29376594.13605821
        ],
        [
            143209509.63137683,
            355733119.448958,
            -28186666.757062368
        ],
        [
            132020482.12856954,
            360290902.61524093,
            -26964821.244858168
        ],
        [
            120679129.393905,
            364457200.5199686,
            -25712597.64775072
        ],
        [
            109199972.06468542,
            368226281.718021,
            -24431587.18348458
        ],
        [
            97597769.5640893,
            371593037.96968436,
            -23123428.978882633
        ],
        [
            85887488.99467237,
            374552996.2760255,
            -21789806.653742373
        ],
        [
            74084273.34257467,
            377102329.0082063,
            -20432444.763190046
        ],
        [
            62203409.12789636,
            379237862.0843627,
            -19053105.11355189
        ],
        [
            50260293.64002872,
            380957081.1589649,
            -17653582.96754825
        ],
        [
            38270401.89902164,
            382258135.80113876,
            -16235703.155245297
        ],
        [
            26249253.485298492,
            383139841.6501376,
            -14801316.107703619
        ],
        [
            14212379.380189642,
            383601680.547913,
            -13352293.830638839
        ],
        [
            2175288.958861053,
            383643798.66042703,
            -11890525.835654838
        ],
        [
            -9846562.724740416,
            383267002.61086524,
            -10417915.046721699
        ],
        [
            -21837807.224268496,
            382472753.65915596,
            -8936373.699550938
        ],
        [
            -33783194.425980076,
            381263159.97305757,
            -7447819.251369253
        ],
        [
            -45667623.58453393,
            379640967.04646534,
            -5954170.318313817
        ],
        [
            -57476173.5475177,
            377609546.33041394,
            -4457342.657269929
        ],
        [
            -69194132.05318753,
            375172882.1514284,
            -2959245.2084537484
        ],
        [
            -80807023.99319871,
            372335557.00034267,
            -1461776.2144127004
        ],
        [
            -92300638.54003648,
            369102735.2823911,
            33180.56961482391
        ],
        [
            -103661055.04734951,
            365480145.62623316,
            1523759.5598633587
        ],
        [
            -114874667.64035583,
            361474061.8555586,
            3008116.909519393
        ],
        [
            -125928208.4228223,
            357091282.73200214,
            4484433.943287082
        ],
        [
            -136808769.23674268,
            352339110.5822599,
            5950920.449855879
        ],
        [
            -147503821.92063898,
            347225328.92552954,
            7405817.822178487
        ],
        [
            -158001237.02230805,
            341758179.2196982,
            8847402.036600746
        ],
        [
            -168289300.93172872,
            335946336.84608793,
            10273986.46304555
        ],
        [
            -178356731.40965784,
            329798886.45305085,
            11683924.499631045
        ],
        [
            -188192691.4970769,
            323325296.7783333,
            13075612.026285406
        ],
        [
            -197786801.80004835,
            316535395.068912,
            14447489.67309978
        ],
        [
            -207129151.15360886,
            309439341.21501565,
            15798044.90032319
        ],
        [
            -216210305.67701644,
            302047601.7123173,
            17125813.888042226
        ],
        [
            -225021316.2409187,
            294370923.56287605,
            18429383.23469448
        ],
        [
            -233553724.37475526,
            286420308.2213906,
            19707391.46462745
        ],
        [
            -241799566.6499411,
            278206985.688748,
            20958530.34593306
        ],
        [
            -249751377.5810202,
            269742388.8497933,
            22181546.02074842
        ],
        [
            -257402191.09303853,
            261038128.14677134,
            23375239.951115645
        ],
        [
            -264745540.60883045,
            252105966.67404896,
            24538469.684332952
        ],
        [
            -271775457.8147239,
            242957795.77362835,
            25670149.44249826
        ],
        [
            -278486470.1673589,
            233605611.20461494,
            26769250.54164847
        ],
        [
            -284873597.20786655,
            224061489.95332557,
            27834801.64652539
        ],
        [
            -290932345.7525893,
            214337567.7441499,
            28865888.867555346
        ],
        [
            -296658704.03185344,
            204446017.30465272,
            29861655.70711318
        ],
        [
            -302049134.8500377,
            194399027.4318354,
            30821302.86255128
        ],
        [
            -307100567.84135765,
            184208782.89994103,
            31744087.893815145
        ],
        [
            -311810390.8964171,
            173887445.24380147,
            32629324.763737194
        ],
        [
            -316176440.83469987,
            163447134.44548965,
            33476383.25930447
        ],
        [
            -320196993.39783126,
            152899911.54599175,
            34284688.30233715
        ],
        [
            -323870752.6376363,
            142257762.19782764,
            35053719.15809305
        ],
        [
            -327196839.7718387,
            131532581.16898575,
            35783008.5503374
        ],
        [
            -330174781.5786705,
            120736157.80328745,
            36472141.69138561
        ],
        [
            -332804498.399777,
            109880162.43733859,
            37120755.23554761
        ],
        [
            -335086291.8186211,
            98976133.7695741,
            37728536.164277986
        ],
        [
            -337020832.0791461,
            88035467.17260551,
            38295220.61116979
        ],
        [
            -338609145.3068156,
            77069403.9360851,
            38820592.63472942
        ],
        [
            -339852600.59130526,
            66089021.423680514,
            39304482.94663426
        ],
        [
            -340752896.9871436,
            55105224.1244352,
            39746767.60291378
        ],
        [
            -341312050.4855056,
            44128735.5758363,
            40147366.66520751
        ],
        [
            -341532381.0071797,
            33170091.133274987,
            40506242.83894725
        ],
        [
            -341416499.46349543,
            22239631.558259748,
            40823400.09498751
        ],
        [
            -340967294.92873937,
            11347497.39575769,
            41098882.28087262
        ],
        [
            -340187921.96431357,
            503624.109317556,
            41332771.7275833
        ],
        [
            -339081788.1316503,
            -10282262.058776543,
            41525187.85725367
        ],
        [
            -337652541.72768086,
            -21000647.53621839,
            41676285.79699424
        ],
        [
            -335904059.7735054,
            -31642234.21305734,
            41786255.00360007
        ],
        [
            -333840436.2838306,
            -42197941.61317,
            41855317.90356875
        ],
        [
            -331465970.84174424,
            -52658908.4806996,
            41883728.55250111
        ],
        [
            -328785157.5004975,
            -63016493.81754452,
            41871771.31761246
        ],
        [
            -325802674.0311788,
            -73262277.40800917,
            41819759.58674373
        ],
        [
            -322523371.53247863,
            -83388059.86659719,
            41728034.50693202
        ],
        [
            -318952264.4162,
            -93385862.24461387,
            41596963.75528087
        ],
        [
            -315094520.77972823,
            -103247925.23082046,
            41426940.344561346
        ],
        [
            -310955453.17438096,
            -112966707.98081276,
            41218381.46567902
        ],
        [
            -306540509.7763841,
            -122534886.60912177,
            40971727.36885686
        ],
        [
            -301855265.96517843,
            -131945352.37728041,
            40687440.28511344
        ],
        [
            -296905416.3118546,
            -141191209.61023512,
            40366003.38935769
        ],
        [
            -291696766.97872734,
            -150265773.3725804,
            40007919.80617706
        ],
        [
            -286235228.5294069,
            -159162566.93511385,
            39613711.659165084
        ],
        [
            -280526809.1471933,
            -167875319.0611897,
            39183919.1644176
        ],
        [
            -274577608.25819826,
            -176397961.14130914,
            38719099.76862231
        ],
        [
            -268393810.55430654,
            -184724624.20328838,
            38219827.33197619
        ],
        [
            -261981680.40989152,
            -192849635.82427493,
            37686691.35598712
        ],
        [
            -255347556.68511757,
            -200767516.96975562,
            37120296.25605065
        ],
        [
            -248497847.90766823,
            -208472978.78361657,
            36521260.67853909
        ],
        [
            -241439027.82384768,
            -215960919.35220128,
            35890216.86199794
        ],
        [
            -234177631.30919516,
            -223226420.4642249,
            35227810.041913666
        ],
        [
            -226720250.62801754,
            -230264744.3873338,
            34534697.898395
        ],
        [
            -219073532.0306034,
            -237071330.68103123,
            33811550.04599978
        ],
        [
            -211244172.67628682,
            -243641793.0646634,
            33059047.56483554
        ],
        [
            -203238917.87001607,
            -249971916.35814208,
            32277882.571969345
        ],
        [
            -195064558.59961963,
            -256057653.51209763,
            31468757.832095798
        ],
        [
            -186727929.36054188,
            -261895122.74320194,
            30632386.406332683
        ],
        [
            -178235906.25446826,
            -267480604.78946504,
            29769491.33794205
        ],
        [
            -169595405.3479225,
            -272810540.2994198,
            28880805.37370709
        ],
        [
            -160813381.2766392,
            -277881527.36823505,
            27967070.719634093
        ],
        [
            -151896826.08125508,
            -282690319.23295486,
            27029038.829592396
        ],
        [
            -142852768.25962764,
            -287233822.1382611,
            26067470.225451685
        ],
        [
            -133688272.02088869,
            -291509093.383358,
            25083134.34722807
        ],
        [
            -124410436.72614327,
            -295513339.5598335,
            24076809.43170321
        ],
        [
            -115026396.50055158,
            -299243914.9896077,
            23049282.41793783
        ],
        [
            -105543320.0013717,
            -302698320.3713736,
            22001348.878059562
        ],
        [
            -95968410.32637303,
            -305874201.64324105,
            20933812.971664127
        ],
        [
            -86308905.0468951,
            -308769349.068622,
            19847487.422131635
        ],
        [
            -76572076.34966326,
            -311381696.55173445,
            18743193.51312026
        ]
    ],
    "(2014 BM25)": [
        [
            140030817.9218608,
            -205932286.49067026,
            98597889.69284064
        ],
        [
            146970253.22258884,
            -201099072.11528516,
            98547831.19262695
        ],
        [
            153795615.36388645,
            -196103984.74331087,
            98419383.81762137
        ],
        [
            160504125.43023473,
            -190948835.1201822,
            98212526.67318344
        ],
        [
            167092969.71389717,
            -185635406.9683436,
            97927222.29166642
        ],
        [
            173559294.4809185,
            -180165461.370025,
            97563416.9122077
        ],
        [
            179900200.8890373,
            -174540741.3830505,
            97121040.87064315
        ],
        [
            186112740.05879375,
            -168762976.89397448,
            96600009.10123943
        ],
        [
            192193908.30011955,
            -162833889.71362677,
            96000221.75241771
        ],
        [
            198140642.4977831,
            -156755198.92087364,
            95321564.9191227
        ],
        [
            203949815.66023755,
            -150528626.46106666,
            94563911.49496724
        ],
        [
            209618232.6376748,
            -144155903.0062419,
            93727122.14775595
        ],
        [
            215142626.01643622,
            -137638774.08465725,
            92811046.4224617
        ],
        [
            220519652.19836915,
            -130979006.48769632,
            91815523.97619148
        ],
        [
            225745887.67524815,
            -124178394.9625265,
            90740385.95013551
        ],
        [
            230817825.51000714,
            -117238769.19916505,
            89585456.48394062
        ],
        [
            235731872.0382563,
            -110162001.12077183,
            88350554.3783853
        ],
        [
            240484343.80538014,
            -102950012.48604077,
            87035494.91265583
        ],
        [
            245071464.75644472,
            -95604782.8124954,
            85640091.82292739
        ],
        [
            249489363.69817114,
            -88128357.62929305,
            84164159.44933853
        ],
        [
            253734072.0543692,
            -80522857.06779203,
            82607515.05880468
        ],
        [
            257801521.938464,
            -72790484.79762872,
            80969981.35144617
        ],
        [
            261687544.5690895,
            -64933537.31535989,
            79251389.15869673
        ],
        [
            265387869.057164,
            -56954413.591843456,
            77451580.34141052
        ],
        [
            268898121.595399,
            -48855625.08343175,
            75570410.89648515
        ],
        [
            272213825.0838181,
            -40639806.11071582,
            73607754.28066228
        ],
        [
            275330399.2275719,
            -32309724.60697028,
            71563504.96024473
        ],
        [
            278243161.14611155,
            -23868293.236575365,
            69437582.19546948
        ],
        [
            280947326.53562033,
            -15318580.881518275,
            67229934.06819014
        ],
        [
            283438011.4294834,
            -6663824.491570011,
            64940541.76133773
        ],
        [
            285710234.60447454,
            2092558.7091289908,
            62569424.09833044
        ],
        [
            287758920.68323797,
            10946958.669585928,
            60116642.350180686
        ],
        [
            289578903.98651624,
            19895559.627743453,
            57582305.31748203
        ],
        [
            291164933.1913785,
            28934326.912803918,
            54966574.693736196
        ],
        [
            292511676.8544163,
            38058993.45691602,
            52269670.71558241
        ],
        [
            293613729.8614338,
            47265046.04410365,
            49491878.10440018
        ],
        [
            294465620.86753166,
            56547711.32989164,
            46633552.30245168
        ],
        [
            295061820.79360205,
            65901941.67119075,
            43695126.00519404
        ],
        [
            295396752.4470575,
            75322400.81267962,
            40677115.98960041
        ],
        [
            295464801.3360356,
            84803449.48316486,
            37580130.23626553
        ],
        [
            295260327.74727595,
            94339130.96323425,
            34404875.34071119
        ],
        [
            294777680.15827,
            103923156.6939381,
            31152164.206632808
        ],
        [
            294011210.0540404,
            113548892.0052414,
            27822924.010817744
        ],
        [
            292955288.2179151,
            123209342.05256617,
            24418204.426102914
        ],
        [
            291604322.5638092,
            132897138.0598742,
            20939186.085003722
        ],
        [
            289952777.5746959,
            142604523.97837365,
            17387189.262529593
        ],
        [
            287995195.408019,
            152323343.68103504,
            13763682.752186825
        ],
        [
            285726218.72363263,
            162045028.82459113,
            10070292.904254925
        ],
        [
            283140615.283324,
            171760587.52248588,
            6308812.790106265
        ],
        [
            280233304.36294454,
            181460593.984236,
            2481211.4506231304
        ],
        [
            276999385.0085032,
            191135179.28872064,
            -1410356.8193316162
        ],
        [
            273434166.1561324,
            200774023.4708895,
            -5363543.204897381
        ],
        [
            269533198.6224996,
            210366349.11308056,
            -9375795.18495388
        ],
        [
            265292308.95687628,
            219900916.6433589,
            -13444347.493998997
        ],
        [
            260707635.1286005,
            229366021.55379733,
            -17566213.30787052
        ],
        [
            255775664.00398883,
            238749493.76113707,
            -21738175.736496713
        ],
        [
            250493270.5448073,
            248038699.34050825,
            -25956779.714424547
        ],
        [
            244857758.63617867,
            257220544.86951935,
            -30218324.387416128
        ],
        [
            238866903.42528468,
            266281484.62469244,
            -34518856.100806475
        ],
        [
            232518995.0234796,
            275207530.8745527,
            -38854162.102445185
        ],
        [
            225812883.39356422,
            283984267.5132737,
            -43219765.079744734
        ],
        [
            218748024.2111482,
            292596867.2752217,
            -47610918.6564571
        ],
        [
            211324525.45447683,
            301030112.76362157,
            -52022603.98011201
        ],
        [
            203543194.44112885,
            309268421.51545036,
            -56449527.53536657
        ],
        [
            195405584.99297708,
            317295875.30915624,
            -60886120.32161872
        ],
        [
            186914044.37321863,
            325096253.90151143,
            -65326538.5348999
        ],
        [
            178071759.60166997,
            332653073.35448337,
            -69764665.89404394
        ],
        [
            168882802.717536,
            339949629.0821636,
            -74194117.74919339
        ],
        [
            159352174.52321577,
            346969043.7112918,
            -78608247.10661486
        ],
        [
            149485846.30922776,
            353694319.80661553,
            -83000152.69732474
        ],
        [
            139290799.02990165,
            360108397.46419126,
            -87362689.2079647
        ],
        [
            128775059.37304713,
            366194216.7218543,
            -91688479.78053457
        ],
        [
            117947732.14538354,
            371934784.67667747,
            -95969930.8728345
        ],
        [
            106819028.38012752,
            377313247.1346827,
            -100199249.5536852
        ],
        [
            95400288.56483239,
            382312964.54893136,
            -104368463.2861386
        ],
        [
            83704000.38739324,
            386917591.9290999,
            -108469442.227965
        ],
        [
            71743810.40702909,
            391111162.3297032,
            -112493924.05180323
        ],
        [
            59534529.07594168,
            394878173.4463301,
            -116433541.25764333
        ],
        [
            47092128.56698698,
            398203676.7709273,
            -120279850.91803928
        ],
        [
            34433732.90369269,
            401073368.6797491,
            -124024366.7619593
        ],
        [
            21577599.94171998,
            403473682.7527182,
            -127658593.46692584
        ],
        [
            8543094.815585405,
            405391882.552351,
            -131174062.99159423
        ],
        [
            -4649345.458994359,
            406816154.02593,
            -134562372.74281317
        ],
        [
            -17978256.44876972,
            407735696.63814324,
            -137815225.3331908
        ],
        [
            -31421199.955560774,
            408140812.2948297,
            -140924469.6480467
        ],
        [
            -44954826.87235865,
            408022991.083608,
            -143882142.90519586
        ],
        [
            -58554949.14087814,
            407374992.83570945,
            -146680513.35815105
        ],
        [
            -72196620.58542281,
            406190923.5068252,
            -149312123.26393896
        ],
        [
            -85854226.27038491,
            404466305.38446486,
            -151769831.71166953
        ],
        [
            -99501579.89907707,
            402198140.15618265,
            -154046856.88811398
        ],
        [
            -113112028.64245194,
            399384963.91766,
            -156136817.34260604
        ],
        [
            -126658564.66035332,
            396026893.2622014,
            -158033771.80624086
        ],
        [
            -140113942.45811218,
            392125661.6734626,
            -159732257.12016052
        ],
        [
            -153450801.110426,
            387684645.54041904,
            -161227323.83506986
        ],
        [
            -166641790.285335,
            382708879.2264917,
            -162514569.05923894
        ],
        [
            -179659698.9163731,
            377205058.7516574,
            -163590166.15514746
        ],
        [
            -192477585.3030307,
            371181533.78516173,
            -164450890.91543895
        ],
        [
            -205068907.37054187,
            364648287.7945543,
            -165094143.88659033
        ],
        [
            -217407651.79136696,
            357616906.3513219,
            -165517968.5530917
        ],
        [
            -229468460.6637063,
            350100533.7512398,
            -165721065.14518538
        ],
        [
            -241226754.45757425,
            342113818.26541615,
            -165702799.88838956
        ],
        [
            -252658849.97643775,
            333672846.49245274,
            -165463209.57202715
        ],
        [
            -263742072.14162353,
            324795067.4298904,
            -165003001.37558034
        ],
        [
            -274454858.48653877,
            315499207.02090234,
            -164323547.9546008
        ],
        [
            -284776855.3465567,
            305805174.0571178,
            -163426877.85078117
        ],
        [
            -294689004.8460592,
            295733958.4278591,
            -162315661.35230973
        ],
        [
            -304173621.9140323,
            285307522.79775006,
            -160993191.98947838
        ],
        [
            -313214460.7008521,
            274548688.86688286,
            -159463363.90549713
        ],
        [
            -321796769.91834307,
            263481019.419298,
            -157730645.39247772
        ],
        [
            -329907336.7795087,
            252128697.3958012,
            -155800048.92665502
        ],
        [
            -337534519.370199,
            240516403.23602086,
            -153677098.07433385
        ],
        [
            -344668267.4391,
            228669191.7225517,
            -151367791.67021635
        ],
        [
            -351300131.74169505,
            216612369.52801132,
            -148878565.69230074
        ],
        [
            -357423262.2153619,
            204371374.61528414,
            -146216253.27228042
        ],
        [
            -363032395.3940103,
            191971658.57396793,
            -143388043.28735328
        ],
        [
            -368123831.5894332,
            179438572.894226,
            -140401437.97879028
        ],
        [
            -372695402.4711062,
            166797260.0852817,
            -137264210.0349211
        ],
        [
            -376746429.7652246,
            154072550.4422003,
            -133984359.56190714
        ],
        [
            -380277675.8664752,
            141288865.1540457,
            -130570071.3454804
        ],
        [
            -383291287.21199447,
            128470126.33154029,
            -127029672.78148182
        ],
        [
            -385790731.30622196,
            115639674.415573,
            -123371592.82339063
        ],
        [
            -387780728.308324,
            102820193.31164193,
            -119604322.26196052
        ],
        [
            -389267178.1013118,
            90033643.4817892,
            -115736375.6164633
        ],
        [
            -390257083.75499165,
            77301203.11670285,
            -111776254.87975389
        ],
        [
            -390758472.2747413,
            64643217.40810916,
            -107732415.32124977
        ],
        [
            -390780313.4963159,
            52079155.84669942,
            -103613233.51373625
        ],
        [
            -390332437.9450351,
            39627577.384722024,
            -99426977.7123766
        ],
        [
            -389425454.4274717,
            27306103.22576955,
            -95181780.67804275
        ],
        [
            -388070668.06683517,
            15131396.93769297,
            -90885615.00261723
        ],
        [
            -386279999.43128306,
            3119151.528210908,
            -86546270.96169893
        ],
        [
            -384065905.3389698,
            -8715916.923419297,
            -82171336.8904953
        ],
        [
            -381441301.85626876,
            -20360069.521523267,
            -77768182.05187742
        ],
        [
            -378419489.93761,
            -31800539.16547981,
            -73343941.94175704
        ],
        [
            -375014084.0879959,
            -43025520.004849374,
            -68905505.9561981
        ],
        [
            -371238944.3635419,
            -54024152.23491421,
            -64459507.327027135
        ],
        [
            -367108111.9622338,
            -64786502.7313578,
            -60012315.21807561
        ],
        [
            -362635748.597237,
            -75303542.01806745,
            -55570028.86249251
        ],
        [
            -357836079.78911716,
            -85567118.05148146,
            -51138473.61263916
        ],
        [
            -352723342.1616475,
            -95569927.28936525,
            -46723198.76773574
        ],
        [
            -347311734.7788123,
            -105305483.49220145,
            -42329477.04047389
        ],
        [
            -341615374.5182935,
            -114768084.68237585,
            -37962305.52199102
        ],
        [
            -335648255.43924034,
            -123952778.66073973,
            -33626408.0047049
        ],
        [
            -329424212.06940734,
            -132855327.4526692,
            -29326238.52427799
        ],
        [
            -322956886.5086905,
            -141472171.02706715,
            -25065985.985181626
        ],
        [
            -316259699.2225177,
            -149800390.60240015,
            -20849579.73874574
        ],
        [
            -309345823.3791975,
            -157837671.8243952,
            -16680695.98796751
        ],
        [
            -302228162.56994057,
            -165582268.0708181,
            -12562764.899531364
        ],
        [
            -294919331.7385354,
            -173032964.1102237,
            -8498978.310259067
        ],
        [
            -287431641.1392334,
            -180189040.3140073,
            -4492297.9223908605
        ],
        [
            -279777083.13599384,
            -187050237.594713,
            -545463.8895580522
        ],
        [
            -271967321.65347654,
            -193616723.21860906,
            3338996.2971159727
        ],
        [
            -264013684.08976424,
            -199889057.61710048,
            7158758.705744751
        ],
        [
            -255927155.50240302,
            -205868162.2997677,
            10911693.71869187
        ],
        [
            -247718374.882693,
            -211555288.9517045,
            14595856.713978566
        ],
        [
            -239397633.33794934,
            -216951989.7794255,
            18209478.734095875
        ],
        [
            -230974874.00742137,
            -222060089.15291536,
            21750957.196429223
        ],
        [
            -222459693.5444947,
            -226881656.57634377,
            25218846.693027943
        ],
        [
            -213861345.0054441,
            -231418981.00655222,
            28611849.92135569
        ],
        [
            -205188741.99321678,
            -235674546.5265364,
            31928808.78193983
        ],
        [
            -196450463.91328907,
            -239651009.370738,
            35168695.673524216
        ],
        [
            -187654762.2074234,
            -243351176.2899349,
            38330605.01142362
        ],
        [
            -178809567.44004017,
            -246777984.2357749,
            41413744.99026769
        ],
        [
            -169922497.12076026,
            -249934481.3384555,
            44417429.60821801
        ],
        [
            -161000864.15542448,
            -252823809.14560315,
            47341070.966015175
        ],
        [
            -152051685.82643878,
            -255449186.08595386,
            50184171.85086111
        ],
        [
            -143081693.21157694,
            -257813892.11790103,
            52946318.612146474
        ],
        [
            -134097340.9583688,
            -259921254.52024716,
            55627174.33336774
        ],
        [
            -125104817.33882299,
            -261774634.78050262,
            58226472.3022358
        ],
        [
            -116110054.51651046,
            -263377416.53472504,
            60744009.778925054
        ],
        [
            -107118738.96490063,
            -264732994.51211452,
            63179642.06063517
        ],
        [
            -98136321.98230326,
            -265844764.43730074,
            65533276.83911635
        ],
        [
            -89168030.2548364,
            -266716113.84340626,
            67804868.84651423
        ],
        [
            -80218876.42447396,
            -267350413.74949646,
            69994414.78381547
        ],
        [
            -71293669.62447506,
            -267751011.15685898,
            72101948.52528726
        ],
        [
            -62397025.94934228,
            -267921222.31966168,
            74127536.59159319
        ],
        [
            -53533378.830904394,
            -267864326.746855,
            76071273.88371655
        ],
        [
            -44706989.29622103,
            -267583561.89368755,
            77933279.66940615
        ],
        [
            -35921956.0867205,
            -267082118.50284314,
            79713693.8135764
        ],
        [
            -27182225.62138976,
            -266363136.5569626,
            81412673.24391484
        ],
        [
            -18491601.789887264,
            -265429701.80614638,
            83030388.64287585
        ],
        [
            -9853755.564224944,
            -264284842.83592948,
            84567021.35724744
        ],
        [
            -1272234.4201392382,
            -262931528.6431496,
            86022760.51656334
        ],
        [
            7249528.438527569,
            -261372666.68907768,
            87397800.35178493
        ],
        [
            15708205.057146087,
            -259611101.4011343,
            88692337.70588297
        ],
        [
            24100563.91232133,
            -257649613.0964572,
            89906569.72820868
        ],
        [
            32423461.30010815,
            -255490917.3025062,
            91040691.74483939
        ],
        [
            40673832.9306135,
            -253137664.45178849,
            92094895.29741918
        ],
        [
            48848685.72807625,
            -250592439.9296383,
            93069366.34337881
        ],
        [
            56945089.834567234,
            -247857764.45580417,
            93964283.61080554
        ],
        [
            64960170.81469263,
            -244936094.78235927,
            94779817.10164502
        ],
        [
            72891102.0580539,
            -241829824.69217056,
            95516126.73734164
        ],
        [
            80735097.37573574,
            -238541286.28382522,
            96173361.14146324
        ],
        [
            88489403.78674978,
            -235072751.53052223,
            96751656.55430795
        ],
        [
            96151294.49011923,
            -231426434.101994,
            97251135.87494908
        ],
        [
            103718062.01818462,
            -227604491.44001895,
            97671907.82664053
        ],
        [
            111187011.56669354,
            -223609027.07953146,
            98014066.24197717
        ],
        [
            118555454.49732587,
            -219442093.20872432,
            98277689.46467887
        ],
        [
            125820702.00849912,
            -215105693.4628672,
            98462839.86534682
        ],
        [
            132980058.97056253,
            -210601785.94784907,
            98569563.46901977
        ],
        [
            140030817.92186075,
            -205932286.4906703,
            98597889.69284064
        ]
    ],
    "(2017 AZ13)": [
        [
            -178992450.05890134,
            288193327.1436771,
            98524357.83285181
        ],
        [
            -188277704.71837765,
            282038118.668418,
            99078052.04429635
        ],
        [
            -197391353.63543656,
            275622723.2526697,
            99540767.14478822
        ],
        [
            -206326375.99576682,
            268951949.6709536,
            99912117.86947165
        ],
        [
            -215075838.66905093,
            262030747.33079973,
            100191767.1002918
        ],
        [
            -223632896.6918185,
            254864206.69058153,
            100379426.05412686
        ],
        [
            -231990793.9244188,
            247457559.85367006,
            100474854.54429989
        ],
        [
            -240142863.89613596,
            239816181.32683688,
            100477861.3157067
        ],
        [
            -248082530.85206288,
            231945588.93019488,
            100388304.45357658
        ],
        [
            -255803311.0149306,
            223851444.84533125,
            100206091.86565967
        ],
        [
            -263298814.07465273,
            215539556.78762877,
            99931181.8374048
        ],
        [
            -270562744.91789484,
            207015879.2881149,
            99563583.65945806
        ],
        [
            -277588905.6095009,
            198286515.06949985,
            99103358.32656902
        ],
        [
            -284371197.6371103,
            189357716.50038183,
            98550619.30674365
        ],
        [
            -290903624.42976826,
            180235887.11089575,
            97905533.37922259
        ],
        [
            -297180294.16077006,
            170927583.15237665,
            97168321.53959845
        ],
        [
            -303195422.8443774,
            161439515.18288177,
            96339259.97010587
        ],
        [
            -308943337.7354052,
            151778549.65968955,
            95418681.07283154
        ],
        [
            -314418481.0399852,
            141951710.51915085,
            94406974.56329152
        ],
        [
            -319615413.9450754,
            131966180.72352368,
            93304588.62151161
        ],
        [
            -324528820.9734868,
            121829303.75367326,
            92112031.09742473
        ],
        [
            -329153514.6703476,
            111548585.02576944,
            90829870.76706272
        ],
        [
            -333484440.62600005,
            101131693.2093676,
            89458738.63567369
        ],
        [
            -337516682.83934474,
            90586461.42351925,
            87999329.28353465
        ],
        [
            -341245469.424576,
            79920888.28683369,
            86452402.24985878
        ],
        [
            -344666178.66312414,
            69143138.79670149,
            84818783.44981128
        ],
        [
            -347774345.4013918,
            58261545.0122059,
            83099366.61925292
        ],
        [
            -350565667.7935728,
            47284606.51459396,
            81295114.78142539
        ],
        [
            -353036014.3874483,
            36220990.61856106,
            79407061.72937569
        ],
        [
            -355181431.54957026,
            25079532.307031512,
            77436313.51749317
        ],
        [
            -356998151.2246692,
            13869233.861599147,
            75384049.95510188
        ],
        [
            -358482599.02244973,
            2599264.1603372097,
            73251526.09461284
        ],
        [
            -359631402.62317246,
            -8721042.385694146,
            71040073.70630103
        ],
        [
            -360441400.49155605,
            -20082187.286216706,
            68751102.73132893
        ],
        [
            -360909650.8865745,
            -31474509.84495476,
            66386102.70419666
        ],
        [
            -361033441.1526735,
            -42888189.48158759,
            63946644.135361224
        ],
        [
            -360810297.2757794,
            -54313248.531696826,
            61434379.8443352
        ],
        [
            -360237993.6852459,
            -65739555.55382547,
            58851046.23315309
        ],
        [
            -359314563.2805588,
            -77156829.17248535,
            56198464.489685744
        ],
        [
            -358038307.65923,
            -88554642.48550674,
            53478541.709890865
        ],
        [
            -356407807.5198363,
            -99922428.06352347,
            50693271.92771877
        ],
        [
            -354421933.2116386,
            -111249483.56860533,
            47844737.04104722
        ],
        [
            -352079855.39962673,
            -122524978.01807532,
            44935107.621706754
        ],
        [
            -349381055.81122077,
            -133737958.71837741,
            41966643.59737936
        ],
        [
            -346325338.0282073,
            -144877358.89247245,
            38941694.79291563
        ],
        [
            -342912838.28483135,
            -155932006.0226251,
            35862701.31842563
        ],
        [
            -339144036.2303083,
            -166890630.9286007,
            32732193.791357823
        ],
        [
            -335019765.61139244,
            -177741877.5991997,
            29552793.379699066
        ],
        [
            -330541224.8280448,
            -188474313.7927131,
            26327211.653409563
        ],
        [
            -325709987.31272835,
            -199076442.41928923,
            23058250.231255833
        ],
        [
            -320528011.6814207,
            -209536713.71533602,
            19748800.210329864
        ],
        [
            -314997651.6021149,
            -219843538.21696046,
            16401841.365746478
        ],
        [
            -309121665.3244031,
            -229985300.53605914,
            13020441.108300865
        ],
        [
            -302903224.8117228,
            -239950373.93901625,
            9607753.188250015
        ],
        [
            -296345924.4160296,
            -249727135.72405875,
            6167016.133856615
        ],
        [
            -289453789.03307366,
            -259303983.3891536,
            2701551.4139119163
        ],
        [
            -282231281.67511976,
            -268669351.5779295,
            -785238.6858667657
        ],
        [
            -274683310.396904,
            -277811729.7864765,
            -4289873.481880635
        ],
        [
            -266815234.50988948,
            -286719680.809034,
            -7808796.615555521
        ],
        [
            -258632870.01949918,
            -295381859.89554775,
            -11338379.087520871
        ],
        [
            -250142494.219994,
            -303787034.5888824,
            -14874922.609352626
        ],
        [
            -241350849.3820653,
            -311924105.2041348,
            -18414663.27793773
        ],
        [
            -232265145.46903515,
            -319782125.9070561,
            -21953775.576175425
        ],
        [
            -222893061.81884453,
            -327350326.3430716,
            -25488376.702278692
        ],
        [
            -213242747.73077545,
            -334618133.76283896,
            -29014531.228382796
        ],
        [
            -203322821.89811194,
            -341575195.5847418,
            -32528256.08751284
        ],
        [
            -193142370.63072467,
            -348211402.3292249,
            -36025525.88621292
        ],
        [
            -182710944.81486768,
            -354516910.8544884,
            -39502278.53830592
        ],
        [
            -172038555.561313,
            -360482167.8178129,
            -42954421.21334243
        ],
        [
            -161135668.49732783,
            -366097933.28175676,
            -46377836.59132265
        ],
        [
            -150013196.66291034,
            -371355304.37967384,
            -49768389.413245164
        ],
        [
            -138682491.97714138,
            -376245738.9505428,
            -53121933.31496921
        ],
        [
            -127155335.24646391,
            -380761079.0489837,
            -56434317.929782994
        ],
        [
            -115443924.69315451,
            -384893574.23266774,
            -59701396.242967695
        ],
        [
            -103560862.98916653,
            -388635904.52612,
            -62919032.17955421
        ],
        [
            -91519142.78788489,
            -391981202.95724463,
            -66083108.40439906
        ],
        [
            -79332130.75407982,
            -394923077.560817,
            -69189534.31168573
        ],
        [
            -67013550.10045537,
            -397455632.7417296,
            -72234254.17899823
        ],
        [
            -54577461.64758903,
            -399573489.8899949,
            -75213255.45924158
        ],
        [
            -42038243.43270904,
            -401271807.13944244,
            -78122577.18191473
        ],
        [
            -29410568.9015761,
            -402546298.1627267,
            -80958318.433601
        ],
        [
            -16709383.726677775,
            -403393249.8967172,
            -83716646.88604075
        ],
        [
            -3949881.3039108515,
            -403809539.09459734,
            -86393807.3388208
        ],
        [
            8852523.011135459,
            -403792647.6040589,
            -88986130.24256295
        ],
        [
            21682218.857370585,
            -403340676.2748592,
            -91490040.16754532
        ],
        [
            34523428.93433276,
            -402452357.4036981,
            -93902064.18195657
        ],
        [
            47360238.09338838,
            -401127065.62986016,
            -96218840.10347944
        ],
        [
            60176623.35918078,
            -399364827.20134175,
            -98437124.58764027
        ],
        [
            72956484.77899128,
            -397166327.53819484,
            -100553801.01635408
        ],
        [
            85683676.99070162,
            -394532917.0275479,
            -102565887.15034717
        ],
        [
            98342041.3936753,
            -391466614.99315315,
            -104470542.50965966
        ],
        [
            110915438.80118991,
            -387970111.79129326,
            -106265075.4472173
        ],
        [
            123387782.44810659,
            -384046768.9944106,
            -107946949.88151675
        ],
        [
            135743071.22334173,
            -379700617.63381237,
            -109513791.65579014
        ],
        [
            147965422.9934336,
            -374936354.48317695,
            -110963394.49259046
        ],
        [
            160039107.88114482,
            -369759336.3752621,
            -112293725.5145683
        ],
        [
            171948581.36163282,
            -364175572.55509293,
            -113502930.30427274
        ],
        [
            183678517.0382789,
            -358191715.0839047,
            -114589337.47809473
        ],
        [
            195213838.9608237,
            -351815047.31911576,
            -115551462.7519597
        ],
        [
            206539753.35000378,
            -345053470.50654006,
            -116388012.47905014
        ],
        [
            217641779.59541783,
            -337915488.5317798,
            -117097886.64267085
        ],
        [
            228505780.39687005,
            -330410190.88820666,
            -117680181.29034229
        ],
        [
            239117990.92388862,
            -322547233.9290221,
            -118134190.39828807
        ],
        [
            249465046.8734929,
            -314336820.4805031,
            -118459407.15864833
        ],
        [
            259534011.3125136,
            -305789677.90260416,
            -118655524.68497115
        ],
        [
            269312400.197804,
            -296917034.69151,
            -118722436.1347804
        ],
        [
            278788206.4754668,
            -287730595.726453,
            -118660234.25126304
        ],
        [
            287949922.66865647,
            -278242516.2700517,
            -118469210.32932922
        ],
        [
            296786561.8725604,
            -268465374.8375387,
            -118149852.61445138
        ],
        [
            305287677.08468723,
            -258412145.05547637,
            -117702844.14575021
        ],
        [
            313443378.80854475,
            -248096166.63488117,
            -117129060.05774583
        ],
        [
            321244350.879045,
            -237531115.5870479,
            -116429564.35800093
        ],
        [
            328681864.4684662,
            -226730973.81278384,
            -115605606.20053178
        ],
        [
            335747790.2424075,
            -215709998.1972155,
            -114658615.67732765
        ],
        [
            342434608.6458147,
            -204482689.34282517,
            -113590199.1525834
        ],
        [
            348735418.3097345,
            -193063760.0729218,
            -112402134.16629843
        ],
        [
            354643942.5798708,
            -181468103.83638775,
            -111096363.93571143
        ],
        [
            360154534.1782012,
            -169710763.14228016,
            -109674991.48461913
        ],
        [
            365262178.0187608,
            -157806898.14978224,
            -108140273.43195562
        ],
        [
            369962492.208158,
            -145771755.53509986,
            -106494613.4720875
        ],
        [
            374251727.27036357,
            -133620637.75228351,
            -104740555.58010136
        ],
        [
            378126763.64376885,
            -121368872.7996561,
            -102880776.97593138
        ],
        [
            381585107.50636417,
            -109031784.59762928,
            -100918080.88149367
        ],
        [
            384624884.99211943,
            -96624664.07725087,
            -98855389.10506979
        ],
        [
            387244834.86819834,
            -84162741.07193998,
            -96695734.48702271
        ],
        [
            389444299.74849206,
            -71661157.09757954,
            -94442253.24054292
        ],
        [
            391223215.9240857,
            -59134939.09855533,
            -92098177.22052372
        ],
        [
            392582101.8956611,
            -46598974.229512274,
            -89666826.15286866
        ],
        [
            393522045.6964945,
            -34067985.734616965,
            -87151599.85555008
        ],
        [
            394044691.0976153,
            -21556509.97807318,
            -84555970.48159158
        ],
        [
            394152222.7888846,
            -9078874.671543151,
            -81883474.81284395
        ],
        [
            393847350.6312205,
            3350821.6638765037,
            -79137706.63199334
        ],
        [
            393133293.0759896,
            15718728.971383035,
            -76322309.19869372
        ],
        [
            392013759.84770876,
            28011263.645902663,
            -73440967.8540692
        ],
        [
            390492933.98570573,
            40215125.220723,
            -70497402.77611364
        ],
        [
            388575453.33930147,
            52317311.74606618,
            -67495361.90672947
        ],
        [
            386266391.6094438,
            64305133.859252825,
            -64438614.06932475
        ],
        [
            383571239.02758574,
            76166227.55267341,
            -61330942.29403652
        ],
        [
            380495882.76000977,
            87888565.65198149,
            -58176137.36578442
        ],
        [
            377046587.122792,
            99460468.0226806,
            -54977991.60850577
        ],
        [
            373229973.6892365,
            110870610.52864674,
            -51740292.91708157
        ],
        [
            369053001.3679248,
            122108032.7710251,
            -48466819.04665837
        ],
        [
            364522946.52557987,
            133162144.64039734,
            -45161332.167308
        ],
        [
            359647383.2247703,
            144022731.71913263,
            -41827573.69025418
        ],
        [
            354434163.64214224,
            154679959.5743643,
            -38469259.37025231
        ],
        [
            348891398.72838175,
            165124376.9851501,
            -35090074.68712801
        ],
        [
            343027439.166553,
            175346918.15001854,
            -31693670.507983074
        ],
        [
            336850856.6808369,
            185338903.923327,
            -28283659.030162286
        ],
        [
            330370425.7430618,
            195092042.13067374,
            -24863610.003741287
        ],
        [
            323595105.7198142,
            204598427.01499605,
            -21437047.231063098
        ],
        [
            316534023.4983482,
            213850537.86603013,
            -18007445.33969871
        ],
        [
            309196456.6250406,
            222841236.88645297,
            -14578226.824161015
        ],
        [
            301591816.9857515,
            231563766.34836873,
            -11152759.350738341
        ],
        [
            293729635.0532075,
            240011745.0938041,
            -7734353.3189526815
        ],
        [
            285619544.7224161,
            248179164.43259373,
            -4326259.672375834
        ],
        [
            277271268.75116724,
            256060383.49050075,
            -931667.9508516267
        ],
        [
            268694604.81892574,
            263650124.0596125,
            2446295.4244160093
        ],
        [
            259899412.213814,
            270943465.00205714,
            5804568.641963821
        ],
        [
            250895599.15401036,
            277935836.25687575,
            9140155.776837729
        ],
        [
            241693110.74669442,
            284623012.4985135,
            12450127.86285843
        ],
        [
            232301917.58468,
            291001106.49387926,
            15731623.770493522
        ],
        [
            222732004.97810954,
            297066562.2032649,
            18981850.900648553
        ],
        [
            212993362.8159962,
            302816147.6686746,
            22198085.704837758
        ],
        [
            203095976.0500422,
            308246947.731271,
            25377674.042275786
        ],
        [
            193049815.79099196,
            313356356.61773825,
            28518031.38445954
        ],
        [
            182864831.00580058,
            318142070.43341446,
            31616642.877790336
        ],
        [
            172550940.80213192,
            322602079.59805024,
            34671063.274712846
        ],
        [
            162118027.28509128,
            326734661.2580439,
            37678916.743741915
        ],
        [
            151575928.9696906,
            330538371.7069937,
            40637896.56859786
        ],
        [
            140934434.7312944,
            334012038.8443905,
            43545764.74649017
        ],
        [
            130203278.27520065,
            337154754.7002957,
            46400351.49538323
        ],
        [
            119392133.10558684,
            339965868.051869,
            49199554.67983797
        ],
        [
            108510607.97325009,
            342444977.1556951,
            51941339.1647719
        ],
        [
            97568242.7809152,
            344591922.6179586,
            54623736.1062028
        ],
        [
            86574504.92435583,
            346406780.4226824,
            57244842.18775231
        ],
        [
            75538786.04714124,
            347889855.1364552,
            59802818.81138714
        ],
        [
            64470399.186525375,
            349041673.30634004,
            62295891.250561364
        ],
        [
            53378576.28775939,
            349862977.0659925,
            64722347.77361119
        ],
        [
            42272466.06399903,
            350354717.96340007,
            67080538.74492778
        ],
        [
            31161132.178910494,
            350518051.02211726,
            69368875.7111145
        ],
        [
            20053551.729111224,
            350354329.0463865,
            71585830.47900817
        ],
        [
            8958614.00366813,
            349865097.17912257,
            73729934.19212225
        ],
        [
            -2114880.5019976795,
            349052087.72038746,
            75799776.41175058
        ],
        [
            -13158220.840240657,
            347917215.212694,
            77794004.20865206
        ],
        [
            -24162786.15558359,
            346462571.79825336,
            79711321.27092694
        ],
        [
            -35120046.04132281,
            344690422.85211486,
            81550487.03338887
        ],
        [
            -46021560.72999556,
            342603202.8940398,
            83310315.83343594
        ],
        [
            -56858981.13904865,
            340203511.7808976,
            84989676.0981336
        ],
        [
            -67624048.79268426,
            337494111.18037564,
            86587489.56693435
        ],
        [
            -78308595.64051561,
            334477921.32583874,
            88102730.55418167
        ],
        [
            -88904543.79328229,
            331158018.05127496,
            89534425.25527544
        ],
        [
            -99403905.19549114,
            327537630.10440075,
            90881651.1001104
        ],
        [
            -109798781.25447154,
            323620136.73517334,
            92143536.15714562
        ],
        [
            -120081362.44492477,
            319409065.5561774,
            93319258.59121071
        ],
        [
            -130243927.90766916,
            314908090.6705949,
            94408046.17791435
        ],
        [
            -140278845.06087732,
            310121031.06273925,
            95409175.87728167
        ],
        [
            -150178569.241709,
            305051849.2454423,
            96321973.46901698
        ],
        [
            -159935643.39586234,
            299704650.15789217,
            97145813.25156349
        ],
        [
            -169542697.8321577,
            294083680.30687,
            97880117.80690637
        ],
        [
            -178992450.05890128,
            288193327.1436772,
            98524357.83285181
        ]
    ],
    "(2019 AR8)": [
        [
            223400953.60692894,
            162763447.50789514,
            -27533523.11966508
        ],
        [
            218161236.62116265,
            169792228.40041846,
            -27288735.873572446
        ],
        [
            212731938.31908223,
            176676448.67946383,
            -27020345.291576143
        ],
        [
            207116168.72559145,
            183411931.9004476,
            -26728496.49946909
        ],
        [
            201317079.8755709,
            189994521.94753778,
            -26413339.420651365
        ],
        [
            195337868.90810215,
            196420080.1865928,
            -26075028.968882184
        ],
        [
            189181781.40957254,
            202684482.8450556,
            -25713725.273392588
        ],
        [
            182852114.99872172,
            208783618.629356,
            -25329593.93608072
        ],
        [
            176352223.1466319,
            214713386.59066677,
            -24922806.320516635
        ],
        [
            169685519.2245491,
            220469694.25020134,
            -24493539.872485217
        ],
        [
            162855480.7722323,
            226048455.9956034,
            -24041978.47179088
        ],
        [
            155865653.9792789,
            231445591.76038408,
            -23568312.815038785
        ],
        [
            148719658.37154296,
            236657025.9987826,
            -23072740.8290907
        ],
        [
            141421191.6943552,
            241678686.96887183,
            -22555468.114871223
        ],
        [
            133974034.983765,
            246506506.33718282,
            -22016708.421169337
        ],
        [
            126382057.81644453,
            251136419.11858934,
            -21456684.148041878
        ],
        [
            118649223.72822721,
            255564363.96565482,
            -20875626.8793783
        ],
        [
            110779595.79048811,
            259786283.82210106,
            -20273777.94412917
        ],
        [
            102777342.33270843,
            263798126.9555003,
            -19651389.00563394
        ],
        [
            94646742.79860155,
            267595848.38471264,
            -19008722.67840615
        ],
        [
            86392193.72210327,
            271175411.71797395,
            -18346053.17164495
        ],
        [
            78018214.80834845,
            274532791.41788995,
            -17663666.958640866
        ],
        [
            69529455.10346133,
            277663975.50987875,
            -16961863.471129972
        ],
        [
            60930699.235580996,
            280564968.7508388,
            -16240955.817523474
        ],
        [
            52226873.70802005,
            283231796.2749658,
            -15501271.523798833
        ],
        [
            43423053.22381714,
            285660507.7337153,
            -14743153.295683295
        ],
        [
            34524467.01919104,
            287847181.94686055,
            -13966959.800590161
        ],
        [
            25536505.181535408,
            289787932.08144784,
            -13173066.4675828
        ],
        [
            16464724.925614148,
            291478911.37516075,
            -12361866.303440008
        ],
        [
            7314856.799528778,
            292916319.42017156,
            -11533770.722679047
        ],
        [
            -1907189.2101623118,
            294096409.0229553,
            -10689210.38915953
        ],
        [
            -11195317.707083032,
            295015493.6547619,
            -9828636.066641752
        ],
        [
            -20543242.082721934,
            295669955.50645536,
            -8952519.475407965
        ],
        [
            -29944478.920902,
            296056254.1602247,
            -8061354.151773762
        ],
        [
            -39392342.64929955,
            296170935.8892329,
            -7155656.307020915
        ],
        [
            -48879940.480847955,
            296010643.59456426,
            -6235965.681972304
        ],
        [
            -58400167.69046746,
            295572127.3868602,
            -5302846.393105488
        ],
        [
            -67945703.27517818,
            294852255.81775534,
            -4356887.765765572
        ],
        [
            -77509006.04826526,
            293848027.7636435,
            -3398705.1496908115
        ],
        [
            -87082311.22073364,
            292556584.96138215,
            -2428940.711709163
        ],
        [
            -96657627.52579883,
            290975225.1922801,
            -1448264.2001015805
        ],
        [
            -106226734.94456676,
            289101416.1070825,
            -457373.6747618858
        ],
        [
            -115781183.09332997,
            286932809.680666,
            543003.8030838585
        ],
        [
            -125312290.335005,
            284467257.28076553,
            1552111.5282000545
        ],
        [
            -134811143.67912006,
            281702825.3302728,
            2569162.5626660343
        ],
        [
            -144268599.5363767,
            278637811.537471,
            3593339.208508949
        ],
        [
            -153675285.3951151,
            275270761.6629926,
            4623792.549283611
        ],
        [
            -163021602.487951,
            271600486.78632873,
            5659642.068548534
        ],
        [
            -172297729.51736364,
            267626081.0283719,
            6699975.353471352
        ],
        [
            -181493627.5090551,
            263346939.67977318,
            7743847.892048382
        ],
        [
            -190599045.86139065,
            258762777.67784768,
            8790282.97263448
        ],
        [
            -199603529.65812823,
            253873648.36741766,
            9838271.694644872
        ],
        [
            -208496428.30987623,
            248679962.47335857,
            10886773.099401942
        ],
        [
            -217266905.58722436,
            243182507.20478144,
            11934714.430149483
        ],
        [
            -225903951.10521948,
            237382465.4027763,
            12980991.53023763
        ],
        [
            -234396393.3147396,
            231281434.6355503,
            14024469.388384242
        ],
        [
            -242732914.05130777,
            224881446.1366676,
            15063982.839736175
        ],
        [
            -250902064.68593222,
            218184983.47404873,
            16098337.431178108
        ],
        [
            -258892283.91561794,
            211195000.82949036,
            17126310.45895971
        ],
        [
            -266691917.22323275,
            203914940.76084238,
            18146652.186227307
        ],
        [
            -274289238.0274085,
            196348751.31173244,
            19158087.247446757
        ],
        [
            -281672470.5330921,
            188500902.3269917,
            20159316.2459841
        ],
        [
            -288829814.28224844,
            180376400.8258335,
            21149017.550265692
        ],
        [
            -295749470.39205396,
            171980805.27950913,
            22125849.292965055
        ],
        [
            -302419669.4547541,
            163320238.63576227,
            23088451.57655856
        ],
        [
            -308828701.059233,
            154401399.9290567,
            24035448.887355305
        ],
        [
            -314964944.879326,
            145231574.31342676,
            24965452.71873869
        ],
        [
            -320816903.2580942,
            135818641.35402715,
            25877064.40286313
        ],
        [
            -326373235.2007791,
            126171081.41419157,
            26768878.148432814
        ],
        [
            -331622791.6721029,
            116297979.97717091,
            27639484.280459847
        ],
        [
            -336554652.0761298,
            106209029.74585687,
            28487472.67606567
        ],
        [
            -341158161.7792377,
            95914530.36978662,
            29311436.38846657
        ],
        [
            -345422970.51906466,
            85425385.65669233,
            30109975.44928635
        ],
        [
            -349339071.5248066,
            74753098.13585979,
            30881700.837285288
        ],
        [
            -352896841.1572004,
            63909760.85264456,
            31625238.599506382
        ],
        [
            -356087078.8601674,
            52908046.28769237,
            32339234.108739022
        ],
        [
            -358901047.2006909,
            41761192.31069434,
            33022356.43911557
        ],
        [
            -361330511.7593299,
            30482985.09685251,
            33673302.83961248
        ],
        [
            -363367780.6211014,
            19087738.9545393,
            34290803.28325721
        ],
        [
            -365005743.20557153,
            7590273.0348008275,
            34873625.06797313
        ],
        [
            -366237908.1661655,
            -3994115.082793653,
            35420577.44326252
        ],
        [
            -367058440.08215916,
            -15649678.908093572,
            35930516.23535988
        ],
        [
            -367462194.662844,
            -27360255.615629494,
            36402348.442121
        ],
        [
            -367444752.1821153,
            -39109301.60311973,
            36835036.76777365
        ],
        [
            -367002448.863461,
            -50879930.93086758,
            37227604.06677628
        ],
        [
            -366132405.94013065,
            -62654956.511076644,
            37579137.665435836
        ],
        [
            -364832556.12327814,
            -74416933.88752015,
            37888793.52965032
        ],
        [
            -363101667.2221343,
            -86148207.4178282,
            38155800.247185215
        ],
        [
            -360939362.67480385,
            -97830958.64330202,
            38379462.79328162
        ],
        [
            -358346138.7660389,
            -109447256.60503781,
            38559166.04913819
        ],
        [
            -355323378.3292213,
            -120979109.84066163,
            38694378.04391509
        ],
        [
            -351873360.75363386,
            -132408519.773538,
            38784652.89237547
        ],
        [
            -347999268.14469427,
            -143717535.18630186,
            38829633.40210096
        ],
        [
            -343705187.5139071,
            -154888307.45335004,
            38829053.32638259
        ],
        [
            -338996108.90651935,
            -165903146.19282368,
            38782739.24137485
        ],
        [
            -333877919.40790224,
            -176744574.98791802,
            38690612.02888669
        ],
        [
            -328357393.00408167,
            -187395386.82029983,
            38552687.94923615
        ],
        [
            -322442176.30719656,
            -197838698.85517332,
            38369079.29188002
        ],
        [
            -316140770.19247,
            -208058006.21824774,
            38139994.59500548
        ],
        [
            -309462507.42907184,
            -218037234.40956503,
            37865738.42889149
        ],
        [
            -302417526.4225248,
            -227760790.00784087,
            37546710.741566576
        ],
        [
            -295016741.22056496,
            -237213609.33158866,
            37183405.76905571
        ],
        [
            -287271807.9671347,
            -246381204.739664,
            36776410.516269706
        ],
        [
            -279195088.01999855,
            -255249708.27381188,
            36326402.81829564
        ],
        [
            -270799607.97589916,
            -263805912.3690198,
            35834148.9954433
        ],
        [
            -262099016.8728323,
            -272037307.38366765,
            35300501.11884199
        ],
        [
            -253107540.86156037,
            -279932115.73024726,
            34726393.90661733
        ],
        [
            -243839935.65763855,
            -287479322.4183726,
            34112841.273666434
        ],
        [
            -234311437.10074663,
            -294668701.85448265,
            33460932.560753044
        ],
        [
            -224537710.15985945,
            -301490840.7765776,
            32771828.47102915
        ],
        [
            -214534796.73064446,
            -307937157.2370357,
            32046756.744129896
        ],
        [
            -204319062.57541198,
            -313999915.581558,
            31287007.59966111
        ],
        [
            -193907143.75600636,
            -319672237.4070937,
            30493928.983192235
        ],
        [
            -183315892.90630597,
            -324948108.515744,
            29668921.64877094
        ],
        [
            -172562325.6836539,
            -329822381.9146982,
            28813434.112490598
        ],
        [
            -161663567.72778225,
            -334290776.94380116,
            27928957.511771835
        ],
        [
            -150636802.4418831,
            -338349874.6420281,
            27017020.404776663
        ],
        [
            -139499219.89370477,
            -341997109.4916241,
            26079183.54377432
        ],
        [
            -128267967.11527199,
            -345230757.70367223,
            25117034.6553455
        ],
        [
            -116960100.05836722,
            -348049922.23117197,
            24132183.259069808
        ],
        [
            -105592537.43967952,
            -350454514.71516097,
            23126255.55482282
        ],
        [
            -94182016.68487993,
            -352445234.58588445,
            22100889.40704459
        ],
        [
            -82745052.15523225,
            -354023545.5544466,
            21057729.452367302
        ],
        [
            -71297895.81405258,
            -355191649.74075794,
            19998422.354840934
        ],
        [
            -59856500.46377933,
            -355952459.6909457,
            18924612.230710644
        ],
        [
            -48436485.65793729,
            -356309568.54182065,
            17837936.26231285
        ],
        [
            -37053106.366217256,
            -356267218.5915943,
            16740020.518206175
        ],
        [
            -25721224.445535183,
            -355830268.53498554,
            15632475.994172245
        ],
        [
            -14455282.945545018,
            -355004159.61731684,
            14516894.88724137
        ],
        [
            -3269283.2539122105,
            -353794880.956396,
            13394847.112452373
        ],
        [
            7823234.935133606,
            -352208934.2731278,
            12267877.069667049
        ],
        [
            18809210.86564669,
            -350253298.2621489,
            11137500.665457578
        ],
        [
            29676077.233408093,
            -347935392.8225602,
            10005202.592887308
        ],
        [
            40411772.03990105,
            -345263043.3563136,
            8872433.869930046
        ],
        [
            51004747.87362626,
            -342244445.3282236,
            7740609.635338372
        ],
        [
            61443978.71860008,
            -338888129.2671668,
            6611107.198983617
        ],
        [
            71718964.40101469,
            -335202926.37303674,
            5485264.342062999
        ],
        [
            81819732.79434691,
            -331197934.878659,
            4364377.861105131
        ],
        [
            91736839.91072491,
            -326882487.3003326,
            3249702.348406147
        ],
        [
            101461368.01213907,
            -322266118.69515955,
            2142449.2003990114
        ],
        [
            110984921.87925379,
            -317358536.02800137,
            1043785.8444904741
        ],
        [
            120299623.37818818,
            -312169588.73592186,
            -45164.82590516284
        ],
        [
            129398104.4668292,
            -306709240.5634775,
            -1123324.8190574674
        ],
        [
            138273498.7821395,
            -300987542.7282864,
            -2189661.226763732
        ],
        [
            146919431.94861406,
            -295014608.4630766,
            -3243186.232135604
        ],
        [
            155330010.74570274,
            -288800588.96791786,
            -4282956.955355897
        ],
        [
            163499811.26872528,
            -282355650.7946647,
            -5308075.1495475415
        ],
        [
            171423866.21371776,
            -275689954.6748159,
            -6317686.758903258
        ],
        [
            179097651.41188398,
            -268813635.7920387,
            -7310981.351133592
        ],
        [
            186517071.73397195,
            -261736785.49155524,
            -8287191.436109936
        ],
        [
            193678446.4791099,
            -254469434.41041258,
            -9245591.682324354
        ],
        [
            200578494.3564722,
            -247021537.0053754,
            -10185498.04246338
        ],
        [
            207214318.16174695,
            -239402957.44874525,
            -11106266.7990148
        ],
        [
            213583389.24379385,
            -231623456.8568169,
            -12007293.540399043
        ],
        [
            219683531.85021812,
            -223692681.8108866,
            -12888012.077652542
        ],
        [
            225512907.43391228,
            -215620154.1266762,
            -13747893.311197244
        ],
        [
            231069998.99598077,
            -207415261.82472596,
            -14586444.056713782
        ],
        [
            236353595.5339458,
            -199087251.2516362,
            -15403205.838606969
        ],
        [
            241362776.65776053,
            -190645220.30001163,
            -16197753.659013482
        ],
        [
            246096897.42997766,
            -182098112.67348844,
            -16969694.749761015
        ],
        [
            250555573.48048472,
            -173454713.14227226,
            -17718667.314151682
        ],
        [
            254738666.4405191,
            -164723643.73414758,
            -18444339.26491084
        ],
        [
            258646269.73527175,
            -155913360.805847,
            -19146406.964124784
        ],
        [
            262278694.76927048,
            -147032152.93999863,
            -19824593.970485598
        ],
        [
            265636457.53391838,
            -138088139.61350995,
            -20478649.79867391
        ],
        [
            268720265.6620709,
            -129089270.58417428,
            -21108348.695243645
        ],
        [
            271531005.95034146,
            -120043325.94347031,
            -21713488.434924826
        ],
        [
            274069732.36595917,
            -110957916.78489503,
            -22293889.14083776
        ],
        [
            276337654.5514382,
            -101840486.43873025,
            -22849392.131710824
        ],
        [
            278336126.837057,
            -92698312.22583047,
            -23379858.798817724
        ],
        [
            280066637.768186,
            -83538507.6848061,
            -23885169.514998883
        ],
        [
            281530800.15181684,
            -74368025.22886385,
            -24365222.57780325
        ],
        [
            282730341.6242453,
            -65193659.19048011,
            -24819933.18848475
        ],
        [
            283667095.73970604,
            -56022049.2140495,
            -25249232.46830769
        ],
        [
            284342993.5778647,
            -46859683.95862293,
            -25653066.513359763
        ],
        [
            284760055.8663987,
            -37712905.07480101,
            -26031395.488838427
        ],
        [
            284920385.6134496,
            -28587911.421805978,
            -26384192.763564244
        ],
        [
            284826161.2434865,
            -19490763.49264331,
            -26711444.085285246
        ],
        [
            284479630.22905684,
            -10427388.017137095,
            -27013146.7971649
        ],
        [
            283883103.2100191,
            -1403582.7144090831,
            -27289309.095695157
        ],
        [
            283038948.5911311,
            7574978.831886992,
            -27539949.33014234
        ],
        [
            281949587.6082845,
            16502742.200602606,
            -27765095.343515888
        ],
        [
            280617489.8532352,
            25374267.085858032,
            -27964783.85494966
        ],
        [
            279045169.2463526,
            34184222.19747335,
            -28139059.883297823
        ],
        [
            277235180.44669485,
            42927380.12960918,
            -28287976.21167486
        ],
        [
            275190115.68859017,
            51598612.216826916,
            -28411592.89260805
        ],
        [
            272912602.0338737,
            60192883.39554371,
            -28509976.79342168
        ],
        [
            270405299.02895725,
            68705247.08772418,
            -28583201.18143342
        ],
        [
            267670896.75601375,
            77130840.12258476,
            -28631345.348513894
        ],
        [
            264712114.26770672,
            85464877.7111404,
            -28654494.274539523
        ],
        [
            261531698.39509332,
            93702648.48754412,
            -28652738.32925574
        ],
        [
            258132422.91856372,
            101839509.6303879,
            -28626173.012060937
        ],
        [
            254517088.0919372,
            109870882.07644778,
            -28574898.72922116
        ],
        [
            250688520.5101195,
            117792245.83873472,
            -28499020.608029928
        ],
        [
            246649573.3110186,
            125599135.4401995,
            -28398648.34743679
        ],
        [
            242403126.70271376,
            133287135.4739864,
            -28273896.104680073
        ],
        [
            237952088.80718124,
            140851876.30076754,
            -28124882.41747556
        ],
        [
            233299396.81216174,
            148289029.8934035,
            -27951730.16132957
        ],
        [
            228448018.42304838,
            155594305.8389503,
            -27754566.54156456
        ],
        [
            223400953.60692897,
            162763447.50789508,
            -27533523.11966508
        ]
    ],
    "(2019 LS1)": [
        [
            -335185835.40867263,
            169119198.15408546,
            67200082.21427894
        ],
        [
            -340345446.40919954,
            158255417.20711392,
            67805533.94635744
        ],
        [
            -345191520.089033,
            147243896.84875363,
            68348458.91540046
        ],
        [
            -349720188.4927405,
            136093141.66875517,
            68828414.71984006
        ],
        [
            -353927756.81691176,
            124811742.05619618,
            69244993.62281659
        ],
        [
            -357810704.29359436,
            113408373.8088186,
            69597822.70265265
        ],
        [
            -361365685.31792104,
            101891797.80099991,
            69886564.05022691
        ],
        [
            -364589530.82575387,
            90270859.69182165,
            70110915.01373203
        ],
        [
            -367479249.92637765,
            78554489.65434258,
            70270608.49114268
        ],
        [
            -370032031.79447275,
            66751702.10683538,
            70365413.27056059
        ],
        [
            -372245247.8247664,
            54871595.42640388,
            70395134.41844046
        ],
        [
            -374116454.05191845,
            42923351.62506002,
            70359613.7155326
        ],
        [
            -375643393.83731514,
            30916235.968014568,
            70258730.1402066
        ],
        [
            -376824000.82354903,
            18859596.513616413,
            70092400.39864445
        ],
        [
            -377656402.1564183,
            6762863.554070234,
            69860579.50120711
        ],
        [
            -378138921.97331524,
            -5364451.06422776,
            69563261.38409263
        ],
        [
            -378270085.1558595,
            -17512754.762171328,
            69200479.57520719
        ],
        [
            -378048621.3435849,
            -29672375.212929428,
            68772307.90296982
        ],
        [
            -377473469.2043954,
            -41833561.512349784,
            68278861.24656284
        ],
        [
            -376543780.95636964,
            -53986485.55689645,
            67720296.32592356
        ],
        [
            -375258927.13430387,
            -66121243.651399165,
            67096812.52954897
        ],
        [
            -373618501.5931577,
            -78227858.36902359,
            66408652.7779543
        ],
        [
            -371622326.7392731,
            -90296280.68595092,
            65656104.42038574
        ],
        [
            -369270458.9789113,
            -102316392.41329192,
            64839500.16214152
        ],
        [
            -366563194.3722576,
            -114278008.94873498,
            63959219.01959939
        ],
        [
            -363501074.479612,
            -126170882.37034388,
            63015687.299787164
        ],
        [
            -360084892.38498855,
            -137984704.89476445,
            62009379.601062015
        ],
        [
            -356315698.8808132,
            -149709112.72186816,
            60940819.83118917
        ],
        [
            -352194808.7958149,
            -161333690.28754193,
            59810582.23882634
        ],
        [
            -347723807.4465805,
            -172847974.94592437,
            58619292.454134196
        ],
        [
            -342904557.1915626,
            -184241462.10188013,
            57367628.53393844
        ],
        [
            -337739204.06461906,
            -195503610.81388187,
            56056322.00657469
        ],
        [
            -332230184.4634191,
            -206623849.8867374,
            54686158.911247894
        ],
        [
            -326380231.8662732,
            -217591584.4727355,
            53257980.82643846
        ],
        [
            -320192383.5491588,
            -228396203.19879276,
            51772685.88158927
        ],
        [
            -313669987.27289826,
            -239027085.83604413,
            50231229.746009625
        ],
        [
            -306816707.9086493,
            -249473611.52704245,
            48634626.58864091
        ],
        [
            -299636533.96805704,
            -259725167.58428198,
            46983950.00204183
        ],
        [
            -292133784.0026376,
            -269771158.87216705,
            45280333.88367304
        ],
        [
            -284313112.83521,
            -279601017.7827644,
            43524973.2672949
        ],
        [
            -276179517.58448213,
            -289204214.8137352,
            41719125.09703809
        ],
        [
            -267738343.44224387,
            -298570269.7547123,
            39864108.93647034
        ],
        [
            -258995289.1610453,
            -307688763.48607445,
            37961307.604765154
        ],
        [
            -249956412.20874533,
            -316549350.3915738,
            36012167.731883295
        ],
        [
            -240628133.5449378,
            -325141771.38358784,
            34018200.224508695
        ],
        [
            -231017241.97300732,
            -333455867.5368914,
            31980980.634340756
        ],
        [
            -221130898.0204562,
            -341481594.32379115,
            29902149.42023751
        ],
        [
            -210976637.29919952,
            -349209036.4402244,
            27783412.095633216
        ],
        [
            -200562373.29676935,
            -356628423.20900786,
            25626539.252622936
        ],
        [
            -189896399.5488134,
            -363730144.5428427,
            23433366.454118896
        ],
        [
            -178987391.14295316,
            -370504767.4459356,
            21205793.985543057
        ],
        [
            -167844405.5039909,
            -376943053.0292136,
            18945786.457630362
        ],
        [
            -156476882.41064975,
            -383035974.01008534,
            16655372.252081208
        ],
        [
            -144894643.19452178,
            -388774732.6635714,
            14336642.802023746
        ],
        [
            -133107889.07269192,
            -394150779.18739337,
            11991751.699527612
        ],
        [
            -121127198.56664073,
            -399155830.43931234,
            9622913.622757044
        ],
        [
            -108963523.96150053,
            -403781889.00065744,
            7232403.075761231
        ],
        [
            -96628186.76158188,
            -408021262.5156131,
            4822552.934378894
        ],
        [
            -84132872.10030898,
            -411866583.2514749,
            2395752.7922823057
        ],
        [
            -71489622.06531128,
            -415310827.8207712,
            -45552.89819506928
        ],
        [
            -58710827.90242712,
            -418347337.0018982,
            -2498866.89511339
        ],
        [
            -45809221.06580022,
            -420969835.5908044,
            -4961641.449767102
        ],
        [
            -32797863.085068524,
            -423172452.212276,
            -7431280.806383446
        ],
        [
            -19690134.22489044,
            -424949739.0156114,
            -9905143.920848358
        ],
        [
            -6499720.916695595,
            -426296691.1759231,
            -12380547.399659943
        ],
        [
            6759398.052412599,
            -427208766.119051,
            -14854768.659276571
        ],
        [
            20072966.60324374,
            -427681902.3851328,
            -17325049.304931507
        ],
        [
            33426467.68444407,
            -427712538.043309,
            -19788598.726835646
        ],
        [
            46805140.84646258,
            -427297628.5678774,
            -22242597.91048842
        ],
        [
            60194001.06080392,
            -426434664.08451056,
            -24684203.45657125
        ],
        [
            73577858.76906115,
            -425121685.8939329,
            -27110551.804613926
        ],
        [
            86941341.13922462,
            -423357302.17977744,
            -29518763.653312802
        ],
        [
            100268914.49955463,
            -421140702.807226,
            -31905948.569046196
        ],
        [
            113544907.91292879,
            -418471673.11953336,
            -34269209.77278818
        ],
        [
            126753537.84710002,
            -415350606.6406496,
            -36605649.09427873
        ],
        [
            139878933.88875002,
            -411778516.5939339,
            -38912372.080972426
        ],
        [
            152905165.44169086,
            -407757046.14939946,
            -41186493.24797672
        ],
        [
            165816269.34208804,
            -403288477.3150679,
            -43425141.45391158
        ],
        [
            178596278.3162327,
            -398375738.3918381,
            -45625465.386389464
        ],
        [
            191229250.1992326,
            -393022409.9158044,
            -47784639.13963885
        ],
        [
            203699297.8261119,
            -387232729.01717085,
            -49899867.86569198
        ],
        [
            215990619.50024194,
            -381011592.1307981,
            -51968393.47953364
        ],
        [
            228087529.93787724,
            -374364555.999966,
            -53987500.39768292
        ],
        [
            239974491.5818813,
            -367297836.92209935,
            -55954521.288858384
        ],
        [
            251636146.17257333,
            -359818308.19296277,
            -57866842.814674504
        ],
        [
            263057346.45907712,
            -351933495.7141313,
            -59721911.3377417
        ],
        [
            274223187.9306508,
            -343651571.73733556,
            -61517238.57410358
        ],
        [
            285119040.4442952,
            -334981346.7285042,
            -63250407.16665165
        ],
        [
            295730579.62251604,
            -325932259.34392595,
            -64919076.15601676
        ],
        [
            306043817.89348924,
            -316514364.52083695,
            -66520986.325452
        ],
        [
            316045135.04510814,
            -306738319.69485897,
            -68053965.39640158
        ],
        [
            325721308.16447544,
            -296615369.16695595,
            -69515933.05179195
        ],
        [
            335059540.8353771,
            -286157326.65288746,
            -70904905.76459008
        ],
        [
            344047491.4681609,
            -275376556.0584049,
            -72219001.409848
        ],
        [
            352673300.63920945,
            -264285950.53358436,
            -73456443.63928641
        ],
        [
            360925617.32087284,
            -252898909.86962694,
            -74615565.99846472
        ],
        [
            368793623.8872732,
            -241229316.31108934,
            -75694815.76773001
        ],
        [
            376267059.78678244,
            -229291508.86575192,
            -76692757.50942579
        ],
        [
            383336243.7781887,
            -217100256.2031011,
            -77608076.3052665
        ],
        [
            389992094.6345393,
            -204670728.24061581,
            -78439580.66933173
        ],
        [
            396226150.2263341,
            -192018466.52463216,
            -79186205.12379237
        ],
        [
            402030584.9040931,
            -179159353.51944008,
            -79847012.42624052
        ],
        [
            407398225.1092359,
            -166109580.9243879,
            -80421195.43933345
        ],
        [
            412322563.1516483,
            -152885617.14406425,
            -80908078.63537113
        ],
        [
            416797769.1021701,
            -139504174.04106563,
            -81307119.23038626
        ],
        [
            420818700.758433,
            -125982173.10438536,
            -81617907.9443182
        ],
        [
            424380911.65293026,
            -112336711.16905862,
            -81840169.38585293
        ],
        [
            427480657.0828149,
            -98585025.82435435,
            -81973762.06252053
        ],
        [
            430114898.15159833,
            -84744460.64849259,
            -82018678.01863353
        ],
        [
            432281303.823582,
            -70832430.40760982,
            -81975042.10560639
        ],
        [
            433978251.0023956,
            -56866386.355490774,
            -81843110.8911022
        ],
        [
            435204822.6553526,
            -42863781.76846239,
            -81623271.21529137
        ],
        [
            435960804.0153878,
            -28842037.84683034,
            -81316038.40426518
        ],
        [
            436246676.90201676,
            -14818510.110381395,
            -80922054.15230851
        ],
        [
            436063612.2119957,
            -810455.4108038843,
            -80442084.08629051
        ],
        [
            435413460.6390808,
            13165000.321528107,
            -79877015.02686892
        ],
        [
            434298741.6904274,
            27090893.485058874,
            -79227851.96250974
        ],
        [
            432722631.0746838,
            40950453.26421288,
            -78495714.75349654
        ],
        [
            430688946.5436616,
            54727131.038838685,
            -77681834.58413152
        ],
        [
            428202132.2755859,
            68404628.65629873,
            -76787550.18221225
        ],
        [
            425267241.8932831,
            81966925.48468894,
            -75814303.8255975
        ],
        [
            421889920.21526927,
            95398304.17411825,
            -74763637.15625535
        ],
        [
            418076383.84150255,
            108683375.06164673,
            -73637186.82261173
        ],
        [
            413833400.6785933,
            121807099.1643227,
            -72436679.97129422
        ],
        [
            409168268.5114929,
            134754809.71365657,
            -71163929.60949431
        ],
        [
            404088792.73014784,
            147512232.19379407,
            -69820829.85915588
        ],
        [
            398603263.3203043,
            160065502.85448593,
            -68409351.12404671
        ],
        [
            392720431.2276229,
            172401185.67866206,
            -66931535.19048601
        ],
        [
            386449484.20352304,
            184506287.7929243,
            -65389490.28209469
        ],
        [
            379800022.2397886,
            196368273.3175042,
            -63785386.08841665
        ],
        [
            372782032.6969311,
            207975075.66017884,
            -62121448.78663023
        ],
        [
            365405865.2287091,
            219315108.26619133,
            -60399956.074850544
        ],
        [
            357682206.60206723,
            230377273.8433863,
            -58623232.234715685
        ],
        [
            349622055.5081282,
            241150972.0885048,
            -56793643.24006696
        ],
        [
            341236697.45583487,
            251626105.94681686,
            -54913591.927589744
        ],
        [
            332537679.8354031,
            261793086.44304895,
            -52985513.24427963
        ],
        [
            323536787.23400116,
            271642836.1267972,
            -51011869.58555656
        ],
        [
            314246017.0810559,
            281166791.18034375,
            -48995146.23677443
        ],
        [
            304677555.6953417,
            290356902.2409998,
            -46937846.92977244
        ],
        [
            294843754.80062103,
            299205633.993745,
            -44842489.525004506
        ],
        [
            284757108.5710763,
            307705963.59308964,
            -42711601.82866369
        ],
        [
            274430231.2621968,
            315851377.9756921,
            -40547717.55310629
        ],
        [
            263875835.47717974,
            323635870.1273813,
            -38353372.42777989
        ],
        [
            253106711.11330163,
            331053934.36986303,
            -36131100.46677456
        ],
        [
            242135705.0272071,
            338100560.7335301,
            -33883430.39806336
        ],
        [
            230975701.4526023,
            344771228.48351336,
            -31612882.258469593
        ],
        [
            219639603.19854316,
            351061898.8663823,
            -29321964.157411978
        ],
        [
            208140313.65134817,
            356969007.1447857,
            -27013169.211531274
        ],
        [
            196490719.59817797,
            362489453.98684293,
            -24688972.65139761
        ],
        [
            184703674.8855631,
            367620596.27625376,
            -22351829.10064624
        ],
        [
            172791984.9215876,
            372360237.40796804,
            -20004170.027082317
        ],
        [
            160768392.0261309,
            376706617.1328163,
            -17648401.364546813
        ],
        [
            148645561.62948194,
            380658401.01284057,
            -15286901.303634858
        ],
        [
            136436069.31582814,
            384214669.54715335,
            -12922018.248716012
        ],
        [
            124152388.70457056,
            387374907.02606547,
            -10556068.938116983
        ],
        [
            111806880.15911019,
            390138990.16896063,
            -8191336.723790228
        ],
        [
            99411780.30974743,
            392507176.5989927,
            -5830070.006314371
        ],
        [
            86979192.37455997,
            394480093.205174,
            -3474480.820639994
        ],
        [
            74521077.25963937,
            396058724.4398146,
            -1126743.567619536
        ],
        [
            62049245.41782868,
            397244400.5966084,
            1211006.1139680967
        ],
        [
            49575349.44310363,
            398038786.11194867,
            3536672.3404698223
        ],
        [
            37110877.37601377,
            398443867.92931986,
            5848199.8472904675
        ],
        [
            24667146.694068193,
            398461943.96386635,
            8143574.729702406
        ],
        [
            12255298.959676057,
            398095611.7015135,
            10420825.066678867
        ],
        [
            -113704.90282568336,
            397347756.964302,
            12678021.434009224
        ],
        [
            -12429088.730409235,
            396221542.87093693,
            14913277.31303303
        ],
        [
            -24680264.67487988,
            394720399.0189325,
            17124749.401369587
        ],
        [
            -36856836.21723336,
            392848010.9121804,
            19310637.832035266
        ],
        [
            -48948600.67372835,
            390608309.65528405,
            21469186.307323564
        ],
        [
            -60945551.22474757,
            388005461.9335977,
            23598682.153781373
        ],
        [
            -72837878.49758592,
            385043860.29558146,
            25697456.304553036
        ],
        [
            -84615971.73421095,
            381728113.75185376,
            27763883.215275552
        ],
        [
            -96270419.57486959,
            378063038.7031765,
            29796380.71960815
        ],
        [
            -107792010.48810875,
            374053650.2075644,
            31793409.83035803
        ],
        [
            -119171732.87739034,
            369705153.59475833,
            33753474.4920304
        ],
        [
            -130400774.89402264,
            365022936.4344454,
            35675121.29048738
        ],
        [
            -141470523.98556915,
            360012560.8628597,
            37556939.125240974
        ],
        [
            -152372566.2083121,
            354679756.2707268,
            39397558.84974457
        ],
        [
            -163098685.33166647,
            349030412.35395867,
            41195652.88487231
        ],
        [
            -173640861.76175565,
            343070572.52702665,
            42949934.81060177
        ],
        [
            -183991271.31060445,
            336806427.6975548,
            44659158.9407329
        ],
        [
            -194142283.8366313,
            330244310.3993863,
            46322119.885291
        ],
        [
            -204086461.78133535,
            323390689.2801506,
            47937652.10507937
        ],
        [
            -213816558.6262403,
            316252163.93823546,
            49504629.46265554
        ],
        [
            -223325517.29334366,
            308835460.10300094,
            51021964.773822956
        ],
        [
            -232606468.51147068,
            301147425.15108716,
            52488609.36354085
        ],
        [
            -241652729.17009032,
            293195023.9507507,
            53903552.62997087
        ],
        [
            -250457800.68131742,
            284985335.02529997,
            55265821.62019791
        ],
        [
            -259015367.36996573,
            276525547.0259066,
            56574480.62097866
        ],
        [
            -267319294.91069573,
            267822955.5033193,
            57828630.76769643
        ],
        [
            -275363628.8304622,
            258884959.9673136,
            59027409.67452356
        ],
        [
            -283142593.0936402,
            249719061.22206104,
            60169991.088619955
        ],
        [
            -290650588.78640634,
            240332858.96498522,
            61255584.57102885
        ],
        [
            -297882192.91613185,
            230734049.63610935,
            62283435.2067615
        ],
        [
            -304832157.3407648,
            220930424.50435102,
            63252823.34640123
        ],
        [
            -311495407.84238267,
            210929867.9767142,
            64163064.38139479
        ],
        [
            -317867043.35832334,
            200740356.11584806,
            65013508.55504073
        ],
        [
            -323942335.3825414,
            190369955.3509696,
            65803540.81102886
        ],
        [
            -329716727.5490631,
            179826821.36671993,
            66532580.68122941
        ],
        [
            -335185835.4086726,
            169119198.15408555,
            67200082.21427894
        ]
    ],
    "(2019 QS6)": [
        [
            268891725.5677847,
            88238331.11955868,
            -63750685.14395224
        ],
        [
            265700159.0859945,
            96748173.34599784,
            -64886273.000160575
        ],
        [
            262287103.5472763,
            105180606.54260501,
            -65968412.96819177
        ],
        [
            258654081.61947277,
            113531397.83489737,
            -66996529.03505233
        ],
        [
            254802618.9619641,
            121796302.54564673,
            -67970043.36575685
        ],
        [
            250734247.11360726,
            129971058.76751556,
            -68888375.72579512
        ],
        [
            246450506.7099541,
            138051382.06463316,
            -69750942.98580186
        ],
        [
            241952951.02997905,
            146032960.31063926,
            -70557158.70995961
        ],
        [
            237243149.87313116,
            153911448.67133552,
            -71306432.82988647
        ],
        [
            232322693.76806027,
            161682464.7407882,
            -71998171.40599187
        ],
        [
            227193198.51483616,
            169341583.84051627,
            -72631776.47852151
        ],
        [
            221856310.06288144,
            176884334.49227598,
            -73206646.01075394
        ],
        [
            216313709.72716984,
            184306194.07591623,
            -73722173.92706062
        ],
        [
            210567119.74548447,
            191602584.68482777,
            -74177750.24878938
        ],
        [
            204618309.17969364,
            198768869.19264174,
            -74572761.33118442
        ],
        [
            198469100.16405988,
            205800347.54604614,
            -74906590.20480539
        ],
        [
            192121374.50355336,
            212692253.29988566,
            -75178617.0251581
        ],
        [
            185577080.62498552,
            219439750.4120828,
            -75388219.63449341
        ],
        [
            178838240.88348803,
            226037930.31736565,
            -75534774.23996812
        ],
        [
            171906959.22644842,
            232481809.3003108,
            -75617656.21259198
        ],
        [
            164785429.21644145,
            238766326.1897942,
            -75636241.01159963
        ],
        [
            157475942.41397205,
            244886340.39859617,
            -75589905.23908983
        ],
        [
            149980897.11994702,
            250836630.33361045,
            -75478027.8299563
        ],
        [
            142302807.47670776,
            256611892.20386094,
            -75299991.38229579
        ],
        [
            134444312.92517865,
            262206739.25532514,
            -75055183.63361377
        ],
        [
            126408188.01418547,
            267615701.46338132,
            -74742999.08825031
        ],
        [
            118197352.5562821,
            272833225.71553695,
            -74362840.80151802
        ],
        [
            109814882.12245369,
            277853676.51893276,
            -73914122.32606763
        ],
        [
            101264018.86584608,
            282671337.2689421,
            -73396269.82597744
        ],
        [
            92548182.66217588,
            287280412.11697584,
            -72808724.36398725
        ],
        [
            83670982.5516945,
            291675028.47733563,
            -72150944.36716166
        ],
        [
            74636228.46449871,
            295849240.21461797,
            -71422408.27606668
        ],
        [
            65447943.20758557,
            299797031.5547156,
            -70622617.38226417
        ],
        [
            56110374.68832864,
            303512321.76387644,
            -69751098.85856895
        ],
        [
            46628008.34499669,
            306988970.64152354,
            -68807408.98606059
        ],
        [
            37005579.750538215,
            310220784.8735665,
            -67791136.5812893
        ],
        [
            27248087.35110341,
            313201525.2937267,
            -66701906.6264536
        ],
        [
            17360805.295679167,
            315924915.10088754,
            -65539384.10454723
        ],
        [
            7349296.307758287,
            318384649.0806328,
            -64303278.040564485
        ],
        [
            -2780575.455826625,
            320574403.87890196,
            -62993345.7488094
        ],
        [
            -13022631.6199051,
            322487849.3749999,
            -61609397.285163015
        ],
        [
            -23370366.94725135,
            324118661.2000178,
            -60151300.101818934
        ],
        [
            -33816936.91032961,
            325460534.4449624,
            -58618983.90049054
        ],
        [
            -44355145.55968636,
            326507198.6005131,
            -57012445.67841633
        ],
        [
            -54977433.77739918,
            327252433.767255,
            -55331754.95963889
        ],
        [
            -65675868.011387825,
            327690088.1713974,
            -53577059.201999396
        ],
        [
            -76442129.5939124,
            327814097.01633734,
            -51748589.368075356
        ],
        [
            -87267504.75514525,
            327618502.69487214,
            -49846665.645887196
        ],
        [
            -98142875.45023096,
            327097476.3803653,
            -47871703.30261734
        ],
        [
            -109058711.1256546,
            326245341.00764734,
            -45824218.65182101
        ],
        [
            -120005061.55790429,
            325056595.6458465,
            -43704835.11167438
        ],
        [
            -130971550.90423548,
            323525941.25563174,
            -41514289.32870929
        ],
        [
            -141947373.11167687,
            321648307.8124842,
            -39253437.33824143
        ],
        [
            -152921288.83612123,
            319418882.7655573,
            -36923260.72933116
        ],
        [
            -163881624.0282633,
            316833140.7884262,
            -34524872.778643504
        ],
        [
            -174816270.3471022,
            313886874.76357126,
            -32059524.514031433
        ],
        [
            -185712687.5645451,
            310576227.92679524,
            -29528610.66508324
        ],
        [
            -196557908.12613785,
            306897727.0809963,
            -26933675.454297017
        ],
        [
            -207338544.03290406,
            302848316.77085954,
            -24276418.17901673
        ],
        [
            -218040796.20750427,
            298425394.29119295,
            -21558698.53083902
        ],
        [
            -228650466.50422096,
            293626845.38193136,
            -18782541.595937558
        ],
        [
            -239152972.5164255,
            288451080.4424235,
            -15950142.476716958
        ],
        [
            -249533365.32701224,
            282897071.07668877,
            -13063870.472471341
        ],
        [
            -259776350.33659154,
            276964386.76009804,
            -10126272.75435938
        ],
        [
            -269866311.29085577,
            270653231.39666444,
            -7140077.468098417
        ],
        [
            -279787337.6123422,
            263964479.51510707,
            -4108196.196405478
        ],
        [
            -289523255.12267286,
            256899711.83141652,
            -1033725.7124608234
        ],
        [
            -299057660.2192059,
            249461249.88615137,
            2080051.0443784073
        ],
        [
            -308373957.544832,
            241652189.44654447,
            5229664.83864411
        ],
        [
            -317455401.1614197,
            233476432.34708846,
            8411460.921021856
        ],
        [
            -326285139.2062225,
            224938716.42807955,
            11621600.786675133
        ],
        [
            -334846261.9765525,
            216044643.22004607,
            14856064.969923839
        ],
        [
            -343121853.35139525,
            206800703.01356065,
            18110656.930935934
        ],
        [
            -351095045.4196745,
            197214296.94909024,
            21381008.084343597
        ],
        [
            -358749076.1439247,
            187293755.76070306,
            24662584.01281266
        ],
        [
            -366067349.8456207,
            177048354.81107807,
            27950691.900559433
        ],
        [
            -373033500.2548655,
            166488325.06370103,
            31240489.212643348
        ],
        [
            -379631455.8231261,
            155624859.6517346,
            34526993.635595016
        ],
        [
            -385845506.9538847,
            144470115.7220791,
            37805094.28362988
        ],
        [
            -391660374.76316327,
            133037211.25777186,
            41069564.16243472
        ],
        [
            -397061280.94064295,
            121340216.61221728,
            44315073.86940961
        ],
        [
            -402034018.2433493,
            109394140.52477899,
            47536206.49544212
        ],
        [
            -406565021.1184386,
            97214910.42887604,
            50727473.67895383
        ],
        [
            -410641435.920345,
            84819346.91066901,
            53883332.74828072
        ],
        [
            -414251190.1612531,
            72225132.22832005,
            56998204.87364821
        ],
        [
            -417383060.21334136,
            59450772.858159766,
            60066494.13531348
        ],
        [
            -420026736.8672387,
            46515556.09426971,
            63082607.40012221
        ],
        [
            -422172888.14430207,
            33439500.791216075,
            66040974.88503295
        ],
        [
            -423813218.7612161,
            20243302.405095443,
            68936071.27336162
        ],
        [
            -424940525.6544697,
            6948272.554685503,
            71762437.2378646
        ],
        [
            -425548748.989776,
            -6423726.608722672,
            74514701.21456963
        ],
        [
            -425633018.1075912,
            -19850352.868428797,
            77187601.2627252
        ],
        [
            -425189691.89053833,
            -33308858.828315884,
            79776006.83959739
        ],
        [
            -424216393.08150667,
            -46776170.7393496,
            82274940.31429228
        ],
        [
            -422712036.1321072,
            -60228970.7323565,
            84679598.04248682
        ],
        [
            -420676848.21939373,
            -73643781.87261835,
            86985370.82402718
        ],
        [
            -418112383.13358825,
            -86997055.40824974,
            89187863.56788494
        ],
        [
            -415021527.8100103,
            -100265259.54834312,
            91282913.99396375
        ],
        [
            -411408501.3534644,
            -113424969.07930091,
            93266610.20871067
        ],
        [
            -407278846.48176473,
            -126452955.10926108,
            95135307.00131752
        ],
        [
            -402639413.3956028,
            -139326274.22154325,
            96885640.71938008
        ],
        [
            -397498336.16320837,
            -152022356.31888402,
            98514542.59703343
        ],
        [
            -391865001.788852,
            -164519090.45095664,
            100019250.42457654
        ],
        [
            -385750012.2127784,
            -176794907.93817604,
            101397318.46617772
        ],
        [
            -379165139.565302,
            -188828862.1347198,
            102646625.55111185
        ],
        [
            -372123275.0682651,
            -200600704.2125338,
            103765381.28379796
        ],
        [
            -364638372.04165465,
            -212090954.3951199,
            104752130.3383354
        ],
        [
            -356725383.5308892,
            -223280968.12423462,
            105605754.82392779
        ],
        [
            -348400195.120185,
            -234152996.70325935,
            106325474.72817665
        ],
        [
            -339679553.53882176,
            -244690242.0267849,
            106910846.46537851
        ],
        [
            -330580991.6995015,
            -254876905.07567903,
            107361759.57633668
        ],
        [
            -321122750.8310177,
            -264698227.92930496,
            107678431.64449595
        ],
        [
            -311323700.38099056,
            -274140529.1203514,
            107861401.51014954
        ],
        [
            -301203256.3685713,
            -283191232.2316354,
            107911520.87981299
        ],
        [
            -290781298.8620026,
            -291838887.707041,
            107829944.44141084
        ],
        [
            -280078089.24221015,
            -300073187.91928166,
            107618118.60752548
        ],
        [
            -269114187.89175785,
            -307884975.6043793,
            107277769.01850443
        ],
        [
            -257910372.9192551,
            -315266245.8356871,
            106810886.94464931
        ],
        [
            -246487560.49350238,
            -322210141.7681328,
            106219714.73200208
        ],
        [
            -234866727.32019156,
            -328710944.4354732,
            105506730.43942426
        ],
        [
            -223068835.74783462,
            -334764056.92919177,
            104674631.81580012
        ],
        [
            -211114761.93976957,
            -340365983.32690173,
            103726319.76538575
        ],
        [
            -199025227.49659097,
            -345514302.7705009,
            102664881.44670254
        ],
        [
            -186820734.85916808,
            -350207639.119819,
            101493573.1460945
        ],
        [
            -174521506.7674983,
            -354445626.6261499,
            100215803.06131086
        ],
        [
            -162147429.9958775,
            -358228872.0820801,
            98835114.12342864
        ],
        [
            -149718003.53108978,
            -361558913.9096937,
            97355166.97729628
        ],
        [
            -137252291.30824685,
            -364438178.6489604,
            95779723.23166291
        ],
        [
            -124768879.56918882,
            -366869935.3023503,
            94112629.08045955
        ],
        [
            -112285838.8615559,
            -368858247.98100483,
            92357799.38652174
        ],
        [
            -99820690.65315248,
            -370407927.2826874,
            90519202.30856758
        ],
        [
            -87390378.49645826,
            -371524480.8128339,
            88600844.54165787
        ],
        [
            -75011243.64229025,
            -372214063.2379341,
            86606757.2308207
        ],
        [
            -62699004.96985358,
            -372483426.23578125,
            84540982.60716727
        ],
        [
            -50468743.07283653,
            -372339868.6804397,
            82407561.3857929
        ],
        [
            -38334888.31773998,
            -371791187.37163496,
            80210520.95514764
        ],
        [
            -26311212.67126727,
            -370845628.5892049,
            77953864.37847176
        ],
        [
            -14410825.078162238,
            -369511840.72375417,
            75641560.21939456
        ],
        [
            -2646170.159181088,
            -367798828.2051453,
            73277533.19593884
        ],
        [
            8970970.009261578,
            -365715906.9213636,
            70865655.6600097
        ],
        [
            20429471.277152106,
            -363272661.29191536,
            68409739.8929814
        ],
        [
            31718860.209924906,
            -360478903.1325724,
            65913531.20225412
        ],
        [
            42829304.52900307,
            -357344632.42220145,
            63380701.798623234
        ],
        [
            53751601.4451843,
            -353880000.0577879,
            60814845.42997045
        ],
        [
            64477164.120953165,
            -350095272.6607565,
            58219472.74313781
        ],
        [
            74998006.4907737,
            -346000799.4763842,
            55598007.34283647
        ],
        [
            85306726.6598602,
            -341606981.3885805,
            52953782.51404993
        ],
        [
            95396489.09214857,
            -336924242.0546029,
            50290038.572567895
        ],
        [
            105261005.78745553,
            -331963001.14837617,
            47609920.80698632
        ],
        [
            114894516.63631938,
            -326733649.6869851,
            44916477.97469678
        ],
        [
            124291769.12904532,
            -321246527.40254897,
            42212661.31399987
        ],
        [
            133447997.58315569,
            -315511902.11100703,
            39501324.03448519
        ],
        [
            142358902.0410222,
            -309539951.0202693,
            36785221.24816081
        ],
        [
            151020626.97702414,
            -303340743.912613,
            34067010.304455996
        ],
        [
            159429739.94130972,
            -296924228.1300565,
            31349251.493114874
        ],
        [
            167583210.25524583,
            -290300215.2865772,
            28634409.080099024
        ],
        [
            175478387.8619951,
            -283478369.6274009,
            25924852.64290145
        ],
        [
            183112982.4244812,
            -276468197.9530108,
            23222858.67308734
        ],
        [
            190485042.75231224,
            -269279041.02395046,
            20530612.415405124
        ],
        [
            197592936.62910378,
            -261920066.36178097,
            17850209.914414223
        ],
        [
            204435331.1021088,
            -254400262.36161405,
            15183660.241227679
        ],
        [
            211011173.2871245,
            -246728433.63238764,
            12532887.874654792
        ],
        [
            217319671.73335123,
            -238913197.4823647,
            9899735.212715812
        ],
        [
            223360278.3851938,
            -230962981.4691554,
            7285965.1921842955
        ],
        [
            229132671.1709435,
            -222886021.9357984,
            4693263.995468661
        ],
        [
            234636737.24183917,
            -214690363.45700008,
            2123243.825760659
        ],
        [
            239872556.87915128,
            -206383859.1224883,
            -422554.26704823226
        ],
        [
            244840388.08166623,
            -197974171.5874821,
            -2942657.525672078
        ],
        [
            249540651.841222,
            -189468774.82349998,
            -5435658.60449595
        ],
        [
            253973918.1097452,
            -180874956.5060468,
            -7900212.681559883
        ],
        [
            258140892.4575429,
            -172199820.97909486,
            -10335034.575315356
        ],
        [
            262042403.4193548,
            -163450292.73969194,
            -12738895.87677285
        ],
        [
            265679390.52187747,
            -154633120.38941416,
            -15110622.10650732
        ],
        [
            269052892.9840684,
            -145754881.002747,
            -17449089.904909138
        ],
        [
            272164039.0795151,
            -136821984.86577612,
            -19753224.26306634
        ],
        [
            275014036.1484798,
            -127840680.541773,
            -22021995.800741635
        ],
        [
            277604161.24586034,
            -118817060.22338885,
            -24254418.09705268
        ],
        [
            279935752.4102425,
            -109757065.3341547,
            -26449545.078689557
        ],
        [
            282010200.53839624,
            -100666492.34487507,
            -28606468.469789866
        ],
        [
            283828941.84900355,
            -91550998.77323404,
            -30724315.30695362
        ],
        [
            285393450.9190303,
            -82416109.33754052,
            -32802245.522299543
        ],
        [
            286705234.27599025,
            -73267222.23800334,
            -34839449.596947804
        ],
        [
            287765824.5293384,
            -64109615.54122722,
            -36835146.28685741
        ],
        [
            288576775.0243804,
            -54948453.64580391,
            -38788580.42253927
        ],
        [
            289139655.00235754,
            -45788793.80887547,
            -40699020.783817135
        ],
        [
            289456045.2507622,
            -36635592.715427876,
            -42565758.05050349
        ],
        [
            289527534.22842515,
            -27493713.0738014,
            -44388102.82959957
        ],
        [
            289355714.65049607,
            -18367930.22247894,
            -46165383.75941641
        ],
        [
            288942180.51908475,
            -9262938.734673321,
            -47896945.69083603
        ],
        [
            288288524.5860425,
            -183359.00853042305,
            -49582147.94579792
        ],
        [
            287396336.2351184,
            8866256.168051153,
            -51220362.65299156
        ],
        [
            286267199.77153087,
            17881415.087934926,
            -52810973.160666876
        ],
        [
            284902693.10781974,
            26857680.63963464,
            -54353372.52643549
        ],
        [
            283304386.83570516,
            35790663.87480066,
            -55846962.08392348
        ],
        [
            281473843.6745427,
            44676017.63586189,
            -57291150.086151995
        ],
        [
            279412618.28785187,
            53509430.2508049,
            -58685350.42556108
        ],
        [
            277122257.46027166,
            62286619.30161591,
            -60028981.43065289
        ],
        [
            274604300.62818086,
            71003325.47257414,
            -61321464.73931568
        ],
        [
            271860280.75809175,
            79655306.4843276,
            -62562224.24898876
        ],
        [
            268891725.5677847,
            88238331.11955862,
            -63750685.143952236
        ]
    ],
    "(2019 YA5)": [
        [
            -240094570.84375295,
            201432050.08244228,
            -510934.208277871
        ],
        [
            -246326617.4060765,
            193801592.3643717,
            413408.73880834406
        ],
        [
            -252353878.4088035,
            186006061.65170556,
            1337696.337779432
        ],
        [
            -258173048.0936537,
            178049428.3328259,
            2261443.9008616437
        ],
        [
            -263780823.66909608,
            169935681.17556006,
            3184165.57532389
        ],
        [
            -269173902.16179425,
            161668832.60037667,
            4105373.7730784533
        ],
        [
            -274348977.5877849,
            153252924.18488148,
            5024578.602295182
        ],
        [
            -279302738.45155483,
            144692032.39353174,
            5941287.301954772
        ],
        [
            -284031865.58193165,
            135990274.52658486,
            6855003.680303857
        ],
        [
            -288533030.3144913,
            127151814.88229583,
            7765227.55822127
        ],
        [
            -292802893.03101915,
            118180871.12627839,
            8671454.218561286
        ],
        [
            -296838102.06742096,
            109081720.8617362,
            9573173.862605654
        ],
        [
            -300635293.00237584,
            99858708.39395508,
            10469871.074832102
        ],
        [
            -304191088.33993506,
            90516251.68201081,
            11361024.297292653
        ],
        [
            -307502097.60020256,
            81058849.47009516,
            12246105.314990377
        ],
        [
            -310564917.83317,
            71491088.59017627,
            13124578.753748503
        ],
        [
            -313376134.5717199,
            61817651.4268983,
            13995901.592180684
        ],
        [
            -315932323.2407422,
            52043323.53466782,
            14859522.68949585
        ],
        [
            -318230051.04022455,
            42173001.39577603,
            15714882.33100526
        ],
        [
            -320265879.3210618,
            32211700.307156324,
            16561411.793342883
        ],
        [
            -322036366.47318536,
            22164562.381968975,
            17398532.931563035
        ],
        [
            -323538071.3464037,
            12036864.65063575,
            18225657.790440757
        ],
        [
            -324767557.2250839,
            1834027.2442090511,
            19042188.242470246
        ],
        [
            -325721396.3784554,
            -8438378.358949333,
            19847515.65523486
        ],
        [
            -326396175.20887643,
            -18774621.044293463,
            20641020.59100705
        ],
        [
            -326788500.0208466,
            -29168801.7534059,
            21422072.541628618
        ],
        [
            -326895003.4338608,
            -39614845.183333725,
            22190029.70191873
        ],
        [
            -326712351.4623563,
            -50106491.52142504,
            22944238.78505893
        ],
        [
            -326237251.28598726,
            -60637288.24696863,
            23684034.88360955
        ],
        [
            -325466459.73323905,
            -71200582.03395087,
            24408741.380018182
        ],
        [
            -324396792.50095105,
            -81789510.79243961,
            25117669.91068784
        ],
        [
            -323025134.1316151,
            -92396995.88947496,
            25810120.387876682
        ],
        [
            -321348448.7693358,
            -103015734.59388869,
            26485381.08390152
        ],
        [
            -319363791.7140439,
            -113638192.79317471,
            27142728.782310713
        ],
        [
            -317068321.7919129,
            -124256598.03437889,
            27781429.000875503
        ],
        [
            -314459314.55791396,
            -134862932.94494897,
            28400736.29141968
        ],
        [
            -311534176.3440138,
            -145448929.0935711,
            28999894.621661667
        ],
        [
            -308290459.1636507,
            -156006061.35517392,
            29578137.84437675
        ],
        [
            -304725876.47976595,
            -166525542.84850335,
            30134690.25929673
        ],
        [
            -300838319.8398087,
            -176998320.51889,
            30668767.273243964
        ],
        [
            -296625876.3767127,
            -187415071.443038,
            31179576.164042685
        ],
        [
            -292086847.1698587,
            -197766199.93678963,
            31666316.953756783
        ],
        [
            -287219766.4544336,
            -208041835.55081797,
            32128183.396764148
        ],
        [
            -282023421.66136515,
            -218231832.04301104,
            32564364.088087365
        ],
        [
            -276496874.2631228,
            -228325767.41986883,
            32974043.69725347
        ],
        [
            -270639481.39310825,
            -238312945.1424555,
            33356404.332743302
        ],
        [
            -264450918.1981098,
            -248182396.59526756,
            33710627.04180971
        ],
        [
            -257931200.87435296,
            -257922884.91869134,
            34035893.4500841
        ],
        [
            -251080710.32805055,
            -267522910.3074437,
            34331387.54494828
        ],
        [
            -243900216.39105684,
            -276970716.8784169,
            34596297.606114715
        ],
        [
            -236390902.51128104,
            -286254301.21156687,
            34829818.28622827
        ],
        [
            -228554390.82596007,
            -295361422.6667985,
            35031152.84356992
        ],
        [
            -220392767.5137748,
            -304279615.57807505,
            35199515.52810174
        ],
        [
            -211908608.30919525,
            -312996203.423114,
            35334134.12113978
        ],
        [
            -203105004.04942948,
            -321498315.0628978,
            35434252.6278716
        ],
        [
            -193985586.11104736,
            -329772903.139709,
            35499134.120747566
        ],
        [
            -184554551.57986265,
            -337806764.71539026,
            35528063.730467334
        ],
        [
            -174816687.98413426,
            -345586564.2229101,
            35520351.7798562
        ],
        [
            -164777397.40775454,
            -353098858.7939942,
            35475337.05438254
        ],
        [
            -154442719.78700948,
            -360330126.01347834,
            35392390.2014125
        ],
        [
            -143819355.18192458,
            -367266794.1370646,
            35270917.24853709
        ],
        [
            -132914684.80139206,
            -373895274.79328704,
            35110363.22945118
        ],
        [
            -121736790.55042613,
            -380201998.17266846,
            34910215.90392406
        ],
        [
            -110294472.85830572,
            -386173450.6872979,
            34670009.55639441
        ],
        [
            -98597266.5382851,
            -391796215.06237704,
            34389328.85566517
        ],
        [
            -86655454.42328852,
            -397057012.79777825,
            34067812.75608956
        ],
        [
            -74480078.51783687,
            -401942748.9123929,
            33705158.41855163
        ],
        [
            -62082948.40468234,
            -406440558.857199,
            33301125.127482
        ],
        [
            -49476646.645541996,
            -410537857.4547185,
            32855538.1781435
        ],
        [
            -36674530.9191995,
            -414222389.6931133,
            32368292.706504643
        ],
        [
            -23690732.647364706,
            -417482283.1728622,
            31839357.432229765
        ],
        [
            -10540151.86926207,
            -420306101.9731132,
            31268778.283690304
        ],
        [
            2761551.8598162234,
            -422682901.6737955,
            30656681.8724825
        ],
        [
            16197972.752642334,
            -424602285.23882973,
            30003278.78376489
        ],
        [
            29751976.441460937,
            -426054459.43577206,
            29308866.647843644
        ],
        [
            43405722.155168146,
            -427030291.4384656,
            28573832.95787741
        ],
        [
            57140689.55067277,
            -427521365.2323055,
            27798657.598383434
        ],
        [
            70937710.29282898,
            -427520037.41709554,
            26983915.0494397
        ],
        [
            84777004.43955147,
            -427019491.9807744,
            26130276.23212629
        ],
        [
            98638221.64742765,
            -426013793.59908617,
            25238509.961860113
        ],
        [
            112500487.1686709,
            -424497939.0021252,
            24309483.97787165
        ],
        [
            126342452.56302017,
            -422467905.93914056,
            23344165.519165687
        ],
        [
            140142350.99872577,
            -419920699.2685468,
            22343621.419904903
        ],
        [
            153878056.9656331,
            -416854393.70117795,
            21309017.70025361
        ],
        [
            167527150.1712908,
            -413268172.73184556,
            20241618.632306475
        ],
        [
            181066983.33869314,
            -409162363.3074783,
            19142785.264779877
        ],
        [
            194474753.572528,
            -404538465.7997482,
            18013973.394629274
        ],
        [
            207727576.91050392,
            -399399178.8761941,
            16856730.978629656
        ],
        [
            220802565.6283242,
            -393748418.89640534,
            15672694.983164
        ],
        [
            233676907.8220719,
            -387591333.49866354,
            14463587.67594159
        ],
        [
            246327948.75103763,
            -380934309.08726496,
            13231212.36904184
        ],
        [
            258733273.3881961,
            -373784971.9811187,
            11977448.628467033
        ],
        [
            270870789.59542704,
            -366152183.03960097,
            10704246.971204113
        ],
        [
            282718811.3168854,
            -358046025.64133215,
            9413623.076546058
        ],
        [
            294256141.16728234,
            -349477786.95475376,
            8107651.544015357
        ],
        [
            305462151.78274775,
            -340459932.50521016,
            6788459.235568497
        ],
        [
            316316865.3007898,
            -331006074.11069906,
            5458218.244747374
        ],
        [
            326801030.3428641,
            -321130931.3265071,
            4119138.5399925476
        ],
        [
            336896195.8883146,
            -310850286.606505,
            2773460.333358441
        ],
        [
            346584781.45184684,
            -300180934.4548269,
            1423446.2292983094
        ],
        [
            355850143.0080015,
            -289140624.9049325,
            71373.21095124877
        ],
        [
            364676634.14491445,
            -277748001.72255915,
            -1280475.476588938
        ],
        [
            373049661.9754,
            -266022535.78385708,
            -2629818.485250217
        ],
        [
            380955737.3853978,
            -253984454.12911737,
            -3974384.5039204513
        ],
        [
            388382519.25723726,
            -241654665.235176,
            -5311920.318341847
        ],
        [
            395318852.36706907,
            -229054681.0851223,
            -6640198.731019535
        ],
        [
            401754798.7211804,
            -216206536.64181513,
            -7957026.283028864
        ],
        [
            407681662.16365725,
            -203132707.35156482,
            -9260250.72215874
        ],
        [
            413092006.1568887,
            -189856025.31591547,
            -10547768.165059917
        ],
        [
            417979664.70559,
            -176399594.77274743,
            -11817529.904912693
        ],
        [
            422339746.46327287,
            -162786707.52300006,
            -13067548.82051697
        ],
        [
            426168632.1263278,
            -149040758.9264533,
            -14295905.347556286
        ],
        [
            429463965.28414905,
            -135185165.06963062,
            -15500752.978009013
        ],
        [
            432224636.95309705,
            -121243281.68152085,
            -16680323.259179873
        ],
        [
            434450764.07677317,
            -107238325.33912325,
            -17832930.26951069
        ],
        [
            436143662.3244002,
            -93193297.46555322,
            -18956974.5541042
        ],
        [
            437305813.56250024,
            -79130911.57942846,
            -20050946.50866674
        ],
        [
            437940828.41213655,
            -65073524.20635715,
            -21113429.206257317
        ],
        [
            438053404.33445704,
            -51043069.812494636,
            -22143100.666737653
        ],
        [
            437649279.7110051,
            -37061000.067213744,
            -23138735.57407767
        ],
        [
            436735184.40224135,
            -23148227.68787113,
            -24099206.451615278
        ],
        [
            435318787.2780659,
            -9325075.065300703,
            -25023484.30994315
        ],
        [
            433408641.21807134,
            4388772.185139298,
            -25910638.786251087
        ],
        [
            431014126.0771166,
            17974306.654655457,
            -26759837.7976553
        ],
        [
            428145390.1040261,
            31413235.51245147,
            -27570346.73426974
        ],
        [
            424813290.2882391,
            44688011.82366395,
            -28341527.22050481
        ],
        [
            421029332.0916421,
            57781860.86480361,
            -29072835.475309327
        ],
        [
            416805609.0011568,
            70678801.5290435,
            -29763820.303807523
        ],
        [
            412154742.31255984,
            83363662.95119882,
            -30414120.754034925
        ],
        [
            407089821.52807236,
            95822096.51566416,
            -31023463.473264728
        ],
        [
            401624345.72009623,
            108040583.43980867,
            -31591659.798766803
        ],
        [
            395772166.181683,
            120006438.15026453,
            -32118602.61778252
        ],
        [
            389547430.651467,
            131707807.6902368,
            -32604263.03106764
        ],
        [
            382964529.36740446,
            143133667.41249117,
            -33048686.853588883
        ],
        [
            376038043.17023873,
            154273813.22515386,
            -33451990.98489656
        ],
        [
            368782693.8445866,
            165118850.66613382,
            -33814359.680377975
        ],
        [
            361213296.85331714,
            175660181.08703387,
            -34136040.75306259
        ],
        [
            353344716.5898169,
            185889985.22916114,
            -34417341.73394199
        ],
        [
            345191824.24306923,
            195801204.47297072,
            -34658626.01692292
        ],
        [
            336769458.3424963,
            205387520.038252,
            -34860309.012586445
        ],
        [
            328092388.02336305,
            214643330.4059766,
            -35022854.33291593
        ],
        [
            319175279.0293895,
            223563727.22422773,
            -35146770.02711115
        ],
        [
            310032662.44715214,
            232144469.95037514,
            -35232604.886554964
        ],
        [
            300678906.1468975,
            240381959.4699581,
            -35280944.834967196
        ],
        [
            291128188.88661134,
            248273210.91984499,
            -35292409.41779089
        ],
        [
            281394477.02050143,
            255815825.9294818,
            -35267648.40292643
        ],
        [
            271491503.7394772,
            263007964.4796355,
            -35207338.50307733
        ],
        [
            261432750.75962692,
            269848316.5632345,
            -35112180.22820817
        ],
        [
            251231432.36503598,
            276336073.81793416,
            -34982894.874953076
        ],
        [
            240900481.7034605,
            282470901.28503966,
            -34820221.658257365
        ],
        [
            230452539.2272179,
            288252909.4346232,
            -34624914.98909317
        ],
        [
            219899943.167105,
            293682626.5821609,
            -34397741.90076269
        ],
        [
            209254721.92401868,
            298760971.8079677,
            -34139479.62509357
        ],
        [
            198528588.26114798,
            303489228.4771718,
            -33850913.318737194
        ],
        [
            187732935.17897317,
            307869018.4450705,
            -33532833.938802734
        ],
        [
            176878833.35570222,
            311902277.0204833,
            -33186036.266191434
        ],
        [
            165977030.03712013,
            315591228.7482108,
            -32811317.074236408
        ],
        [
            155037949.26192874,
            318938364.06097794,
            -32409473.439594533
        ],
        [
            144071693.31146324,
            321946416.8412673,
            -31981301.19177598
        ],
        [
            133088045.27603883,
            324618342.92426836,
            -31527593.497226283
        ],
        [
            122096472.63400297,
            326957299.5647708,
            -31049139.573489167
        ],
        [
            111106131.7437902,
            328966625.8831868,
            -30546723.528670482
        ],
        [
            100125873.15374875,
            330649824.29900575,
            -30021123.3211857
        ],
        [
            89164247.63922057,
            332010542.9538142,
            -29473109.834601767
        ],
        [
            78229512.88118759,
            333052559.1205376,
            -28903446.062270284
        ],
        [
            67329640.705703,
            333779763.5907458,
            -28312886.396387294
        ],
        [
            56472324.80826898,
            334196146.02766204,
            -27702176.01610061
        ],
        [
            45664988.892214715,
            334305781.26890326,
            -27072050.36931109
        ],
        [
            34914795.15497121,
            334112816.55990624,
            -26423234.74287598
        ],
        [
            24228653.060872316,
            333621459.6964216,
            -25756443.916014545
        ],
        [
            13613228.343699604,
            332835968.0523582,
            -25072381.89183384
        ],
        [
            3074952.186645359,
            331760638.4675699,
            -24371741.70203248
        ],
        [
            -7379969.468382716,
            330399797.96888745,
            -23655205.27999709
        ],
        [
            -17745546.526108265,
            328757795.2967482,
            -22923443.39767797
        ],
        [
            -28015995.298009515,
            326838993.20914525,
            -22177115.661812894
        ],
        [
            -38185729.05369359,
            324647761.53426296,
            -21416870.56525765
        ],
        [
            -48249348.59653959,
            322188470.94306695,
            -20643345.589378744
        ],
        [
            -58201632.89342132,
            319465487.4132266,
            -19857167.353661213
        ],
        [
            -68037529.78529893,
            316483167.3560598,
            -19058951.8088855
        ],
        [
            -77752146.8026969,
            313245853.3786588,
            -18249304.47042525
        ],
        [
            -87340742.1075034,
            309757870.6539695,
            -17428820.688415118
        ],
        [
            -96798715.58016273,
            306023523.872331,
            -16598085.951730741
        ],
        [
            -106121600.069185,
            302047094.7488098,
            -15757676.222910242
        ],
        [
            -115305052.81792186,
            297832840.06158036,
            -14908158.301330013
        ],
        [
            -124344847.08180249,
            293384990.1975726,
            -14050090.21212195
        ],
        [
            -133236863.94763374,
            288707748.18263686,
            -13184021.618488142
        ],
        [
            -141977084.36515766,
            283805289.1745322,
            -12310494.25522942
        ],
        [
            -150561581.39983222,
            278681760.39812285,
            -11430042.381455138
        ],
        [
            -158986512.7147097,
            273341281.50326335,
            -10543193.250586048
        ],
        [
            -167248113.28837693,
            267787945.32693946,
            -9650467.59589504
        ],
        [
            -175342688.37513304,
            262025819.0423178,
            -8752380.129956225
        ],
        [
            -183266606.71294492,
            256058945.67842728,
            -7849440.056488399
        ],
        [
            -191016293.98421326,
            249891345.99522796,
            -6942151.593184275
        ],
        [
            -198588226.53399,
            243527020.69985,
            -6031014.504214679
        ],
        [
            -205978925.3500278,
            236969952.99074587,
            -5116524.641182572
        ],
        [
            -213184950.30887884,
            230224111.41744307,
            -4199174.4913800135
        ],
        [
            -220202894.69220543,
            223293453.04446858,
            -3279453.732269024
        ],
        [
            -227029379.9775176,
            216181926.90884584,
            -2357849.791164588
        ],
        [
            -233661050.90767848,
            208893477.7613534,
            -1434848.4091481813
        ],
        [
            -240094570.8437529,
            201432050.08244234,
            -510934.2082778782
        ]
    ],
    "(2022 UF4)": [
        [
            -76572076.34966318,
            -311381696.55173445,
            18743193.513120253
        ],
        [
            -66765231.27133511,
            -313709321.1884591,
            17621761.10346302
        ],
        [
            -56895712.009602636,
            -315750443.05763817,
            16484028.65865602
        ],
        [
            -46970896.29451658,
            -317503425.2572824,
            15330843.297088176
        ],
        [
            -36998197.803554244,
            -318966774.1895143,
            14163060.849125594
        ],
        [
            -26985066.603786364,
            -320139140.09745336,
            12981545.927124593
        ],
        [
            -16938989.604336478,
            -321019317.8566085,
            11787172.004408527
        ],
        [
            -6867491.00215669,
            -321606248.02270687,
            10580821.50120334
        ],
        [
            3221867.296030998,
            -321899018.1372321,
            9363385.875486007
        ],
        [
            13321485.292957962,
            -321896864.29128057,
            8135765.71665776
        ],
        [
            23423724.578708038,
            -321599172.9476563,
            6898870.8399114255
        ],
        [
            33520908.084989563,
            -321005483.0204243,
            5653620.379118161
        ],
        [
            43605319.933660686,
            -320115488.2104025,
            4400942.876014294
        ],
        [
            53669205.39757255,
            -318929039.5943216,
            3141776.363423789
        ],
        [
            63704770.9919734,
            -317446148.46458286,
            1877068.440206021
        ],
        [
            73704184.71488827,
            -315666989.415724,
            607776.3355726618
        ],
        [
            83659576.45505087,
            -313591903.67283547,
            -665133.0396283045
        ],
        [
            93563038.58611211,
            -311221402.6562669,
            -1940683.0571088344
        ],
        [
            103406626.76597857,
            -308556171.77601296,
            -3217887.353309227
        ],
        [
            113182360.96024254,
            -305597074.4481804,
            -4495749.832073614
        ],
        [
            122882226.70874372,
            -302345156.3248899,
            -5773264.690408757
        ],
        [
            132498176.65435052,
            -298801649.72788095,
            -7049416.469941156
        ],
        [
            142022132.3530579,
            -294967978.274947,
            -8323180.136723032
        ],
        [
            151445986.38446215,
            -290845761.6871317,
            -9593521.192069674
        ],
        [
            160761604.7815867,
            -286436820.7633781,
            -10859395.817137627
        ],
        [
            169960829.79888976,
            -281743182.50802124,
            -12119751.053975249
        ],
        [
            179035483.03707433,
            -276767085.3951709,
            -13373525.02579231
        ],
        [
            187977368.94304004,
            -271510984.75262874,
            -14619647.199203635
        ],
        [
            196778278.7029568,
            -265977558.24654433,
            -15857038.691201797
        ],
        [
            205429994.54598802,
            -260169711.44651848,
            -17084612.62360418
        ],
        [
            213924294.47564894,
            -254090583.44933075,
            -18301274.527700186
        ],
        [
            222252957.44513464,
            -247743552.53789902,
            -19505922.801793
        ],
        [
            230407768.99219143,
            -241132241.85047624,
            -20697449.224286057
        ],
        [
            238380527.34821996,
            -234260525.03345865,
            -21874739.524906628
        ],
        [
            246163050.03529018,
            -227132531.84953701,
            -23036674.016585656
        ],
        [
            253747180.9635943,
            -219752653.71126258,
            -24182128.290423647
        ],
        [
            261124798.0405749,
            -212125549.1084417,
            -25309973.97606518
        ],
        [
            268287821.30151266,
            -204256148.89612734,
            -26419079.56967882
        ],
        [
            275228221.5697574,
            -196149661.4083448,
            -27508311.331593245
        ],
        [
            281938029.6530121,
            -187811577.361103,
            -28576534.255473442
        ],
        [
            288409346.0801353,
            -179247674.5066925,
            -29622613.110731132
        ],
        [
            294634351.380815,
            -170464021.99979708,
            -30645413.55965173
        ],
        [
            300605316.9081627,
            -161466984.43454304,
            -31643803.35048233
        ],
        [
            306314616.2018021,
            -152263225.51031068,
            -32616653.58746423
        ],
        [
            311754736.8863668,
            -142859711.282945,
            -33562840.07850578
        ],
        [
            316918293.0974755,
            -133263712.956956,
            -34481244.7608774
        ],
        [
            321798038.4242343,
            -123482809.17340297,
            -35370757.204970784
        ],
        [
            326386879.35412097,
            -113524887.74744429,
            -36230276.19579753
        ],
        [
            330677889.2027365,
            -103398146.80901584,
            -37058711.39150876
        ],
        [
            334664322.50739145,
            -93111095.2998073,
            -37854985.057798386
        ],
        [
            338339629.859816,
            -82672552.77965537,
            -38618033.87660738
        ],
        [
            341697473.1494784,
            -72091648.49568689,
            -39346810.82707718
        ],
        [
            344731741.1850655,
            -61377819.66804899,
            -40040287.13620781
        ],
        [
            347436565.6576556,
            -50540808.94687942,
            -40697454.2961618
        ],
        [
            349806337.4050015,
            -39590660.99631143,
            -41317326.14462148
        ],
        [
            351835722.93218887,
            -28537718.162807353,
            -41898941.004056014
        ],
        [
            353519681.1397392,
            -17392615.18697624,
            -42441363.87518921
        ],
        [
            354853480.20604956,
            -6166272.920281112,
            -42943688.679382265
        ],
        [
            355832714.56691,
            5130108.989308864,
            -43405040.54406152
        ],
        [
            356453321.9307641,
            16485060.475608245,
            -43824578.12473272
        ],
        [
            356711600.264412,
            27886850.525857598,
            -44201495.95653634
        ],
        [
            356604224.680043,
            39323497.77122253,
            -44535026.82771627
        ],
        [
            356128264.1508539,
            50782782.21733275,
            -44824444.16680244
        ],
        [
            355281197.97913104,
            62252258.13129182,
            -45069064.43475303
        ],
        [
            354060931.93756294,
            73719268.09642623,
            -45268249.512767196
        ],
        [
            352465814.0017762,
            85170958.24047911,
            -45421409.07597396
        ],
        [
            350494649.5896826,
            96594294.63700187,
            -45528002.94272968
        ],
        [
            348146716.2212439,
            107976080.87338673,
            -45587543.38882489
        ],
        [
            345421777.51074487,
            119302976.77233967,
            -45599597.41551542
        ],
        [
            342320096.4026539,
            130561518.24664861,
            -45563788.959959716
        ],
        [
            338842447.5617045,
            141738138.25989544,
            -45479801.03637105
        ],
        [
            334990128.82795906,
            152819188.85834658,
            -45347377.79598494
        ],
        [
            330764971.64838076,
            163790964.23167044,
            -45166326.49380463
        ],
        [
            326169350.3978671,
            174639724.75243992,
            -44936519.35002823
        ],
        [
            321206190.5047943,
            185351721.9366436,
            -44657895.29408092
        ],
        [
            315878975.2989407,
            195913224.2597012,
            -44330461.57928505
        ],
        [
            310191751.5031835,
            206310543.75485253,
            -43954295.25639735
        ],
        [
            304149133.2946236,
            216530063.313309,
            -43529544.49453435
        ],
        [
            297756304.8657772,
            226558264.5983177,
            -43056429.738393165
        ],
        [
            291019021.4221807,
            236381756.4783555,
            -42535244.69115862
        ],
        [
            283943608.55916023,
            245987303.87813026,
            -41966357.11306787
        ],
        [
            276536959.96760845,
            255361856.93998265,
            -41350209.42628131
        ],
        [
            268806533.42634135,
            264492580.38274965,
            -40687319.11748031
        ],
        [
            260760345.04694283,
            273366882.94022536,
            -39978278.93047629
        ],
        [
            252406961.7458926,
            281972446.7571139,
            -39223756.84206742
        ],
        [
            243755491.92814904,
            290297256.6168878,
            -38424495.81541294
        ],
        [
            234815574.3761648,
            298329628.8732802,
            -37581313.32630644
        ],
        [
            225597365.34846127,
            306058239.9553315,
            -36695100.658907056
        ],
        [
            216111523.90231085,
            313472154.3150073,
            -35766821.96872795
        ],
        [
            206369195.46567112,
            320560851.6864463,
            -34797513.11196991
        ],
        [
            196381993.69420445,
            327314253.52691716,
            -33788280.24161837
        ],
        [
            186161980.65988588,
            333722748.5115773,
            -32740298.172079705
        ],
        [
            175721645.42827308,
            339777216.95712906,
            -31654808.515508775
        ],
        [
            165073881.0918606,
            345469054.0534833,
            -30533117.594359055
        ],
        [
            154231960.33698517,
            350790191.78751856,
            -29376594.13605821
        ],
        [
            143209509.63137683,
            355733119.448958,
            -28186666.757062368
        ],
        [
            132020482.12856954,
            360290902.61524093,
            -26964821.244858168
        ],
        [
            120679129.393905,
            364457200.5199686,
            -25712597.64775072
        ],
        [
            109199972.06468542,
            368226281.718021,
            -24431587.18348458
        ],
        [
            97597769.5640893,
            371593037.96968436,
            -23123428.978882633
        ],
        [
            85887488.99467237,
            374552996.2760255,
            -21789806.653742373
        ],
        [
            74084273.34257467,
            377102329.0082063,
            -20432444.763190046
        ],
        [
            62203409.12789636,
            379237862.0843627,
            -19053105.11355189
        ],
        [
            50260293.64002872,
            380957081.1589649,
            -17653582.96754825
        ],
        [
            38270401.89902164,
            382258135.80113876,
            -16235703.155245297
        ],
        [
            26249253.485298492,
            383139841.6501376,
            -14801316.107703619
        ],
        [
            14212379.380189642,
            383601680.547913,
            -13352293.830638839
        ],
        [
            2175288.958861053,
            383643798.66042703,
            -11890525.835654838
        ],
        [
            -9846562.724740416,
            383267002.61086524,
            -10417915.046721699
        ],
        [
            -21837807.224268496,
            382472753.65915596,
            -8936373.699550938
        ],
        [
            -33783194.425980076,
            381263159.97305757,
            -7447819.251369253
        ],
        [
            -45667623.58453393,
            379640967.04646534,
            -5954170.318313817
        ],
        [
            -57476173.5475177,
            377609546.33041394,
            -4457342.657269929
        ],
        [
            -69194132.05318753,
            375172882.1514284,
            -2959245.2084537484
        ],
        [
            -80807023.99319871,
            372335557.00034267,
            -1461776.2144127004
        ],
        [
            -92300638.54003648,
            369102735.2823911,
            33180.56961482391
        ],
        [
            -103661055.04734951,
            365480145.62623316,
            1523759.5598633587
        ],
        [
            -114874667.64035583,
            361474061.8555586,
            3008116.909519393
        ],
        [
            -125928208.4228223,
            357091282.73200214,
            4484433.943287082
        ],
        [
            -136808769.23674268,
            352339110.5822599,
            5950920.449855879
        ],
        [
            -147503821.92063898,
            347225328.92552954,
            7405817.822178487
        ],
        [
            -158001237.02230805,
            341758179.2196982,
            8847402.036600746
        ],
        [
            -168289300.93172872,
            335946336.84608793,
            10273986.46304555
        ],
        [
            -178356731.40965784,
            329798886.45305085,
            11683924.499631045
        ],
        [
            -188192691.4970769,
            323325296.7783333,
            13075612.026285406
        ],
        [
            -197786801.80004835,
            316535395.068912,
            14447489.67309978
        ],
        [
            -207129151.15360886,
            309439341.21501565,
            15798044.90032319
        ],
        [
            -216210305.67701644,
            302047601.7123173,
            17125813.888042226
        ],
        [
            -225021316.2409187,
            294370923.56287605,
            18429383.23469448
        ],
        [
            -233553724.37475526,
            286420308.2213906,
            19707391.46462745
        ],
        [
            -241799566.6499411,
            278206985.688748,
            20958530.34593306
        ],
        [
            -249751377.5810202,
            269742388.8497933,
            22181546.02074842
        ],
        [
            -257402191.09303853,
            261038128.14677134,
            23375239.951115645
        ],
        [
            -264745540.60883045,
            252105966.67404896,
            24538469.684332952
        ],
        [
            -271775457.8147239,
            242957795.77362835,
            25670149.44249826
        ],
        [
            -278486470.1673589,
            233605611.20461494,
            26769250.54164847
        ],
        [
            -284873597.20786655,
            224061489.95332557,
            27834801.64652539
        ],
        [
            -290932345.7525893,
            214337567.7441499,
            28865888.867555346
        ],
        [
            -296658704.03185344,
            204446017.30465272,
            29861655.70711318
        ],
        [
            -302049134.8500377,
            194399027.4318354,
            30821302.86255128
        ],
        [
            -307100567.84135765,
            184208782.89994103,
            31744087.893815145
        ],
        [
            -311810390.8964171,
            173887445.24380147,
            32629324.763737194
        ],
        [
            -316176440.83469987,
            163447134.44548965,
            33476383.25930447
        ],
        [
            -320196993.39783126,
            152899911.54599175,
            34284688.30233715
        ],
        [
            -323870752.6376363,
            142257762.19782764,
            35053719.15809305
        ],
        [
            -327196839.7718387,
            131532581.16898575,
            35783008.5503374
        ],
        [
            -330174781.5786705,
            120736157.80328745,
            36472141.69138561
        ],
        [
            -332804498.399777,
            109880162.43733859,
            37120755.23554761
        ],
        [
            -335086291.8186211,
            98976133.7695741,
            37728536.164277986
        ],
        [
            -337020832.0791461,
            88035467.17260551,
            38295220.61116979
        ],
        [
            -338609145.3068156,
            77069403.9360851,
            38820592.63472942
        ],
        [
            -339852600.59130526,
            66089021.423680514,
            39304482.94663426
        ],
        [
            -340752896.9871436,
            55105224.1244352,
            39746767.60291378
        ],
        [
            -341312050.4855056,
            44128735.5758363,
            40147366.66520751
        ],
        [
            -341532381.0071797,
            33170091.133274987,
            40506242.83894725
        ],
        [
            -341416499.46349543,
            22239631.558259748,
            40823400.09498751
        ],
        [
            -340967294.92873937,
            11347497.39575769,
            41098882.28087262
        ],
        [
            -340187921.96431357,
            503624.109317556,
            41332771.7275833
        ],
        [
            -339081788.1316503,
            -10282262.058776543,
            41525187.85725367
        ],
        [
            -337652541.72768086,
            -21000647.53621839,
            41676285.79699424
        ],
        [
            -335904059.7735054,
            -31642234.21305734,
            41786255.00360007
        ],
        [
            -333840436.2838306,
            -42197941.61317,
            41855317.90356875
        ],
        [
            -331465970.84174424,
            -52658908.4806996,
            41883728.55250111
        ],
        [
            -328785157.5004975,
            -63016493.81754452,
            41871771.31761246
        ],
        [
            -325802674.0311788,
            -73262277.40800917,
            41819759.58674373
        ],
        [
            -322523371.53247863,
            -83388059.86659719,
            41728034.50693202
        ],
        [
            -318952264.4162,
            -93385862.24461387,
            41596963.75528087
        ],
        [
            -315094520.77972823,
            -103247925.23082046,
            41426940.344561346
        ],
        [
            -310955453.17438096,
            -112966707.98081276,
            41218381.46567902
        ],
        [
            -306540509.7763841,
            -122534886.60912177,
            40971727.36885686
        ],
        [
            -301855265.96517843,
            -131945352.37728041,
            40687440.28511344
        ],
        [
            -296905416.3118546,
            -141191209.61023512,
            40366003.38935769
        ],
        [
            -291696766.97872734,
            -150265773.3725804,
            40007919.80617706
        ],
        [
            -286235228.5294069,
            -159162566.93511385,
            39613711.659165084
        ],
        [
            -280526809.1471933,
            -167875319.0611897,
            39183919.1644176
        ],
        [
            -274577608.25819826,
            -176397961.14130914,
            38719099.76862231
        ],
        [
            -268393810.55430654,
            -184724624.20328838,
            38219827.33197619
        ],
        [
            -261981680.40989152,
            -192849635.82427493,
            37686691.35598712
        ],
        [
            -255347556.68511757,
            -200767516.96975562,
            37120296.25605065
        ],
        [
            -248497847.90766823,
            -208472978.78361657,
            36521260.67853909
        ],
        [
            -241439027.82384768,
            -215960919.35220128,
            35890216.86199794
        ],
        [
            -234177631.30919516,
            -223226420.4642249,
            35227810.041913666
        ],
        [
            -226720250.62801754,
            -230264744.3873338,
            34534697.898395
        ],
        [
            -219073532.0306034,
            -237071330.68103123,
            33811550.04599978
        ],
        [
            -211244172.67628682,
            -243641793.0646634,
            33059047.56483554
        ],
        [
            -203238917.87001607,
            -249971916.35814208,
            32277882.571969345
        ],
        [
            -195064558.59961963,
            -256057653.51209763,
            31468757.832095798
        ],
        [
            -186727929.36054188,
            -261895122.74320194,
            30632386.406332683
        ],
        [
            -178235906.25446826,
            -267480604.78946504,
            29769491.33794205
        ],
        [
            -169595405.3479225,
            -272810540.2994198,
            28880805.37370709
        ],
        [
            -160813381.2766392,
            -277881527.36823505,
            27967070.719634093
        ],
        [
            -151896826.08125508,
            -282690319.23295486,
            27029038.829592396
        ],
        [
            -142852768.25962764,
            -287233822.1382611,
            26067470.225451685
        ],
        [
            -133688272.02088869,
            -291509093.383358,
            25083134.34722807
        ],
        [
            -124410436.72614327,
            -295513339.5598335,
            24076809.43170321
        ],
        [
            -115026396.50055158,
            -299243914.9896077,
            23049282.41793783
        ],
        [
            -105543320.0013717,
            -302698320.3713736,
            22001348.878059562
        ],
        [
            -95968410.32637303,
            -305874201.64324105,
            20933812.971664127
        ],
        [
            -86308905.0468951,
            -308769349.068622,
            19847487.422131635
        ],
        [
            -76572076.34966326,
            -311381696.55173445,
            18743193.51312026
        ]
    ],
    "(2022 WF2)": [
        [
            -183465266.75299683,
            221252823.714325,
            -137599911.25815198
        ],
        [
            -191586981.5671301,
            216715600.0643739,
            -133767807.49277854
        ],
        [
            -199556536.55011028,
            212001124.22314802,
            -129825908.78317164
        ],
        [
            -207370324.98934856,
            207111304.77054155,
            -125775843.28144674
        ],
        [
            -215024709.6375341,
            202048035.06299645,
            -121619231.19482934
        ],
        [
            -222516017.0818206,
            196813197.2358465,
            -117357688.03563368
        ],
        [
            -229840532.3374452,
            191408666.46712348,
            -112992828.03319925
        ],
        [
            -236994493.67057484,
            185836315.5047664,
            -108526267.70872203
        ],
        [
            -243974087.65629014,
            180098019.45984763,
            -103959629.61428756
        ],
        [
            -250775444.47882244,
            174195660.8690408,
            -99294546.23773456
        ],
        [
            -257394633.48245287,
            168131135.03009394,
            -94532664.07523842
        ],
        [
            -263827658.98286963,
            161906355.61453676,
            -89675647.87371185
        ],
        [
            -270070456.3502503,
            155523260.56223947,
            -84725185.04526041
        ],
        [
            -276118888.37690264,
            148983818.26274118,
            -79682990.25600791
        ],
        [
            -281968741.943948,
            142290034.02847576,
            -74550810.19161081
        ],
        [
            -287615725.00327134,
            135443956.86513284,
            -69330428.50170854
        ],
        [
            -293055463.8927911,
            128447686.54439285,
            -64023670.9254029
        ],
        [
            -298283501.0050094,
            121303380.98415887,
            -58632410.59961612
        ],
        [
            -303295292.8308041,
            114013263.941164,
            -53158573.55183893
        ],
        [
            -308086208.4024891,
            106579633.02044936,
            -47604144.37833819
        ],
        [
            -312651528.16232455,
            99004868.00567341,
            -41971172.10834077
        ],
        [
            -316986443.2848673,
            91291439.51351385,
            -36261776.25403787
        ],
        [
            -321086055.4838356,
            83441917.97454603,
            -30478153.045453086
        ],
        [
            -324945377.3364865,
            75458982.94190964,
            -24622581.848276556
        ],
        [
            -328559333.1608771,
            67345432.72779502,
            -18697431.761680186
        ],
        [
            -331922760.4837807,
            59104194.36627275,
            -12705168.391880006
        ],
        [
            -335030412.13943964,
            50738333.89923774,
            -6648360.795794547
        ],
        [
            -337876959.04174113,
            42251066.98022562,
            -529688.5875481516
        ],
        [
            -340456993.6747845,
            33645769.7885627,
            5648050.801222876
        ],
        [
            -342765034.3491315,
            24925990.24371645,
            11881934.718299136
        ],
        [
            -344795530.27327913,
            16095459.506795019,
            18168907.75828977
        ],
        [
            -346542867.49202734,
            7158103.752891064,
            24505774.11620991
        ],
        [
            -348001375.74539584,
            -1881943.8056477457,
            30889189.84557675
        ],
        [
            -349165336.30353534,
            -11020330.668929398,
            37315655.04229182
        ],
        [
            -350028990.8346335,
            -20252472.600496814,
            43781505.97874187
        ],
        [
            -350586551.36407447,
            -29573541.012652174,
            50282907.21597426
        ],
        [
            -350832211.3840311,
            -38978450.22441247,
            56815843.7254875
        ],
        [
            -350760158.1731709,
            -48461844.63601813,
            63376113.05612276
        ],
        [
            -350364586.3861878,
            -58018085.86999273,
            69959317.58575207
        ],
        [
            -349639712.972342,
            -67641239.93525723,
            76560856.90191849
        ],
        [
            -348579793.48103595,
            -77325064.47774726,
            83175920.36029369
        ],
        [
            -347179139.810579,
            -87062996.1883428,
            89799479.8747558
        ],
        [
            -345432139.45360565,
            -96848138.4466815,
            96426282.9980375
        ],
        [
            -343333276.2890341,
            -106673249.28757064,
            103050846.3572261
        ],
        [
            -340877152.9658572,
            -116530729.78518656,
            109667449.51387799
        ],
        [
            -338058514.9183753,
            -126412612.9590165,
            116270129.32409242
        ],
        [
            -334872276.04558694,
            -136310553.31449193,
            122852674.87953466
        ],
        [
            -331313546.07925016,
            -146215817.14040872,
            129408623.11603141
        ],
        [
            -327377659.6555306,
            -156119273.69443414,
            135931255.18192062
        ],
        [
            -323060207.09403414,
            -166011387.41716847,
            142413593.66373983
        ],
        [
            -318357066.875334,
            -175882211.32421875,
            148848400.77198273
        ],
        [
            -313264439.7937249,
            -185721381.73442623,
            155228177.5944448
        ],
        [
            -307778884.74583554,
            -195518114.50059858,
            161545164.52899432
        ],
        [
            -301897356.09784365,
            -205261202.91664797,
            167791343.01131132
        ],
        [
            -295617242.55433065,
            -214939017.48173752,
            173958438.65610278
        ],
        [
            -288936407.4303017,
            -224539507.7076545,
            180037925.93236113
        ],
        [
            -281853230.2045945,
            -234050206.15993658,
            186021034.49423537
        ],
        [
            -274366649.2078736,
            -243458234.9260123,
            191898757.28884998
        ],
        [
            -266476205.27176556,
            -252750314.70450848,
            197661860.560759
        ],
        [
            -258182086.1375785,
            -261912776.7086545,
            203300895.8694858
        ],
        [
            -249485171.39366,
            -270931577.5730765,
            208806214.23158333
        ],
        [
            -240387077.6800521,
            -279792317.44694006,
            214167982.49167758
        ],
        [
            -230890203.86798388,
            -288480261.4470799,
            219376202.01785994
        ],
        [
            -220997775.89030883,
            -296980364.6321766,
            224420729.8054114
        ],
        [
            -210713890.86764804,
            -305277300.6429347,
            229291302.0590243
        ],
        [
            -200043560.14426687,
            -313355494.1333758,
            233977560.30733865
        ],
        [
            -188992750.81814435,
            -321199157.09456843,
            238469080.08461916
        ],
        [
            -177568425.3219195,
            -328792329.1442483,
            242755402.19274545
        ],
        [
            -165778578.5860915,
            -336118921.8237456,
            246826066.5323501
        ],
        [
            -153632272.2937463,
            -343162766.9074174,
            250670648.46498477
        ],
        [
            -141139665.71794713,
            -349907668.6894534,
            254278797.63872537
        ],
        [
            -128312042.61953542,
            -356337460.16863906,
            257640279.17782867
        ],
        [
            -115161833.67526814,
            -362436063.0036932,
            260745017.10317296
        ],
        [
            -101702633.90473735,
            -368187551.0605148,
            263583139.81458175
        ],
        [
            -87949214.57014519,
            -373576217.3185684,
            266145027.4291462
        ],
        [
            -73917529.03646183,
            -378586643.847337,
            268421360.73181987
        ],
        [
            -59624712.10138011,
            -383203774.50599015,
            270403171.4564151
        ],
        [
            -45089072.33534637,
            -387412989.96103734,
            272081893.57733095
        ],
        [
            -30330077.01216224,
            -391200184.55871224,
            273449415.2555859
        ],
        [
            -15368329.260461658,
            -394551844.532246,
            274498131.0477809
        ],
        [
            -225537.12579756975,
            -397455126.97020257,
            275220993.9542918
        ],
        [
            15075525.698020399,
            -399897938.92187536,
            275611566.8541074
        ],
        [
            30511067.63173163,
            -401869015.97067255,
            275664072.8491485
        ],
        [
            46056335.544560045,
            -403357999.5677074,
            275373444.0214477
        ],
        [
            61685679.64232272,
            -404355512.3867199,
            274735368.0930269
        ],
        [
            77372626.79240754,
            -404853230.93919545,
            273746332.4714298
        ],
        [
            93089962.0629527,
            -404843954.6761914,
            272403665.1642673
        ],
        [
            108809818.14481464,
            -404321670.801913,
            270705572.0543638
        ],
        [
            124503772.21458814,
            -403281614.0342731,
            268651170.0435273
        ],
        [
            140142949.68705773,
            -401720320.5700873,
            266240515.5978333
        ],
        [
            155698134.19813132,
            -399635675.5475497,
            263474628.2606619
        ],
        [
            171139883.05675167,
            -397026953.3462147,
            260355508.74139842
        ],
        [
            186438647.30871788,
            -393894850.124683,
            256886151.2373517
        ],
        [
            201564895.46898568,
            -390241508.0679622,
            253070549.70348614
        ],
        [
            216489239.9039284,
            -386070530.899224,
            248913697.84824434
        ],
        [
            231182564.7831535,
            -381386990.303229,
            244421582.70307997
        ],
        [
            245616154.473478,
            -376197423.00961006,
            239601171.6871945
        ],
        [
            259761821.21695298,
            -370509818.3917988,
            234460393.1660801
        ],
        [
            273592030.92147106,
            -364333596.5497317,
            229008110.5814018
        ],
        [
            287080025.8971469,
            -357679576.95951974,
            223254090.3090149
        ],
        [
            300199943.3945938,
            -350559937.8887978,
            217208963.47995913
        ],
        [
            312926928.8422778,
            -342988166.89025927,
            210884182.07457152
        ],
        [
            325237242.73867166,
            -334979002.7956848,
            204291969.67090946
        ],
        [
            337108360.2299736,
            -326548369.7364296,
            197445267.2940678
        ],
        [
            348519062.49425364,
            -317713303.81181717,
            190357674.87143064
        ],
        [
            359449519.1562555,
            -308491873.1123705,
            183043388.84929514
        ],
        [
            369881361.0716686,
            -298903091.87869275,
            175517136.5677235
        ],
        [
            379797742.94312084,
            -288966829.63781303,
            167794108.0222209
        ],
        [
            389183395.359961,
            -278703716.2059312,
            159889885.66242856
        ],
        [
            398024665.9874739,
            -268135043.47911826,
            151820372.88925007
        ],
        [
            406309549.76587963,
            -257282664.95135647,
            143601721.91272417
        ],
        [
            414027708.11272055,
            -246168893.90240827,
            135250261.62377486
        ],
        [
            421170477.25157416,
            -234816401.18678796,
            126782426.11421104
        ],
        [
            427730865.91315,
            -223248113.53030038,
            118214684.45170106
        ],
        [
            433703542.76969457,
            -211487113.20318806,
            109563472.28077012
        ],
        [
            439084814.06845206,
            -199556539.89014906,
            100845125.77818158
        ],
        [
            443872592.02327585,
            -187479495.51877892,
            92075818.44247638
        ],
        [
            448066354.60419714,
            -175278952.740917,
            83271501.14414127
        ],
        [
            451667097.432101,
            -162977667.6876443,
            74447845.80609708
        ],
        [
            454677278.5391531,
            -150598097.53996074,
            65620193.02514452
        ],
        [
            457100756.795196,
            -138162323.37521702,
            56803503.884895876
        ],
        [
            458942724.8261739,
            -125691978.6658266,
            48012316.15067327
        ],
        [
            460209637.26323974,
            -113208183.72322866,
            39260704.97792947
        ],
        [
            460909135.1612822,
            -100731486.29795632,
            30562248.20888132
        ],
        [
            461049967.41410995,
            -88281808.46731591,
            21929996.278082654
        ],
        [
            460641909.97155124,
            -75878399.86671412,
            13376446.697275981
        ],
        [
            459695683.6324798,
            -63539797.25007191,
            4913523.043636903
        ],
        [
            458222871.1485779,
            -51283790.299797624,
            -3447441.6661268175
        ],
        [
            456235834.3278156,
            -39127393.54803884,
            -11695717.370142296
        ],
        [
            453747631.77551955,
            -27086824.21883422,
            -19821185.310255975
        ],
        [
            450771937.855836,
            -15177485.75552243,
            -27814342.548144758
        ],
        [
            447322963.3986157,
            -3413956.759475261,
            -35666302.88296431
        ],
        [
            443415378.6174511,
            8190014.965203077,
            -43368794.42156257
        ],
        [
            439064238.6448491,
            19621513.591117114,
            -50914154.06434268
        ],
        [
            434284912.0313123,
            30868452.01959625,
            -58295319.17751728
        ],
        [
            429093012.4972621,
            41919564.56607649,
            -65505816.72613241
        ],
        [
            423504334.17101705,
            52764395.94640711,
            -72539750.1421909
        ],
        [
            417534790.4930284,
            63393286.93336311,
            -79391784.19888833
        ],
        [
            411200356.91676277,
            73797357.04984686,
            -86057128.15580422
        ],
        [
            404517017.4903872,
            83968484.6584595,
            -92531517.43124916
        ],
        [
            397500715.3609911,
            93899284.79691851,
            -98811194.04729706
        ],
        [
            390167307.2046597,
            103583085.09568012,
            -104892886.0806821
        ],
        [
            382532521.5513613,
            113013900.09864672,
            -110773786.33910273
        ],
        [
            374611920.94329154,
            122186404.29050025,
            -116451530.46789035
        ],
        [
            366420867.83902097,
            131095904.11542338,
            -121924174.67676322
        ],
        [
            357974494.1533147,
            139738309.25223568,
            -127190173.2608093
        ],
        [
            349287674.3037254,
            148110103.3906095,
            -132248356.07414824
        ],
        [
            340375001.6197554,
            156208314.73241374,
            -137097906.0991452
        ],
        [
            331250767.95831025,
            164030486.42166528,
            -141738337.23878235
        ],
        [
            321928946.3600946,
            171574647.08627212,
            -146169472.44496825
        ],
        [
            312423176.5752213,
            178839281.65499887,
            -150391422.2813465
        ],
        [
            302746753.28240633,
            185823302.59399632,
            -154404564.0056159
        ],
        [
            292912616.8243735,
            192526021.68901277,
            -158209521.2436073
        ],
        [
            282933346.2822893,
            198947122.48211005,
            -161807144.31540352
        ],
        [
            272821154.71389836,
            205086633.455451,
            -165198491.26269093
        ],
        [
            262587886.38330597,
            210944902.03956544,
            -168384809.6163122
        ],
        [
            252245015.8148424,
            216522569.50944126,
            -171367518.9336362
        ],
        [
            241803648.50890255,
            221820546.8188806,
            -174148194.12688857
        ],
        [
            231274523.16392928,
            226839991.41176566,
            -176728549.59595215
        ],
        [
            220668015.25559798,
            231582285.03819662,
            -179110424.1723359
        ],
        [
            209994141.8315993,
            236049012.59386203,
            -181295766.87498713
        ],
        [
            199262567.38810357,
            240241941.9924248,
            -183286623.4733356
        ],
        [
            188482610.70184618,
            244163005.07313144,
            -185085123.84837997
        ],
        [
            177663252.49973404,
            247814279.53919864,
            -186693470.13869858
        ],
        [
            166813143.85582703,
            251197971.9167593,
            -188113925.6549455
        ],
        [
            155940615.21339804,
            254316401.51920295,
            -189348804.54363292
        ],
        [
            145053685.93750155,
            257171985.39753938,
            -190400462.178749
        ],
        [
            134160074.31096356,
            259767224.25392336,
            -191271286.25797564
        ],
        [
            123267207.89396372,
            262104689.29261097,
            -191963688.57890514
        ],
        [
            112382234.17433445,
            264187009.9803353,
            -192480097.46966344
        ],
        [
            101512031.44233376,
            266016862.68633196,
            -192822950.84769577
        ],
        [
            90663219.82996848,
            267596960.17095017,
            -192994689.8801106
        ],
        [
            79842172.4608846,
            268930041.89091814,
            -192997753.2188835
        ],
        [
            69055026.66245179,
            270018865.0888283,
            -192834571.78434992
        ],
        [
            58307695.19691071,
            270866196.6342381,
            -192507564.07074454
        ],
        [
            47605877.47332576,
            271474805.58389527,
            -192019131.94803745
        ],
        [
            36955070.70663422,
            271847456.4289548,
            -191371656.9349529
        ],
        [
            26360580.994252056,
            271986902.99763656,
            -190567496.91881192
        ],
        [
            15827534.284566224,
            271895882.9825226,
            -189608983.29869026
        ],
        [
            5360887.215155244,
            271577113.06260663,
            -188498418.52931318
        ],
        [
            -5034562.198194265,
            271033284.59124327,
            -187238074.04410017
        ],
        [
            -15354164.037686706,
            270267059.8222877,
            -185830188.5368112
        ],
        [
            -25593406.138323814,
            269281068.647936,
            -184276966.58231544
        ],
        [
            -35747903.93232447,
            268077905.8230699,
            -182580577.57809955
        ],
        [
            -45813390.49207413,
            266660128.65224198,
            -180743154.9892344
        ],
        [
            -55785706.77864222,
            265030255.11681336,
            -178766795.88063124
        ],
        [
            -65660792.10126318,
            263190762.42114604,
            -176653560.7215192
        ],
        [
            -75434674.79176377,
            261144085.93815804,
            -174405473.44817203
        ],
        [
            -85103463.09667635,
            258892618.53595492,
            -172024521.77198833
        ],
        [
            -94663336.28875943,
            256438710.2686531,
            -169512657.7210884
        ],
        [
            -104110535.99877767,
            253784668.41589317,
            -166871798.404622
        ],
        [
            -113441357.76770276,
            250932757.85691643,
            -164103826.9899908
        ],
        [
            -122652142.81897125,
            247885201.7664131,
            -161210593.88416064
        ],
        [
            -131739270.05003321,
            244644182.62067497,
            -158193918.1111875
        ],
        [
            -140699148.24219367,
            241211843.50386557,
            -155055588.8789898
        ],
        [
            -149528208.48762012,
            237590289.70547077,
            -151797367.32927346
        ],
        [
            -158222896.83240068,
            233781590.6012106,
            -148420988.46536058
        ],
        [
            -166779667.13467053,
            229787781.81085962,
            -144928163.25346762
        ],
        [
            -175194974.13704944,
            225610867.62756374,
            -141320580.8937504
        ],
        [
            -183465266.75299677,
            221252823.71432504,
            -137599911.258152
        ]
    ],
    "(2024 GE2)": [
        [
            -183465266.75299683,
            221252823.714325,
            -137599911.25815198
        ],
        [
            -191586981.5671301,
            216715600.0643739,
            -133767807.49277854
        ],
        [
            -199556536.55011028,
            212001124.22314802,
            -129825908.78317164
        ],
        [
            -207370324.98934856,
            207111304.77054155,
            -125775843.28144674
        ],
        [
            -215024709.6375341,
            202048035.06299645,
            -121619231.19482934
        ],
        [
            -222516017.0818206,
            196813197.2358465,
            -117357688.03563368
        ],
        [
            -229840532.3374452,
            191408666.46712348,
            -112992828.03319925
        ],
        [
            -236994493.67057484,
            185836315.5047664,
            -108526267.70872203
        ],
        [
            -243974087.65629014,
            180098019.45984763,
            -103959629.61428756
        ],
        [
            -250775444.47882244,
            174195660.8690408,
            -99294546.23773456
        ],
        [
            -257394633.48245287,
            168131135.03009394,
            -94532664.07523842
        ],
        [
            -263827658.98286963,
            161906355.61453676,
            -89675647.87371185
        ],
        [
            -270070456.3502503,
            155523260.56223947,
            -84725185.04526041
        ],
        [
            -276118888.37690264,
            148983818.26274118,
            -79682990.25600791
        ],
        [
            -281968741.943948,
            142290034.02847576,
            -74550810.19161081
        ],
        [
            -287615725.00327134,
            135443956.86513284,
            -69330428.50170854
        ],
        [
            -293055463.8927911,
            128447686.54439285,
            -64023670.9254029
        ],
        [
            -298283501.0050094,
            121303380.98415887,
            -58632410.59961612
        ],
        [
            -303295292.8308041,
            114013263.941164,
            -53158573.55183893
        ],
        [
            -308086208.4024891,
            106579633.02044936,
            -47604144.37833819
        ],
        [
            -312651528.16232455,
            99004868.00567341,
            -41971172.10834077
        ],
        [
            -316986443.2848673,
            91291439.51351385,
            -36261776.25403787
        ],
        [
            -321086055.4838356,
            83441917.97454603,
            -30478153.045453086
        ],
        [
            -324945377.3364865,
            75458982.94190964,
            -24622581.848276556
        ],
        [
            -328559333.1608771,
            67345432.72779502,
            -18697431.761680186
        ],
        [
            -331922760.4837807,
            59104194.36627275,
            -12705168.391880006
        ],
        [
            -335030412.13943964,
            50738333.89923774,
            -6648360.795794547
        ],
        [
            -337876959.04174113,
            42251066.98022562,
            -529688.5875481516
        ],
        [
            -340456993.6747845,
            33645769.7885627,
            5648050.801222876
        ],
        [
            -342765034.3491315,
            24925990.24371645,
            11881934.718299136
        ],
        [
            -344795530.27327913,
            16095459.506795019,
            18168907.75828977
        ],
        [
            -346542867.49202734,
            7158103.752891064,
            24505774.11620991
        ],
        [
            -348001375.74539584,
            -1881943.8056477457,
            30889189.84557675
        ],
        [
            -349165336.30353534,
            -11020330.668929398,
            37315655.04229182
        ],
        [
            -350028990.8346335,
            -20252472.600496814,
            43781505.97874187
        ],
        [
            -350586551.36407447,
            -29573541.012652174,
            50282907.21597426
        ],
        [
            -350832211.3840311,
            -38978450.22441247,
            56815843.7254875
        ],
        [
            -350760158.1731709,
            -48461844.63601813,
            63376113.05612276
        ],
        [
            -350364586.3861878,
            -58018085.86999273,
            69959317.58575207
        ],
        [
            -349639712.972342,
            -67641239.93525723,
            76560856.90191849
        ],
        [
            -348579793.48103595,
            -77325064.47774726,
            83175920.36029369
        ],
        [
            -347179139.810579,
            -87062996.1883428,
            89799479.8747558
        ],
        [
            -345432139.45360565,
            -96848138.4466815,
            96426282.9980375
        ],
        [
            -343333276.2890341,
            -106673249.28757064,
            103050846.3572261
        ],
        [
            -340877152.9658572,
            -116530729.78518656,
            109667449.51387799
        ],
        [
            -338058514.9183753,
            -126412612.9590165,
            116270129.32409242
        ],
        [
            -334872276.04558694,
            -136310553.31449193,
            122852674.87953466
        ],
        [
            -331313546.07925016,
            -146215817.14040872,
            129408623.11603141
        ],
        [
            -327377659.6555306,
            -156119273.69443414,
            135931255.18192062
        ],
        [
            -323060207.09403414,
            -166011387.41716847,
            142413593.66373983
        ],
        [
            -318357066.875334,
            -175882211.32421875,
            148848400.77198273
        ],
        [
            -313264439.7937249,
            -185721381.73442623,
            155228177.5944448
        ],
        [
            -307778884.74583554,
            -195518114.50059858,
            161545164.52899432
        ],
        [
            -301897356.09784365,
            -205261202.91664797,
            167791343.01131132
        ],
        [
            -295617242.55433065,
            -214939017.48173752,
            173958438.65610278
        ],
        [
            -288936407.4303017,
            -224539507.7076545,
            180037925.93236113
        ],
        [
            -281853230.2045945,
            -234050206.15993658,
            186021034.49423537
        ],
        [
            -274366649.2078736,
            -243458234.9260123,
            191898757.28884998
        ],
        [
            -266476205.27176556,
            -252750314.70450848,
            197661860.560759
        ],
        [
            -258182086.1375785,
            -261912776.7086545,
            203300895.8694858
        ],
        [
            -249485171.39366,
            -270931577.5730765,
            208806214.23158333
        ],
        [
            -240387077.6800521,
            -279792317.44694006,
            214167982.49167758
        ],
        [
            -230890203.86798388,
            -288480261.4470799,
            219376202.01785994
        ],
        [
            -220997775.89030883,
            -296980364.6321766,
            224420729.8054114
        ],
        [
            -210713890.86764804,
            -305277300.6429347,
            229291302.0590243
        ],
        [
            -200043560.14426687,
            -313355494.1333758,
            233977560.30733865
        ],
        [
            -188992750.81814435,
            -321199157.09456843,
            238469080.08461916
        ],
        [
            -177568425.3219195,
            -328792329.1442483,
            242755402.19274545
        ],
        [
            -165778578.5860915,
            -336118921.8237456,
            246826066.5323501
        ],
        [
            -153632272.2937463,
            -343162766.9074174,
            250670648.46498477
        ],
        [
            -141139665.71794713,
            -349907668.6894534,
            254278797.63872537
        ],
        [
            -128312042.61953542,
            -356337460.16863906,
            257640279.17782867
        ],
        [
            -115161833.67526814,
            -362436063.0036932,
            260745017.10317296
        ],
        [
            -101702633.90473735,
            -368187551.0605148,
            263583139.81458175
        ],
        [
            -87949214.57014519,
            -373576217.3185684,
            266145027.4291462
        ],
        [
            -73917529.03646183,
            -378586643.847337,
            268421360.73181987
        ],
        [
            -59624712.10138011,
            -383203774.50599015,
            270403171.4564151
        ],
        [
            -45089072.33534637,
            -387412989.96103734,
            272081893.57733095
        ],
        [
            -30330077.01216224,
            -391200184.55871224,
            273449415.2555859
        ],
        [
            -15368329.260461658,
            -394551844.532246,
            274498131.0477809
        ],
        [
            -225537.12579756975,
            -397455126.97020257,
            275220993.9542918
        ],
        [
            15075525.698020399,
            -399897938.92187536,
            275611566.8541074
        ],
        [
            30511067.63173163,
            -401869015.97067255,
            275664072.8491485
        ],
        [
            46056335.544560045,
            -403357999.5677074,
            275373444.0214477
        ],
        [
            61685679.64232272,
            -404355512.3867199,
            274735368.0930269
        ],
        [
            77372626.79240754,
            -404853230.93919545,
            273746332.4714298
        ],
        [
            93089962.0629527,
            -404843954.6761914,
            272403665.1642673
        ],
        [
            108809818.14481464,
            -404321670.801913,
            270705572.0543638
        ],
        [
            124503772.21458814,
            -403281614.0342731,
            268651170.0435273
        ],
        [
            140142949.68705773,
            -401720320.5700873,
            266240515.5978333
        ],
        [
            155698134.19813132,
            -399635675.5475497,
            263474628.2606619
        ],
        [
            171139883.05675167,
            -397026953.3462147,
            260355508.74139842
        ],
        [
            186438647.30871788,
            -393894850.124683,
            256886151.2373517
        ],
        [
            201564895.46898568,
            -390241508.0679622,
            253070549.70348614
        ],
        [
            216489239.9039284,
            -386070530.899224,
            248913697.84824434
        ],
        [
            231182564.7831535,
            -381386990.303229,
            244421582.70307997
        ],
        [
            245616154.473478,
            -376197423.00961006,
            239601171.6871945
        ],
        [
            259761821.21695298,
            -370509818.3917988,
            234460393.1660801
        ],
        [
            273592030.92147106,
            -364333596.5497317,
            229008110.5814018
        ],
        [
            287080025.8971469,
            -357679576.95951974,
            223254090.3090149
        ],
        [
            300199943.3945938,
            -350559937.8887978,
            217208963.47995913
        ],
        [
            312926928.8422778,
            -342988166.89025927,
            210884182.07457152
        ],
        [
            325237242.73867166,
            -334979002.7956848,
            204291969.67090946
        ],
        [
            337108360.2299736,
            -326548369.7364296,
            197445267.2940678
        ],
        [
            348519062.49425364,
            -317713303.81181717,
            190357674.87143064
        ],
        [
            359449519.1562555,
            -308491873.1123705,
            183043388.84929514
        ],
        [
            369881361.0716686,
            -298903091.87869275,
            175517136.5677235
        ],
        [
            379797742.94312084,
            -288966829.63781303,
            167794108.0222209
        ],
        [
            389183395.359961,
            -278703716.2059312,
            159889885.66242856
        ],
        [
            398024665.9874739,
            -268135043.47911826,
            151820372.88925007
        ],
        [
            406309549.76587963,
            -257282664.95135647,
            143601721.91272417
        ],
        [
            414027708.11272055,
            -246168893.90240827,
            135250261.62377486
        ],
        [
            421170477.25157416,
            -234816401.18678796,
            126782426.11421104
        ],
        [
            427730865.91315,
            -223248113.53030038,
            118214684.45170106
        ],
        [
            433703542.76969457,
            -211487113.20318806,
            109563472.28077012
        ],
        [
            439084814.06845206,
            -199556539.89014906,
            100845125.77818158
        ],
        [
            443872592.02327585,
            -187479495.51877892,
            92075818.44247638
        ],
        [
            448066354.60419714,
            -175278952.740917,
            83271501.14414127
        ],
        [
            451667097.432101,
            -162977667.6876443,
            74447845.80609708
        ],
        [
            454677278.5391531,
            -150598097.53996074,
            65620193.02514452
        ],
        [
            457100756.795196,
            -138162323.37521702,
            56803503.884895876
        ],
        [
            458942724.8261739,
            -125691978.6658266,
            48012316.15067327
        ],
        [
            460209637.26323974,
            -113208183.72322866,
            39260704.97792947
        ],
        [
            460909135.1612822,
            -100731486.29795632,
            30562248.20888132
        ],
        [
            461049967.41410995,
            -88281808.46731591,
            21929996.278082654
        ],
        [
            460641909.97155124,
            -75878399.86671412,
            13376446.697275981
        ],
        [
            459695683.6324798,
            -63539797.25007191,
            4913523.043636903
        ],
        [
            458222871.1485779,
            -51283790.299797624,
            -3447441.6661268175
        ],
        [
            456235834.3278156,
            -39127393.54803884,
            -11695717.370142296
        ],
        [
            453747631.77551955,
            -27086824.21883422,
            -19821185.310255975
        ],
        [
            450771937.855836,
            -15177485.75552243,
            -27814342.548144758
        ],
        [
            447322963.3986157,
            -3413956.759475261,
            -35666302.88296431
        ],
        [
            443415378.6174511,
            8190014.965203077,
            -43368794.42156257
        ],
        [
            439064238.6448491,
            19621513.591117114,
            -50914154.06434268
        ],
        [
            434284912.0313123,
            30868452.01959625,
            -58295319.17751728
        ],
        [
            429093012.4972621,
            41919564.56607649,
            -65505816.72613241
        ],
        [
            423504334.17101705,
            52764395.94640711,
            -72539750.1421909
        ],
        [
            417534790.4930284,
            63393286.93336311,
            -79391784.19888833
        ],
        [
            411200356.91676277,
            73797357.04984686,
            -86057128.15580422
        ],
        [
            404517017.4903872,
            83968484.6584595,
            -92531517.43124916
        ],
        [
            397500715.3609911,
            93899284.79691851,
            -98811194.04729706
        ],
        [
            390167307.2046597,
            103583085.09568012,
            -104892886.0806821
        ],
        [
            382532521.5513613,
            113013900.09864672,
            -110773786.33910273
        ],
        [
            374611920.94329154,
            122186404.29050025,
            -116451530.46789035
        ],
        [
            366420867.83902097,
            131095904.11542338,
            -121924174.67676322
        ],
        [
            357974494.1533147,
            139738309.25223568,
            -127190173.2608093
        ],
        [
            349287674.3037254,
            148110103.3906095,
            -132248356.07414824
        ],
        [
            340375001.6197554,
            156208314.73241374,
            -137097906.0991452
        ],
        [
            331250767.95831025,
            164030486.42166528,
            -141738337.23878235
        ],
        [
            321928946.3600946,
            171574647.08627212,
            -146169472.44496825
        ],
        [
            312423176.5752213,
            178839281.65499887,
            -150391422.2813465
        ],
        [
            302746753.28240633,
            185823302.59399632,
            -154404564.0056159
        ],
        [
            292912616.8243735,
            192526021.68901277,
            -158209521.2436073
        ],
        [
            282933346.2822893,
            198947122.48211005,
            -161807144.31540352
        ],
        [
            272821154.71389836,
            205086633.455451,
            -165198491.26269093
        ],
        [
            262587886.38330597,
            210944902.03956544,
            -168384809.6163122
        ],
        [
            252245015.8148424,
            216522569.50944126,
            -171367518.9336362
        ],
        [
            241803648.50890255,
            221820546.8188806,
            -174148194.12688857
        ],
        [
            231274523.16392928,
            226839991.41176566,
            -176728549.59595215
        ],
        [
            220668015.25559798,
            231582285.03819662,
            -179110424.1723359
        ],
        [
            209994141.8315993,
            236049012.59386203,
            -181295766.87498713
        ],
        [
            199262567.38810357,
            240241941.9924248,
            -183286623.4733356
        ],
        [
            188482610.70184618,
            244163005.07313144,
            -185085123.84837997
        ],
        [
            177663252.49973404,
            247814279.53919864,
            -186693470.13869858
        ],
        [
            166813143.85582703,
            251197971.9167593,
            -188113925.6549455
        ],
        [
            155940615.21339804,
            254316401.51920295,
            -189348804.54363292
        ],
        [
            145053685.93750155,
            257171985.39753938,
            -190400462.178749
        ],
        [
            134160074.31096356,
            259767224.25392336,
            -191271286.25797564
        ],
        [
            123267207.89396372,
            262104689.29261097,
            -191963688.57890514
        ],
        [
            112382234.17433445,
            264187009.9803353,
            -192480097.46966344
        ],
        [
            101512031.44233376,
            266016862.68633196,
            -192822950.84769577
        ],
        [
            90663219.82996848,
            267596960.17095017,
            -192994689.8801106
        ],
        [
            79842172.4608846,
            268930041.89091814,
            -192997753.2188835
        ],
        [
            69055026.66245179,
            270018865.0888283,
            -192834571.78434992
        ],
        [
            58307695.19691071,
            270866196.6342381,
            -192507564.07074454
        ],
        [
            47605877.47332576,
            271474805.58389527,
            -192019131.94803745
        ],
        [
            36955070.70663422,
            271847456.4289548,
            -191371656.9349529
        ],
        [
            26360580.994252056,
            271986902.99763656,
            -190567496.91881192
        ],
        [
            15827534.284566224,
            271895882.9825226,
            -189608983.29869026
        ],
        [
            5360887.215155244,
            271577113.06260663,
            -188498418.52931318
        ],
        [
            -5034562.198194265,
            271033284.59124327,
            -187238074.04410017
        ],
        [
            -15354164.037686706,
            270267059.8222877,
            -185830188.5368112
        ],
        [
            -25593406.138323814,
            269281068.647936,
            -184276966.58231544
        ],
        [
            -35747903.93232447,
            268077905.8230699,
            -182580577.57809955
        ],
        [
            -45813390.49207413,
            266660128.65224198,
            -180743154.9892344
        ],
        [
            -55785706.77864222,
            265030255.11681336,
            -178766795.88063124
        ],
        [
            -65660792.10126318,
            263190762.42114604,
            -176653560.7215192
        ],
        [
            -75434674.79176377,
            261144085.93815804,
            -174405473.44817203
        ],
        [
            -85103463.09667635,
            258892618.53595492,
            -172024521.77198833
        ],
        [
            -94663336.28875943,
            256438710.2686531,
            -169512657.7210884
        ],
        [
            -104110535.99877767,
            253784668.41589317,
            -166871798.404622
        ],
        [
            -113441357.76770276,
            250932757.85691643,
            -164103826.9899908
        ],
        [
            -122652142.81897125,
            247885201.7664131,
            -161210593.88416064
        ],
        [
            -131739270.05003321,
            244644182.62067497,
            -158193918.1111875
        ],
        [
            -140699148.24219367,
            241211843.50386557,
            -155055588.8789898
        ],
        [
            -149528208.48762012,
            237590289.70547077,
            -151797367.32927346
        ],
        [
            -158222896.83240068,
            233781590.6012106,
            -148420988.46536058
        ],
        [
            -166779667.13467053,
            229787781.81085962,
            -144928163.25346762
        ],
        [
            -175194974.13704944,
            225610867.62756374,
            -141320580.8937504
        ],
        [
            -183465266.75299677,
            221252823.71432504,
            -137599911.258152
        ]
    ],
    "(2024 XP10)": [
        [
            -234382219.88190532,
            -348323287.6643636,
            -20534349.221586525
        ],
        [
            -223295006.09312162,
            -355591726.84309983,
            -19920589.222039197
        ],
        [
            -212004709.57361552,
            -362541605.06793135,
            -19288784.74713728
        ],
        [
            -200519211.17586195,
            -369167877.2848335,
            -18639373.88897539
        ],
        [
            -188846483.35045475,
            -375465626.2768506,
            -17972802.639764242
        ],
        [
            -176994592.5749188,
            -381430062.2307591,
            -17289525.043736268
        ],
        [
            -164971701.94818905,
            -387056522.67263013,
            -16590003.365413196
        ],
        [
            -152786073.9304819,
            -392340472.7833413,
            -15874708.273079418
        ],
        [
            -140446073.2078033,
            -397277506.1045966,
            -15144119.036266297
        ],
        [
            -127960169.65981895,
            -401863345.6455316,
            -14398723.736011403
        ],
        [
            -115336941.40924886,
            -406093845.3994695,
            -13639019.486612272
        ],
        [
            -102585077.93034776,
            -409964992.27987576,
            -12865512.667547312
        ],
        [
            -89713383.19338602,
            -413472908.48399794,
            -12078719.1641857
        ],
        [
            -76730778.8213585,
            -416613854.292094,
            -11279164.615854714
        ],
        [
            -63646307.234420985,
            -419384231.3095168,
            -10467384.669775765
        ],
        [
            -50469134.75678572,
            -421780586.158243,
            -9643925.239319997
        ],
        [
            -37208554.66000062,
            -423799614.6236937,
            -8809342.764970718
        ],
        [
            -23873990.11569637,
            -425438166.26188487,
            -7964204.476312796
        ],
        [
            -10474997.030013293,
            -426693249.4710731,
            -7109088.653299037
        ],
        [
            2978733.2689813673,
            -427562037.0310929,
            -6244584.884970419
        ],
        [
            16477371.520496398,
            -428041872.112535,
            -5371294.323730912
        ],
        [
            30010948.22739038,
            -428130274.75676906,
            -4489829.933199286
        ],
        [
            43569351.59121561,
            -427824948.82655406,
            -3600816.7275792547
        ],
        [
            57142325.71838373,
            -427123789.4256204,
            -2704892.0004068445
        ],
        [
            70719469.13084781,
            -426024890.7841177,
            -1802705.540449893
        ],
        [
            84290233.61562803,
            -424526554.6052103,
            -894919.8324494138
        ],
        [
            97843923.44840723,
            -422627298.8663556,
            17789.75969230756
        ],
        [
            111369695.02729058,
            -420325867.0669134,
            934734.8297571037
        ],
        [
            124856556.95363644,
            -417621237.911705,
            1855213.78865356
        ],
        [
            138293370.59761122,
            -414512635.4179555,
            2778511.749102287
        ],
        [
            151668851.18679735,
            -410999539.4307231,
            3703900.438288316
        ],
        [
            164971569.4567497,
            -407081696.5294229,
            4630638.141279722
        ],
        [
            178189953.9028611,
            -402759131.3054081,
            5557969.678081712
        ],
        [
            191312293.67322546,
            -398032157.9877605,
            6485126.417259108
        ],
        [
            204326742.14236698,
            -392901392.3914803,
            7411326.329116594
        ],
        [
            217221321.20571065,
            -387367764.1591464,
            8335774.081473412
        ],
        [
            229983926.33449137,
            -381432529.26384866,
            9257661.181106847
        ],
        [
            242602332.4303981,
            -375097282.73778707,
            10176166.16396401
        ],
        [
            255064200.51862305,
            -368363971.5873822,
            11090454.837254073
        ],
        [
            267357085.31709474,
            -361234907.85208404,
            11999680.576529916
        ],
        [
            279468443.7185037,
            -353712781.76027954,
            12902984.680849092
        ],
        [
            291385644.22025985,
            -345800674.9318442,
            13799496.78906588
        ],
        [
            303095977.335713,
            -337502073.5729332,
            14688335.360248141
        ],
        [
            314586667.0178263,
            -328820881.60462713,
            15568608.22113251
        ],
        [
            325844883.12396866,
            -319761433.66302717,
            16439413.18342783
        ],
        [
            336857754.94757986,
            -310328507.9043901,
            17299838.733646702
        ],
        [
            347612385.8391491,
            -300527338.5449208,
            18148964.797988933
        ],
        [
            358095868.9351967,
            -290363628.06093997,
            18985863.58461464
        ],
        [
            368295304.00976425,
            -279843558.97135895,
            19809600.505428914
        ],
        [
            378197815.4582839,
            -268973805.1207563,
            20619235.179252308
        ],
        [
            387790571.418596,
            -257761542.37791982,
            21413822.51797038
        ],
        [
            397060804.0283257,
            -246214458.66152424,
            22192413.896940984
        ],
        [
            405995830.8118041,
            -234340763.20172837,
            22954058.410588533
        ],
        [
            414583077.18323404,
            -222149194.94393563,
            23697804.213729512
        ],
        [
            422810100.04586565,
            -209649029.99882585,
            24422699.948753506
        ],
        [
            430664612.45958596,
            -196850088.04110402,
            25127796.258328747
        ],
        [
            438134509.34154445,
            -183762737.55825812,
            25812147.382810913
        ],
        [
            445207894.1562836,
            -170397899.85005388,
            26474812.84101082
        ],
        [
            451873106.5433392,
            -156767051.67956454,
            27114859.19242043
        ],
        [
            458118750.82147086,
            -142882226.47729877,
            27731361.878411252
        ],
        [
            463933725.2996317,
            -128756014.00150177,
            28323407.13930563
        ],
        [
            469307252.31553805,
            -114401558.36002675,
            28890094.003583454
        ],
        [
            474228908.9133332,
            -99832554.30233243,
            29430536.34482804
        ],
        [
            478688658.062418,
            -85063241.69422486,
            29943865.001339477
        ],
        [
            482676880.31013536,
            -70108398.09294903,
            30429229.952656016
        ],
        [
            486184405.75172704,
            -54983329.34617898,
            30885802.546530433
        ],
        [
            489202546.1919323,
            -39703858.14538658,
            31312777.76921323
        ],
        [
            491723127.36386585,
            -24286310.47198668,
            31709376.55120606
        ],
        [
            493738521.06250393,
            -8747499.883571923,
            32074848.09997223
        ],
        [
            495241677.0423349,
            6895290.402553618,
            32408472.250435345
        ],
        [
            496226154.52160466,
            22624327.66046518,
            32709561.82346855
        ],
        [
            496686153.12922883,
            38421452.06147316,
            32977464.981984593
        ],
        [
            496616543.12495434,
            54268101.342216134,
            33211567.573688187
        ],
        [
            496012894.7188641,
            70145337.72897705,
            33411295.449056182
        ],
        [
            494871506.31292343,
            86033877.09799922,
            33576116.74267563
        ],
        [
            493189431.4850793,
            101914120.33670163,
            33705544.10570303
        ],
        [
            490964504.53553635,
            117766186.85530153,
            33799136.8769184
        ],
        [
            488195364.4153357,
            133569950.18252438,
            33856503.17964245
        ],
        [
            484881476.85933566,
            149305075.56297818,
            33877301.93167083
        ],
        [
            481023154.5491867,
            164951059.45752028,
            33861244.75536309
        ],
        [
            476621575.1369753,
            180487270.83172244,
            33808097.775110945
        ],
        [
            471678796.9668956,
            195892994.1014836,
            33717683.289604634
        ],
        [
            466197772.3406213,
            211147473.5891563,
            33589881.306622446
        ],
        [
            460182358.1819798,
            226229959.3283862,
            33424630.928487655
        ],
        [
            453637323.96805096,
            241119754.04141733,
            33221931.576870963
        ],
        [
            446568356.80687994,
            255796261.09906363,
            32981844.046265025
        ],
        [
            438982063.5565324,
            270239033.26105225,
            32704491.3762177
        ],
        [
            430885969.8961462,
            284427821.9832115,
            32390059.533280276
        ],
        [
            422288516.27682334,
            298342627.06813323,
            32038797.894600153
        ],
        [
            413199050.6985389,
            311963746.4276625,
            31651019.52615861
        ],
        [
            403627818.27855736,
            325271825.71898854,
            31227101.249814898
        ],
        [
            393585947.5969675,
            338247907.61135423,
            30767483.49455906
        ],
        [
            383085433.8257052,
            350873480.4375553,
            30272669.92868663
        ],
        [
            372139118.66859615,
            363130525.98357725,
            29743226.870976917
        ],
        [
            360760667.1613462,
            375001566.17093873,
            29179782.480370138
        ],
        [
            348964541.4017691,
            386469708.3896327,
            28583025.72508254
        ],
        [
            336765971.3016919,
            397518689.2449866,
            27953705.133559693
        ],
        [
            324180922.4726483,
            408132916.4892528,
            27292627.331129644
        ],
        [
            311226061.37746257,
            418297508.9182879,
            26600655.367665112
        ],
        [
            297918717.89890873,
            427998334.0251687,
            25878706.842981927
        ],
        [
            284276845.4945926,
            437222043.21594095,
            25127751.838073593
        ],
        [
            270318979.12385064,
            445956104.40778536,
            24348810.661594734
        ],
        [
            256064191.1476075,
            454188831.8465436,
            23542951.422245488
        ],
        [
            241532045.415611,
            461909412.9986302,
            22711287.438860033
        ],
        [
            226742549.76713702,
            469107932.3916524,
            21854974.501054633
        ],
        [
            211716107.18099803,
            475775392.29838395,
            20975207.994232073
        ],
        [
            196473465.81839615,
            481903730.17985475,
            20073219.90356012
        ],
        [
            181035668.20779514,
            487485832.8250226,
            19150275.71223582
        ],
        [
            165423999.82445413,
            492515547.14652514,
            18207671.209905718
        ],
        [
            149659937.318607,
            496987687.6141714,
            17246729.227533124
        ],
        [
            133765096.64546168,
            500898040.32985,
            16268796.315282326
        ],
        [
            117761181.34729186,
            504243363.7692193,
            15275239.380127104
        ],
        [
            101669931.23295623,
            507021386.23664665,
            14267442.299886493
        ],
        [
            85513071.6933111,
            509230800.10020584,
            13246802.530249033
        ],
        [
            69312263.88227412,
            510871252.892902,
            12214727.72107031
        ],
        [
            53089055.98290095,
            511943335.3845204,
            11172632.357824901
        ],
        [
            36864835.76589811,
            512448566.7454152,
            10121934.443569968
        ],
        [
            20660784.63466698,
            512389376.9390371,
            9064052.236141387
        ],
        [
            4497833.336461484,
            511769086.4939414,
            8000401.054566693
        ],
        [
            -11603380.496308863,
            510591883.81830454,
            6932390.167849813
        ],
        [
            -27622552.8269535,
            508862800.23056865,
            5861419.778375164
        ],
        [
            -43539751.586878926,
            506587682.88867384,
            4788878.111202722
        ],
        [
            -59335452.82622293,
            503773165.80739534,
            3716138.6194952764
        ],
        [
            -74990574.54718652,
            500426639.15860474,
            2644557.315245008
        ],
        [
            -90486508.14223543,
            496556217.0528226,
            1575470.2333634906
        ],
        [
            -105805147.37698531,
            492170704.0022744,
            510191.03607607447
        ],
        [
            -120928914.87492064,
            487279560.2658675,
            -549991.2365659978
        ],
        [
            -135840786.0780185,
            481892866.27514887,
            -1603814.2653666548
        ],
        [
            -150524310.6736845,
            476021286.3374617,
            -2650044.396278601
        ],
        [
            -164963631.49403444,
            469676031.80832595,
            -3687478.427811116
        ],
        [
            -179143500.90839282,
            462868823.91960096,
            -4714945.240104141
        ],
        [
            -193049294.743783,
            455611856.44339585,
            -5731307.265226681
        ],
        [
            -206667023.7811111,
            447917758.3640969,
            -6735461.799215425
        ],
        [
            -219983342.88664192,
            439799556.7223887,
            -7726342.157273183
        ],
        [
            -232985557.84912986,
            431270639.78593576,
            -8702918.674387809
        ],
        [
            -245661630.00265104,
            422344720.69153285,
            -9664199.554412216
        ],
        [
            -258000178.7236907,
            413035801.693214,
            -10609231.571356496
        ],
        [
            -269990481.89841616,
            403358139.1401192,
            -11537100.627285399
        ],
        [
            -281622474.46232367,
            393326209.2969744,
            -12446932.171787329
        ],
        [
            -292886745.11956227,
            382954675.10899764,
            -13337891.488480905
        ],
        [
            -303774531.35330683,
            372258354.0019424,
            -14209183.854458023
        ],
        [
            -314277712.8415641,
            361252186.7969954,
            -15060054.57892396
        ],
        [
            -324388803.3948196,
            349951207.8094057,
            -15889788.927590705
        ],
        [
            -334100941.53304285,
            338370516.18911654,
            -16697711.939611591
        ],
        [
            -343407879.81977594,
            326525248.5514147,
            -17483188.14401336
        ],
        [
            -352303973.07046694,
            314430552.9357026,
            -18245621.182694208
        ],
        [
            -360784165.5508733,
            302101564.12104475,
            -18984453.34711177
        ],
        [
            -368843977.2793771,
            289553380.31816405,
            -19699165.035790414
        ],
        [
            -376479489.5444665,
            276801041.24907774,
            -20389274.13973669
        ],
        [
            -383687329.7455067,
            263859507.61765543,
            -21054335.36276621
        ],
        [
            -390464655.66135925,
            250743641.966992,
            -21693939.4836243
        ],
        [
            -396809139.2474166,
            237468190.91270947,
            -22307712.566624284
        ],
        [
            -402718950.05733,
            224047768.73506346,
            -22895315.127341546
        ],
        [
            -408192738.3811343,
            210496842.30709782,
            -23456441.259687845
        ],
        [
            -413229618.1866889,
            196829717.33101302,
            -23990817.730454907
        ],
        [
            -417829149.9464381,
            183060525.8503861,
            -24498203.04716357
        ],
        [
            -421991323.4264445,
            169203215.0019248,
            -24978386.50478526
        ],
        [
            -425716540.50957924,
            155271536.9669682,
            -25431187.21662383
        ],
        [
            -429005598.1196378,
            141279040.0800094,
            -25856453.13435661
        ],
        [
            -431859671.30809176,
            127239061.04904614,
            -26254060.06194055
        ],
        [
            -434280296.56017023,
            113164718.2405303,
            -26623910.667792875
        ],
        [
            -436269355.3720492,
            99068905.98011124,
            -26965933.499358762
        ],
        [
            -437829058.1461299,
            84964289.81914404,
            -27280082.003883973
        ],
        [
            -438961928.44673145,
            70863302.71610811,
            -27566333.558919214
        ],
        [
            -439670787.65402514,
            56778142.08157885,
            -27824688.515797064
        ],
        [
            -439958740.04972434,
            42720767.6351842,
            -28055169.259044256
        ],
        [
            -439829158.3639108,
            28702900.02307731,
            -28257819.284420863
        ],
        [
            -439285669.80845016,
            14736020.144762456,
            -28432702.29801719
        ],
        [
            -438332142.6187266,
            831369.1386736631,
            -28579901.338587813
        ],
        [
            -436972673.12190753,
            -13000051.023355603,
            -28699517.925061584
        ],
        [
            -435211573.34665096,
            -26747476.381694168,
            -28791671.230937686
        ],
        [
            -433053359.18607676,
            -40400379.3224746,
            -28856497.287060037
        ],
        [
            -430502739.1229372,
            -53948466.445847034,
            -28894148.214056633
        ],
        [
            -427564603.52325433,
            -67381676.01436728,
            -28904791.485537037
        ],
        [
            -424244014.5022143,
            -80690175.0256029,
            -28888609.222959075
        ],
        [
            -420546196.3638313,
            -93864355.95163521,
            -28845797.5229062
        ],
        [
            -416476526.6138057,
            -106894833.18664506,
            -28776565.81735816
        ],
        [
            -412040527.5430912,
            -119772439.24230102,
            -28681136.26739107
        ],
        [
            -407243858.37794954,
            -132488220.7291272,
            -28559743.190606494
        ],
        [
            -402092307.990697,
            -145033434.16053507,
            -28412632.522463754
        ],
        [
            -396591788.1639235,
            -157399541.61467943,
            -28240061.31157428
        ],
        [
            -390748327.399693,
            -169578206.28780347,
            -28042297.248910986
        ],
        [
            -384568065.26408464,
            -181561287.9712852,
            -27819618.23078882
        ],
        [
            -378057247.25641644,
            -193340838.48314106,
            -27572311.955384623
        ],
        [
            -371222220.19158435,
            -204909097.0833656,
            -27300675.55248405
        ],
        [
            -364069428.08314764,
            -216258485.9011245,
            -27005015.24607074
        ],
        [
            -356605408.5140816,
            -227381605.40051162,
            -26685646.049306702
        ],
        [
            -348836789.48148656,
            -238271229.91034567,
            -26342891.491393443
        ],
        [
            -340770286.7010007,
            -248920303.2422628,
            -25977083.375749163
        ],
        [
            -332412701.3561654,
            -259321934.42024314,
            -25588561.568888426
        ],
        [
            -323770918.27757037,
            -269469393.5436102,
            -25177673.819346372
        ],
        [
            -314851904.5362205,
            -279356107.80451894,
            -24744775.605949223
        ],
        [
            -305662708.4352183,
            -288975657.67998827,
            -24290230.014695443
        ],
        [
            -296210458.8835546,
            -298321773.3176025,
            -23814407.643478412
        ],
        [
            -286502365.135502,
            -307388331.13316596,
            -23317686.533849258
        ],
        [
            -276545716.8788403,
            -316169350.6377732,
            -22800452.128989
        ],
        [
            -266347884.654888,
            -324658991.51100576,
            -22263097.257030845
        ],
        [
            -255916320.59304288,
            -332851550.93625927,
            -21706022.13884561
        ],
        [
            -245258559.44229704,
            -340741461.21352905,
            -21129634.419377074
        ],
        [
            -234382219.8819054,
            -348323287.66436356,
            -20534349.22158653
        ]
    ],
    "(2024 XB20)": [
        [
            -69413047.53153698,
            300683963.20832855,
            -3720940.0356016704
        ],
        [
            -78876136.10036722,
            298361078.68286794,
            -3746439.377469251
        ],
        [
            -88272853.63194515,
            295777569.7580702,
            -3768679.847884985
        ],
        [
            -97597326.70476948,
            292934893.81227946,
            -3787645.7942412696
        ],
        [
            -106843689.06643337,
            289834574.7114113,
            -3803322.342335806
        ],
        [
            -116006077.98986998,
            286478204.57616454,
            -3815695.3962607593
        ],
        [
            -125078630.7543447,
            282867445.89084935,
            -3824751.6427682955
        ],
        [
            -134055481.26601365,
            279004033.9504273,
            -3830478.560155048
        ],
        [
            -142930756.83311257,
            274889779.6422753,
            -3832864.4317084225
        ],
        [
            -151698575.11113718,
            270526572.55904764,
            -3831898.3637577463
        ],
        [
            -160353041.23372597,
            265916384.43883324,
            -3827570.3083732007
        ],
        [
            -168888245.1453526,
            261061272.9285666,
            -3819871.090754958
        ],
        [
            -177298259.1523782,
            255963385.66635734,
            -3808792.4413540876
        ],
        [
            -185577135.70949358,
            250624964.6780365,
            -3794327.0327653224
        ],
        [
            -193718905.45910266,
            245048351.0827844,
            -3776468.5214297804
        ],
        [
            -201717575.54174477,
            239235990.10218507,
            -3755211.5941829216
        ],
        [
            -209567128.19622844,
            233190436.36645317,
            -3730552.019679477
        ],
        [
            -217261519.66874588,
            226914359.51088583,
            -3702486.7047225977
        ],
        [
            -224794679.45084026,
            220410550.05479783,
            -3671013.7555189347
        ],
        [
            -232160509.86671394,
            213681925.55430853,
            -3636132.5438747755
        ],
        [
            -239352886.0309717,
            206731537.01933932,
            -3597843.7783404486
        ],
        [
            -246365656.1984944,
            199562575.58406752,
            -3556149.5803010613
        ],
        [
            -253192642.52871254,
            192178379.41883802,
            -3511053.5650009336
        ],
        [
            -259827642.28709537,
            184582440.8701732,
            -3462560.927476906
        ],
        [
            -266264429.50717217,
            176778413.81402823,
            -3410678.5333618047
        ],
        [
            -272496757.13684994,
            168770121.20580965,
            -3355415.0145036583
        ],
        [
            -278518359.69316506,
            160561562.80891484,
            -3296780.86932871
        ],
        [
            -284322956.4499049,
            152156923.08164605,
            -3234788.567856704
        ],
        [
            -289904255.1827262,
            143560579.20031142,
            -3169452.6612552605
        ],
        [
            -295255956.4964789,
            134777109.19414115,
            -3100789.895796298
        ],
        [
            -300371758.75938904,
            125811300.16532475,
            -3028819.3310513515
        ],
        [
            -305245363.66855484,
            116668156.56501365,
            -2953562.4621341377
        ],
        [
            -309870482.4708286,
            107352908.4935398,
            -2875043.345767844
        ],
        [
            -314240842.86260104,
            97871019.99037643,
            -2793288.7299212655
        ],
        [
            -318350196.59122133,
            88228197.2765244,
            -2708328.1867220546
        ],
        [
            -322192327.77978134,
            78430396.90905344,
            -2620194.2483170535
        ],
        [
            -325761061.99572724,
            68483833.80447207,
            -2528922.545308813
        ],
        [
            -329050276.08222014,
            58394989.08446658,
            -2434551.947354189
        ],
        [
            -332053908.76932484,
            48170617.69434212,
            -2337124.705465258
        ],
        [
            -334765972.0799433,
            37817755.74125421,
            -2236686.5955049335
        ],
        [
            -337180563.54290026,
            27343727.496046543,
            -2133287.0623197053
        ],
        [
            -339291879.22271216,
            16756151.999247715,
            -2026979.3638999755
        ],
        [
            -341094227.5723151,
            6062949.208553299,
            -1917820.7149049612
        ],
        [
            -342582044.1113604,
            -4727654.378035903,
            -1805872.428834106
        ],
        [
            -343749906.9286024,
            -15607120.692294419,
            -1691200.0580709472
        ],
        [
            -344592553.00238806,
            -26566595.730836622,
            -1573873.5309687117
        ],
        [
            -345104895.328288,
            -37596905.92962534,
            -1453967.2850900043
        ],
        [
            -345282040.83750373,
            -48688555.35482994,
            -1331560.3956564139
        ],
        [
            -345119309.0838033,
            -59831723.78907819,
            -1206736.6982081719
        ],
        [
            -344612251.6704285,
            -71016265.79393424,
            -1079584.9044198855
        ],
        [
            -343756672.3816402,
            -82231710.83079283,
            -950198.70996649
        ],
        [
            -342548647.9763781,
            -93467264.5232651,
            -818676.8932847385
        ],
        [
            -340984549.5939059,
            -104711811.14446421,
            -685123.4040305505
        ],
        [
            -339061064.71332663,
            -115953917.41231793,
            -549647.439992381
        ],
        [
            -336775219.60052705,
            -127181837.67507866,
            -412363.5111862221
        ],
        [
            -334124402.1674907,
            -138383520.5674908,
            -273391.4898301194
        ],
        [
            -331106385.16005063,
            -149546617.21555638,
            -132856.6448760014
        ],
        [
            -327719349.58112067,
            -160658491.06444415,
            9110.340234614094
        ],
        [
            -323961908.24730015,
            -171706229.3997497,
            152373.3679258352
        ],
        [
            -319833129.3676027,
            -182676656.62699494,
            296790.946278768
        ],
        [
            -315332560.0239801,
            -193556349.36788815,
            442216.2295627205
        ],
        [
            -310460249.4244387,
            -204331653.424424,
            588497.0807752729
        ],
        [
            -305216771.7909598,
            -214988702.6533497,
            735476.1574117116
        ],
        [
            -299603248.7362838,
            -225513439.78384387,
            882991.0216208493
        ],
        [
            -293621370.97602785,
            -235891639.2004357,
            1030874.2758251306
        ],
        [
            -287273419.2157072,
            -246108931.7012534,
            1178953.7247875433
        ],
        [
            -280562284.0461807,
            -256150831.2286482,
            1327052.5649955994
        ],
        [
            -273491484.6759779,
            -266002763.55514157,
            1474989.6021033246
        ],
        [
            -266065186.32504258,
            -275650096.8925507,
            1622579.4970255797
        ],
        [
            -258288216.10179383,
            -285078174.3761442,
            1769633.0411153603
        ],
        [
            -250166077.18420246,
            -294272348.35886335,
            1915957.4606741734
        ],
        [
            -241704961.12595034,
            -303218016.4331546,
            2061356.7508490672
        ],
        [
            -232911758.11080867,
            -311900659.0799243,
            2205632.0387580823
        ],
        [
            -223794064.98225826,
            -320305878.8257282,
            2348581.9754601624
        ],
        [
            -214360190.88117298,
            -328419440.77073795,
            2490003.156147552
        ],
        [
            -204619160.3321924,
            -336227314.3314719,
            2629690.5676899976
        ],
        [
            -194580713.62926137,
            -343715716.02399313,
            2767438.062403258
        ],
        [
            -184255304.38276386,
            -350871153.0954797,
            2903038.8566516303
        ],
        [
            -173654094.10471505,
            -357680467.7950254,
            3036286.052628476
        ],
        [
            -162788943.72458696,
            -364130882.05848926,
            3166973.181392882
        ],
        [
            -151672401.94645396,
            -370210042.3674533,
            3294894.76497823
        ],
        [
            -140317690.37817952,
            -375906064.5291173,
            3419846.8951325705
        ],
        [
            -128738685.38517213,
            -381207578.1125419,
            3541627.82600542
        ],
        [
            -116949896.64467187,
            -386103770.26727325,
            3660038.57786417
        ],
        [
            -104966442.40137316,
            -390584428.64330006,
            3774883.5487097353
        ],
        [
            -92804021.4512104,
            -394639983.1267036,
            3885971.130468872
        ],
        [
            -80478881.9070727,
            -398261546.10346574,
            3993114.3262733426
        ],
        [
            -68007786.82775739,
            -401440950.96484673,
            4096131.365197252
        ],
        [
            -55407976.81931116,
            -404170788.57166004,
            4194846.310716362
        ],
        [
            -42697129.74569367,
            -406444441.4017332,
            4289089.659079927
        ],
        [
            -29893317.71306984,
            -408256115.1148898,
            4378698.92374884
        ],
        [
            -17014961.51862602,
            -409600867.2829071,
            4463519.202055523
        ],
        [
            -4080782.7802512646,
            -410474633.04803956,
            4543403.720282486
        ],
        [
            8890246.012660742,
            -410874247.49273384,
            4618214.353438414
        ],
        [
            21878953.264983177,
            -410797464.5249529,
            4687822.116133446
        ],
        [
            34866021.57606075,
            -410242972.107843,
            4752107.62111814
        ],
        [
            47832042.274899654,
            -409210403.68909496,
            4810961.50225281
        ],
        [
            60757570.876381256,
            -407700345.71394384,
            4864284.798913171
        ],
        [
            73623183.13308111,
            -405714341.1360015,
            4911989.29911262
        ],
        [
            86409531.34905103,
            -403254888.8716628,
            4953997.838927632
        ],
        [
            99097400.61709158,
            -400325439.1762449,
            4990244.556147209
        ],
        [
            111667764.63970628,
            -396930384.9529397,
            5020675.096426227
        ],
        [
            124101840.79611109,
            -393075049.0386196,
            5045246.77060092
        ],
        [
            136381144.12338763,
            -388765667.54313046,
            5063928.662218304
        ],
        [
            148487539.88902158,
            -384009369.3505041,
            5076701.684734697
        ],
        [
            160403294.44454858,
            -378814151.9211091,
            5083558.588246338
        ],
        [
            172111124.06566614,
            -373188853.562752,
            5084503.916022477
        ],
        [
            183594241.5027183,
            -367143122.36577356,
            5079553.911512557
        ],
        [
            194836399.9866807,
            -360687382.02192354,
            5068736.376889418
        ],
        [
            205821934.4593317,
            -353832794.7689641,
            5052090.484564776
        ],
        [
            216535799.82187343,
            -346591221.7222968,
            5029666.543467175
        ],
        [
            226963606.02348515,
            -338975180.871231,
            5001525.72220181
        ],
        [
            237091649.83978766,
            -330997803.0306827,
            4967739.731512702
        ],
        [
            246906943.2205544,
            -322672786.0490062,
            4928390.46873723
        ],
        [
            256397238.11585626,
            -314014347.579288,
            4883569.627178666
        ],
        [
            265551047.7197618,
            -305037176.7247757,
            4833378.273521976
        ],
        [
            274357664.1003669,
            -295756384.8692592,
            4777926.396580512
        ],
        [
            282807172.21393275,
            -286187456.000235,
            4717332.430785518
        ],
        [
            290890460.3289358,
            -276346196.82677925,
            4651722.757916539
        ],
        [
            298599226.9125693,
            -266248686.98535305,
            4581231.19061922
        ],
        [
            305925984.0574133,
            -255911229.61554942,
            4505998.441268726
        ],
        [
            312864057.5493633,
            -245350302.57427126,
            4426171.579713527
        ],
        [
            319407583.6992914,
            -234582510.54130393,
            4341903.483377504
        ],
        [
            325551503.08013445,
            -223624538.25197524,
            4253352.283110619
        ],
        [
            331291551.32805425,
            -212493105.0739112,
            4160680.808062427
        ],
        [
            336624247.1809151,
            -201204921.1250559,
            4064056.032711315
        ],
        [
            341546877.9395243,
            -189776645.1094625,
            3963648.5290186573
        ],
        [
            346057482.5468968,
            -178224844.02615026,
            3859631.926494485
        ],
        [
            350154832.48825186,
            -166565954.88484132,
            3752182.3827626305
        ],
        [
            353838410.7195908,
            -154816248.54092476,
            3641478.0670025367
        ],
        [
            357108388.83565,
            -142991795.7407486,
            3527698.658424504
        ],
        [
            359965602.6888593,
            -131108435.44759242,
            3411024.8617089507
        ],
        [
            362411526.6698144,
            -119181745.49858105,
            3291637.941110697
        ],
        [
            364448246.8568529,
            -107227015.62355225,
            3169719.2746993536
        ],
        [
            366078433.2377394,
            -95259222.83866681,
            3045449.929979317
        ],
        [
            367305311.2004329,
            -83293009.21042085,
            2919010.2619096786
        ],
        [
            368132632.4825625,
            -71342661.96984383,
            2790579.5341278464
        ],
        [
            368564645.76079506,
            -59422095.94208287,
            2660335.5639727344
        ],
        [
            368606067.0518898,
            -47544838.243331134,
            2528454.3917051223
        ],
        [
            368262050.0870973,
            -35724015.18523267,
            2395109.974136269
        ],
        [
            367538156.8108277,
            -23972341.316423416,
            2260473.90270116
        ],
        [
            366440328.1433595,
            -12302110.521812528,
            2124715.145851535
        ],
        [
            364974855.13592416,
            -725189.0924987346,
            1987999.8154960675
        ],
        [
            363148350.6349424,
            10746989.327189013,
            1850490.9570810993
        ],
        [
            360967721.5606095,
            22103427.014145076,
            1712348.3627857147
        ],
        [
            358440141.89357173,
            33333563.764997788,
            1573728.4071989376
        ],
        [
            355573026.452188,
            44427276.924024135,
            1434783.9047548224
        ],
        [
            352374005.53192765,
            55374879.947558306,
            1295663.9881224902
        ],
        [
            348850900.4678991,
            66167119.61276904,
            1156514.0066821391
        ],
        [
            345011700.1713873,
            76795171.97855046,
            1017475.4441646385
        ],
        [
            340864538.681669,
            87250637.20538339,
            878685.8544900581
        ],
        [
            336417673.76530373,
            97525533.33938304,
            740278.814809524
        ],
        [
            331679466.5865965,
            107612289.16352165,
            602383.8947334548
        ],
        [
            326658362.46502846,
            117503736.21621582,
            465126.64071749797
        ],
        [
            321362872.728152,
            127193100.07421929,
            328628.5745740208
        ],
        [
            315801557.66175294,
            136673990.9931382,
            193007.20508101885
        ],
        [
            309983010.5530117,
            145940393.99492332,
            58376.05167142674
        ],
        [
            303915842.81689876,
            154986658.4875167,
            -75155.32079753443
        ],
        [
            297608670.1911495,
            163807487.49744797,
            -207481.25717312156
        ],
        [
            291070099.9808222,
            172397926.59167552,
            -338499.95798560197
        ],
        [
            284308719.3296455,
            180753352.5604064,
            -468113.4171980737
        ],
        [
            277333084.4920876,
            188869461.928018,
            -596227.3526155605
        ],
        [
            270151711.07727903,
            196742259.35463738,
            -722751.1298057827
        ],
        [
            262773065.2335895,
            204368045.98639864,
            -847597.6803461873
        ],
        [
            255205555.74074993,
            211743407.80795783,
            -970683.415172787
        ],
        [
            247457526.9748876,
            218865204.04652044,
            -1091928.1337665333
        ],
        [
            239537252.71070418,
            225730555.67243534,
            -1211254.9298723855
        ],
        [
            231452930.72418797,
            232336834.0373772,
            -1328590.0944059368
        ],
        [
            223212678.15874487,
            238681649.687268,
            -1443863.0161621643
        ],
        [
            214824527.6173743,
            244762841.38339767,
            -1557006.080901208
        ],
        [
            206296423.94350433,
            250578465.36171955,
            -1667954.5693473946
        ],
        [
            197636221.65331,
            256126784.85698402,
            -1776646.5545997513
        ],
        [
            188851682.982718,
            261406259.9152879,
            -1883022.7994158673
        ],
        [
            179950476.51285475,
            266415537.5157132,
            -1987026.6537956665
        ],
        [
            170940176.33838478,
            271153442.0190365,
            -2088603.953257945
        ],
        [
            161828261.7439757,
            275618965.95899695,
            -2187702.918170547
        ],
        [
            152622117.35503647,
            279811261.1893021,
            -2284274.0544644007
        ],
        [
            143329033.729831,
            283729630.3974492,
            -2378270.0560330935
        ],
        [
            133956208.36111422,
            287373518.9945034,
            -2469645.7090924773
        ],
        [
            124510747.05649082,
            290742507.38823056,
            -2558357.7987496383
        ],
        [
            114999665.66780752,
            293836303.6453976,
            -2644365.018006982
        ],
        [
            105429892.14099848,
            296654736.54763496,
            -2727627.879405321
        ],
        [
            95808268.85890934,
            299197749.04399085,
            -2808108.6294898554
        ],
        [
            86141555.25074509,
            301465392.10218084,
            -2885771.1662642667
        ],
        [
            76436430.64286089,
            303457818.95955336,
            -2960580.959781454
        ],
        [
            66699497.32668375,
            305175279.7739291,
            -3032504.976003991
        ],
        [
            56937283.82058307,
            306618116.6737261,
            -3101511.6040535364
        ],
        [
            47156248.30348536,
            307786759.2061527,
            -3167570.5869561015
        ],
        [
            37362782.19898564,
            308681720.1817099,
            -3230652.9559788844
        ],
        [
            27563213.88958633,
            309303591.9128015,
            -3290730.9686446837
        ],
        [
            17763812.541540496,
            309653042.843888,
            -3347778.050501272
        ],
        [
            7970792.021557361,
            309730814.57033074,
            -3401768.7407156858
        ],
        [
            -1809685.1126614138,
            309537719.24284875,
            -3452678.6415569987
        ],
        [
            -11571503.565415353,
            309074637.35434735,
            -3500484.371825718
        ],
        [
            -21308591.21631019,
            308342515.9057601,
            -3545163.5242834897
        ],
        [
            -31014915.010120653,
            307342366.947474,
            -3586694.6271330905
        ],
        [
            -40684476.838995814,
            306075266.4928693,
            -3625057.109595756
        ],
        [
            -50311309.43240972,
            304542353.8004972,
            -3660231.271630735
        ],
        [
            -59889472.26991772,
            302744831.02142763,
            -3692198.2578402054
        ],
        [
            -69413047.5315369,
            300683963.20832855,
            -3720940.0356016704
        ]
    ],
    "(2024 YR3)": [
        [
            156251501.8757009,
            245062511.47061962,
            -61981702.6850496
        ],
        [
            148217224.73939407,
            249848393.42825663,
            -62747731.67137975
        ],
        [
            140062002.28545994,
            254437848.18578896,
            -63464252.136874765
        ],
        [
            131788889.44778574,
            258828914.6609495,
            -64130940.68014462
        ],
        [
            123400926.82236314,
            263019581.2467158,
            -64747461.837647386
        ],
        [
            114901147.52678029,
            267007782.53957132,
            -65313467.61481994
        ],
        [
            106292584.23896584,
            270791396.33582395,
            -65828597.08534085
        ],
        [
            97578276.41948085,
            274368240.899279,
            -66292476.05944685
        ],
        [
            88761277.72206199,
            277736072.5049995,
            -66704716.822567746
        ],
        [
            79844663.59743254,
            280892583.2653806,
            -67064917.94589652
        ],
        [
            70831539.09560429,
            283835399.24631536,
            -67372664.17087242
        ],
        [
            61725046.87199682,
            286562078.88283527,
            -67627526.36992374
        ],
        [
            52528375.402686685,
            289070111.70527077,
            -67829061.58619472
        ],
        [
            43244767.413968086,
            291356917.38869923,
            -67976813.15536708
        ],
        [
            33877528.53114465,
            293419845.1402239,
            -68070310.91307981
        ],
        [
            24430036.151074618,
            295256173.4404583,
            -68109071.49185205
        ],
        [
            14905748.542445228,
            296863110.1574818,
            -68092598.7118204
        ],
        [
            5308214.177048862,
            298237793.05346525,
            -68020384.07001525
        ],
        [
            -4358918.705544442,
            299377290.70615923,
            -67891907.33331725
        ],
        [
            -14091892.298580855,
            300278603.86946404,
            -67706637.24065416
        ],
        [
            -23886829.19390765,
            300938667.2993741,
            -67464032.3204191
        ],
        [
            -33739722.1143468,
            301354352.0736922,
            -67163541.82951011
        ],
        [
            -43646423.41576128,
            301522468.4360287,
            -66804606.82080457
        ],
        [
            -53602634.36387421,
            301439769.196742,
            -66386661.34629022
        ],
        [
            -63603894.19312334,
            301102953.72560453,
            -65909133.80346972
        ],
        [
            -73645568.95734574,
            300508672.5730981,
            -65371448.43303614
        ],
        [
            -83722840.18490602,
            299653532.7593192,
            -64773026.97617681
        ],
        [
            -93830693.35402855,
            298534103.7714948,
            -64113290.500195324
        ],
        [
            -103963906.20759058,
            297146924.313049,
            -63391661.4014426
        ],
        [
            -114117036.93049926,
            295488509.84898025,
            -62607565.59480694
        ],
        [
            -124284412.21703252,
            293555360.9939923,
            -61760434.89922445
        ],
        [
            -134460115.26018932,
            291343972.7913115,
            -60849709.628823236
        ],
        [
            -144637973.70018864,
            288850844.93139464,
            -59874841.39939957
        ],
        [
            -154811547.57479584,
            286072492.9607228,
            -58835296.15992759
        ],
        [
            -164974117.3201509,
            283005460.5315488,
            -57730557.45871638
        ],
        [
            -175118671.8772354,
            279646332.7437415,
            -56560129.95363192
        ],
        [
            -185237896.96605927,
            275991750.6297072,
            -55323543.175486326
        ],
        [
            -195324163.59705687,
            272038426.8326776,
            -54020355.55324179
        ],
        [
            -205369516.89707443,
            267783162.52736723,
            -52650158.70906911
        ],
        [
            -215365665.33566836,
            263222865.6300394,
            -51212582.0305184
        ],
        [
            -225303970.44621903,
            258354570.34228292,
            -49707297.526086524
        ],
        [
            -235175437.14554864,
            253175458.06921002,
            -48134024.9692799
        ],
        [
            -244970704.76528144,
            247682879.74822676,
            -46492537.33485261
        ],
        [
            -254680038.91803598,
            241874379.61891082,
            -44782666.52922752
        ],
        [
            -264293324.3316331,
            235747720.45774147,
            -43004309.41515977
        ],
        [
            -273800058.7947314,
            229300910.29336736,
            -41157434.128459476
        ],
        [
            -283189348.3675834,
            222532230.60864872,
            -39242086.682030246
        ],
        [
            -292449904.0217867,
            215440266.0247764,
            -37258397.849585555
        ],
        [
            -301570039.88286036,
            208023935.45025128,
            -35206590.31816006
        ],
        [
            -310537673.2590141,
            200282524.66329792,
            -33086986.094919275
        ],
        [
            -319340326.64842105,
            192215720.28032294,
            -30900014.149783764
        ],
        [
            -327965131.92540956,
            183823645.04522657,
            -28646218.27101087
        ],
        [
            -336398836.91302615,
            175106894.35469443,
            -26326265.10612076
        ],
        [
            -344627814.5551028,
            166066573.91301662,
            -23940952.355418876
        ],
        [
            -352638074.9049954,
            156704338.38648912,
            -21491217.079864383
        ],
        [
            -360415280.1502114,
            147022430.902111,
            -18978144.07919001
        ],
        [
            -367944762.8918837,
            137023723.20815682,
            -16402974.290020097
        ],
        [
            -375211547.89508975,
            126711756.28541942,
            -13767113.14730781
        ],
        [
            -382200377.51999825,
            116090781.167655,
            -11072138.845772922
        ],
        [
            -388895741.03435117,
            105165799.69826137,
            -8319810.431239422
        ],
        [
            -395281907.9944847,
            93942604.9177816,
            -5512075.644930251
        ],
        [
            -401342965.8645559,
            82427820.74383093,
            -2651078.4369777553
        ],
        [
            -407062862.02154124,
            70628940.57192677,
            260833.94123496488
        ],
        [
            -412425450.2665603,
            58554364.39300406,
            3221104.3626382425
        ],
        [
            -417414541.9308738,
            46213433.99170995,
            6226959.870595228
        ],
        [
            -422013961.62728965,
            33616465.75958124,
            9275406.45353714
        ],
        [
            -426207607.65453523,
            20774780.629674584,
            12363224.660603896
        ],
        [
            -429979517.0133589,
            7700730.6149652,
            15486966.174338128
        ],
        [
            -433313934.93877184,
            -5592278.587253839,
            18642951.458867744
        ],
        [
            -436195388.7931201,
            -19089769.47772172,
            21827268.60302425
        ],
        [
            -438608766.0999043,
            -32776179.68596351,
            25035773.47727213
        ],
        [
            -440539396.4289546,
            -46634854.51296669,
            28264091.32096943
        ],
        [
            -441973136.77036273,
            -60648045.64314386,
            31507619.872146077
        ],
        [
            -442896459.9583466,
            -74796916.56785509,
            34761534.14549868
        ],
        [
            -443296545.62799335,
            -89061555.23789251,
            38020792.95551075
        ],
        [
            -443161373.1088395,
            -103420994.42692152,
            41280147.27038953
        ],
        [
            -442479815.5809075,
            -117853240.24135524,
            44534150.46879384
        ],
        [
            -441241734.7427162,
            -132335309.1540722,
            47777170.55507471
        ],
        [
            -439438075.1686439,
            -146843273.8696034,
            51003404.36999188
        ],
        [
            -437060957.4667157,
            -161352318.24695587,
            54206893.81269102
        ],
        [
            -434103769.28933764,
            -175836801.41348803,
            57381544.06629041
        ],
        [
            -430561253.20069635,
            -190270331.09984487,
            60521143.79395949
        ],
        [
            -426429590.3674347,
            -204625846.1129455,
            63619387.245187856
        ],
        [
            -421706479.0156956,
            -218875707.74271852,
            66669898.1834227
        ],
        [
            -416391206.5894364,
            -232991799.77042472,
            69666255.51685484
        ],
        [
            -410484714.5535822,
            -246945636.61403376,
            72602020.48438448
        ],
        [
            -403989654.81238043,
            -260708479.01157227,
            75470765.21928088
        ],
        [
            -396910436.75912607,
            -274251456.5092807,
            78266102.4844018
        ],
        [
            -389253264.03876597,
            -287545695.8906184,
            80981716.34571972
        ],
        [
            -381026160.1897978,
            -300562454.557654,
            83611393.52599907
        ],
        [
            -372238982.4358869,
            -313273257.7612098,
            86149055.15845333
        ],
        [
            -362903423.01974714,
            -325650038.4733511,
            88588788.64173889
        ],
        [
            -353032997.6105461,
            -337665278.6083184,
            90924879.28331181
        ],
        [
            -342643020.4693287,
            -349292150.22853416,
            93151841.40852204
        ],
        [
            -331750566.2221621,
            -360504655.32322526,
            95264448.60828212
        ],
        [
            -320374418.26488227,
            -371277762.7204962,
            97257762.79905812
        ],
        [
            -308535004.0030705,
            -381587540.6908389,
            99127161.7754887
        ],
        [
            -296254317.3125625,
            -391411283.8219838,
            100868364.94820479
        ],
        [
            -283555828.7854984,
            -400727632.7920032,
            102477456.97731486
        ],
        [
            -270464384.50075984,
            -409516685.73929524,
            103950909.03529492
        ],
        [
            -257006094.22171754,
            -417760100.02350754,
            105285597.4612973
        ],
        [
            -243208210.07482165,
            -425441183.28893995,
            106478819.60164143
        ],
        [
            -229098996.89632255,
            -432544972.8792153,
            107528306.66781637
        ],
        [
            -214707595.54828054,
            -439058302.8062388,
            108432233.48295656
        ],
        [
            -200063880.5965488,
            -444969857.64438266,
            109189225.02959897
        ],
        [
            -185198313.81066257,
            -450270212.89882034,
            109798359.75469314
        ],
        [
            -170141794.98728544,
            -454951861.5811114,
            110259169.6313826
        ],
        [
            -154925511.61447024,
            -459009226.91150904,
            110571637.0200759
        ],
        [
            -139580788.88356864,
            -462438661.252046,
            110736188.4128733
        ],
        [
            -124138941.5199605,
            -465238431.55337036,
            110753685.18466556
        ],
        [
            -108631128.84425917,
            -467408691.7679619,
            110625411.51040812
        ],
        [
            -93088214.39424765,
            -468951442.8394651,
            110353059.64052999
        ],
        [
            -77540631.33696544,
            -469870481.0196131,
            109938712.7546213
        ],
        [
            -62018254.78295231,
            -470171335.3882495,
            109384825.6370346
        ],
        [
            -46550281.98377037,
            -469861195.55650103,
            108694203.4365594
        ],
        [
            -31165121.252909422,
            -468948830.6170124,
            107869978.78574063
        ],
        [
            -15890290.302395046,
            -467444500.46769416,
            106915587.5637073
        ],
        [
            -752324.53621611,
            -465359860.6765853,
            105834743.58967116
        ],
        [
            14223304.30969426,
            -462707862.07566804,
            104631412.53278723
        ],
        [
            29012258.93978098,
            -459502646.2716994,
            103309785.31816377
        ],
        [
            43591396.585385025,
            -455759438.24372524,
            101874251.2988894
        ],
        [
            57938818.44247958,
            -451494437.1615609,
            100329371.45048669
        ],
        [
            72033908.62283531,
            -446724706.50915307,
            98679851.82772721
        ],
        [
            85857362.89449868,
            -441468064.53347313,
            96930517.50480482
        ],
        [
            99391207.5883739,
            -435742975.9657182,
            95086287.19902125
        ],
        [
            112618809.13510117,
            -429568445.87936497,
            93152148.75593784
        ],
        [
            125524874.76984203,
            -422963916.46130764,
            91133135.65092595
        ],
        [
            138095445.00199187,
            -415949167.38007796,
            89034304.6386951
        ],
        [
            150317878.49247918,
            -408544220.34102404,
            86860714.65915047
        ],
        [
            162180830.0136775,
            -400769248.32419395,
            84617407.0852302
        ],
        [
            173674222.18686926,
            -392644489.9081688,
            82309387.37654579
        ],
        [
            184789211.70051107,
            -384190168.99368834,
            79941608.18198673
        ],
        [
            195518150.71040303,
            -375426420.1558135,
            77518953.91519079
        ],
        [
            205854544.11139524,
            -366373219.77353954,
            75046226.80908924
        ],
        [
            215793003.35067832,
            -357050323.0120176,
            72528134.43975328
        ],
        [
            225329197.42627853,
            -347477206.6653455,
            69969278.69554842
        ],
        [
            234459801.6822826,
            -337673017.80764467,
            67374146.15519452
        ],
        [
            243182444.97576046,
            -327656528.146988,
            64747099.82770851
        ],
        [
            251495655.75045004,
            -317446093.93068403,
            62092372.19833587
        ],
        [
            259398807.51001257,
            -307059621.2113568,
            59414059.51738766
        ],
        [
            266892064.14005446,
            -296514536.250892,
            56716117.26329005
        ],
        [
            273976325.48392886,
            -285827760.813357,
            54002356.707020625
        ],
        [
            280653173.5333378,
            -275015692.07801145,
            51276442.502324894
        ],
        [
            286924819.5515962,
            -264094186.88902998,
            48541891.224540815
        ],
        [
            292794052.4055747,
            -253078550.04911348,
            45802070.780389264
        ],
        [
            298264188.3422951,
            -241983526.35918495,
            43060200.611561336
        ],
        [
            303339022.4082049,
            -230823296.10539854,
            40319352.61623466
        ],
        [
            308022781.67357206,
            -219611473.6971799,
            37582452.71464385
        ],
        [
            312320080.39141124,
            -208361109.1654685,
            34852282.987393424
        ],
        [
            316235877.1899515,
            -197084692.23831013,
            32131484.31823499
        ],
        [
            319775434.3699737,
            -185794158.72094512,
            29422559.476412296
        ],
        [
            322944279.353336,
            -174500898.9192099,
            26727876.57733491
        ],
        [
            325748168.30667573,
            -163215767.85797632,
            24049672.86417056
        ],
        [
            328193051.94449544,
            -151949097.0602057,
            21390058.756889015
        ],
        [
            330285043.49854046,
            -140710707.66666472,
            18751022.11927343
        ],
        [
            332030388.8254118,
            -129509924.69115746,
            16134432.69838223
        ],
        [
            333435438.611587,
            -118355592.2210953,
            13542046.694858797
        ],
        [
            334506622.624297,
            -107256089.38807793,
            10975511.426293608
        ],
        [
            335250425.9478622,
            -96219346.9478039,
            8436370.049527176
        ],
        [
            335673367.1379681,
            -85252864.32288417,
            5926066.311309136
        ],
        [
            335781978.22080094,
            -74363726.97588709,
            3445949.3000788093
        ],
        [
            335582786.45980245,
            -63558623.993153036,
            997278.1748030558
        ],
        [
            335082297.8098935,
            -52843865.77244963,
            -1418773.1502270885
        ],
        [
            334286981.9772185,
            -42225401.71941291,
            -3801111.3829671554
        ],
        [
            333203259.0016241,
            -31708837.868863136,
            -6148719.309316758
        ],
        [
            331837487.27909243,
            -21299454.35748218,
            -8460651.34033927
        ],
        [
            330195952.9420847,
            -11002222.684024721,
            -10736029.162226249
        ],
        [
            328284860.5170826,
            -821822.7021529078,
            -12974037.49825561
        ],
        [
            326110324.7804776,
            9237340.700793535,
            -15173919.990197238
        ],
        [
            323678363.7362306,
            19171121.27826923,
            -17334975.205003593
        ],
        [
            320994892.64134336,
            28975615.484589517,
            -19456552.771176036
        ],
        [
            318065719.00807226,
            38647146.94674249,
            -21538049.647903357
        ],
        [
            314896538.5149044,
            48182251.36854008,
            -23578906.528929394
        ],
        [
            311492931.7615559,
            57577661.882703364,
            -25578604.38210006
        ],
        [
            307860361.8065971,
            66830294.86203322,
            -27536661.124663804
        ],
        [
            304004172.42969537,
            75937236.19689517,
            -29452628.4336433
        ],
        [
            299929587.0638906,
            84895728.0427767,
            -31326088.689944863
        ],
        [
            295641708.3467179,
            93703156.03867732,
            -33156652.05432613
        ],
        [
            291145518.2423611,
            102357036.9944684,
            -34943953.67288162
        ],
        [
            286445878.690329,
            110855007.04314384,
            -36687651.00933452
        ],
        [
            281547532.7393763,
            119194810.25198574,
            -38387421.301121086
        ],
        [
            276455106.12854016,
            127374287.68509711,
            -40042959.136022985
        ],
        [
            271173109.28019214,
            135391366.9084782,
            -41653974.145934336
        ],
        [
            265705939.67294997,
            143244051.92778364,
            -43220188.81423198
        ],
        [
            260057884.56509674,
            150930413.54812643,
            -44741336.39315434
        ],
        [
            254233124.04185852,
            158448580.14471287,
            -46217158.92757064
        ],
        [
            248235734.36246386,
            165796728.8327148,
            -47647405.38153924
        ],
        [
            242069691.5853542,
            172973077.024593,
            -49031829.8641081
        ],
        [
            235738875.45225137,
            179975874.36302757,
            -50370189.95089123
        ],
        [
            229247073.51398644,
            186803395.0177258,
            -51662245.09806859
        ],
        [
            222597985.48308456,
            193453930.3345953,
            -52907755.14559092
        ],
        [
            215795227.80007315,
            199925781.82612222,
            -54106478.906529054
        ],
        [
            208842338.40232807,
            206217254.49224818,
            -55258172.83968562
        ],
        [
            201742781.6860262,
            212326650.46158248,
            -56362589.80277991
        ],
        [
            194499953.6533983,
            218252262.94342968,
            -57419477.88372873
        ],
        [
            187117187.23901418,
            223992370.4818289,
            -58428579.307770096
        ],
        [
            179597757.8102593,
            229545231.50359032,
            -59389629.41841385
        ],
        [
            171944888.83848608,
            234909079.15318647,
            -60302355.73045403
        ],
        [
            164161757.73856637,
            240082116.40827364,
            -61166477.05353667
        ],
        [
            156251501.87570095,
            245062511.4706196,
            -61981702.68504959
        ]
    ],
    "(2024 YF7)": [
        [
            197318998.1316767,
            191382619.93926042,
            15189718.892953793
        ],
        [
            191233621.6498874,
            197551111.53595456,
            14498677.616553625
        ],
        [
            184990938.15409836,
            203561743.10981652,
            13795624.231602123
        ],
        [
            178593552.84728447,
            209411746.79895553,
            13080856.92222057
        ],
        [
            172044061.01559883,
            215098326.99022114,
            12354673.44349749
        ],
        [
            165345053.11944836,
            220618656.19740093,
            11617371.680463782
        ],
        [
            158499120.11665112,
            225969871.17292637,
            10869250.224778514
        ],
        [
            151508859.0187208,
            231149069.25755867,
            10110608.969142202
        ],
        [
            144376878.6818245,
            236153304.973575,
            9341749.719482355
        ],
        [
            137105805.83437026,
            240979586.8680852,
            8562976.824974671
        ],
        [
            129698291.34351227,
            245624874.61429006,
            7774597.825972939
        ],
        [
            122157016.72309521,
            250086076.37973192,
            6976924.119919884
        ],
        [
            114484700.88569862,
            254360046.4718914,
            6170271.645300426
        ],
        [
            106684107.14147589,
            258443583.2728529,
            5354961.583676957
        ],
        [
            98758050.44640708,
            262333427.47618312,
            4531321.079812562
        ],
        [
            90709404.90239105,
            266026260.6406541,
            3699683.9798425958
        ],
        [
            82541111.51127857,
            269518704.0769755,
            2860391.587395843
        ],
        [
            74256186.18449377,
            272807318.0852972,
            2013793.4374940526
        ],
        [
            65857728.00928387,
            275888601.56287575,
            1160248.0879708808
        ],
        [
            57348927.77187842,
            278758992.0029844,
            300123.9280482102
        ],
        [
            48733076.736907676,
            281414865.9078628,
            -566199.996412212
        ],
        [
            40013575.68131818,
            283852539.6402514,
            -1438333.1416015811
        ],
        [
            31193944.179717943,
            286068270.7398285,
            -2315872.6091775987
        ],
        [
            22277830.136567473,
            288058259.7326453,
            -3198402.2753517143
        ],
        [
            13269019.558897316,
            289818652.4634403,
            -4085491.9068005495
        ],
        [
            4171446.561254382,
            291345542.98247814,
            -4976696.264772199
        ],
        [
            -5010796.407646477,
            292634977.0202949,
            -5871554.199001316
        ],
        [
            -14273448.129588604,
            293682956.08541775,
            -6769587.733315058
        ],
        [
            -23612067.988640875,
            294485442.2217443,
            -7670301.1451055985
        ],
        [
            -33022025.168950066,
            295038363.4637873,
            -8573180.0411651
        ],
        [
            -42498487.70081742,
            295337620.0293886,
            -9477690.432727048
        ],
        [
            -52036411.381060645,
            295379091.2907528,
            -10383277.81293381
        ],
        [
            -61630528.59772557,
            295158643.56571215,
            -11289366.240355315
        ],
        [
            -71275337.09362523,
            294672138.77196246,
            -12195357.43261785
        ],
        [
            -80965088.70795977,
            293915443.9875838,
            -13100629.874665309
        ],
        [
            -90693778.14040852,
            292884441.9614052,
            -14004537.946667504
        ],
        [
            -100455131.7875971,
            291575042.6166681,
            -14906411.077110844
        ],
        [
            -110242596.70771427,
            289983195.59091276,
            -15805552.927154046
        ],
        [
            -120049329.77529378,
            288104903.8540073,
            -16701240.61290497
        ],
        [
            -129868187.09475647,
            285936238.4446977,
            -17592723.97287054
        ],
        [
            -139691713.74822426,
            283473354.36390406,
            -18479224.888448082
        ],
        [
            -149512133.96033454,
            280712507.6601723,
            -19359936.665959112
        ],
        [
            -159321341.7702654,
            277650073.7391129,
            -20234023.489370465
        ],
        [
            -169110892.30889052,
            274282566.92426986,
            -21100619.953497957
        ],
        [
            -178871993.7868572,
            270606661.29157054,
            -21958830.68813719
        ],
        [
            -188595500.30735013,
            266619212.7932413,
            -22807730.08420666
        ],
        [
            -198271905.62529638,
            262317282.6797585,
            -23646362.133611526
        ],
        [
            -207891337.98267898,
            257698162.21996647,
            -24473740.395131607
        ],
        [
            -217443556.15734974,
            252759398.70986125,
            -25288848.099191897
        ],
        [
            -226917946.87014508,
            247498822.74965787,
            -26090638.404876832
        ],
        [
            -236303523.70206052,
            241914576.75656623,
            -26878034.822983947
        ],
        [
            -245588927.6795756,
            236005144.6671613,
            -27649931.819264125
        ],
        [
            -254762429.69176638,
            229769382.76831597,
            -28405195.612246566
        ],
        [
            -263811934.90739328,
            223206551.57936496,
            -29142665.180177685
        ],
        [
            -272724989.36350965,
            216316348.69048467,
            -29861153.491595782
        ],
        [
            -281488788.8990686,
            209098942.44326302,
            -30559448.973895755
        ],
        [
            -290090190.6072742,
            201555006.31913388,
            -31236317.233889613
        ],
        [
            -298515726.9787832,
            193685753.87988174,
            -31890503.04381676
        ],
        [
            -306751622.904051,
            185492974.0819018,
            -32520732.605481405
        ],
        [
            -314783815.69688344,
            176979066.76250976,
            -33125716.104171555
        ],
        [
            -322597978.29232705,
            168147078.07253635,
            -33704150.56272371
        ],
        [
            -330179545.76017624,
            159000735.60499847,
            -34254723.00452175
        ],
        [
            -337513745.26033807,
            149544482.94509012,
            -34776113.93233946
        ],
        [
            -344585629.5478772,
            139783513.342467,
            -35267001.1277414
        ],
        [
            -351380114.1135699,
            129723802.18320487,
            -35726063.77323502
        ],
        [
            -357882018.020084,
            119372137.91634662,
            -36151986.89651397
        ],
        [
            -364076108.464381,
            108736151.06913318,
            -36543466.13294741
        ],
        [
            -369947149.0635656,
            97824340.9663718,
            -36899212.798961595
        ],
        [
            -375479951.82422596,
            86646099.75352216,
            -37217959.265138894
        ],
        [
            -380659432.7144269,
            75211733.31057897,
            -37498464.61375165
        ],
        [
            -385470670.71314293,
            63532478.63534066,
            -37739520.56108136
        ],
        [
            -389898970.16435826,
            51620517.270790845,
            -37939957.62029097
        ],
        [
            -393929926.2127151,
            39488984.35272533,
            -38098651.475867905
        ],
        [
            -397549493.04499257,
            27151972.861021608,
            -38214529.53579929
        ],
        [
            -400744054.60747343,
            14624532.671618402,
            -38286577.62274918
        ],
        [
            -403500497.4141572,
            1922664.0268539488,
            -38313846.76065986
        ],
        [
            -405806285.005667,
            -10936694.930315346,
            -38295460.00848518
        ],
        [
            -407649533.5645344,
            -23935686.877220422,
            -38230619.28827997
        ],
        [
            -409019088.14039487,
            -37055560.56328213,
            -38118612.1507189
        ],
        [
            -409904598.8895987,
            -50276702.81747651,
            -37958818.41740838
        ],
        [
            -410296596.6890559,
            -63578677.47761381,
            -37750716.636195995
        ],
        [
            -410186567.4449688,
            -76940271.34167537,
            -37493890.28318249
        ],
        [
            -409567024.38471466,
            -90339547.16882333,
            -37188033.64340736
        ],
        [
            -408431577.59568316,
            -103753903.67906001,
            -36832957.30130931
        ],
        [
            -406775000.05948883,
            -117160142.41683036,
            -36428593.172146276
        ],
        [
            -404593289.42466795,
            -130534541.25627595,
            -35974999.00667112
        ],
        [
            -401883724.76661885,
            -143852934.2356948,
            -35472362.30355733
        ],
        [
            -398644917.60083956,
            -157090797.31755346,
            -34921003.56739187
        ],
        [
            -394876856.44494045,
            -170223339.57977587,
            -34321378.85451456
        ],
        [
            -390580944.26669824,
            -183225599.25575835,
            -33674081.554575354
        ],
        [
            -385760028.2095324,
            -196072543.95646244,
            -32979843.362365548
        ],
        [
            -380418421.05289495,
            -208739174.32985538,
            -32239534.402190268
        ],
        [
            -374561913.9425514,
            -221200630.3427277,
            -31454162.475695476
        ],
        [
            -368197780.01364565,
            -233432299.3092538,
            -30624871.413521774
        ],
        [
            -361334768.62657756,
            -245409924.7411788,
            -29752938.521284435
        ],
        [
            -353983090.0405573,
            -257109715.05761784,
            -28839771.121004876
        ],
        [
            -346154390.4605056,
            -268508451.16933537,
            -27886902.200056646
        ],
        [
            -337861717.50777084,
            -279583591.94389796,
            -26895985.19073602
        ],
        [
            -329119476.2818284,
            -290313376.56487435,
            -25868787.914512563
        ],
        [
            -319943376.29648286,
            -300676922.82048833,
            -24807185.73564335
        ],
        [
            -310350369.6878581,
            -310654320.3947028,
            -23713153.978933774
        ],
        [
            -300358581.2003649,
            -320226718.28612715,
            -22588759.675792936
        ],
        [
            -289987230.55874276,
            -329376405.54652184,
            -21436152.711174823
        ],
        [
            -279256547.92713296,
            -338086884.6098536,
            -20257556.45134584
        ],
        [
            -268187683.23816812,
            -346342936.57330835,
            -19055257.938532848
        ],
        [
            -256802610.2446775,
            -354130677.8916327,
            -17831597.743266556
        ],
        [
            -245124026.20255405,
            -361437608.05367094,
            -16588959.568560306
        ],
        [
            -233175248.13469213,
            -368252647.9228375,
            -15329759.701906875
        ],
        [
            -220980106.65208694,
            -374566168.53928673,
            -14056436.41142018
        ],
        [
            -208562838.31900132,
            -380370010.2984405,
            -12771439.381319107
        ],
        [
            -195947977.5446859,
            -385657492.53606033,
            -11477219.279401239
        ],
        [
            -183160248.96500182,
            -390423413.66208404,
            -10176217.54527268
        ],
        [
            -170224461.24423462,
            -394664042.091963,
            -8870856.482999954
        ],
        [
            -157165403.181552,
            -398377098.3234644,
            -7563529.735671699
        ],
        [
            -144007742.94925314,
            -401561728.5972702,
            -6256593.212255446
        ],
        [
            -130775931.22277778,
            -404218470.65993035,
            -4952356.529282078
        ],
        [
            -117494108.887056,
            -406349212.21681535,
            -3653075.021465253
        ],
        [
            -104186019.92198294,
            -407957142.719966,
            -2360942.3665473126
        ],
        [
            -90874929.98343375,
            -409046699.1807651,
            -1078083.8606396653
        ],
        [
            -77583551.10708064,
            -409623506.73005426,
            193449.62873507664
        ],
        [
            -64333972.87212801,
            -409694314.66886175,
            1451687.0136223882
        ],
        [
            -51147600.272570014,
            -409266928.76172584,
            2694741.631014075
        ],
        [
            -38045098.45624313,
            -408350140.5223237,
            3920815.181245677
        ],
        [
            -25046344.40813303,
            -406953654.2285926,
            5128200.96575347
        ],
        [
            -12170385.575309545,
            -405088012.3827299,
            6315286.437631944
        ],
        [
            564594.6425554156,
            -402764520.30147326,
            7480555.084844716
        ],
        [
            13141304.680060506,
            -399995170.4850571,
            8622587.671608496
        ],
        [
            25543366.073204935,
            -396792567.3704275,
            9740062.868362356
        ],
        [
            37755328.462109506,
            -393169853.0268667,
            10831757.3048369
        ],
        [
            49762678.629486084,
            -389140634.3013438,
            11896545.08405311
        ],
        [
            61551843.91221848,
            -384718911.8677696,
            12933396.79762992
        ],
        [
            73110190.35306612,
            -379919011.5799982,
            13941378.08459071
        ],
        [
            84426015.98189887,
            -374755518.47382206,
            14919647.776976373
        ],
        [
            95488539.63138342,
            -369243213.70925874,
            15867455.676049782
        ],
        [
            106287885.70108563,
            -363397014.6918839,
            16784140.00276523
        ],
        [
            116815065.2871247,
            -357231918.5614773,
            17669124.565546542
        ],
        [
            127061954.09232654,
            -350762949.1883738,
            18521915.687326837
        ],
        [
            137021267.52491897,
            -344005107.7730775,
            19342098.932321507
        ],
        [
            146686533.382813,
            -336973327.1032184,
            20129335.671197392
        ],
        [
            156052062.50600052,
            -329682429.484062,
            20883359.52122625
        ],
        [
            165112917.76223215,
            -322147088.3246299,
            21603972.695733074
        ],
        [
            173864881.71143833,
            -314381793.331131,
            22291042.294721376
        ],
        [
            182304423.27290738,
            -306400819.2328167,
            22944496.566032235
        ],
        [
            190428663.6965299,
            -298218197.94246185,
            23564321.163817678
        ],
        [
            198235342.11589807,
            -289847694.03435016,
            24150555.42852134
        ],
        [
            205722780.93716612,
            -281302783.40668374,
            24703288.709999397
        ],
        [
            212889851.29365435,
            -272596634.9825855,
            25222656.752910033
        ],
        [
            219735938.77255684,
            -263742095.29406902,
            25708838.16107836
        ],
        [
            226260909.59705988,
            -254751675.786262,
            26162050.95522577
        ],
        [
            232465077.42489433,
            -245637542.67457658,
            26582549.236254223
        ],
        [
            238349170.90304708,
            -236411509.1851045,
            26970619.96421095
        ],
        [
            243914302.09814468,
            -227085030.0080945,
            27326579.8611338
        ],
        [
            249161935.9030402,
            -217669197.79563054,
            27650772.444200043
        ],
        [
            254093860.50242183,
            -208174741.53738898,
            27943565.193971913
        ],
        [
            258712158.96388134,
            -198612026.65235683,
            28205346.861052264
        ],
        [
            263019182.00584817,
            -188991056.6394241,
            28436524.91313009
        ],
        [
            267017521.98009497,
            -179321476.13566834,
            28637523.12320537
        ],
        [
            270709988.09415525,
            -169612575.2376879,
            28808779.298729695
        ],
        [
            274099582.887898,
            -159873294.948408,
            28950743.15047735
        ],
        [
            277189479.9686551,
            -150112233.61920306,
            29063874.29916357
        ],
        [
            279983003.00062597,
            -140337654.26481485,
            29148640.417145316
        ],
        [
            282483605.93672264,
            -130557492.63632883,
            29205515.501965612
        ],
        [
            284694854.4745063,
            -120779365.94523591,
            29234978.27802849
        ],
        [
            286620408.71233004,
            -111010582.1393388,
            29237510.7223083
        ],
        [
            288264006.9771566,
            -101258149.63884178,
            29213596.709696893
        ],
        [
            289629450.79171187,
            -91528787.44834203,
            29163720.77336623
        ],
        [
            290720590.9455703,
            -81828935.56760173,
            29088366.975366063
        ],
        [
            291541314.6323899,
            -72164765.6308279,
            28988017.882576294
        ],
        [
            292095533.61374986,
            -62542191.71075387,
            28863153.64308785
        ],
        [
            292387173.36882603,
            -52966881.23003991,
            28714251.158084754
        ],
        [
            292420163.18840927,
            -43444265.928379744,
            28541783.34433926
        ],
        [
            292198427.1714692,
            -33979552.83924103,
            28346218.482505336
        ],
        [
            291725876.0825395,
            -24577735.235321313,
            28128019.64649775
        ],
        [
            291006400.0285969,
            -15243603.506621718,
            27887644.209370553
        ],
        [
            290043861.9147815,
            -5981755.939500928,
            27625543.421255052
        ],
        [
            288842091.63921976,
            3203390.630822271,
            27342162.05507964
        ],
        [
            287404880.9883173,
            12307590.318054676,
            27037938.11596906
        ],
        [
            285735979.1951672,
            21326757.853200257,
            26713302.61040494
        ],
        [
            283839089.1251223,
            30256958.440652132,
            26368679.37142115
        ],
        [
            281717864.05409133,
            39094397.81630826,
            26004484.936303116
        ],
        [
            279375905.0067098,
            47835412.519436166,
            25621128.47345853
        ],
        [
            276816758.6231892,
            56476460.387717545,
            25219011.75532604
        ],
        [
            274043915.5253296,
            65014111.282865465,
            24798529.174385794
        ],
        [
            271060809.15390235,
            73445038.05238853,
            24360067.79953225
        ],
        [
            267870815.051321,
            81766007.73150492,
            23904007.47026128
        ],
        [
            264477250.5652392,
            89973872.9878304,
            23430720.926312014
        ],
        [
            260883374.95041615,
            98065563.81028554,
            22940573.970587336
        ],
        [
            257092389.8478639,
            106038079.44268185,
            22433925.66335352
        ],
        [
            253107440.12194365,
            113888480.5616129,
            21911128.545892082
        ],
        [
            248931615.03768027,
            121613881.69762221,
            21372528.8919406
        ],
        [
            244567949.7621369,
            129211443.8981007,
            20818466.985418297
        ],
        [
            240019427.17520836,
            136678367.6299872,
            20249277.423082847
        ],
        [
            235288979.9766586,
            144011885.9201073,
            19665289.44090862
        ],
        [
            230379493.07764933,
            151209257.7308489,
            19066827.26311371
        ],
        [
            225293806.2663598,
            158267761.56886902,
            18454210.472891793
        ],
        [
            220034717.13860607,
            165184689.3246163,
            17827754.404027067
        ],
        [
            214604984.28560808,
            171957340.34064206,
            17187770.552684907
        ],
        [
            209007330.73223788,
            178583015.70697337,
            16534567.008777529
        ],
        [
            203244447.62020275,
            185059012.78218177,
            15868448.906403787
        ],
        [
            197318998.13167676,
            191382619.93926036,
            15189718.892953798
        ]
    ],
    "(2024 YR8)": [
        [
            223400953.60692894,
            162763447.50789514,
            -27533523.11966508
        ],
        [
            218161236.62116265,
            169792228.40041846,
            -27288735.873572446
        ],
        [
            212731938.31908223,
            176676448.67946383,
            -27020345.291576143
        ],
        [
            207116168.72559145,
            183411931.9004476,
            -26728496.49946909
        ],
        [
            201317079.8755709,
            189994521.94753778,
            -26413339.420651365
        ],
        [
            195337868.90810215,
            196420080.1865928,
            -26075028.968882184
        ],
        [
            189181781.40957254,
            202684482.8450556,
            -25713725.273392588
        ],
        [
            182852114.99872172,
            208783618.629356,
            -25329593.93608072
        ],
        [
            176352223.1466319,
            214713386.59066677,
            -24922806.320516635
        ],
        [
            169685519.2245491,
            220469694.25020134,
            -24493539.872485217
        ],
        [
            162855480.7722323,
            226048455.9956034,
            -24041978.47179088
        ],
        [
            155865653.9792789,
            231445591.76038408,
            -23568312.815038785
        ],
        [
            148719658.37154296,
            236657025.9987826,
            -23072740.8290907
        ],
        [
            141421191.6943552,
            241678686.96887183,
            -22555468.114871223
        ],
        [
            133974034.983765,
            246506506.33718282,
            -22016708.421169337
        ],
        [
            126382057.81644453,
            251136419.11858934,
            -21456684.148041878
        ],
        [
            118649223.72822721,
            255564363.96565482,
            -20875626.8793783
        ],
        [
            110779595.79048811,
            259786283.82210106,
            -20273777.94412917
        ],
        [
            102777342.33270843,
            263798126.9555003,
            -19651389.00563394
        ],
        [
            94646742.79860155,
            267595848.38471264,
            -19008722.67840615
        ],
        [
            86392193.72210327,
            271175411.71797395,
            -18346053.17164495
        ],
        [
            78018214.80834845,
            274532791.41788995,
            -17663666.958640866
        ],
        [
            69529455.10346133,
            277663975.50987875,
            -16961863.471129972
        ],
        [
            60930699.235580996,
            280564968.7508388,
            -16240955.817523474
        ],
        [
            52226873.70802005,
            283231796.2749658,
            -15501271.523798833
        ],
        [
            43423053.22381714,
            285660507.7337153,
            -14743153.295683295
        ],
        [
            34524467.01919104,
            287847181.94686055,
            -13966959.800590161
        ],
        [
            25536505.181535408,
            289787932.08144784,
            -13173066.4675828
        ],
        [
            16464724.925614148,
            291478911.37516075,
            -12361866.303440008
        ],
        [
            7314856.799528778,
            292916319.42017156,
            -11533770.722679047
        ],
        [
            -1907189.2101623118,
            294096409.0229553,
            -10689210.38915953
        ],
        [
            -11195317.707083032,
            295015493.6547619,
            -9828636.066641752
        ],
        [
            -20543242.082721934,
            295669955.50645536,
            -8952519.475407965
        ],
        [
            -29944478.920902,
            296056254.1602247,
            -8061354.151773762
        ],
        [
            -39392342.64929955,
            296170935.8892329,
            -7155656.307020915
        ],
        [
            -48879940.480847955,
            296010643.59456426,
            -6235965.681972304
        ],
        [
            -58400167.69046746,
            295572127.3868602,
            -5302846.393105488
        ],
        [
            -67945703.27517818,
            294852255.81775534,
            -4356887.765765572
        ],
        [
            -77509006.04826526,
            293848027.7636435,
            -3398705.1496908115
        ],
        [
            -87082311.22073364,
            292556584.96138215,
            -2428940.711709163
        ],
        [
            -96657627.52579883,
            290975225.1922801,
            -1448264.2001015805
        ],
        [
            -106226734.94456676,
            289101416.1070825,
            -457373.6747618858
        ],
        [
            -115781183.09332997,
            286932809.680666,
            543003.8030838585
        ],
        [
            -125312290.335005,
            284467257.28076553,
            1552111.5282000545
        ],
        [
            -134811143.67912006,
            281702825.3302728,
            2569162.5626660343
        ],
        [
            -144268599.5363767,
            278637811.537471,
            3593339.208508949
        ],
        [
            -153675285.3951151,
            275270761.6629926,
            4623792.549283611
        ],
        [
            -163021602.487951,
            271600486.78632873,
            5659642.068548534
        ],
        [
            -172297729.51736364,
            267626081.0283719,
            6699975.353471352
        ],
        [
            -181493627.5090551,
            263346939.67977318,
            7743847.892048382
        ],
        [
            -190599045.86139065,
            258762777.67784768,
            8790282.97263448
        ],
        [
            -199603529.65812823,
            253873648.36741766,
            9838271.694644872
        ],
        [
            -208496428.30987623,
            248679962.47335857,
            10886773.099401942
        ],
        [
            -217266905.58722436,
            243182507.20478144,
            11934714.430149483
        ],
        [
            -225903951.10521948,
            237382465.4027763,
            12980991.53023763
        ],
        [
            -234396393.3147396,
            231281434.6355503,
            14024469.388384242
        ],
        [
            -242732914.05130777,
            224881446.1366676,
            15063982.839736175
        ],
        [
            -250902064.68593222,
            218184983.47404873,
            16098337.431178108
        ],
        [
            -258892283.91561794,
            211195000.82949036,
            17126310.45895971
        ],
        [
            -266691917.22323275,
            203914940.76084238,
            18146652.186227307
        ],
        [
            -274289238.0274085,
            196348751.31173244,
            19158087.247446757
        ],
        [
            -281672470.5330921,
            188500902.3269917,
            20159316.2459841
        ],
        [
            -288829814.28224844,
            180376400.8258335,
            21149017.550265692
        ],
        [
            -295749470.39205396,
            171980805.27950913,
            22125849.292965055
        ],
        [
            -302419669.4547541,
            163320238.63576227,
            23088451.57655856
        ],
        [
            -308828701.059233,
            154401399.9290567,
            24035448.887355305
        ],
        [
            -314964944.879326,
            145231574.31342676,
            24965452.71873869
        ],
        [
            -320816903.2580942,
            135818641.35402715,
            25877064.40286313
        ],
        [
            -326373235.2007791,
            126171081.41419157,
            26768878.148432814
        ],
        [
            -331622791.6721029,
            116297979.97717091,
            27639484.280459847
        ],
        [
            -336554652.0761298,
            106209029.74585687,
            28487472.67606567
        ],
        [
            -341158161.7792377,
            95914530.36978662,
            29311436.38846657
        ],
        [
            -345422970.51906466,
            85425385.65669233,
            30109975.44928635
        ],
        [
            -349339071.5248066,
            74753098.13585979,
            30881700.837285288
        ],
        [
            -352896841.1572004,
            63909760.85264456,
            31625238.599506382
        ],
        [
            -356087078.8601674,
            52908046.28769237,
            32339234.108739022
        ],
        [
            -358901047.2006909,
            41761192.31069434,
            33022356.43911557
        ],
        [
            -361330511.7593299,
            30482985.09685251,
            33673302.83961248
        ],
        [
            -363367780.6211014,
            19087738.9545393,
            34290803.28325721
        ],
        [
            -365005743.20557153,
            7590273.0348008275,
            34873625.06797313
        ],
        [
            -366237908.1661655,
            -3994115.082793653,
            35420577.44326252
        ],
        [
            -367058440.08215916,
            -15649678.908093572,
            35930516.23535988
        ],
        [
            -367462194.662844,
            -27360255.615629494,
            36402348.442121
        ],
        [
            -367444752.1821153,
            -39109301.60311973,
            36835036.76777365
        ],
        [
            -367002448.863461,
            -50879930.93086758,
            37227604.06677628
        ],
        [
            -366132405.94013065,
            -62654956.511076644,
            37579137.665435836
        ],
        [
            -364832556.12327814,
            -74416933.88752015,
            37888793.52965032
        ],
        [
            -363101667.2221343,
            -86148207.4178282,
            38155800.247185215
        ],
        [
            -360939362.67480385,
            -97830958.64330202,
            38379462.79328162
        ],
        [
            -358346138.7660389,
            -109447256.60503781,
            38559166.04913819
        ],
        [
            -355323378.3292213,
            -120979109.84066163,
            38694378.04391509
        ],
        [
            -351873360.75363386,
            -132408519.773538,
            38784652.89237547
        ],
        [
            -347999268.14469427,
            -143717535.18630186,
            38829633.40210096
        ],
        [
            -343705187.5139071,
            -154888307.45335004,
            38829053.32638259
        ],
        [
            -338996108.90651935,
            -165903146.19282368,
            38782739.24137485
        ],
        [
            -333877919.40790224,
            -176744574.98791802,
            38690612.02888669
        ],
        [
            -328357393.00408167,
            -187395386.82029983,
            38552687.94923615
        ],
        [
            -322442176.30719656,
            -197838698.85517332,
            38369079.29188002
        ],
        [
            -316140770.19247,
            -208058006.21824774,
            38139994.59500548
        ],
        [
            -309462507.42907184,
            -218037234.40956503,
            37865738.42889149
        ],
        [
            -302417526.4225248,
            -227760790.00784087,
            37546710.741566576
        ],
        [
            -295016741.22056496,
            -237213609.33158866,
            37183405.76905571
        ],
        [
            -287271807.9671347,
            -246381204.739664,
            36776410.516269706
        ],
        [
            -279195088.01999855,
            -255249708.27381188,
            36326402.81829564
        ],
        [
            -270799607.97589916,
            -263805912.3690198,
            35834148.9954433
        ],
        [
            -262099016.8728323,
            -272037307.38366765,
            35300501.11884199
        ],
        [
            -253107540.86156037,
            -279932115.73024726,
            34726393.90661733
        ],
        [
            -243839935.65763855,
            -287479322.4183726,
            34112841.273666434
        ],
        [
            -234311437.10074663,
            -294668701.85448265,
            33460932.560753044
        ],
        [
            -224537710.15985945,
            -301490840.7765776,
            32771828.47102915
        ],
        [
            -214534796.73064446,
            -307937157.2370357,
            32046756.744129896
        ],
        [
            -204319062.57541198,
            -313999915.581558,
            31287007.59966111
        ],
        [
            -193907143.75600636,
            -319672237.4070937,
            30493928.983192235
        ],
        [
            -183315892.90630597,
            -324948108.515744,
            29668921.64877094
        ],
        [
            -172562325.6836539,
            -329822381.9146982,
            28813434.112490598
        ],
        [
            -161663567.72778225,
            -334290776.94380116,
            27928957.511771835
        ],
        [
            -150636802.4418831,
            -338349874.6420281,
            27017020.404776663
        ],
        [
            -139499219.89370477,
            -341997109.4916241,
            26079183.54377432
        ],
        [
            -128267967.11527199,
            -345230757.70367223,
            25117034.6553455
        ],
        [
            -116960100.05836722,
            -348049922.23117197,
            24132183.259069808
        ],
        [
            -105592537.43967952,
            -350454514.71516097,
            23126255.55482282
        ],
        [
            -94182016.68487993,
            -352445234.58588445,
            22100889.40704459
        ],
        [
            -82745052.15523225,
            -354023545.5544466,
            21057729.452367302
        ],
        [
            -71297895.81405258,
            -355191649.74075794,
            19998422.354840934
        ],
        [
            -59856500.46377933,
            -355952459.6909457,
            18924612.230710644
        ],
        [
            -48436485.65793729,
            -356309568.54182065,
            17837936.26231285
        ],
        [
            -37053106.366217256,
            -356267218.5915943,
            16740020.518206175
        ],
        [
            -25721224.445535183,
            -355830268.53498554,
            15632475.994172245
        ],
        [
            -14455282.945545018,
            -355004159.61731684,
            14516894.88724137
        ],
        [
            -3269283.2539122105,
            -353794880.956396,
            13394847.112452373
        ],
        [
            7823234.935133606,
            -352208934.2731278,
            12267877.069667049
        ],
        [
            18809210.86564669,
            -350253298.2621489,
            11137500.665457578
        ],
        [
            29676077.233408093,
            -347935392.8225602,
            10005202.592887308
        ],
        [
            40411772.03990105,
            -345263043.3563136,
            8872433.869930046
        ],
        [
            51004747.87362626,
            -342244445.3282236,
            7740609.635338372
        ],
        [
            61443978.71860008,
            -338888129.2671668,
            6611107.198983617
        ],
        [
            71718964.40101469,
            -335202926.37303674,
            5485264.342062999
        ],
        [
            81819732.79434691,
            -331197934.878659,
            4364377.861105131
        ],
        [
            91736839.91072491,
            -326882487.3003326,
            3249702.348406147
        ],
        [
            101461368.01213907,
            -322266118.69515955,
            2142449.2003990114
        ],
        [
            110984921.87925379,
            -317358536.02800137,
            1043785.8444904741
        ],
        [
            120299623.37818818,
            -312169588.73592186,
            -45164.82590516284
        ],
        [
            129398104.4668292,
            -306709240.5634775,
            -1123324.8190574674
        ],
        [
            138273498.7821395,
            -300987542.7282864,
            -2189661.226763732
        ],
        [
            146919431.94861406,
            -295014608.4630766,
            -3243186.232135604
        ],
        [
            155330010.74570274,
            -288800588.96791786,
            -4282956.955355897
        ],
        [
            163499811.26872528,
            -282355650.7946647,
            -5308075.1495475415
        ],
        [
            171423866.21371776,
            -275689954.6748159,
            -6317686.758903258
        ],
        [
            179097651.41188398,
            -268813635.7920387,
            -7310981.351133592
        ],
        [
            186517071.73397195,
            -261736785.49155524,
            -8287191.436109936
        ],
        [
            193678446.4791099,
            -254469434.41041258,
            -9245591.682324354
        ],
        [
            200578494.3564722,
            -247021537.0053754,
            -10185498.04246338
        ],
        [
            207214318.16174695,
            -239402957.44874525,
            -11106266.7990148
        ],
        [
            213583389.24379385,
            -231623456.8568169,
            -12007293.540399043
        ],
        [
            219683531.85021812,
            -223692681.8108866,
            -12888012.077652542
        ],
        [
            225512907.43391228,
            -215620154.1266762,
            -13747893.311197244
        ],
        [
            231069998.99598077,
            -207415261.82472596,
            -14586444.056713782
        ],
        [
            236353595.5339458,
            -199087251.2516362,
            -15403205.838606969
        ],
        [
            241362776.65776053,
            -190645220.30001163,
            -16197753.659013482
        ],
        [
            246096897.42997766,
            -182098112.67348844,
            -16969694.749761015
        ],
        [
            250555573.48048472,
            -173454713.14227226,
            -17718667.314151682
        ],
        [
            254738666.4405191,
            -164723643.73414758,
            -18444339.26491084
        ],
        [
            258646269.73527175,
            -155913360.805847,
            -19146406.964124784
        ],
        [
            262278694.76927048,
            -147032152.93999863,
            -19824593.970485598
        ],
        [
            265636457.53391838,
            -138088139.61350995,
            -20478649.79867391
        ],
        [
            268720265.6620709,
            -129089270.58417428,
            -21108348.695243645
        ],
        [
            271531005.95034146,
            -120043325.94347031,
            -21713488.434924826
        ],
        [
            274069732.36595917,
            -110957916.78489503,
            -22293889.14083776
        ],
        [
            276337654.5514382,
            -101840486.43873025,
            -22849392.131710824
        ],
        [
            278336126.837057,
            -92698312.22583047,
            -23379858.798817724
        ],
        [
            280066637.768186,
            -83538507.6848061,
            -23885169.514998883
        ],
        [
            281530800.15181684,
            -74368025.22886385,
            -24365222.57780325
        ],
        [
            282730341.6242453,
            -65193659.19048011,
            -24819933.18848475
        ],
        [
            283667095.73970604,
            -56022049.2140495,
            -25249232.46830769
        ],
        [
            284342993.5778647,
            -46859683.95862293,
            -25653066.513359763
        ],
        [
            284760055.8663987,
            -37712905.07480101,
            -26031395.488838427
        ],
        [
            284920385.6134496,
            -28587911.421805978,
            -26384192.763564244
        ],
        [
            284826161.2434865,
            -19490763.49264331,
            -26711444.085285246
        ],
        [
            284479630.22905684,
            -10427388.017137095,
            -27013146.7971649
        ],
        [
            283883103.2100191,
            -1403582.7144090831,
            -27289309.095695157
        ],
        [
            283038948.5911311,
            7574978.831886992,
            -27539949.33014234
        ],
        [
            281949587.6082845,
            16502742.200602606,
            -27765095.343515888
        ],
        [
            280617489.8532352,
            25374267.085858032,
            -27964783.85494966
        ],
        [
            279045169.2463526,
            34184222.19747335,
            -28139059.883297823
        ],
        [
            277235180.44669485,
            42927380.12960918,
            -28287976.21167486
        ],
        [
            275190115.68859017,
            51598612.216826916,
            -28411592.89260805
        ],
        [
            272912602.0338737,
            60192883.39554371,
            -28509976.79342168
        ],
        [
            270405299.02895725,
            68705247.08772418,
            -28583201.18143342
        ],
        [
            267670896.75601375,
            77130840.12258476,
            -28631345.348513894
        ],
        [
            264712114.26770672,
            85464877.7111404,
            -28654494.274539523
        ],
        [
            261531698.39509332,
            93702648.48754412,
            -28652738.32925574
        ],
        [
            258132422.91856372,
            101839509.6303879,
            -28626173.012060937
        ],
        [
            254517088.0919372,
            109870882.07644778,
            -28574898.72922116
        ],
        [
            250688520.5101195,
            117792245.83873472,
            -28499020.608029928
        ],
        [
            246649573.3110186,
            125599135.4401995,
            -28398648.34743679
        ],
        [
            242403126.70271376,
            133287135.4739864,
            -28273896.104680073
        ],
        [
            237952088.80718124,
            140851876.30076754,
            -28124882.41747556
        ],
        [
            233299396.81216174,
            148289029.8934035,
            -27951730.16132957
        ],
        [
            228448018.42304838,
            155594305.8389503,
            -27754566.54156456
        ],
        [
            223400953.60692897,
            162763447.50789508,
            -27533523.11966508
        ]
    ],
    "(2024 YR9)": [
        [
            82354958.1618789,
            302537156.5077198,
            3134074.4937036675
        ],
        [
            72809020.37107688,
            304981549.39957064,
            4090140.759099153
        ],
        [
            63196355.75272572,
            307155702.5477673,
            5042784.411884376
        ],
        [
            53523370.8881527,
            309058026.7760242,
            5991365.611142328
        ],
        [
            43796502.85820001,
            310687023.9499462,
            6935244.938028907
        ],
        [
            34022222.08401721,
            312041287.0700354,
            7873783.140111195
        ],
        [
            24207035.207163453,
            313119500.69835585,
            8806340.88385785
        ],
        [
            14357487.992572911,
            313920441.72227466,
            9732278.516900938
        ],
        [
            4480168.237689182,
            314442980.45842355,
            10650955.841701388
        ],
        [
            -5418291.329214588,
            314686082.09975135,
            11561731.902267063
        ],
        [
            -15331210.178848758,
            314648808.50822693,
            12463964.785592016
        ],
        [
            -25251857.156550705,
            314330320.35542846,
            13357011.439508684
        ],
        [
            -35173447.721876115,
            313729879.61289084,
            14240227.508670166
        ],
        [
            -45089141.27071802,
            312846852.3936808,
            15112967.190407837
        ],
        [
            -54992038.559033364,
            311680712.14622325,
            15974583.11223936
        ],
        [
            -64875179.247795075,
            310231043.200905,
            16824426.232833795
        ],
        [
            -74731539.58935799,
            308497544.6694222,
            17661845.768272616
        ],
        [
            -84554030.27602695,
            306480034.69621783,
            18486189.14547867
        ],
        [
            -94335494.47224472,
            304178455.06066376,
            19296801.98471772
        ],
        [
            -104068706.05246237,
            301592876.12786806,
            20093028.11310916
        ],
        [
            -113746368.06742072,
            298723502.1451359,
            20874209.611112975
        ],
        [
            -123361111.46224426,
            295570676.8801678,
            21639686.89398823
        ],
        [
            -132905494.07042585,
            292134889.59603554,
            22388798.83024329
        ],
        [
            -142371999.9084521,
            288416781.35683346,
            23120882.89911917
        ],
        [
            -151753038.79647762,
            284417151.6566523,
            23835275.389163192
        ],
        [
            -161040946.33109468,
            280136965.36315507,
            24531311.63996039
        ],
        [
            -170227984.23684618,
            275577359.96555525,
            25208326.329092838
        ],
        [
            -179306341.12369233,
            270739653.1151886,
            25865653.80639174
        ],
        [
            -188268133.67814624,
            265625350.44514173,
            26502628.47753234
        ],
        [
            -197105408.31622893,
            260236153.65353924,
            27118585.238995988
        ],
        [
            -205810143.3267505,
            254573968.83309984,
            27712859.966386106
        ],
        [
            -214374251.53368118,
            248640915.02744907,
            28284790.058033407
        ],
        [
            -222789583.5065204,
            242439332.99242258,
            28833715.035759944
        ],
        [
            -231047931.34758848,
            235971794.13820618,
            29358977.204588752
        ],
        [
            -239141033.0850354,
            229241109.6256469,
            29859922.37308581
        ],
        [
            -247060577.70006323,
            222250339.58743268,
            30335900.63590124
        ],
        [
            -254798210.81638432,
            215002802.44208437,
            30786267.21993622
        ],
        [
            -262345541.07925057,
            207502084.26584095,
            31210383.3953993
        ],
        [
            -269694147.2504898,
            199752048.18455637,
            31607617.452829167
        ],
        [
            -276835586.04483443,
            191756843.74468228,
            31977345.746949248
        ],
        [
            -283761400.73142105,
            183520916.21928692,
            32318953.807981383
        ],
        [
            -290463130.5226463,
            175049015.8018921,
            32631837.520779885
        ],
        [
            -296932320.7705703,
            166346206.63770252,
            32915404.37185307
        ],
        [
            -303160533.98874414,
            157417875.63858706,
            33169074.764014788
        ],
        [
            -309139361.71468586,
            148269741.02496994,
            33392283.398054745
        ],
        [
            -314860437.2252177,
            138907860.53463832,
            33584480.72043047
        ],
        [
            -320315449.11350214,
            129338639.23539454,
            33745134.43556835
        ],
        [
            -325496155.73285383,
            119568836.87551738,
            33873731.0809138
        ],
        [
            -330394400.50824916,
            109605574.70318842,
            33969777.66239343
        ],
        [
            -335002128.1119097,
            99456341.6834166,
            34032803.34744516
        ],
        [
            -339311401.49437594,
            89129000.03861806,
            34062361.21223692
        ],
        [
            -343314419.75714076,
            78631790.03690878,
            34058030.03913302
        ],
        [
            -347003536.84715503,
            67973333.95040548,
            34019416.15988109
        ],
        [
            -350371281.0473887,
            57162639.104454696,
            33946155.33938463
        ],
        [
            -353410375.2311197,
            46209099.937765755,
            33837914.69430048
        ],
        [
            -356113757.84077555,
            35122498.99297849,
            33694394.640059985
        ],
        [
            -358474604.54497784,
            23913006.757290453,
            33515330.859262384
        ],
        [
            -360486350.5199854,
            12591180.273463428,
            33300496.28373383
        ],
        [
            -362142713.2940343,
            1167960.4428786635,
            33049703.08189127
        ],
        [
            -363437716.0851874,
            -10345332.055642039,
            32762804.642403655
        ],
        [
            -364365711.555277,
            -21937002.30473374,
            32439697.544509754
        ],
        [
            -364921405.8944419,
            -33594988.21499097,
            32080323.504741278
        ],
        [
            -365099883.142661,
            -45306869.18454014,
            31684671.289217893
        ],
        [
            -364896629.6466913,
            -57059876.411852375,
            31252778.580137607
        ],
        [
            -364307558.5429743,
            -68840904.91578452,
            30784733.784589067
        ],
        [
            -363329034.1495111,
            -80636527.30974737,
            30280677.773371883
        ],
        [
            -361957896.1424935,
            -92433009.36889338,
            29740805.537135333
        ],
        [
            -360191483.38674116,
            -104216327.42030069,
            29165367.746845305
        ],
        [
            -358027657.2828259,
            -115972187.576315,
            28554672.205372218
        ],
        [
            -355464824.4882836,
            -127686046.8205341,
            27909085.17686875
        ],
        [
            -352501958.8656329,
            -139343135.94440323,
            27229032.580584332
        ],
        [
            -349138622.50613916,
            -150928484.32011774,
            26515001.03585051
        ],
        [
            -345374985.6755055,
            -162426946.4825443,
            25767538.74517695
        ],
        [
            -341211845.52603537,
            -173823230.47927368,
            24987256.202726267
        ],
        [
            -336650643.41938895,
            -185101927.93381256,
            24174826.715894215
        ],
        [
            -331693480.70495474,
            -196247545.75240117,
            23330986.728313852
        ],
        [
            -326343132.80113333,
            -207244539.3901663,
            22456535.93332981
        ],
        [
            -320603061.430576,
            -218077347.57740155,
            21552337.16785471
        ],
        [
            -314477424.86566997,
            -228730428.3918835,
            20619316.0775217
        ],
        [
            -307971086.04736054,
            -239188296.5484273,
            19658460.54518398
        ],
        [
            -301089618.4487628,
            -249435561.76255834,
            18670819.876078293
        ],
        [
            -293839309.564942,
            -259456968.03137505,
            17657503.734359488
        ],
        [
            -286227161.9217073,
            -269237433.66162014,
            16619680.827217735
        ],
        [
            -278260891.5092187,
            -278762091.8628133,
            15558577.334398398
        ],
        [
            -269948923.5605932,
            -288016331.71224135,
            14475475.082645018
        ],
        [
            -261300385.61140597,
            -296985839.2888099,
            13371709.466361925
        ],
        [
            -252325097.79291597,
            -305656638.76440465,
            12248667.117630495
        ],
        [
            -243033560.32984948,
            -314015133.23466575,
            11107783.330591286
        ],
        [
            -233436938.2325021,
            -322048145.0660626,
            9950539.247105839
        ],
        [
            -223547043.19258103,
            -329742955.5330181,
            8778458.8125145
        ],
        [
            -213376312.71241406,
            -337087343.5176553,
            7593105.512189364
        ],
        [
            -202937786.5176785,
            -344069623.0456307,
            6396078.901421466
        ],
        [
            -192245080.32444018,
            -350678679.43449855,
            5189010.942957086
        ],
        [
            -181312357.05178687,
            -356904003.8361856,
            3973562.1681858026
        ],
        [
            -170154295.59147,
            -362735725.962411,
            2751417.6795623186
        ],
        [
            -158786057.26548257,
            -368164644.79125196,
            1524283.013293427
        ],
        [
            -147223250.1211575,
            -373182257.06445444,
            293879.88262104103
        ],
        [
            -135481891.23095343,
            -377780783.3984389,
            -938058.1768347239
        ],
        [
            -123578367.1803591,
            -381953191.847126,
            -2169790.237259639
        ],
        [
            -111529392.94210796,
            -385693218.7715532,
            -3399572.4611910465
        ],
        [
            -99351969.34795135,
            -388995386.88960344,
            -4625662.612714789
        ],
        [
            -87063339.38042463,
            -391855020.39881754,
            -5846324.573274584
        ],
        [
            -74680943.51622719,
            -394268257.085989,
            -7059832.837946763
        ],
        [
            -62222374.35988928,
            -396232057.35882044,
            -8264476.968149427
        ],
        [
            -49705330.81125481,
            -397744210.1570948,
            -9458565.977092443
        ],
        [
            -37147572.01289996,
            -398803335.72333235,
            -10640432.624830414
        ],
        [
            -24566871.3239163,
            -399408885.23550296,
            -11808437.600547528
        ],
        [
            -11980970.564533845,
            -399561137.32678324,
            -12960973.57066971
        ],
        [
            592465.2281321585,
            -399261191.5393361,
            -14096469.072554931
        ],
        [
            13135892.299264252,
            -398510958.7803904,
            -15213392.234839235
        ],
        [
            25631931.704900667,
            -397313148.86929554,
            -16310254.306998499
        ],
        [
            38063411.65462808,
            -395671255.2834801,
            -17385612.982303035
        ],
        [
            50413408.46525459,
            -393589537.2291745,
            -18438075.50007467
        ],
        [
            62665285.935982585,
            -391072999.17918944,
            -19466301.514979925
        ],
        [
            74802732.9706873,
            -388127368.0348107,
            -20469005.72298778
        ],
        [
            86809799.28918466,
            -384759068.08187604,
            -21444960.235561203
        ],
        [
            98670929.08662899,
            -380975193.92222726,
            -22392996.695616346
        ],
        [
            110370992.51820676,
            -376783481.57092416,
            -23312008.130749293
        ],
        [
            121895314.90483664,
            -372192277.91683024,
            -24200950.5411748
        ],
        [
            133229703.57445656,
            -367210508.7494138,
            -25058844.2217254
        ],
        [
            144360472.27242935,
            -361847645.55788016,
            -25884774.819101818
        ],
        [
            155274463.0934369,
            -356113671.3101004,
            -26677894.127329946
        ],
        [
            165959065.90574646,
            -350019045.41828966,
            -27437420.62604943
        ],
        [
            176402235.25675425,
            -343574668.09611255,
            -28162639.76782117
        ],
        [
            186592504.76604098,
            -336791844.30795413,
            -28852904.02208232
        ],
        [
            196518999.02869642,
            -329682247.50561106,
            -29507632.68469032
        ],
        [
            206171443.06721798,
            -322257883.34077907,
            -30126311.463172805
        ],
        [
            215540169.38477284,
            -314531053.53356874,
            -30708491.848834045
        ],
        [
            224616122.68592995,
            -306514320.06803805,
            -31253790.287757196
        ],
        [
            233390862.343037,
            -298220469.87554514,
            -31761887.16348352
        ],
        [
            241856562.69721937,
            -289662480.1557441,
            -32232525.60474814
        ],
        [
            250006011.29242942,
            -280853484.47345245,
            -32665510.132105548
        ],
        [
            257832605.14910656,
            -271806739.7575574,
            -33060705.157594956
        ],
        [
            265330345.19080785,
            -262535594.31573045,
            -33418033.351779632
        ],
        [
            272493828.94263893,
            -253053456.96618372,
            -33737473.89255167
        ],
        [
            279318241.6245279,
            -243373767.3750961,
            -34019060.61003448
        ],
        [
            285799345.76534617,
            -233509967.67584592,
            -34262880.04174591
        ],
        [
            291933469.46567416,
            -223475475.43389705,
            -34469069.41191598
        ],
        [
            297717493.43770796,
            -213283658.00919348,
            -34637814.548495315
        ],
        [
            303148836.9504438,
            -202947808.3563535,
            -34769347.75095079
        ],
        [
            308225442.8070011,
            -192481122.29184592,
            -34863945.62143771
        ],
        [
            312945761.47877324,
            -181896677.24679288,
            -34921926.8713698
        ],
        [
            317308734.5181646,
            -171207412.51410693,
            -34943650.11479091
        ],
        [
            321313777.368055,
            -160426110.98936927,
            -34929511.65929629
        ],
        [
            324960761.68189895,
            -149565382.39626488,
            -34879943.30456259
        ],
        [
            328249997.26364946,
            -138637647.97947186,
            -34795410.15783765
        ],
        [
            331182213.7315261,
            -127655126.64072514,
            -34676408.47501729
        ],
        [
            333758542.00415504,
            -116629822.48730923,
            -34523463.53520837
        ],
        [
            335980495.7018424,
            -105573513.7564717,
            -34337127.55594907
        ],
        [
            337849952.54978234,
            -94497743.0742162,
            -34117977.65553712
        ],
        [
            339369135.8639297,
            -83413809.00255048,
            -33866613.86820932
        ],
        [
            340540596.19412583,
            -72332758.825578,
            -33583657.21722572
        ],
        [
            341367193.19293046,
            -61265382.52173125,
            -33269747.850244556
        ],
        [
            341852077.77252305,
            -50222207.86698118,
            -32925543.24073184
        ],
        [
            341998674.6060496,
            -39213496.61194665,
            -32551716.458536755
        ],
        [
            341810665.02393436,
            -28249241.674433157,
            -32148954.512181204
        ],
        [
            341291970.3499965,
            -17339165.2880508,
            -31717956.76486311
        ],
        [
            340446735.71673506,
            -6492718.047096863,
            -31259433.425657626
        ],
        [
            339279314.39388686,
            4280921.212141648,
            -30774104.11692004
        ],
        [
            337794252.65936136,
            14972844.753182203,
            -30262696.518449903
        ],
        [
            335996275.2369068,
            25574414.563107997,
            -29725945.088565692
        ],
        [
            333890271.3203916,
            36077260.31620307,
            -29164589.861865662
        ],
        [
            331481281.2003863,
            46473276.73418322,
            -28579375.323109686
        ],
        [
            328774483.50482684,
            56754620.39831483,
            -27971049.356351238
        ],
        [
            325775183.0619069,
            66913706.067109495,
            -27340362.268173717
        ],
        [
            322488799.39000463,
            76943202.55153318,
            -26688065.88364262
        ],
        [
            318920855.81638354,
            86836028.19777422,
            -26014912.713371765
        ],
        [
            315076969.22360396,
            96585346.02564782,
            -25321655.18991587
        ],
        [
            310962840.42005384,
            106184558.56865868,
            -24609044.971543476
        ],
        [
            306584245.1287234,
            115627302.45964433,
            -23877832.311309785
        ],
        [
            301947025.5863076,
            124907442.80380611,
            -23128765.489237536
        ],
        [
            297057082.74291456,
            134019067.37878826,
            -22362590.305324975
        ],
        [
            291920369.0510628,
            142956480.69935253,
            -21580049.63102862
        ],
        [
            286542881.8312653,
            151714197.98208773,
            -20781883.01681678
        ],
        [
            280930657.20030534,
            160286939.0435264,
            -19968826.353353497
        ],
        [
            275089764.54728174,
            168669622.16303143,
            -19141611.58384968
        ],
        [
            269026301.54166037,
            176857357.93984103,
            -18300966.4651111
        ],
        [
            262746389.65684998,
            184845443.17177945,
            -17447614.374813437
        ],
        [
            256256170.19226882,
            192629354.7812993,
            -16582274.16254912
        ],
        [
            249561800.77641457,
            200204743.81278908,
            -15705660.042210225
        ],
        [
            242669452.3331255,
            207567429.5234011,
            -14818481.52330115
        ],
        [
            235585306.49299157,
            214713393.5880722,
            -13921443.3788096
        ],
        [
            228315553.4317235,
            221638774.43791896,
            -13015245.647303037
        ],
        [
            220866390.11723214,
            228339861.74976468,
            -12100583.666962847
        ],
        [
            213244018.94715947,
            234813091.1032399,
            -11178148.139313651
        ],
        [
            205454646.75866592,
            241055038.8206548,
            -10248625.220454816
        ],
        [
            197504484.1923777,
            247062417.0036806,
            -9312696.63765097
        ],
        [
            189399745.39253443,
            252832068.77981782,
            -8371039.8291881215
        ],
        [
            181146648.02555323,
            258360963.7706231,
            -7424328.1054532835
        ],
        [
            172751413.59940392,
            263646193.79276153,
            -6473230.829243809
        ],
        [
            164220268.0664029,
            268684968.8021089,
            -5518413.613361377
        ],
        [
            155559442.69223917,
            273474613.0903561,
            -4560538.533591835
        ],
        [
            146775175.1742528,
            278012561.74287415,
            -3600264.3552150205
        ],
        [
            137873710.992201,
            282296357.36595035,
            -2638246.7712313547
        ],
        [
            128861304.97493061,
            286323647.0909368,
            -1675138.6505285655
        ],
        [
            119744223.06656241,
            290092179.86231846,
            -711590.2942477525
        ],
        [
            110528744.27595302,
            293599804.0162384,
            251750.3013608395
        ],
        [
            101221162.79332553,
            296844465.15558743,
            1214237.1772754272
        ],
        [
            91827790.2580828,
            299824204.3273715,
            2175226.140891745
        ],
        [
            82354958.16187897,
            302537156.5077198,
            3134074.49370366
        ]
    ],
    "(2024 YS9)": [
        [
            82354958.1618789,
            302537156.5077198,
            3134074.4937036675
        ],
        [
            72809020.37107688,
            304981549.39957064,
            4090140.759099153
        ],
        [
            63196355.75272572,
            307155702.5477673,
            5042784.411884376
        ],
        [
            53523370.8881527,
            309058026.7760242,
            5991365.611142328
        ],
        [
            43796502.85820001,
            310687023.9499462,
            6935244.938028907
        ],
        [
            34022222.08401721,
            312041287.0700354,
            7873783.140111195
        ],
        [
            24207035.207163453,
            313119500.69835585,
            8806340.88385785
        ],
        [
            14357487.992572911,
            313920441.72227466,
            9732278.516900938
        ],
        [
            4480168.237689182,
            314442980.45842355,
            10650955.841701388
        ],
        [
            -5418291.329214588,
            314686082.09975135,
            11561731.902267063
        ],
        [
            -15331210.178848758,
            314648808.50822693,
            12463964.785592016
        ],
        [
            -25251857.156550705,
            314330320.35542846,
            13357011.439508684
        ],
        [
            -35173447.721876115,
            313729879.61289084,
            14240227.508670166
        ],
        [
            -45089141.27071802,
            312846852.3936808,
            15112967.190407837
        ],
        [
            -54992038.559033364,
            311680712.14622325,
            15974583.11223936
        ],
        [
            -64875179.247795075,
            310231043.200905,
            16824426.232833795
        ],
        [
            -74731539.58935799,
            308497544.6694222,
            17661845.768272616
        ],
        [
            -84554030.27602695,
            306480034.69621783,
            18486189.14547867
        ],
        [
            -94335494.47224472,
            304178455.06066376,
            19296801.98471772
        ],
        [
            -104068706.05246237,
            301592876.12786806,
            20093028.11310916
        ],
        [
            -113746368.06742072,
            298723502.1451359,
            20874209.611112975
        ],
        [
            -123361111.46224426,
            295570676.8801678,
            21639686.89398823
        ],
        [
            -132905494.07042585,
            292134889.59603554,
            22388798.83024329
        ],
        [
            -142371999.9084521,
            288416781.35683346,
            23120882.89911917
        ],
        [
            -151753038.79647762,
            284417151.6566523,
            23835275.389163192
        ],
        [
            -161040946.33109468,
            280136965.36315507,
            24531311.63996039
        ],
        [
            -170227984.23684618,
            275577359.96555525,
            25208326.329092838
        ],
        [
            -179306341.12369233,
            270739653.1151886,
            25865653.80639174
        ],
        [
            -188268133.67814624,
            265625350.44514173,
            26502628.47753234
        ],
        [
            -197105408.31622893,
            260236153.65353924,
            27118585.238995988
        ],
        [
            -205810143.3267505,
            254573968.83309984,
            27712859.966386106
        ],
        [
            -214374251.53368118,
            248640915.02744907,
            28284790.058033407
        ],
        [
            -222789583.5065204,
            242439332.99242258,
            28833715.035759944
        ],
        [
            -231047931.34758848,
            235971794.13820618,
            29358977.204588752
        ],
        [
            -239141033.0850354,
            229241109.6256469,
            29859922.37308581
        ],
        [
            -247060577.70006323,
            222250339.58743268,
            30335900.63590124
        ],
        [
            -254798210.81638432,
            215002802.44208437,
            30786267.21993622
        ],
        [
            -262345541.07925057,
            207502084.26584095,
            31210383.3953993
        ],
        [
            -269694147.2504898,
            199752048.18455637,
            31607617.452829167
        ],
        [
            -276835586.04483443,
            191756843.74468228,
            31977345.746949248
        ],
        [
            -283761400.73142105,
            183520916.21928692,
            32318953.807981383
        ],
        [
            -290463130.5226463,
            175049015.8018921,
            32631837.520779885
        ],
        [
            -296932320.7705703,
            166346206.63770252,
            32915404.37185307
        ],
        [
            -303160533.98874414,
            157417875.63858706,
            33169074.764014788
        ],
        [
            -309139361.71468586,
            148269741.02496994,
            33392283.398054745
        ],
        [
            -314860437.2252177,
            138907860.53463832,
            33584480.72043047
        ],
        [
            -320315449.11350214,
            129338639.23539454,
            33745134.43556835
        ],
        [
            -325496155.73285383,
            119568836.87551738,
            33873731.0809138
        ],
        [
            -330394400.50824916,
            109605574.70318842,
            33969777.66239343
        ],
        [
            -335002128.1119097,
            99456341.6834166,
            34032803.34744516
        ],
        [
            -339311401.49437594,
            89129000.03861806,
            34062361.21223692
        ],
        [
            -343314419.75714076,
            78631790.03690878,
            34058030.03913302
        ],
        [
            -347003536.84715503,
            67973333.95040548,
            34019416.15988109
        ],
        [
            -350371281.0473887,
            57162639.104454696,
            33946155.33938463
        ],
        [
            -353410375.2311197,
            46209099.937765755,
            33837914.69430048
        ],
        [
            -356113757.84077555,
            35122498.99297849,
            33694394.640059985
        ],
        [
            -358474604.54497784,
            23913006.757290453,
            33515330.859262384
        ],
        [
            -360486350.5199854,
            12591180.273463428,
            33300496.28373383
        ],
        [
            -362142713.2940343,
            1167960.4428786635,
            33049703.08189127
        ],
        [
            -363437716.0851874,
            -10345332.055642039,
            32762804.642403655
        ],
        [
            -364365711.555277,
            -21937002.30473374,
            32439697.544509754
        ],
        [
            -364921405.8944419,
            -33594988.21499097,
            32080323.504741278
        ],
        [
            -365099883.142661,
            -45306869.18454014,
            31684671.289217893
        ],
        [
            -364896629.6466913,
            -57059876.411852375,
            31252778.580137607
        ],
        [
            -364307558.5429743,
            -68840904.91578452,
            30784733.784589067
        ],
        [
            -363329034.1495111,
            -80636527.30974737,
            30280677.773371883
        ],
        [
            -361957896.1424935,
            -92433009.36889338,
            29740805.537135333
        ],
        [
            -360191483.38674116,
            -104216327.42030069,
            29165367.746845305
        ],
        [
            -358027657.2828259,
            -115972187.576315,
            28554672.205372218
        ],
        [
            -355464824.4882836,
            -127686046.8205341,
            27909085.17686875
        ],
        [
            -352501958.8656329,
            -139343135.94440323,
            27229032.580584332
        ],
        [
            -349138622.50613916,
            -150928484.32011774,
            26515001.03585051
        ],
        [
            -345374985.6755055,
            -162426946.4825443,
            25767538.74517695
        ],
        [
            -341211845.52603537,
            -173823230.47927368,
            24987256.202726267
        ],
        [
            -336650643.41938895,
            -185101927.93381256,
            24174826.715894215
        ],
        [
            -331693480.70495474,
            -196247545.75240117,
            23330986.728313852
        ],
        [
            -326343132.80113333,
            -207244539.3901663,
            22456535.93332981
        ],
        [
            -320603061.430576,
            -218077347.57740155,
            21552337.16785471
        ],
        [
            -314477424.86566997,
            -228730428.3918835,
            20619316.0775217
        ],
        [
            -307971086.04736054,
            -239188296.5484273,
            19658460.54518398
        ],
        [
            -301089618.4487628,
            -249435561.76255834,
            18670819.876078293
        ],
        [
            -293839309.564942,
            -259456968.03137505,
            17657503.734359488
        ],
        [
            -286227161.9217073,
            -269237433.66162014,
            16619680.827217735
        ],
        [
            -278260891.5092187,
            -278762091.8628133,
            15558577.334398398
        ],
        [
            -269948923.5605932,
            -288016331.71224135,
            14475475.082645018
        ],
        [
            -261300385.61140597,
            -296985839.2888099,
            13371709.466361925
        ],
        [
            -252325097.79291597,
            -305656638.76440465,
            12248667.117630495
        ],
        [
            -243033560.32984948,
            -314015133.23466575,
            11107783.330591286
        ],
        [
            -233436938.2325021,
            -322048145.0660626,
            9950539.247105839
        ],
        [
            -223547043.19258103,
            -329742955.5330181,
            8778458.8125145
        ],
        [
            -213376312.71241406,
            -337087343.5176553,
            7593105.512189364
        ],
        [
            -202937786.5176785,
            -344069623.0456307,
            6396078.901421466
        ],
        [
            -192245080.32444018,
            -350678679.43449855,
            5189010.942957086
        ],
        [
            -181312357.05178687,
            -356904003.8361856,
            3973562.1681858026
        ],
        [
            -170154295.59147,
            -362735725.962411,
            2751417.6795623186
        ],
        [
            -158786057.26548257,
            -368164644.79125196,
            1524283.013293427
        ],
        [
            -147223250.1211575,
            -373182257.06445444,
            293879.88262104103
        ],
        [
            -135481891.23095343,
            -377780783.3984389,
            -938058.1768347239
        ],
        [
            -123578367.1803591,
            -381953191.847126,
            -2169790.237259639
        ],
        [
            -111529392.94210796,
            -385693218.7715532,
            -3399572.4611910465
        ],
        [
            -99351969.34795135,
            -388995386.88960344,
            -4625662.612714789
        ],
        [
            -87063339.38042463,
            -391855020.39881754,
            -5846324.573274584
        ],
        [
            -74680943.51622719,
            -394268257.085989,
            -7059832.837946763
        ],
        [
            -62222374.35988928,
            -396232057.35882044,
            -8264476.968149427
        ],
        [
            -49705330.81125481,
            -397744210.1570948,
            -9458565.977092443
        ],
        [
            -37147572.01289996,
            -398803335.72333235,
            -10640432.624830414
        ],
        [
            -24566871.3239163,
            -399408885.23550296,
            -11808437.600547528
        ],
        [
            -11980970.564533845,
            -399561137.32678324,
            -12960973.57066971
        ],
        [
            592465.2281321585,
            -399261191.5393361,
            -14096469.072554931
        ],
        [
            13135892.299264252,
            -398510958.7803904,
            -15213392.234839235
        ],
        [
            25631931.704900667,
            -397313148.86929554,
            -16310254.306998499
        ],
        [
            38063411.65462808,
            -395671255.2834801,
            -17385612.982303035
        ],
        [
            50413408.46525459,
            -393589537.2291745,
            -18438075.50007467
        ],
        [
            62665285.935982585,
            -391072999.17918944,
            -19466301.514979925
        ],
        [
            74802732.9706873,
            -388127368.0348107,
            -20469005.72298778
        ],
        [
            86809799.28918466,
            -384759068.08187604,
            -21444960.235561203
        ],
        [
            98670929.08662899,
            -380975193.92222726,
            -22392996.695616346
        ],
        [
            110370992.51820676,
            -376783481.57092416,
            -23312008.130749293
        ],
        [
            121895314.90483664,
            -372192277.91683024,
            -24200950.5411748
        ],
        [
            133229703.57445656,
            -367210508.7494138,
            -25058844.2217254
        ],
        [
            144360472.27242935,
            -361847645.55788016,
            -25884774.819101818
        ],
        [
            155274463.0934369,
            -356113671.3101004,
            -26677894.127329946
        ],
        [
            165959065.90574646,
            -350019045.41828966,
            -27437420.62604943
        ],
        [
            176402235.25675425,
            -343574668.09611255,
            -28162639.76782117
        ],
        [
            186592504.76604098,
            -336791844.30795413,
            -28852904.02208232
        ],
        [
            196518999.02869642,
            -329682247.50561106,
            -29507632.68469032
        ],
        [
            206171443.06721798,
            -322257883.34077907,
            -30126311.463172805
        ],
        [
            215540169.38477284,
            -314531053.53356874,
            -30708491.848834045
        ],
        [
            224616122.68592995,
            -306514320.06803805,
            -31253790.287757196
        ],
        [
            233390862.343037,
            -298220469.87554514,
            -31761887.16348352
        ],
        [
            241856562.69721937,
            -289662480.1557441,
            -32232525.60474814
        ],
        [
            250006011.29242942,
            -280853484.47345245,
            -32665510.132105548
        ],
        [
            257832605.14910656,
            -271806739.7575574,
            -33060705.157594956
        ],
        [
            265330345.19080785,
            -262535594.31573045,
            -33418033.351779632
        ],
        [
            272493828.94263893,
            -253053456.96618372,
            -33737473.89255167
        ],
        [
            279318241.6245279,
            -243373767.3750961,
            -34019060.61003448
        ],
        [
            285799345.76534617,
            -233509967.67584592,
            -34262880.04174591
        ],
        [
            291933469.46567416,
            -223475475.43389705,
            -34469069.41191598
        ],
        [
            297717493.43770796,
            -213283658.00919348,
            -34637814.548495315
        ],
        [
            303148836.9504438,
            -202947808.3563535,
            -34769347.75095079
        ],
        [
            308225442.8070011,
            -192481122.29184592,
            -34863945.62143771
        ],
        [
            312945761.47877324,
            -181896677.24679288,
            -34921926.8713698
        ],
        [
            317308734.5181646,
            -171207412.51410693,
            -34943650.11479091
        ],
        [
            321313777.368055,
            -160426110.98936927,
            -34929511.65929629
        ],
        [
            324960761.68189895,
            -149565382.39626488,
            -34879943.30456259
        ],
        [
            328249997.26364946,
            -138637647.97947186,
            -34795410.15783765
        ],
        [
            331182213.7315261,
            -127655126.64072514,
            -34676408.47501729
        ],
        [
            333758542.00415504,
            -116629822.48730923,
            -34523463.53520837
        ],
        [
            335980495.7018424,
            -105573513.7564717,
            -34337127.55594907
        ],
        [
            337849952.54978234,
            -94497743.0742162,
            -34117977.65553712
        ],
        [
            339369135.8639297,
            -83413809.00255048,
            -33866613.86820932
        ],
        [
            340540596.19412583,
            -72332758.825578,
            -33583657.21722572
        ],
        [
            341367193.19293046,
            -61265382.52173125,
            -33269747.850244556
        ],
        [
            341852077.77252305,
            -50222207.86698118,
            -32925543.24073184
        ],
        [
            341998674.6060496,
            -39213496.61194665,
            -32551716.458536755
        ],
        [
            341810665.02393436,
            -28249241.674433157,
            -32148954.512181204
        ],
        [
            341291970.3499965,
            -17339165.2880508,
            -31717956.76486311
        ],
        [
            340446735.71673506,
            -6492718.047096863,
            -31259433.425657626
        ],
        [
            339279314.39388686,
            4280921.212141648,
            -30774104.11692004
        ],
        [
            337794252.65936136,
            14972844.753182203,
            -30262696.518449903
        ],
        [
            335996275.2369068,
            25574414.563107997,
            -29725945.088565692
        ],
        [
            333890271.3203916,
            36077260.31620307,
            -29164589.861865662
        ],
        [
            331481281.2003863,
            46473276.73418322,
            -28579375.323109686
        ],
        [
            328774483.50482684,
            56754620.39831483,
            -27971049.356351238
        ],
        [
            325775183.0619069,
            66913706.067109495,
            -27340362.268173717
        ],
        [
            322488799.39000463,
            76943202.55153318,
            -26688065.88364262
        ],
        [
            318920855.81638354,
            86836028.19777422,
            -26014912.713371765
        ],
        [
            315076969.22360396,
            96585346.02564782,
            -25321655.18991587
        ],
        [
            310962840.42005384,
            106184558.56865868,
            -24609044.971543476
        ],
        [
            306584245.1287234,
            115627302.45964433,
            -23877832.311309785
        ],
        [
            301947025.5863076,
            124907442.80380611,
            -23128765.489237536
        ],
        [
            297057082.74291456,
            134019067.37878826,
            -22362590.305324975
        ],
        [
            291920369.0510628,
            142956480.69935253,
            -21580049.63102862
        ],
        [
            286542881.8312653,
            151714197.98208773,
            -20781883.01681678
        ],
        [
            280930657.20030534,
            160286939.0435264,
            -19968826.353353497
        ],
        [
            275089764.54728174,
            168669622.16303143,
            -19141611.58384968
        ],
        [
            269026301.54166037,
            176857357.93984103,
            -18300966.4651111
        ],
        [
            262746389.65684998,
            184845443.17177945,
            -17447614.374813437
        ],
        [
            256256170.19226882,
            192629354.7812993,
            -16582274.16254912
        ],
        [
            249561800.77641457,
            200204743.81278908,
            -15705660.042210225
        ],
        [
            242669452.3331255,
            207567429.5234011,
            -14818481.52330115
        ],
        [
            235585306.49299157,
            214713393.5880722,
            -13921443.3788096
        ],
        [
            228315553.4317235,
            221638774.43791896,
            -13015245.647303037
        ],
        [
            220866390.11723214,
            228339861.74976468,
            -12100583.666962847
        ],
        [
            213244018.94715947,
            234813091.1032399,
            -11178148.139313651
        ],
        [
            205454646.75866592,
            241055038.8206548,
            -10248625.220454816
        ],
        [
            197504484.1923777,
            247062417.0036806,
            -9312696.63765097
        ],
        [
            189399745.39253443,
            252832068.77981782,
            -8371039.8291881215
        ],
        [
            181146648.02555323,
            258360963.7706231,
            -7424328.1054532835
        ],
        [
            172751413.59940392,
            263646193.79276153,
            -6473230.829243809
        ],
        [
            164220268.0664029,
            268684968.8021089,
            -5518413.613361377
        ],
        [
            155559442.69223917,
            273474613.0903561,
            -4560538.533591835
        ],
        [
            146775175.1742528,
            278012561.74287415,
            -3600264.3552150205
        ],
        [
            137873710.992201,
            282296357.36595035,
            -2638246.7712313547
        ],
        [
            128861304.97493061,
            286323647.0909368,
            -1675138.6505285655
        ],
        [
            119744223.06656241,
            290092179.86231846,
            -711590.2942477525
        ],
        [
            110528744.27595302,
            293599804.0162384,
            251750.3013608395
        ],
        [
            101221162.79332553,
            296844465.15558743,
            1214237.1772754272
        ],
        [
            91827790.2580828,
            299824204.3273715,
            2175226.140891745
        ],
        [
            82354958.16187897,
            302537156.5077198,
            3134074.49370366
        ]
    ],
    "(2025 AO1)": [
        [
            -335185835.40867263,
            169119198.15408546,
            67200082.21427894
        ],
        [
            -340345446.40919954,
            158255417.20711392,
            67805533.94635744
        ],
        [
            -345191520.089033,
            147243896.84875363,
            68348458.91540046
        ],
        [
            -349720188.4927405,
            136093141.66875517,
            68828414.71984006
        ],
        [
            -353927756.81691176,
            124811742.05619618,
            69244993.62281659
        ],
        [
            -357810704.29359436,
            113408373.8088186,
            69597822.70265265
        ],
        [
            -361365685.31792104,
            101891797.80099991,
            69886564.05022691
        ],
        [
            -364589530.82575387,
            90270859.69182165,
            70110915.01373203
        ],
        [
            -367479249.92637765,
            78554489.65434258,
            70270608.49114268
        ],
        [
            -370032031.79447275,
            66751702.10683538,
            70365413.27056059
        ],
        [
            -372245247.8247664,
            54871595.42640388,
            70395134.41844046
        ],
        [
            -374116454.05191845,
            42923351.62506002,
            70359613.7155326
        ],
        [
            -375643393.83731514,
            30916235.968014568,
            70258730.1402066
        ],
        [
            -376824000.82354903,
            18859596.513616413,
            70092400.39864445
        ],
        [
            -377656402.1564183,
            6762863.554070234,
            69860579.50120711
        ],
        [
            -378138921.97331524,
            -5364451.06422776,
            69563261.38409263
        ],
        [
            -378270085.1558595,
            -17512754.762171328,
            69200479.57520719
        ],
        [
            -378048621.3435849,
            -29672375.212929428,
            68772307.90296982
        ],
        [
            -377473469.2043954,
            -41833561.512349784,
            68278861.24656284
        ],
        [
            -376543780.95636964,
            -53986485.55689645,
            67720296.32592356
        ],
        [
            -375258927.13430387,
            -66121243.651399165,
            67096812.52954897
        ],
        [
            -373618501.5931577,
            -78227858.36902359,
            66408652.7779543
        ],
        [
            -371622326.7392731,
            -90296280.68595092,
            65656104.42038574
        ],
        [
            -369270458.9789113,
            -102316392.41329192,
            64839500.16214152
        ],
        [
            -366563194.3722576,
            -114278008.94873498,
            63959219.01959939
        ],
        [
            -363501074.479612,
            -126170882.37034388,
            63015687.299787164
        ],
        [
            -360084892.38498855,
            -137984704.89476445,
            62009379.601062015
        ],
        [
            -356315698.8808132,
            -149709112.72186816,
            60940819.83118917
        ],
        [
            -352194808.7958149,
            -161333690.28754193,
            59810582.23882634
        ],
        [
            -347723807.4465805,
            -172847974.94592437,
            58619292.454134196
        ],
        [
            -342904557.1915626,
            -184241462.10188013,
            57367628.53393844
        ],
        [
            -337739204.06461906,
            -195503610.81388187,
            56056322.00657469
        ],
        [
            -332230184.4634191,
            -206623849.8867374,
            54686158.911247894
        ],
        [
            -326380231.8662732,
            -217591584.4727355,
            53257980.82643846
        ],
        [
            -320192383.5491588,
            -228396203.19879276,
            51772685.88158927
        ],
        [
            -313669987.27289826,
            -239027085.83604413,
            50231229.746009625
        ],
        [
            -306816707.9086493,
            -249473611.52704245,
            48634626.58864091
        ],
        [
            -299636533.96805704,
            -259725167.58428198,
            46983950.00204183
        ],
        [
            -292133784.0026376,
            -269771158.87216705,
            45280333.88367304
        ],
        [
            -284313112.83521,
            -279601017.7827644,
            43524973.2672949
        ],
        [
            -276179517.58448213,
            -289204214.8137352,
            41719125.09703809
        ],
        [
            -267738343.44224387,
            -298570269.7547123,
            39864108.93647034
        ],
        [
            -258995289.1610453,
            -307688763.48607445,
            37961307.604765154
        ],
        [
            -249956412.20874533,
            -316549350.3915738,
            36012167.731883295
        ],
        [
            -240628133.5449378,
            -325141771.38358784,
            34018200.224508695
        ],
        [
            -231017241.97300732,
            -333455867.5368914,
            31980980.634340756
        ],
        [
            -221130898.0204562,
            -341481594.32379115,
            29902149.42023751
        ],
        [
            -210976637.29919952,
            -349209036.4402244,
            27783412.095633216
        ],
        [
            -200562373.29676935,
            -356628423.20900786,
            25626539.252622936
        ],
        [
            -189896399.5488134,
            -363730144.5428427,
            23433366.454118896
        ],
        [
            -178987391.14295316,
            -370504767.4459356,
            21205793.985543057
        ],
        [
            -167844405.5039909,
            -376943053.0292136,
            18945786.457630362
        ],
        [
            -156476882.41064975,
            -383035974.01008534,
            16655372.252081208
        ],
        [
            -144894643.19452178,
            -388774732.6635714,
            14336642.802023746
        ],
        [
            -133107889.07269192,
            -394150779.18739337,
            11991751.699527612
        ],
        [
            -121127198.56664073,
            -399155830.43931234,
            9622913.622757044
        ],
        [
            -108963523.96150053,
            -403781889.00065744,
            7232403.075761231
        ],
        [
            -96628186.76158188,
            -408021262.5156131,
            4822552.934378894
        ],
        [
            -84132872.10030898,
            -411866583.2514749,
            2395752.7922823057
        ],
        [
            -71489622.06531128,
            -415310827.8207712,
            -45552.89819506928
        ],
        [
            -58710827.90242712,
            -418347337.0018982,
            -2498866.89511339
        ],
        [
            -45809221.06580022,
            -420969835.5908044,
            -4961641.449767102
        ],
        [
            -32797863.085068524,
            -423172452.212276,
            -7431280.806383446
        ],
        [
            -19690134.22489044,
            -424949739.0156114,
            -9905143.920848358
        ],
        [
            -6499720.916695595,
            -426296691.1759231,
            -12380547.399659943
        ],
        [
            6759398.052412599,
            -427208766.119051,
            -14854768.659276571
        ],
        [
            20072966.60324374,
            -427681902.3851328,
            -17325049.304931507
        ],
        [
            33426467.68444407,
            -427712538.043309,
            -19788598.726835646
        ],
        [
            46805140.84646258,
            -427297628.5678774,
            -22242597.91048842
        ],
        [
            60194001.06080392,
            -426434664.08451056,
            -24684203.45657125
        ],
        [
            73577858.76906115,
            -425121685.8939329,
            -27110551.804613926
        ],
        [
            86941341.13922462,
            -423357302.17977744,
            -29518763.653312802
        ],
        [
            100268914.49955463,
            -421140702.807226,
            -31905948.569046196
        ],
        [
            113544907.91292879,
            -418471673.11953336,
            -34269209.77278818
        ],
        [
            126753537.84710002,
            -415350606.6406496,
            -36605649.09427873
        ],
        [
            139878933.88875002,
            -411778516.5939339,
            -38912372.080972426
        ],
        [
            152905165.44169086,
            -407757046.14939946,
            -41186493.24797672
        ],
        [
            165816269.34208804,
            -403288477.3150679,
            -43425141.45391158
        ],
        [
            178596278.3162327,
            -398375738.3918381,
            -45625465.386389464
        ],
        [
            191229250.1992326,
            -393022409.9158044,
            -47784639.13963885
        ],
        [
            203699297.8261119,
            -387232729.01717085,
            -49899867.86569198
        ],
        [
            215990619.50024194,
            -381011592.1307981,
            -51968393.47953364
        ],
        [
            228087529.93787724,
            -374364555.999966,
            -53987500.39768292
        ],
        [
            239974491.5818813,
            -367297836.92209935,
            -55954521.288858384
        ],
        [
            251636146.17257333,
            -359818308.19296277,
            -57866842.814674504
        ],
        [
            263057346.45907712,
            -351933495.7141313,
            -59721911.3377417
        ],
        [
            274223187.9306508,
            -343651571.73733556,
            -61517238.57410358
        ],
        [
            285119040.4442952,
            -334981346.7285042,
            -63250407.16665165
        ],
        [
            295730579.62251604,
            -325932259.34392595,
            -64919076.15601676
        ],
        [
            306043817.89348924,
            -316514364.52083695,
            -66520986.325452
        ],
        [
            316045135.04510814,
            -306738319.69485897,
            -68053965.39640158
        ],
        [
            325721308.16447544,
            -296615369.16695595,
            -69515933.05179195
        ],
        [
            335059540.8353771,
            -286157326.65288746,
            -70904905.76459008
        ],
        [
            344047491.4681609,
            -275376556.0584049,
            -72219001.409848
        ],
        [
            352673300.63920945,
            -264285950.53358436,
            -73456443.63928641
        ],
        [
            360925617.32087284,
            -252898909.86962694,
            -74615565.99846472
        ],
        [
            368793623.8872732,
            -241229316.31108934,
            -75694815.76773001
        ],
        [
            376267059.78678244,
            -229291508.86575192,
            -76692757.50942579
        ],
        [
            383336243.7781887,
            -217100256.2031011,
            -77608076.3052665
        ],
        [
            389992094.6345393,
            -204670728.24061581,
            -78439580.66933173
        ],
        [
            396226150.2263341,
            -192018466.52463216,
            -79186205.12379237
        ],
        [
            402030584.9040931,
            -179159353.51944008,
            -79847012.42624052
        ],
        [
            407398225.1092359,
            -166109580.9243879,
            -80421195.43933345
        ],
        [
            412322563.1516483,
            -152885617.14406425,
            -80908078.63537113
        ],
        [
            416797769.1021701,
            -139504174.04106563,
            -81307119.23038626
        ],
        [
            420818700.758433,
            -125982173.10438536,
            -81617907.9443182
        ],
        [
            424380911.65293026,
            -112336711.16905862,
            -81840169.38585293
        ],
        [
            427480657.0828149,
            -98585025.82435435,
            -81973762.06252053
        ],
        [
            430114898.15159833,
            -84744460.64849259,
            -82018678.01863353
        ],
        [
            432281303.823582,
            -70832430.40760982,
            -81975042.10560639
        ],
        [
            433978251.0023956,
            -56866386.355490774,
            -81843110.8911022
        ],
        [
            435204822.6553526,
            -42863781.76846239,
            -81623271.21529137
        ],
        [
            435960804.0153878,
            -28842037.84683034,
            -81316038.40426518
        ],
        [
            436246676.90201676,
            -14818510.110381395,
            -80922054.15230851
        ],
        [
            436063612.2119957,
            -810455.4108038843,
            -80442084.08629051
        ],
        [
            435413460.6390808,
            13165000.321528107,
            -79877015.02686892
        ],
        [
            434298741.6904274,
            27090893.485058874,
            -79227851.96250974
        ],
        [
            432722631.0746838,
            40950453.26421288,
            -78495714.75349654
        ],
        [
            430688946.5436616,
            54727131.038838685,
            -77681834.58413152
        ],
        [
            428202132.2755859,
            68404628.65629873,
            -76787550.18221225
        ],
        [
            425267241.8932831,
            81966925.48468894,
            -75814303.8255975
        ],
        [
            421889920.21526927,
            95398304.17411825,
            -74763637.15625535
        ],
        [
            418076383.84150255,
            108683375.06164673,
            -73637186.82261173
        ],
        [
            413833400.6785933,
            121807099.1643227,
            -72436679.97129422
        ],
        [
            409168268.5114929,
            134754809.71365657,
            -71163929.60949431
        ],
        [
            404088792.73014784,
            147512232.19379407,
            -69820829.85915588
        ],
        [
            398603263.3203043,
            160065502.85448593,
            -68409351.12404671
        ],
        [
            392720431.2276229,
            172401185.67866206,
            -66931535.19048601
        ],
        [
            386449484.20352304,
            184506287.7929243,
            -65389490.28209469
        ],
        [
            379800022.2397886,
            196368273.3175042,
            -63785386.08841665
        ],
        [
            372782032.6969311,
            207975075.66017884,
            -62121448.78663023
        ],
        [
            365405865.2287091,
            219315108.26619133,
            -60399956.074850544
        ],
        [
            357682206.60206723,
            230377273.8433863,
            -58623232.234715685
        ],
        [
            349622055.5081282,
            241150972.0885048,
            -56793643.24006696
        ],
        [
            341236697.45583487,
            251626105.94681686,
            -54913591.927589744
        ],
        [
            332537679.8354031,
            261793086.44304895,
            -52985513.24427963
        ],
        [
            323536787.23400116,
            271642836.1267972,
            -51011869.58555656
        ],
        [
            314246017.0810559,
            281166791.18034375,
            -48995146.23677443
        ],
        [
            304677555.6953417,
            290356902.2409998,
            -46937846.92977244
        ],
        [
            294843754.80062103,
            299205633.993745,
            -44842489.525004506
        ],
        [
            284757108.5710763,
            307705963.59308964,
            -42711601.82866369
        ],
        [
            274430231.2621968,
            315851377.9756921,
            -40547717.55310629
        ],
        [
            263875835.47717974,
            323635870.1273813,
            -38353372.42777989
        ],
        [
            253106711.11330163,
            331053934.36986303,
            -36131100.46677456
        ],
        [
            242135705.0272071,
            338100560.7335301,
            -33883430.39806336
        ],
        [
            230975701.4526023,
            344771228.48351336,
            -31612882.258469593
        ],
        [
            219639603.19854316,
            351061898.8663823,
            -29321964.157411978
        ],
        [
            208140313.65134817,
            356969007.1447857,
            -27013169.211531274
        ],
        [
            196490719.59817797,
            362489453.98684293,
            -24688972.65139761
        ],
        [
            184703674.8855631,
            367620596.27625376,
            -22351829.10064624
        ],
        [
            172791984.9215876,
            372360237.40796804,
            -20004170.027082317
        ],
        [
            160768392.0261309,
            376706617.1328163,
            -17648401.364546813
        ],
        [
            148645561.62948194,
            380658401.01284057,
            -15286901.303634858
        ],
        [
            136436069.31582814,
            384214669.54715335,
            -12922018.248716012
        ],
        [
            124152388.70457056,
            387374907.02606547,
            -10556068.938116983
        ],
        [
            111806880.15911019,
            390138990.16896063,
            -8191336.723790228
        ],
        [
            99411780.30974743,
            392507176.5989927,
            -5830070.006314371
        ],
        [
            86979192.37455997,
            394480093.205174,
            -3474480.820639994
        ],
        [
            74521077.25963937,
            396058724.4398146,
            -1126743.567619536
        ],
        [
            62049245.41782868,
            397244400.5966084,
            1211006.1139680967
        ],
        [
            49575349.44310363,
            398038786.11194867,
            3536672.3404698223
        ],
        [
            37110877.37601377,
            398443867.92931986,
            5848199.8472904675
        ],
        [
            24667146.694068193,
            398461943.96386635,
            8143574.729702406
        ],
        [
            12255298.959676057,
            398095611.7015135,
            10420825.066678867
        ],
        [
            -113704.90282568336,
            397347756.964302,
            12678021.434009224
        ],
        [
            -12429088.730409235,
            396221542.87093693,
            14913277.31303303
        ],
        [
            -24680264.67487988,
            394720399.0189325,
            17124749.401369587
        ],
        [
            -36856836.21723336,
            392848010.9121804,
            19310637.832035266
        ],
        [
            -48948600.67372835,
            390608309.65528405,
            21469186.307323564
        ],
        [
            -60945551.22474757,
            388005461.9335977,
            23598682.153781373
        ],
        [
            -72837878.49758592,
            385043860.29558146,
            25697456.304553036
        ],
        [
            -84615971.73421095,
            381728113.75185376,
            27763883.215275552
        ],
        [
            -96270419.57486959,
            378063038.7031765,
            29796380.71960815
        ],
        [
            -107792010.48810875,
            374053650.2075644,
            31793409.83035803
        ],
        [
            -119171732.87739034,
            369705153.59475833,
            33753474.4920304
        ],
        [
            -130400774.89402264,
            365022936.4344454,
            35675121.29048738
        ],
        [
            -141470523.98556915,
            360012560.8628597,
            37556939.125240974
        ],
        [
            -152372566.2083121,
            354679756.2707268,
            39397558.84974457
        ],
        [
            -163098685.33166647,
            349030412.35395867,
            41195652.88487231
        ],
        [
            -173640861.76175565,
            343070572.52702665,
            42949934.81060177
        ],
        [
            -183991271.31060445,
            336806427.6975548,
            44659158.9407329
        ],
        [
            -194142283.8366313,
            330244310.3993863,
            46322119.885291
        ],
        [
            -204086461.78133535,
            323390689.2801506,
            47937652.10507937
        ],
        [
            -213816558.6262403,
            316252163.93823546,
            49504629.46265554
        ],
        [
            -223325517.29334366,
            308835460.10300094,
            51021964.773822956
        ],
        [
            -232606468.51147068,
            301147425.15108716,
            52488609.36354085
        ],
        [
            -241652729.17009032,
            293195023.9507507,
            53903552.62997087
        ],
        [
            -250457800.68131742,
            284985335.02529997,
            55265821.62019791
        ],
        [
            -259015367.36996573,
            276525547.0259066,
            56574480.62097866
        ],
        [
            -267319294.91069573,
            267822955.5033193,
            57828630.76769643
        ],
        [
            -275363628.8304622,
            258884959.9673136,
            59027409.67452356
        ],
        [
            -283142593.0936402,
            249719061.22206104,
            60169991.088619955
        ],
        [
            -290650588.78640634,
            240332858.96498522,
            61255584.57102885
        ],
        [
            -297882192.91613185,
            230734049.63610935,
            62283435.2067615
        ],
        [
            -304832157.3407648,
            220930424.50435102,
            63252823.34640123
        ],
        [
            -311495407.84238267,
            210929867.9767142,
            64163064.38139479
        ],
        [
            -317867043.35832334,
            200740356.11584806,
            65013508.55504073
        ],
        [
            -323942335.3825414,
            190369955.3509696,
            65803540.81102886
        ],
        [
            -329716727.5490631,
            179826821.36671993,
            66532580.68122941
        ],
        [
            -335185835.4086726,
            169119198.15408555,
            67200082.21427894
        ]
    ],
    "(2025 AA2)": [
        [
            -183465266.75299683,
            221252823.714325,
            -137599911.25815198
        ],
        [
            -191586981.5671301,
            216715600.0643739,
            -133767807.49277854
        ],
        [
            -199556536.55011028,
            212001124.22314802,
            -129825908.78317164
        ],
        [
            -207370324.98934856,
            207111304.77054155,
            -125775843.28144674
        ],
        [
            -215024709.6375341,
            202048035.06299645,
            -121619231.19482934
        ],
        [
            -222516017.0818206,
            196813197.2358465,
            -117357688.03563368
        ],
        [
            -229840532.3374452,
            191408666.46712348,
            -112992828.03319925
        ],
        [
            -236994493.67057484,
            185836315.5047664,
            -108526267.70872203
        ],
        [
            -243974087.65629014,
            180098019.45984763,
            -103959629.61428756
        ],
        [
            -250775444.47882244,
            174195660.8690408,
            -99294546.23773456
        ],
        [
            -257394633.48245287,
            168131135.03009394,
            -94532664.07523842
        ],
        [
            -263827658.98286963,
            161906355.61453676,
            -89675647.87371185
        ],
        [
            -270070456.3502503,
            155523260.56223947,
            -84725185.04526041
        ],
        [
            -276118888.37690264,
            148983818.26274118,
            -79682990.25600791
        ],
        [
            -281968741.943948,
            142290034.02847576,
            -74550810.19161081
        ],
        [
            -287615725.00327134,
            135443956.86513284,
            -69330428.50170854
        ],
        [
            -293055463.8927911,
            128447686.54439285,
            -64023670.9254029
        ],
        [
            -298283501.0050094,
            121303380.98415887,
            -58632410.59961612
        ],
        [
            -303295292.8308041,
            114013263.941164,
            -53158573.55183893
        ],
        [
            -308086208.4024891,
            106579633.02044936,
            -47604144.37833819
        ],
        [
            -312651528.16232455,
            99004868.00567341,
            -41971172.10834077
        ],
        [
            -316986443.2848673,
            91291439.51351385,
            -36261776.25403787
        ],
        [
            -321086055.4838356,
            83441917.97454603,
            -30478153.045453086
        ],
        [
            -324945377.3364865,
            75458982.94190964,
            -24622581.848276556
        ],
        [
            -328559333.1608771,
            67345432.72779502,
            -18697431.761680186
        ],
        [
            -331922760.4837807,
            59104194.36627275,
            -12705168.391880006
        ],
        [
            -335030412.13943964,
            50738333.89923774,
            -6648360.795794547
        ],
        [
            -337876959.04174113,
            42251066.98022562,
            -529688.5875481516
        ],
        [
            -340456993.6747845,
            33645769.7885627,
            5648050.801222876
        ],
        [
            -342765034.3491315,
            24925990.24371645,
            11881934.718299136
        ],
        [
            -344795530.27327913,
            16095459.506795019,
            18168907.75828977
        ],
        [
            -346542867.49202734,
            7158103.752891064,
            24505774.11620991
        ],
        [
            -348001375.74539584,
            -1881943.8056477457,
            30889189.84557675
        ],
        [
            -349165336.30353534,
            -11020330.668929398,
            37315655.04229182
        ],
        [
            -350028990.8346335,
            -20252472.600496814,
            43781505.97874187
        ],
        [
            -350586551.36407447,
            -29573541.012652174,
            50282907.21597426
        ],
        [
            -350832211.3840311,
            -38978450.22441247,
            56815843.7254875
        ],
        [
            -350760158.1731709,
            -48461844.63601813,
            63376113.05612276
        ],
        [
            -350364586.3861878,
            -58018085.86999273,
            69959317.58575207
        ],
        [
            -349639712.972342,
            -67641239.93525723,
            76560856.90191849
        ],
        [
            -348579793.48103595,
            -77325064.47774726,
            83175920.36029369
        ],
        [
            -347179139.810579,
            -87062996.1883428,
            89799479.8747558
        ],
        [
            -345432139.45360565,
            -96848138.4466815,
            96426282.9980375
        ],
        [
            -343333276.2890341,
            -106673249.28757064,
            103050846.3572261
        ],
        [
            -340877152.9658572,
            -116530729.78518656,
            109667449.51387799
        ],
        [
            -338058514.9183753,
            -126412612.9590165,
            116270129.32409242
        ],
        [
            -334872276.04558694,
            -136310553.31449193,
            122852674.87953466
        ],
        [
            -331313546.07925016,
            -146215817.14040872,
            129408623.11603141
        ],
        [
            -327377659.6555306,
            -156119273.69443414,
            135931255.18192062
        ],
        [
            -323060207.09403414,
            -166011387.41716847,
            142413593.66373983
        ],
        [
            -318357066.875334,
            -175882211.32421875,
            148848400.77198273
        ],
        [
            -313264439.7937249,
            -185721381.73442623,
            155228177.5944448
        ],
        [
            -307778884.74583554,
            -195518114.50059858,
            161545164.52899432
        ],
        [
            -301897356.09784365,
            -205261202.91664797,
            167791343.01131132
        ],
        [
            -295617242.55433065,
            -214939017.48173752,
            173958438.65610278
        ],
        [
            -288936407.4303017,
            -224539507.7076545,
            180037925.93236113
        ],
        [
            -281853230.2045945,
            -234050206.15993658,
            186021034.49423537
        ],
        [
            -274366649.2078736,
            -243458234.9260123,
            191898757.28884998
        ],
        [
            -266476205.27176556,
            -252750314.70450848,
            197661860.560759
        ],
        [
            -258182086.1375785,
            -261912776.7086545,
            203300895.8694858
        ],
        [
            -249485171.39366,
            -270931577.5730765,
            208806214.23158333
        ],
        [
            -240387077.6800521,
            -279792317.44694006,
            214167982.49167758
        ],
        [
            -230890203.86798388,
            -288480261.4470799,
            219376202.01785994
        ],
        [
            -220997775.89030883,
            -296980364.6321766,
            224420729.8054114
        ],
        [
            -210713890.86764804,
            -305277300.6429347,
            229291302.0590243
        ],
        [
            -200043560.14426687,
            -313355494.1333758,
            233977560.30733865
        ],
        [
            -188992750.81814435,
            -321199157.09456843,
            238469080.08461916
        ],
        [
            -177568425.3219195,
            -328792329.1442483,
            242755402.19274545
        ],
        [
            -165778578.5860915,
            -336118921.8237456,
            246826066.5323501
        ],
        [
            -153632272.2937463,
            -343162766.9074174,
            250670648.46498477
        ],
        [
            -141139665.71794713,
            -349907668.6894534,
            254278797.63872537
        ],
        [
            -128312042.61953542,
            -356337460.16863906,
            257640279.17782867
        ],
        [
            -115161833.67526814,
            -362436063.0036932,
            260745017.10317296
        ],
        [
            -101702633.90473735,
            -368187551.0605148,
            263583139.81458175
        ],
        [
            -87949214.57014519,
            -373576217.3185684,
            266145027.4291462
        ],
        [
            -73917529.03646183,
            -378586643.847337,
            268421360.73181987
        ],
        [
            -59624712.10138011,
            -383203774.50599015,
            270403171.4564151
        ],
        [
            -45089072.33534637,
            -387412989.96103734,
            272081893.57733095
        ],
        [
            -30330077.01216224,
            -391200184.55871224,
            273449415.2555859
        ],
        [
            -15368329.260461658,
            -394551844.532246,
            274498131.0477809
        ],
        [
            -225537.12579756975,
            -397455126.97020257,
            275220993.9542918
        ],
        [
            15075525.698020399,
            -399897938.92187536,
            275611566.8541074
        ],
        [
            30511067.63173163,
            -401869015.97067255,
            275664072.8491485
        ],
        [
            46056335.544560045,
            -403357999.5677074,
            275373444.0214477
        ],
        [
            61685679.64232272,
            -404355512.3867199,
            274735368.0930269
        ],
        [
            77372626.79240754,
            -404853230.93919545,
            273746332.4714298
        ],
        [
            93089962.0629527,
            -404843954.6761914,
            272403665.1642673
        ],
        [
            108809818.14481464,
            -404321670.801913,
            270705572.0543638
        ],
        [
            124503772.21458814,
            -403281614.0342731,
            268651170.0435273
        ],
        [
            140142949.68705773,
            -401720320.5700873,
            266240515.5978333
        ],
        [
            155698134.19813132,
            -399635675.5475497,
            263474628.2606619
        ],
        [
            171139883.05675167,
            -397026953.3462147,
            260355508.74139842
        ],
        [
            186438647.30871788,
            -393894850.124683,
            256886151.2373517
        ],
        [
            201564895.46898568,
            -390241508.0679622,
            253070549.70348614
        ],
        [
            216489239.9039284,
            -386070530.899224,
            248913697.84824434
        ],
        [
            231182564.7831535,
            -381386990.303229,
            244421582.70307997
        ],
        [
            245616154.473478,
            -376197423.00961006,
            239601171.6871945
        ],
        [
            259761821.21695298,
            -370509818.3917988,
            234460393.1660801
        ],
        [
            273592030.92147106,
            -364333596.5497317,
            229008110.5814018
        ],
        [
            287080025.8971469,
            -357679576.95951974,
            223254090.3090149
        ],
        [
            300199943.3945938,
            -350559937.8887978,
            217208963.47995913
        ],
        [
            312926928.8422778,
            -342988166.89025927,
            210884182.07457152
        ],
        [
            325237242.73867166,
            -334979002.7956848,
            204291969.67090946
        ],
        [
            337108360.2299736,
            -326548369.7364296,
            197445267.2940678
        ],
        [
            348519062.49425364,
            -317713303.81181717,
            190357674.87143064
        ],
        [
            359449519.1562555,
            -308491873.1123705,
            183043388.84929514
        ],
        [
            369881361.0716686,
            -298903091.87869275,
            175517136.5677235
        ],
        [
            379797742.94312084,
            -288966829.63781303,
            167794108.0222209
        ],
        [
            389183395.359961,
            -278703716.2059312,
            159889885.66242856
        ],
        [
            398024665.9874739,
            -268135043.47911826,
            151820372.88925007
        ],
        [
            406309549.76587963,
            -257282664.95135647,
            143601721.91272417
        ],
        [
            414027708.11272055,
            -246168893.90240827,
            135250261.62377486
        ],
        [
            421170477.25157416,
            -234816401.18678796,
            126782426.11421104
        ],
        [
            427730865.91315,
            -223248113.53030038,
            118214684.45170106
        ],
        [
            433703542.76969457,
            -211487113.20318806,
            109563472.28077012
        ],
        [
            439084814.06845206,
            -199556539.89014906,
            100845125.77818158
        ],
        [
            443872592.02327585,
            -187479495.51877892,
            92075818.44247638
        ],
        [
            448066354.60419714,
            -175278952.740917,
            83271501.14414127
        ],
        [
            451667097.432101,
            -162977667.6876443,
            74447845.80609708
        ],
        [
            454677278.5391531,
            -150598097.53996074,
            65620193.02514452
        ],
        [
            457100756.795196,
            -138162323.37521702,
            56803503.884895876
        ],
        [
            458942724.8261739,
            -125691978.6658266,
            48012316.15067327
        ],
        [
            460209637.26323974,
            -113208183.72322866,
            39260704.97792947
        ],
        [
            460909135.1612822,
            -100731486.29795632,
            30562248.20888132
        ],
        [
            461049967.41410995,
            -88281808.46731591,
            21929996.278082654
        ],
        [
            460641909.97155124,
            -75878399.86671412,
            13376446.697275981
        ],
        [
            459695683.6324798,
            -63539797.25007191,
            4913523.043636903
        ],
        [
            458222871.1485779,
            -51283790.299797624,
            -3447441.6661268175
        ],
        [
            456235834.3278156,
            -39127393.54803884,
            -11695717.370142296
        ],
        [
            453747631.77551955,
            -27086824.21883422,
            -19821185.310255975
        ],
        [
            450771937.855836,
            -15177485.75552243,
            -27814342.548144758
        ],
        [
            447322963.3986157,
            -3413956.759475261,
            -35666302.88296431
        ],
        [
            443415378.6174511,
            8190014.965203077,
            -43368794.42156257
        ],
        [
            439064238.6448491,
            19621513.591117114,
            -50914154.06434268
        ],
        [
            434284912.0313123,
            30868452.01959625,
            -58295319.17751728
        ],
        [
            429093012.4972621,
            41919564.56607649,
            -65505816.72613241
        ],
        [
            423504334.17101705,
            52764395.94640711,
            -72539750.1421909
        ],
        [
            417534790.4930284,
            63393286.93336311,
            -79391784.19888833
        ],
        [
            411200356.91676277,
            73797357.04984686,
            -86057128.15580422
        ],
        [
            404517017.4903872,
            83968484.6584595,
            -92531517.43124916
        ],
        [
            397500715.3609911,
            93899284.79691851,
            -98811194.04729706
        ],
        [
            390167307.2046597,
            103583085.09568012,
            -104892886.0806821
        ],
        [
            382532521.5513613,
            113013900.09864672,
            -110773786.33910273
        ],
        [
            374611920.94329154,
            122186404.29050025,
            -116451530.46789035
        ],
        [
            366420867.83902097,
            131095904.11542338,
            -121924174.67676322
        ],
        [
            357974494.1533147,
            139738309.25223568,
            -127190173.2608093
        ],
        [
            349287674.3037254,
            148110103.3906095,
            -132248356.07414824
        ],
        [
            340375001.6197554,
            156208314.73241374,
            -137097906.0991452
        ],
        [
            331250767.95831025,
            164030486.42166528,
            -141738337.23878235
        ],
        [
            321928946.3600946,
            171574647.08627212,
            -146169472.44496825
        ],
        [
            312423176.5752213,
            178839281.65499887,
            -150391422.2813465
        ],
        [
            302746753.28240633,
            185823302.59399632,
            -154404564.0056159
        ],
        [
            292912616.8243735,
            192526021.68901277,
            -158209521.2436073
        ],
        [
            282933346.2822893,
            198947122.48211005,
            -161807144.31540352
        ],
        [
            272821154.71389836,
            205086633.455451,
            -165198491.26269093
        ],
        [
            262587886.38330597,
            210944902.03956544,
            -168384809.6163122
        ],
        [
            252245015.8148424,
            216522569.50944126,
            -171367518.9336362
        ],
        [
            241803648.50890255,
            221820546.8188806,
            -174148194.12688857
        ],
        [
            231274523.16392928,
            226839991.41176566,
            -176728549.59595215
        ],
        [
            220668015.25559798,
            231582285.03819662,
            -179110424.1723359
        ],
        [
            209994141.8315993,
            236049012.59386203,
            -181295766.87498713
        ],
        [
            199262567.38810357,
            240241941.9924248,
            -183286623.4733356
        ],
        [
            188482610.70184618,
            244163005.07313144,
            -185085123.84837997
        ],
        [
            177663252.49973404,
            247814279.53919864,
            -186693470.13869858
        ],
        [
            166813143.85582703,
            251197971.9167593,
            -188113925.6549455
        ],
        [
            155940615.21339804,
            254316401.51920295,
            -189348804.54363292
        ],
        [
            145053685.93750155,
            257171985.39753938,
            -190400462.178749
        ],
        [
            134160074.31096356,
            259767224.25392336,
            -191271286.25797564
        ],
        [
            123267207.89396372,
            262104689.29261097,
            -191963688.57890514
        ],
        [
            112382234.17433445,
            264187009.9803353,
            -192480097.46966344
        ],
        [
            101512031.44233376,
            266016862.68633196,
            -192822950.84769577
        ],
        [
            90663219.82996848,
            267596960.17095017,
            -192994689.8801106
        ],
        [
            79842172.4608846,
            268930041.89091814,
            -192997753.2188835
        ],
        [
            69055026.66245179,
            270018865.0888283,
            -192834571.78434992
        ],
        [
            58307695.19691071,
            270866196.6342381,
            -192507564.07074454
        ],
        [
            47605877.47332576,
            271474805.58389527,
            -192019131.94803745
        ],
        [
            36955070.70663422,
            271847456.4289548,
            -191371656.9349529
        ],
        [
            26360580.994252056,
            271986902.99763656,
            -190567496.91881192
        ],
        [
            15827534.284566224,
            271895882.9825226,
            -189608983.29869026
        ],
        [
            5360887.215155244,
            271577113.06260663,
            -188498418.52931318
        ],
        [
            -5034562.198194265,
            271033284.59124327,
            -187238074.04410017
        ],
        [
            -15354164.037686706,
            270267059.8222877,
            -185830188.5368112
        ],
        [
            -25593406.138323814,
            269281068.647936,
            -184276966.58231544
        ],
        [
            -35747903.93232447,
            268077905.8230699,
            -182580577.57809955
        ],
        [
            -45813390.49207413,
            266660128.65224198,
            -180743154.9892344
        ],
        [
            -55785706.77864222,
            265030255.11681336,
            -178766795.88063124
        ],
        [
            -65660792.10126318,
            263190762.42114604,
            -176653560.7215192
        ],
        [
            -75434674.79176377,
            261144085.93815804,
            -174405473.44817203
        ],
        [
            -85103463.09667635,
            258892618.53595492,
            -172024521.77198833
        ],
        [
            -94663336.28875943,
            256438710.2686531,
            -169512657.7210884
        ],
        [
            -104110535.99877767,
            253784668.41589317,
            -166871798.404622
        ],
        [
            -113441357.76770276,
            250932757.85691643,
            -164103826.9899908
        ],
        [
            -122652142.81897125,
            247885201.7664131,
            -161210593.88416064
        ],
        [
            -131739270.05003321,
            244644182.62067497,
            -158193918.1111875
        ],
        [
            -140699148.24219367,
            241211843.50386557,
            -155055588.8789898
        ],
        [
            -149528208.48762012,
            237590289.70547077,
            -151797367.32927346
        ],
        [
            -158222896.83240068,
            233781590.6012106,
            -148420988.46536058
        ],
        [
            -166779667.13467053,
            229787781.81085962,
            -144928163.25346762
        ],
        [
            -175194974.13704944,
            225610867.62756374,
            -141320580.8937504
        ],
        [
            -183465266.75299677,
            221252823.71432504,
            -137599911.258152
        ]
    ],
    "(2025 AE2)": [
        [
            -183465266.75299683,
            221252823.714325,
            -137599911.25815198
        ],
        [
            -191586981.5671301,
            216715600.0643739,
            -133767807.49277854
        ],
        [
            -199556536.55011028,
            212001124.22314802,
            -129825908.78317164
        ],
        [
            -207370324.98934856,
            207111304.77054155,
            -125775843.28144674
        ],
        [
            -215024709.6375341,
            202048035.06299645,
            -121619231.19482934
        ],
        [
            -222516017.0818206,
            196813197.2358465,
            -117357688.03563368
        ],
        [
            -229840532.3374452,
            191408666.46712348,
            -112992828.03319925
        ],
        [
            -236994493.67057484,
            185836315.5047664,
            -108526267.70872203
        ],
        [
            -243974087.65629014,
            180098019.45984763,
            -103959629.61428756
        ],
        [
            -250775444.47882244,
            174195660.8690408,
            -99294546.23773456
        ],
        [
            -257394633.48245287,
            168131135.03009394,
            -94532664.07523842
        ],
        [
            -263827658.98286963,
            161906355.61453676,
            -89675647.87371185
        ],
        [
            -270070456.3502503,
            155523260.56223947,
            -84725185.04526041
        ],
        [
            -276118888.37690264,
            148983818.26274118,
            -79682990.25600791
        ],
        [
            -281968741.943948,
            142290034.02847576,
            -74550810.19161081
        ],
        [
            -287615725.00327134,
            135443956.86513284,
            -69330428.50170854
        ],
        [
            -293055463.8927911,
            128447686.54439285,
            -64023670.9254029
        ],
        [
            -298283501.0050094,
            121303380.98415887,
            -58632410.59961612
        ],
        [
            -303295292.8308041,
            114013263.941164,
            -53158573.55183893
        ],
        [
            -308086208.4024891,
            106579633.02044936,
            -47604144.37833819
        ],
        [
            -312651528.16232455,
            99004868.00567341,
            -41971172.10834077
        ],
        [
            -316986443.2848673,
            91291439.51351385,
            -36261776.25403787
        ],
        [
            -321086055.4838356,
            83441917.97454603,
            -30478153.045453086
        ],
        [
            -324945377.3364865,
            75458982.94190964,
            -24622581.848276556
        ],
        [
            -328559333.1608771,
            67345432.72779502,
            -18697431.761680186
        ],
        [
            -331922760.4837807,
            59104194.36627275,
            -12705168.391880006
        ],
        [
            -335030412.13943964,
            50738333.89923774,
            -6648360.795794547
        ],
        [
            -337876959.04174113,
            42251066.98022562,
            -529688.5875481516
        ],
        [
            -340456993.6747845,
            33645769.7885627,
            5648050.801222876
        ],
        [
            -342765034.3491315,
            24925990.24371645,
            11881934.718299136
        ],
        [
            -344795530.27327913,
            16095459.506795019,
            18168907.75828977
        ],
        [
            -346542867.49202734,
            7158103.752891064,
            24505774.11620991
        ],
        [
            -348001375.74539584,
            -1881943.8056477457,
            30889189.84557675
        ],
        [
            -349165336.30353534,
            -11020330.668929398,
            37315655.04229182
        ],
        [
            -350028990.8346335,
            -20252472.600496814,
            43781505.97874187
        ],
        [
            -350586551.36407447,
            -29573541.012652174,
            50282907.21597426
        ],
        [
            -350832211.3840311,
            -38978450.22441247,
            56815843.7254875
        ],
        [
            -350760158.1731709,
            -48461844.63601813,
            63376113.05612276
        ],
        [
            -350364586.3861878,
            -58018085.86999273,
            69959317.58575207
        ],
        [
            -349639712.972342,
            -67641239.93525723,
            76560856.90191849
        ],
        [
            -348579793.48103595,
            -77325064.47774726,
            83175920.36029369
        ],
        [
            -347179139.810579,
            -87062996.1883428,
            89799479.8747558
        ],
        [
            -345432139.45360565,
            -96848138.4466815,
            96426282.9980375
        ],
        [
            -343333276.2890341,
            -106673249.28757064,
            103050846.3572261
        ],
        [
            -340877152.9658572,
            -116530729.78518656,
            109667449.51387799
        ],
        [
            -338058514.9183753,
            -126412612.9590165,
            116270129.32409242
        ],
        [
            -334872276.04558694,
            -136310553.31449193,
            122852674.87953466
        ],
        [
            -331313546.07925016,
            -146215817.14040872,
            129408623.11603141
        ],
        [
            -327377659.6555306,
            -156119273.69443414,
            135931255.18192062
        ],
        [
            -323060207.09403414,
            -166011387.41716847,
            142413593.66373983
        ],
        [
            -318357066.875334,
            -175882211.32421875,
            148848400.77198273
        ],
        [
            -313264439.7937249,
            -185721381.73442623,
            155228177.5944448
        ],
        [
            -307778884.74583554,
            -195518114.50059858,
            161545164.52899432
        ],
        [
            -301897356.09784365,
            -205261202.91664797,
            167791343.01131132
        ],
        [
            -295617242.55433065,
            -214939017.48173752,
            173958438.65610278
        ],
        [
            -288936407.4303017,
            -224539507.7076545,
            180037925.93236113
        ],
        [
            -281853230.2045945,
            -234050206.15993658,
            186021034.49423537
        ],
        [
            -274366649.2078736,
            -243458234.9260123,
            191898757.28884998
        ],
        [
            -266476205.27176556,
            -252750314.70450848,
            197661860.560759
        ],
        [
            -258182086.1375785,
            -261912776.7086545,
            203300895.8694858
        ],
        [
            -249485171.39366,
            -270931577.5730765,
            208806214.23158333
        ],
        [
            -240387077.6800521,
            -279792317.44694006,
            214167982.49167758
        ],
        [
            -230890203.86798388,
            -288480261.4470799,
            219376202.01785994
        ],
        [
            -220997775.89030883,
            -296980364.6321766,
            224420729.8054114
        ],
        [
            -210713890.86764804,
            -305277300.6429347,
            229291302.0590243
        ],
        [
            -200043560.14426687,
            -313355494.1333758,
            233977560.30733865
        ],
        [
            -188992750.81814435,
            -321199157.09456843,
            238469080.08461916
        ],
        [
            -177568425.3219195,
            -328792329.1442483,
            242755402.19274545
        ],
        [
            -165778578.5860915,
            -336118921.8237456,
            246826066.5323501
        ],
        [
            -153632272.2937463,
            -343162766.9074174,
            250670648.46498477
        ],
        [
            -141139665.71794713,
            -349907668.6894534,
            254278797.63872537
        ],
        [
            -128312042.61953542,
            -356337460.16863906,
            257640279.17782867
        ],
        [
            -115161833.67526814,
            -362436063.0036932,
            260745017.10317296
        ],
        [
            -101702633.90473735,
            -368187551.0605148,
            263583139.81458175
        ],
        [
            -87949214.57014519,
            -373576217.3185684,
            266145027.4291462
        ],
        [
            -73917529.03646183,
            -378586643.847337,
            268421360.73181987
        ],
        [
            -59624712.10138011,
            -383203774.50599015,
            270403171.4564151
        ],
        [
            -45089072.33534637,
            -387412989.96103734,
            272081893.57733095
        ],
        [
            -30330077.01216224,
            -391200184.55871224,
            273449415.2555859
        ],
        [
            -15368329.260461658,
            -394551844.532246,
            274498131.0477809
        ],
        [
            -225537.12579756975,
            -397455126.97020257,
            275220993.9542918
        ],
        [
            15075525.698020399,
            -399897938.92187536,
            275611566.8541074
        ],
        [
            30511067.63173163,
            -401869015.97067255,
            275664072.8491485
        ],
        [
            46056335.544560045,
            -403357999.5677074,
            275373444.0214477
        ],
        [
            61685679.64232272,
            -404355512.3867199,
            274735368.0930269
        ],
        [
            77372626.79240754,
            -404853230.93919545,
            273746332.4714298
        ],
        [
            93089962.0629527,
            -404843954.6761914,
            272403665.1642673
        ],
        [
            108809818.14481464,
            -404321670.801913,
            270705572.0543638
        ],
        [
            124503772.21458814,
            -403281614.0342731,
            268651170.0435273
        ],
        [
            140142949.68705773,
            -401720320.5700873,
            266240515.5978333
        ],
        [
            155698134.19813132,
            -399635675.5475497,
            263474628.2606619
        ],
        [
            171139883.05675167,
            -397026953.3462147,
            260355508.74139842
        ],
        [
            186438647.30871788,
            -393894850.124683,
            256886151.2373517
        ],
        [
            201564895.46898568,
            -390241508.0679622,
            253070549.70348614
        ],
        [
            216489239.9039284,
            -386070530.899224,
            248913697.84824434
        ],
        [
            231182564.7831535,
            -381386990.303229,
            244421582.70307997
        ],
        [
            245616154.473478,
            -376197423.00961006,
            239601171.6871945
        ],
        [
            259761821.21695298,
            -370509818.3917988,
            234460393.1660801
        ],
        [
            273592030.92147106,
            -364333596.5497317,
            229008110.5814018
        ],
        [
            287080025.8971469,
            -357679576.95951974,
            223254090.3090149
        ],
        [
            300199943.3945938,
            -350559937.8887978,
            217208963.47995913
        ],
        [
            312926928.8422778,
            -342988166.89025927,
            210884182.07457152
        ],
        [
            325237242.73867166,
            -334979002.7956848,
            204291969.67090946
        ],
        [
            337108360.2299736,
            -326548369.7364296,
            197445267.2940678
        ],
        [
            348519062.49425364,
            -317713303.81181717,
            190357674.87143064
        ],
        [
            359449519.1562555,
            -308491873.1123705,
            183043388.84929514
        ],
        [
            369881361.0716686,
            -298903091.87869275,
            175517136.5677235
        ],
        [
            379797742.94312084,
            -288966829.63781303,
            167794108.0222209
        ],
        [
            389183395.359961,
            -278703716.2059312,
            159889885.66242856
        ],
        [
            398024665.9874739,
            -268135043.47911826,
            151820372.88925007
        ],
        [
            406309549.76587963,
            -257282664.95135647,
            143601721.91272417
        ],
        [
            414027708.11272055,
            -246168893.90240827,
            135250261.62377486
        ],
        [
            421170477.25157416,
            -234816401.18678796,
            126782426.11421104
        ],
        [
            427730865.91315,
            -223248113.53030038,
            118214684.45170106
        ],
        [
            433703542.76969457,
            -211487113.20318806,
            109563472.28077012
        ],
        [
            439084814.06845206,
            -199556539.89014906,
            100845125.77818158
        ],
        [
            443872592.02327585,
            -187479495.51877892,
            92075818.44247638
        ],
        [
            448066354.60419714,
            -175278952.740917,
            83271501.14414127
        ],
        [
            451667097.432101,
            -162977667.6876443,
            74447845.80609708
        ],
        [
            454677278.5391531,
            -150598097.53996074,
            65620193.02514452
        ],
        [
            457100756.795196,
            -138162323.37521702,
            56803503.884895876
        ],
        [
            458942724.8261739,
            -125691978.6658266,
            48012316.15067327
        ],
        [
            460209637.26323974,
            -113208183.72322866,
            39260704.97792947
        ],
        [
            460909135.1612822,
            -100731486.29795632,
            30562248.20888132
        ],
        [
            461049967.41410995,
            -88281808.46731591,
            21929996.278082654
        ],
        [
            460641909.97155124,
            -75878399.86671412,
            13376446.697275981
        ],
        [
            459695683.6324798,
            -63539797.25007191,
            4913523.043636903
        ],
        [
            458222871.1485779,
            -51283790.299797624,
            -3447441.6661268175
        ],
        [
            456235834.3278156,
            -39127393.54803884,
            -11695717.370142296
        ],
        [
            453747631.77551955,
            -27086824.21883422,
            -19821185.310255975
        ],
        [
            450771937.855836,
            -15177485.75552243,
            -27814342.548144758
        ],
        [
            447322963.3986157,
            -3413956.759475261,
            -35666302.88296431
        ],
        [
            443415378.6174511,
            8190014.965203077,
            -43368794.42156257
        ],
        [
            439064238.6448491,
            19621513.591117114,
            -50914154.06434268
        ],
        [
            434284912.0313123,
            30868452.01959625,
            -58295319.17751728
        ],
        [
            429093012.4972621,
            41919564.56607649,
            -65505816.72613241
        ],
        [
            423504334.17101705,
            52764395.94640711,
            -72539750.1421909
        ],
        [
            417534790.4930284,
            63393286.93336311,
            -79391784.19888833
        ],
        [
            411200356.91676277,
            73797357.04984686,
            -86057128.15580422
        ],
        [
            404517017.4903872,
            83968484.6584595,
            -92531517.43124916
        ],
        [
            397500715.3609911,
            93899284.79691851,
            -98811194.04729706
        ],
        [
            390167307.2046597,
            103583085.09568012,
            -104892886.0806821
        ],
        [
            382532521.5513613,
            113013900.09864672,
            -110773786.33910273
        ],
        [
            374611920.94329154,
            122186404.29050025,
            -116451530.46789035
        ],
        [
            366420867.83902097,
            131095904.11542338,
            -121924174.67676322
        ],
        [
            357974494.1533147,
            139738309.25223568,
            -127190173.2608093
        ],
        [
            349287674.3037254,
            148110103.3906095,
            -132248356.07414824
        ],
        [
            340375001.6197554,
            156208314.73241374,
            -137097906.0991452
        ],
        [
            331250767.95831025,
            164030486.42166528,
            -141738337.23878235
        ],
        [
            321928946.3600946,
            171574647.08627212,
            -146169472.44496825
        ],
        [
            312423176.5752213,
            178839281.65499887,
            -150391422.2813465
        ],
        [
            302746753.28240633,
            185823302.59399632,
            -154404564.0056159
        ],
        [
            292912616.8243735,
            192526021.68901277,
            -158209521.2436073
        ],
        [
            282933346.2822893,
            198947122.48211005,
            -161807144.31540352
        ],
        [
            272821154.71389836,
            205086633.455451,
            -165198491.26269093
        ],
        [
            262587886.38330597,
            210944902.03956544,
            -168384809.6163122
        ],
        [
            252245015.8148424,
            216522569.50944126,
            -171367518.9336362
        ],
        [
            241803648.50890255,
            221820546.8188806,
            -174148194.12688857
        ],
        [
            231274523.16392928,
            226839991.41176566,
            -176728549.59595215
        ],
        [
            220668015.25559798,
            231582285.03819662,
            -179110424.1723359
        ],
        [
            209994141.8315993,
            236049012.59386203,
            -181295766.87498713
        ],
        [
            199262567.38810357,
            240241941.9924248,
            -183286623.4733356
        ],
        [
            188482610.70184618,
            244163005.07313144,
            -185085123.84837997
        ],
        [
            177663252.49973404,
            247814279.53919864,
            -186693470.13869858
        ],
        [
            166813143.85582703,
            251197971.9167593,
            -188113925.6549455
        ],
        [
            155940615.21339804,
            254316401.51920295,
            -189348804.54363292
        ],
        [
            145053685.93750155,
            257171985.39753938,
            -190400462.178749
        ],
        [
            134160074.31096356,
            259767224.25392336,
            -191271286.25797564
        ],
        [
            123267207.89396372,
            262104689.29261097,
            -191963688.57890514
        ],
        [
            112382234.17433445,
            264187009.9803353,
            -192480097.46966344
        ],
        [
            101512031.44233376,
            266016862.68633196,
            -192822950.84769577
        ],
        [
            90663219.82996848,
            267596960.17095017,
            -192994689.8801106
        ],
        [
            79842172.4608846,
            268930041.89091814,
            -192997753.2188835
        ],
        [
            69055026.66245179,
            270018865.0888283,
            -192834571.78434992
        ],
        [
            58307695.19691071,
            270866196.6342381,
            -192507564.07074454
        ],
        [
            47605877.47332576,
            271474805.58389527,
            -192019131.94803745
        ],
        [
            36955070.70663422,
            271847456.4289548,
            -191371656.9349529
        ],
        [
            26360580.994252056,
            271986902.99763656,
            -190567496.91881192
        ],
        [
            15827534.284566224,
            271895882.9825226,
            -189608983.29869026
        ],
        [
            5360887.215155244,
            271577113.06260663,
            -188498418.52931318
        ],
        [
            -5034562.198194265,
            271033284.59124327,
            -187238074.04410017
        ],
        [
            -15354164.037686706,
            270267059.8222877,
            -185830188.5368112
        ],
        [
            -25593406.138323814,
            269281068.647936,
            -184276966.58231544
        ],
        [
            -35747903.93232447,
            268077905.8230699,
            -182580577.57809955
        ],
        [
            -45813390.49207413,
            266660128.65224198,
            -180743154.9892344
        ],
        [
            -55785706.77864222,
            265030255.11681336,
            -178766795.88063124
        ],
        [
            -65660792.10126318,
            263190762.42114604,
            -176653560.7215192
        ],
        [
            -75434674.79176377,
            261144085.93815804,
            -174405473.44817203
        ],
        [
            -85103463.09667635,
            258892618.53595492,
            -172024521.77198833
        ],
        [
            -94663336.28875943,
            256438710.2686531,
            -169512657.7210884
        ],
        [
            -104110535.99877767,
            253784668.41589317,
            -166871798.404622
        ],
        [
            -113441357.76770276,
            250932757.85691643,
            -164103826.9899908
        ],
        [
            -122652142.81897125,
            247885201.7664131,
            -161210593.88416064
        ],
        [
            -131739270.05003321,
            244644182.62067497,
            -158193918.1111875
        ],
        [
            -140699148.24219367,
            241211843.50386557,
            -155055588.8789898
        ],
        [
            -149528208.48762012,
            237590289.70547077,
            -151797367.32927346
        ],
        [
            -158222896.83240068,
            233781590.6012106,
            -148420988.46536058
        ],
        [
            -166779667.13467053,
            229787781.81085962,
            -144928163.25346762
        ],
        [
            -175194974.13704944,
            225610867.62756374,
            -141320580.8937504
        ],
        [
            -183465266.75299677,
            221252823.71432504,
            -137599911.258152
        ]
    ],
    "(2011 GE3)": [
        [
            156251501.8757009,
            245062511.47061962,
            -61981702.6850496
        ],
        [
            148217224.73939407,
            249848393.42825663,
            -62747731.67137975
        ],
        [
            140062002.28545994,
            254437848.18578896,
            -63464252.136874765
        ],
        [
            131788889.44778574,
            258828914.6609495,
            -64130940.68014462
        ],
        [
            123400926.82236314,
            263019581.2467158,
            -64747461.837647386
        ],
        [
            114901147.52678029,
            267007782.53957132,
            -65313467.61481994
        ],
        [
            106292584.23896584,
            270791396.33582395,
            -65828597.08534085
        ],
        [
            97578276.41948085,
            274368240.899279,
            -66292476.05944685
        ],
        [
            88761277.72206199,
            277736072.5049995,
            -66704716.822567746
        ],
        [
            79844663.59743254,
            280892583.2653806,
            -67064917.94589652
        ],
        [
            70831539.09560429,
            283835399.24631536,
            -67372664.17087242
        ],
        [
            61725046.87199682,
            286562078.88283527,
            -67627526.36992374
        ],
        [
            52528375.402686685,
            289070111.70527077,
            -67829061.58619472
        ],
        [
            43244767.413968086,
            291356917.38869923,
            -67976813.15536708
        ],
        [
            33877528.53114465,
            293419845.1402239,
            -68070310.91307981
        ],
        [
            24430036.151074618,
            295256173.4404583,
            -68109071.49185205
        ],
        [
            14905748.542445228,
            296863110.1574818,
            -68092598.7118204
        ],
        [
            5308214.177048862,
            298237793.05346525,
            -68020384.07001525
        ],
        [
            -4358918.705544442,
            299377290.70615923,
            -67891907.33331725
        ],
        [
            -14091892.298580855,
            300278603.86946404,
            -67706637.24065416
        ],
        [
            -23886829.19390765,
            300938667.2993741,
            -67464032.3204191
        ],
        [
            -33739722.1143468,
            301354352.0736922,
            -67163541.82951011
        ],
        [
            -43646423.41576128,
            301522468.4360287,
            -66804606.82080457
        ],
        [
            -53602634.36387421,
            301439769.196742,
            -66386661.34629022
        ],
        [
            -63603894.19312334,
            301102953.72560453,
            -65909133.80346972
        ],
        [
            -73645568.95734574,
            300508672.5730981,
            -65371448.43303614
        ],
        [
            -83722840.18490602,
            299653532.7593192,
            -64773026.97617681
        ],
        [
            -93830693.35402855,
            298534103.7714948,
            -64113290.500195324
        ],
        [
            -103963906.20759058,
            297146924.313049,
            -63391661.4014426
        ],
        [
            -114117036.93049926,
            295488509.84898025,
            -62607565.59480694
        ],
        [
            -124284412.21703252,
            293555360.9939923,
            -61760434.89922445
        ],
        [
            -134460115.26018932,
            291343972.7913115,
            -60849709.628823236
        ],
        [
            -144637973.70018864,
            288850844.93139464,
            -59874841.39939957
        ],
        [
            -154811547.57479584,
            286072492.9607228,
            -58835296.15992759
        ],
        [
            -164974117.3201509,
            283005460.5315488,
            -57730557.45871638
        ],
        [
            -175118671.8772354,
            279646332.7437415,
            -56560129.95363192
        ],
        [
            -185237896.96605927,
            275991750.6297072,
            -55323543.175486326
        ],
        [
            -195324163.59705687,
            272038426.8326776,
            -54020355.55324179
        ],
        [
            -205369516.89707443,
            267783162.52736723,
            -52650158.70906911
        ],
        [
            -215365665.33566836,
            263222865.6300394,
            -51212582.0305184
        ],
        [
            -225303970.44621903,
            258354570.34228292,
            -49707297.526086524
        ],
        [
            -235175437.14554864,
            253175458.06921002,
            -48134024.9692799
        ],
        [
            -244970704.76528144,
            247682879.74822676,
            -46492537.33485261
        ],
        [
            -254680038.91803598,
            241874379.61891082,
            -44782666.52922752
        ],
        [
            -264293324.3316331,
            235747720.45774147,
            -43004309.41515977
        ],
        [
            -273800058.7947314,
            229300910.29336736,
            -41157434.128459476
        ],
        [
            -283189348.3675834,
            222532230.60864872,
            -39242086.682030246
        ],
        [
            -292449904.0217867,
            215440266.0247764,
            -37258397.849585555
        ],
        [
            -301570039.88286036,
            208023935.45025128,
            -35206590.31816006
        ],
        [
            -310537673.2590141,
            200282524.66329792,
            -33086986.094919275
        ],
        [
            -319340326.64842105,
            192215720.28032294,
            -30900014.149783764
        ],
        [
            -327965131.92540956,
            183823645.04522657,
            -28646218.27101087
        ],
        [
            -336398836.91302615,
            175106894.35469443,
            -26326265.10612076
        ],
        [
            -344627814.5551028,
            166066573.91301662,
            -23940952.355418876
        ],
        [
            -352638074.9049954,
            156704338.38648912,
            -21491217.079864383
        ],
        [
            -360415280.1502114,
            147022430.902111,
            -18978144.07919001
        ],
        [
            -367944762.8918837,
            137023723.20815682,
            -16402974.290020097
        ],
        [
            -375211547.89508975,
            126711756.28541942,
            -13767113.14730781
        ],
        [
            -382200377.51999825,
            116090781.167655,
            -11072138.845772922
        ],
        [
            -388895741.03435117,
            105165799.69826137,
            -8319810.431239422
        ],
        [
            -395281907.9944847,
            93942604.9177816,
            -5512075.644930251
        ],
        [
            -401342965.8645559,
            82427820.74383093,
            -2651078.4369777553
        ],
        [
            -407062862.02154124,
            70628940.57192677,
            260833.94123496488
        ],
        [
            -412425450.2665603,
            58554364.39300406,
            3221104.3626382425
        ],
        [
            -417414541.9308738,
            46213433.99170995,
            6226959.870595228
        ],
        [
            -422013961.62728965,
            33616465.75958124,
            9275406.45353714
        ],
        [
            -426207607.65453523,
            20774780.629674584,
            12363224.660603896
        ],
        [
            -429979517.0133589,
            7700730.6149652,
            15486966.174338128
        ],
        [
            -433313934.93877184,
            -5592278.587253839,
            18642951.458867744
        ],
        [
            -436195388.7931201,
            -19089769.47772172,
            21827268.60302425
        ],
        [
            -438608766.0999043,
            -32776179.68596351,
            25035773.47727213
        ],
        [
            -440539396.4289546,
            -46634854.51296669,
            28264091.32096943
        ],
        [
            -441973136.77036273,
            -60648045.64314386,
            31507619.872146077
        ],
        [
            -442896459.9583466,
            -74796916.56785509,
            34761534.14549868
        ],
        [
            -443296545.62799335,
            -89061555.23789251,
            38020792.95551075
        ],
        [
            -443161373.1088395,
            -103420994.42692152,
            41280147.27038953
        ],
        [
            -442479815.5809075,
            -117853240.24135524,
            44534150.46879384
        ],
        [
            -441241734.7427162,
            -132335309.1540722,
            47777170.55507471
        ],
        [
            -439438075.1686439,
            -146843273.8696034,
            51003404.36999188
        ],
        [
            -437060957.4667157,
            -161352318.24695587,
            54206893.81269102
        ],
        [
            -434103769.28933764,
            -175836801.41348803,
            57381544.06629041
        ],
        [
            -430561253.20069635,
            -190270331.09984487,
            60521143.79395949
        ],
        [
            -426429590.3674347,
            -204625846.1129455,
            63619387.245187856
        ],
        [
            -421706479.0156956,
            -218875707.74271852,
            66669898.1834227
        ],
        [
            -416391206.5894364,
            -232991799.77042472,
            69666255.51685484
        ],
        [
            -410484714.5535822,
            -246945636.61403376,
            72602020.48438448
        ],
        [
            -403989654.81238043,
            -260708479.01157227,
            75470765.21928088
        ],
        [
            -396910436.75912607,
            -274251456.5092807,
            78266102.4844018
        ],
        [
            -389253264.03876597,
            -287545695.8906184,
            80981716.34571972
        ],
        [
            -381026160.1897978,
            -300562454.557654,
            83611393.52599907
        ],
        [
            -372238982.4358869,
            -313273257.7612098,
            86149055.15845333
        ],
        [
            -362903423.01974714,
            -325650038.4733511,
            88588788.64173889
        ],
        [
            -353032997.6105461,
            -337665278.6083184,
            90924879.28331181
        ],
        [
            -342643020.4693287,
            -349292150.22853416,
            93151841.40852204
        ],
        [
            -331750566.2221621,
            -360504655.32322526,
            95264448.60828212
        ],
        [
            -320374418.26488227,
            -371277762.7204962,
            97257762.79905812
        ],
        [
            -308535004.0030705,
            -381587540.6908389,
            99127161.7754887
        ],
        [
            -296254317.3125625,
            -391411283.8219838,
            100868364.94820479
        ],
        [
            -283555828.7854984,
            -400727632.7920032,
            102477456.97731486
        ],
        [
            -270464384.50075984,
            -409516685.73929524,
            103950909.03529492
        ],
        [
            -257006094.22171754,
            -417760100.02350754,
            105285597.4612973
        ],
        [
            -243208210.07482165,
            -425441183.28893995,
            106478819.60164143
        ],
        [
            -229098996.89632255,
            -432544972.8792153,
            107528306.66781637
        ],
        [
            -214707595.54828054,
            -439058302.8062388,
            108432233.48295656
        ],
        [
            -200063880.5965488,
            -444969857.64438266,
            109189225.02959897
        ],
        [
            -185198313.81066257,
            -450270212.89882034,
            109798359.75469314
        ],
        [
            -170141794.98728544,
            -454951861.5811114,
            110259169.6313826
        ],
        [
            -154925511.61447024,
            -459009226.91150904,
            110571637.0200759
        ],
        [
            -139580788.88356864,
            -462438661.252046,
            110736188.4128733
        ],
        [
            -124138941.5199605,
            -465238431.55337036,
            110753685.18466556
        ],
        [
            -108631128.84425917,
            -467408691.7679619,
            110625411.51040812
        ],
        [
            -93088214.39424765,
            -468951442.8394651,
            110353059.64052999
        ],
        [
            -77540631.33696544,
            -469870481.0196131,
            109938712.7546213
        ],
        [
            -62018254.78295231,
            -470171335.3882495,
            109384825.6370346
        ],
        [
            -46550281.98377037,
            -469861195.55650103,
            108694203.4365594
        ],
        [
            -31165121.252909422,
            -468948830.6170124,
            107869978.78574063
        ],
        [
            -15890290.302395046,
            -467444500.46769416,
            106915587.5637073
        ],
        [
            -752324.53621611,
            -465359860.6765853,
            105834743.58967116
        ],
        [
            14223304.30969426,
            -462707862.07566804,
            104631412.53278723
        ],
        [
            29012258.93978098,
            -459502646.2716994,
            103309785.31816377
        ],
        [
            43591396.585385025,
            -455759438.24372524,
            101874251.2988894
        ],
        [
            57938818.44247958,
            -451494437.1615609,
            100329371.45048669
        ],
        [
            72033908.62283531,
            -446724706.50915307,
            98679851.82772721
        ],
        [
            85857362.89449868,
            -441468064.53347313,
            96930517.50480482
        ],
        [
            99391207.5883739,
            -435742975.9657182,
            95086287.19902125
        ],
        [
            112618809.13510117,
            -429568445.87936497,
            93152148.75593784
        ],
        [
            125524874.76984203,
            -422963916.46130764,
            91133135.65092595
        ],
        [
            138095445.00199187,
            -415949167.38007796,
            89034304.6386951
        ],
        [
            150317878.49247918,
            -408544220.34102404,
            86860714.65915047
        ],
        [
            162180830.0136775,
            -400769248.32419395,
            84617407.0852302
        ],
        [
            173674222.18686926,
            -392644489.9081688,
            82309387.37654579
        ],
        [
            184789211.70051107,
            -384190168.99368834,
            79941608.18198673
        ],
        [
            195518150.71040303,
            -375426420.1558135,
            77518953.91519079
        ],
        [
            205854544.11139524,
            -366373219.77353954,
            75046226.80908924
        ],
        [
            215793003.35067832,
            -357050323.0120176,
            72528134.43975328
        ],
        [
            225329197.42627853,
            -347477206.6653455,
            69969278.69554842
        ],
        [
            234459801.6822826,
            -337673017.80764467,
            67374146.15519452
        ],
        [
            243182444.97576046,
            -327656528.146988,
            64747099.82770851
        ],
        [
            251495655.75045004,
            -317446093.93068403,
            62092372.19833587
        ],
        [
            259398807.51001257,
            -307059621.2113568,
            59414059.51738766
        ],
        [
            266892064.14005446,
            -296514536.250892,
            56716117.26329005
        ],
        [
            273976325.48392886,
            -285827760.813357,
            54002356.707020625
        ],
        [
            280653173.5333378,
            -275015692.07801145,
            51276442.502324894
        ],
        [
            286924819.5515962,
            -264094186.88902998,
            48541891.224540815
        ],
        [
            292794052.4055747,
            -253078550.04911348,
            45802070.780389264
        ],
        [
            298264188.3422951,
            -241983526.35918495,
            43060200.611561336
        ],
        [
            303339022.4082049,
            -230823296.10539854,
            40319352.61623466
        ],
        [
            308022781.67357206,
            -219611473.6971799,
            37582452.71464385
        ],
        [
            312320080.39141124,
            -208361109.1654685,
            34852282.987393424
        ],
        [
            316235877.1899515,
            -197084692.23831013,
            32131484.31823499
        ],
        [
            319775434.3699737,
            -185794158.72094512,
            29422559.476412296
        ],
        [
            322944279.353336,
            -174500898.9192099,
            26727876.57733491
        ],
        [
            325748168.30667573,
            -163215767.85797632,
            24049672.86417056
        ],
        [
            328193051.94449544,
            -151949097.0602057,
            21390058.756889015
        ],
        [
            330285043.49854046,
            -140710707.66666472,
            18751022.11927343
        ],
        [
            332030388.8254118,
            -129509924.69115746,
            16134432.69838223
        ],
        [
            333435438.611587,
            -118355592.2210953,
            13542046.694858797
        ],
        [
            334506622.624297,
            -107256089.38807793,
            10975511.426293608
        ],
        [
            335250425.9478622,
            -96219346.9478039,
            8436370.049527176
        ],
        [
            335673367.1379681,
            -85252864.32288417,
            5926066.311309136
        ],
        [
            335781978.22080094,
            -74363726.97588709,
            3445949.3000788093
        ],
        [
            335582786.45980245,
            -63558623.993153036,
            997278.1748030558
        ],
        [
            335082297.8098935,
            -52843865.77244963,
            -1418773.1502270885
        ],
        [
            334286981.9772185,
            -42225401.71941291,
            -3801111.3829671554
        ],
        [
            333203259.0016241,
            -31708837.868863136,
            -6148719.309316758
        ],
        [
            331837487.27909243,
            -21299454.35748218,
            -8460651.34033927
        ],
        [
            330195952.9420847,
            -11002222.684024721,
            -10736029.162226249
        ],
        [
            328284860.5170826,
            -821822.7021529078,
            -12974037.49825561
        ],
        [
            326110324.7804776,
            9237340.700793535,
            -15173919.990197238
        ],
        [
            323678363.7362306,
            19171121.27826923,
            -17334975.205003593
        ],
        [
            320994892.64134336,
            28975615.484589517,
            -19456552.771176036
        ],
        [
            318065719.00807226,
            38647146.94674249,
            -21538049.647903357
        ],
        [
            314896538.5149044,
            48182251.36854008,
            -23578906.528929394
        ],
        [
            311492931.7615559,
            57577661.882703364,
            -25578604.38210006
        ],
        [
            307860361.8065971,
            66830294.86203322,
            -27536661.124663804
        ],
        [
            304004172.42969537,
            75937236.19689517,
            -29452628.4336433
        ],
        [
            299929587.0638906,
            84895728.0427767,
            -31326088.689944863
        ],
        [
            295641708.3467179,
            93703156.03867732,
            -33156652.05432613
        ],
        [
            291145518.2423611,
            102357036.9944684,
            -34943953.67288162
        ],
        [
            286445878.690329,
            110855007.04314384,
            -36687651.00933452
        ],
        [
            281547532.7393763,
            119194810.25198574,
            -38387421.301121086
        ],
        [
            276455106.12854016,
            127374287.68509711,
            -40042959.136022985
        ],
        [
            271173109.28019214,
            135391366.9084782,
            -41653974.145934336
        ],
        [
            265705939.67294997,
            143244051.92778364,
            -43220188.81423198
        ],
        [
            260057884.56509674,
            150930413.54812643,
            -44741336.39315434
        ],
        [
            254233124.04185852,
            158448580.14471287,
            -46217158.92757064
        ],
        [
            248235734.36246386,
            165796728.8327148,
            -47647405.38153924
        ],
        [
            242069691.5853542,
            172973077.024593,
            -49031829.8641081
        ],
        [
            235738875.45225137,
            179975874.36302757,
            -50370189.95089123
        ],
        [
            229247073.51398644,
            186803395.0177258,
            -51662245.09806859
        ],
        [
            222597985.48308456,
            193453930.3345953,
            -52907755.14559092
        ],
        [
            215795227.80007315,
            199925781.82612222,
            -54106478.906529054
        ],
        [
            208842338.40232807,
            206217254.49224818,
            -55258172.83968562
        ],
        [
            201742781.6860262,
            212326650.46158248,
            -56362589.80277991
        ],
        [
            194499953.6533983,
            218252262.94342968,
            -57419477.88372873
        ],
        [
            187117187.23901418,
            223992370.4818289,
            -58428579.307770096
        ],
        [
            179597757.8102593,
            229545231.50359032,
            -59389629.41841385
        ],
        [
            171944888.83848608,
            234909079.15318647,
            -60302355.73045403
        ],
        [
            164161757.73856637,
            240082116.40827364,
            -61166477.05353667
        ],
        [
            156251501.87570095,
            245062511.4706196,
            -61981702.68504959
        ]
    ],
    "(2021 NT5)": [
        [
            -240094570.84375295,
            201432050.08244228,
            -510934.208277871
        ],
        [
            -246326617.4060765,
            193801592.3643717,
            413408.73880834406
        ],
        [
            -252353878.4088035,
            186006061.65170556,
            1337696.337779432
        ],
        [
            -258173048.0936537,
            178049428.3328259,
            2261443.9008616437
        ],
        [
            -263780823.66909608,
            169935681.17556006,
            3184165.57532389
        ],
        [
            -269173902.16179425,
            161668832.60037667,
            4105373.7730784533
        ],
        [
            -274348977.5877849,
            153252924.18488148,
            5024578.602295182
        ],
        [
            -279302738.45155483,
            144692032.39353174,
            5941287.301954772
        ],
        [
            -284031865.58193165,
            135990274.52658486,
            6855003.680303857
        ],
        [
            -288533030.3144913,
            127151814.88229583,
            7765227.55822127
        ],
        [
            -292802893.03101915,
            118180871.12627839,
            8671454.218561286
        ],
        [
            -296838102.06742096,
            109081720.8617362,
            9573173.862605654
        ],
        [
            -300635293.00237584,
            99858708.39395508,
            10469871.074832102
        ],
        [
            -304191088.33993506,
            90516251.68201081,
            11361024.297292653
        ],
        [
            -307502097.60020256,
            81058849.47009516,
            12246105.314990377
        ],
        [
            -310564917.83317,
            71491088.59017627,
            13124578.753748503
        ],
        [
            -313376134.5717199,
            61817651.4268983,
            13995901.592180684
        ],
        [
            -315932323.2407422,
            52043323.53466782,
            14859522.68949585
        ],
        [
            -318230051.04022455,
            42173001.39577603,
            15714882.33100526
        ],
        [
            -320265879.3210618,
            32211700.307156324,
            16561411.793342883
        ],
        [
            -322036366.47318536,
            22164562.381968975,
            17398532.931563035
        ],
        [
            -323538071.3464037,
            12036864.65063575,
            18225657.790440757
        ],
        [
            -324767557.2250839,
            1834027.2442090511,
            19042188.242470246
        ],
        [
            -325721396.3784554,
            -8438378.358949333,
            19847515.65523486
        ],
        [
            -326396175.20887643,
            -18774621.044293463,
            20641020.59100705
        ],
        [
            -326788500.0208466,
            -29168801.7534059,
            21422072.541628618
        ],
        [
            -326895003.4338608,
            -39614845.183333725,
            22190029.70191873
        ],
        [
            -326712351.4623563,
            -50106491.52142504,
            22944238.78505893
        ],
        [
            -326237251.28598726,
            -60637288.24696863,
            23684034.88360955
        ],
        [
            -325466459.73323905,
            -71200582.03395087,
            24408741.380018182
        ],
        [
            -324396792.50095105,
            -81789510.79243961,
            25117669.91068784
        ],
        [
            -323025134.1316151,
            -92396995.88947496,
            25810120.387876682
        ],
        [
            -321348448.7693358,
            -103015734.59388869,
            26485381.08390152
        ],
        [
            -319363791.7140439,
            -113638192.79317471,
            27142728.782310713
        ],
        [
            -317068321.7919129,
            -124256598.03437889,
            27781429.000875503
        ],
        [
            -314459314.55791396,
            -134862932.94494897,
            28400736.29141968
        ],
        [
            -311534176.3440138,
            -145448929.0935711,
            28999894.621661667
        ],
        [
            -308290459.1636507,
            -156006061.35517392,
            29578137.84437675
        ],
        [
            -304725876.47976595,
            -166525542.84850335,
            30134690.25929673
        ],
        [
            -300838319.8398087,
            -176998320.51889,
            30668767.273243964
        ],
        [
            -296625876.3767127,
            -187415071.443038,
            31179576.164042685
        ],
        [
            -292086847.1698587,
            -197766199.93678963,
            31666316.953756783
        ],
        [
            -287219766.4544336,
            -208041835.55081797,
            32128183.396764148
        ],
        [
            -282023421.66136515,
            -218231832.04301104,
            32564364.088087365
        ],
        [
            -276496874.2631228,
            -228325767.41986883,
            32974043.69725347
        ],
        [
            -270639481.39310825,
            -238312945.1424555,
            33356404.332743302
        ],
        [
            -264450918.1981098,
            -248182396.59526756,
            33710627.04180971
        ],
        [
            -257931200.87435296,
            -257922884.91869134,
            34035893.4500841
        ],
        [
            -251080710.32805055,
            -267522910.3074437,
            34331387.54494828
        ],
        [
            -243900216.39105684,
            -276970716.8784169,
            34596297.606114715
        ],
        [
            -236390902.51128104,
            -286254301.21156687,
            34829818.28622827
        ],
        [
            -228554390.82596007,
            -295361422.6667985,
            35031152.84356992
        ],
        [
            -220392767.5137748,
            -304279615.57807505,
            35199515.52810174
        ],
        [
            -211908608.30919525,
            -312996203.423114,
            35334134.12113978
        ],
        [
            -203105004.04942948,
            -321498315.0628978,
            35434252.6278716
        ],
        [
            -193985586.11104736,
            -329772903.139709,
            35499134.120747566
        ],
        [
            -184554551.57986265,
            -337806764.71539026,
            35528063.730467334
        ],
        [
            -174816687.98413426,
            -345586564.2229101,
            35520351.7798562
        ],
        [
            -164777397.40775454,
            -353098858.7939942,
            35475337.05438254
        ],
        [
            -154442719.78700948,
            -360330126.01347834,
            35392390.2014125
        ],
        [
            -143819355.18192458,
            -367266794.1370646,
            35270917.24853709
        ],
        [
            -132914684.80139206,
            -373895274.79328704,
            35110363.22945118
        ],
        [
            -121736790.55042613,
            -380201998.17266846,
            34910215.90392406
        ],
        [
            -110294472.85830572,
            -386173450.6872979,
            34670009.55639441
        ],
        [
            -98597266.5382851,
            -391796215.06237704,
            34389328.85566517
        ],
        [
            -86655454.42328852,
            -397057012.79777825,
            34067812.75608956
        ],
        [
            -74480078.51783687,
            -401942748.9123929,
            33705158.41855163
        ],
        [
            -62082948.40468234,
            -406440558.857199,
            33301125.127482
        ],
        [
            -49476646.645541996,
            -410537857.4547185,
            32855538.1781435
        ],
        [
            -36674530.9191995,
            -414222389.6931133,
            32368292.706504643
        ],
        [
            -23690732.647364706,
            -417482283.1728622,
            31839357.432229765
        ],
        [
            -10540151.86926207,
            -420306101.9731132,
            31268778.283690304
        ],
        [
            2761551.8598162234,
            -422682901.6737955,
            30656681.8724825
        ],
        [
            16197972.752642334,
            -424602285.23882973,
            30003278.78376489
        ],
        [
            29751976.441460937,
            -426054459.43577206,
            29308866.647843644
        ],
        [
            43405722.155168146,
            -427030291.4384656,
            28573832.95787741
        ],
        [
            57140689.55067277,
            -427521365.2323055,
            27798657.598383434
        ],
        [
            70937710.29282898,
            -427520037.41709554,
            26983915.0494397
        ],
        [
            84777004.43955147,
            -427019491.9807744,
            26130276.23212629
        ],
        [
            98638221.64742765,
            -426013793.59908617,
            25238509.961860113
        ],
        [
            112500487.1686709,
            -424497939.0021252,
            24309483.97787165
        ],
        [
            126342452.56302017,
            -422467905.93914056,
            23344165.519165687
        ],
        [
            140142350.99872577,
            -419920699.2685468,
            22343621.419904903
        ],
        [
            153878056.9656331,
            -416854393.70117795,
            21309017.70025361
        ],
        [
            167527150.1712908,
            -413268172.73184556,
            20241618.632306475
        ],
        [
            181066983.33869314,
            -409162363.3074783,
            19142785.264779877
        ],
        [
            194474753.572528,
            -404538465.7997482,
            18013973.394629274
        ],
        [
            207727576.91050392,
            -399399178.8761941,
            16856730.978629656
        ],
        [
            220802565.6283242,
            -393748418.89640534,
            15672694.983164
        ],
        [
            233676907.8220719,
            -387591333.49866354,
            14463587.67594159
        ],
        [
            246327948.75103763,
            -380934309.08726496,
            13231212.36904184
        ],
        [
            258733273.3881961,
            -373784971.9811187,
            11977448.628467033
        ],
        [
            270870789.59542704,
            -366152183.03960097,
            10704246.971204113
        ],
        [
            282718811.3168854,
            -358046025.64133215,
            9413623.076546058
        ],
        [
            294256141.16728234,
            -349477786.95475376,
            8107651.544015357
        ],
        [
            305462151.78274775,
            -340459932.50521016,
            6788459.235568497
        ],
        [
            316316865.3007898,
            -331006074.11069906,
            5458218.244747374
        ],
        [
            326801030.3428641,
            -321130931.3265071,
            4119138.5399925476
        ],
        [
            336896195.8883146,
            -310850286.606505,
            2773460.333358441
        ],
        [
            346584781.45184684,
            -300180934.4548269,
            1423446.2292983094
        ],
        [
            355850143.0080015,
            -289140624.9049325,
            71373.21095124877
        ],
        [
            364676634.14491445,
            -277748001.72255915,
            -1280475.476588938
        ],
        [
            373049661.9754,
            -266022535.78385708,
            -2629818.485250217
        ],
        [
            380955737.3853978,
            -253984454.12911737,
            -3974384.5039204513
        ],
        [
            388382519.25723726,
            -241654665.235176,
            -5311920.318341847
        ],
        [
            395318852.36706907,
            -229054681.0851223,
            -6640198.731019535
        ],
        [
            401754798.7211804,
            -216206536.64181513,
            -7957026.283028864
        ],
        [
            407681662.16365725,
            -203132707.35156482,
            -9260250.72215874
        ],
        [
            413092006.1568887,
            -189856025.31591547,
            -10547768.165059917
        ],
        [
            417979664.70559,
            -176399594.77274743,
            -11817529.904912693
        ],
        [
            422339746.46327287,
            -162786707.52300006,
            -13067548.82051697
        ],
        [
            426168632.1263278,
            -149040758.9264533,
            -14295905.347556286
        ],
        [
            429463965.28414905,
            -135185165.06963062,
            -15500752.978009013
        ],
        [
            432224636.95309705,
            -121243281.68152085,
            -16680323.259179873
        ],
        [
            434450764.07677317,
            -107238325.33912325,
            -17832930.26951069
        ],
        [
            436143662.3244002,
            -93193297.46555322,
            -18956974.5541042
        ],
        [
            437305813.56250024,
            -79130911.57942846,
            -20050946.50866674
        ],
        [
            437940828.41213655,
            -65073524.20635715,
            -21113429.206257317
        ],
        [
            438053404.33445704,
            -51043069.812494636,
            -22143100.666737653
        ],
        [
            437649279.7110051,
            -37061000.067213744,
            -23138735.57407767
        ],
        [
            436735184.40224135,
            -23148227.68787113,
            -24099206.451615278
        ],
        [
            435318787.2780659,
            -9325075.065300703,
            -25023484.30994315
        ],
        [
            433408641.21807134,
            4388772.185139298,
            -25910638.786251087
        ],
        [
            431014126.0771166,
            17974306.654655457,
            -26759837.7976553
        ],
        [
            428145390.1040261,
            31413235.51245147,
            -27570346.73426974
        ],
        [
            424813290.2882391,
            44688011.82366395,
            -28341527.22050481
        ],
        [
            421029332.0916421,
            57781860.86480361,
            -29072835.475309327
        ],
        [
            416805609.0011568,
            70678801.5290435,
            -29763820.303807523
        ],
        [
            412154742.31255984,
            83363662.95119882,
            -30414120.754034925
        ],
        [
            407089821.52807236,
            95822096.51566416,
            -31023463.473264728
        ],
        [
            401624345.72009623,
            108040583.43980867,
            -31591659.798766803
        ],
        [
            395772166.181683,
            120006438.15026453,
            -32118602.61778252
        ],
        [
            389547430.651467,
            131707807.6902368,
            -32604263.03106764
        ],
        [
            382964529.36740446,
            143133667.41249117,
            -33048686.853588883
        ],
        [
            376038043.17023873,
            154273813.22515386,
            -33451990.98489656
        ],
        [
            368782693.8445866,
            165118850.66613382,
            -33814359.680377975
        ],
        [
            361213296.85331714,
            175660181.08703387,
            -34136040.75306259
        ],
        [
            353344716.5898169,
            185889985.22916114,
            -34417341.73394199
        ],
        [
            345191824.24306923,
            195801204.47297072,
            -34658626.01692292
        ],
        [
            336769458.3424963,
            205387520.038252,
            -34860309.012586445
        ],
        [
            328092388.02336305,
            214643330.4059766,
            -35022854.33291593
        ],
        [
            319175279.0293895,
            223563727.22422773,
            -35146770.02711115
        ],
        [
            310032662.44715214,
            232144469.95037514,
            -35232604.886554964
        ],
        [
            300678906.1468975,
            240381959.4699581,
            -35280944.834967196
        ],
        [
            291128188.88661134,
            248273210.91984499,
            -35292409.41779089
        ],
        [
            281394477.02050143,
            255815825.9294818,
            -35267648.40292643
        ],
        [
            271491503.7394772,
            263007964.4796355,
            -35207338.50307733
        ],
        [
            261432750.75962692,
            269848316.5632345,
            -35112180.22820817
        ],
        [
            251231432.36503598,
            276336073.81793416,
            -34982894.874953076
        ],
        [
            240900481.7034605,
            282470901.28503966,
            -34820221.658257365
        ],
        [
            230452539.2272179,
            288252909.4346232,
            -34624914.98909317
        ],
        [
            219899943.167105,
            293682626.5821609,
            -34397741.90076269
        ],
        [
            209254721.92401868,
            298760971.8079677,
            -34139479.62509357
        ],
        [
            198528588.26114798,
            303489228.4771718,
            -33850913.318737194
        ],
        [
            187732935.17897317,
            307869018.4450705,
            -33532833.938802734
        ],
        [
            176878833.35570222,
            311902277.0204833,
            -33186036.266191434
        ],
        [
            165977030.03712013,
            315591228.7482108,
            -32811317.074236408
        ],
        [
            155037949.26192874,
            318938364.06097794,
            -32409473.439594533
        ],
        [
            144071693.31146324,
            321946416.8412673,
            -31981301.19177598
        ],
        [
            133088045.27603883,
            324618342.92426836,
            -31527593.497226283
        ],
        [
            122096472.63400297,
            326957299.5647708,
            -31049139.573489167
        ],
        [
            111106131.7437902,
            328966625.8831868,
            -30546723.528670482
        ],
        [
            100125873.15374875,
            330649824.29900575,
            -30021123.3211857
        ],
        [
            89164247.63922057,
            332010542.9538142,
            -29473109.834601767
        ],
        [
            78229512.88118759,
            333052559.1205376,
            -28903446.062270284
        ],
        [
            67329640.705703,
            333779763.5907458,
            -28312886.396387294
        ],
        [
            56472324.80826898,
            334196146.02766204,
            -27702176.01610061
        ],
        [
            45664988.892214715,
            334305781.26890326,
            -27072050.36931109
        ],
        [
            34914795.15497121,
            334112816.55990624,
            -26423234.74287598
        ],
        [
            24228653.060872316,
            333621459.6964216,
            -25756443.916014545
        ],
        [
            13613228.343699604,
            332835968.0523582,
            -25072381.89183384
        ],
        [
            3074952.186645359,
            331760638.4675699,
            -24371741.70203248
        ],
        [
            -7379969.468382716,
            330399797.96888745,
            -23655205.27999709
        ],
        [
            -17745546.526108265,
            328757795.2967482,
            -22923443.39767797
        ],
        [
            -28015995.298009515,
            326838993.20914525,
            -22177115.661812894
        ],
        [
            -38185729.05369359,
            324647761.53426296,
            -21416870.56525765
        ],
        [
            -48249348.59653959,
            322188470.94306695,
            -20643345.589378744
        ],
        [
            -58201632.89342132,
            319465487.4132266,
            -19857167.353661213
        ],
        [
            -68037529.78529893,
            316483167.3560598,
            -19058951.8088855
        ],
        [
            -77752146.8026969,
            313245853.3786588,
            -18249304.47042525
        ],
        [
            -87340742.1075034,
            309757870.6539695,
            -17428820.688415118
        ],
        [
            -96798715.58016273,
            306023523.872331,
            -16598085.951730741
        ],
        [
            -106121600.069185,
            302047094.7488098,
            -15757676.222910242
        ],
        [
            -115305052.81792186,
            297832840.06158036,
            -14908158.301330013
        ],
        [
            -124344847.08180249,
            293384990.1975726,
            -14050090.21212195
        ],
        [
            -133236863.94763374,
            288707748.18263686,
            -13184021.618488142
        ],
        [
            -141977084.36515766,
            283805289.1745322,
            -12310494.25522942
        ],
        [
            -150561581.39983222,
            278681760.39812285,
            -11430042.381455138
        ],
        [
            -158986512.7147097,
            273341281.50326335,
            -10543193.250586048
        ],
        [
            -167248113.28837693,
            267787945.32693946,
            -9650467.59589504
        ],
        [
            -175342688.37513304,
            262025819.0423178,
            -8752380.129956225
        ],
        [
            -183266606.71294492,
            256058945.67842728,
            -7849440.056488399
        ],
        [
            -191016293.98421326,
            249891345.99522796,
            -6942151.593184275
        ],
        [
            -198588226.53399,
            243527020.69985,
            -6031014.504214679
        ],
        [
            -205978925.3500278,
            236969952.99074587,
            -5116524.641182572
        ],
        [
            -213184950.30887884,
            230224111.41744307,
            -4199174.4913800135
        ],
        [
            -220202894.69220543,
            223293453.04446858,
            -3279453.732269024
        ],
        [
            -227029379.9775176,
            216181926.90884584,
            -2357849.791164588
        ],
        [
            -233661050.90767848,
            208893477.7613534,
            -1434848.4091481813
        ],
        [
            -240094570.8437529,
            201432050.08244234,
            -510934.2082778782
        ]
    ],
    "(2021 VR3)": [
        [
            156251501.8757009,
            245062511.47061962,
            -61981702.6850496
        ],
        [
            148217224.73939407,
            249848393.42825663,
            -62747731.67137975
        ],
        [
            140062002.28545994,
            254437848.18578896,
            -63464252.136874765
        ],
        [
            131788889.44778574,
            258828914.6609495,
            -64130940.68014462
        ],
        [
            123400926.82236314,
            263019581.2467158,
            -64747461.837647386
        ],
        [
            114901147.52678029,
            267007782.53957132,
            -65313467.61481994
        ],
        [
            106292584.23896584,
            270791396.33582395,
            -65828597.08534085
        ],
        [
            97578276.41948085,
            274368240.899279,
            -66292476.05944685
        ],
        [
            88761277.72206199,
            277736072.5049995,
            -66704716.822567746
        ],
        [
            79844663.59743254,
            280892583.2653806,
            -67064917.94589652
        ],
        [
            70831539.09560429,
            283835399.24631536,
            -67372664.17087242
        ],
        [
            61725046.87199682,
            286562078.88283527,
            -67627526.36992374
        ],
        [
            52528375.402686685,
            289070111.70527077,
            -67829061.58619472
        ],
        [
            43244767.413968086,
            291356917.38869923,
            -67976813.15536708
        ],
        [
            33877528.53114465,
            293419845.1402239,
            -68070310.91307981
        ],
        [
            24430036.151074618,
            295256173.4404583,
            -68109071.49185205
        ],
        [
            14905748.542445228,
            296863110.1574818,
            -68092598.7118204
        ],
        [
            5308214.177048862,
            298237793.05346525,
            -68020384.07001525
        ],
        [
            -4358918.705544442,
            299377290.70615923,
            -67891907.33331725
        ],
        [
            -14091892.298580855,
            300278603.86946404,
            -67706637.24065416
        ],
        [
            -23886829.19390765,
            300938667.2993741,
            -67464032.3204191
        ],
        [
            -33739722.1143468,
            301354352.0736922,
            -67163541.82951011
        ],
        [
            -43646423.41576128,
            301522468.4360287,
            -66804606.82080457
        ],
        [
            -53602634.36387421,
            301439769.196742,
            -66386661.34629022
        ],
        [
            -63603894.19312334,
            301102953.72560453,
            -65909133.80346972
        ],
        [
            -73645568.95734574,
            300508672.5730981,
            -65371448.43303614
        ],
        [
            -83722840.18490602,
            299653532.7593192,
            -64773026.97617681
        ],
        [
            -93830693.35402855,
            298534103.7714948,
            -64113290.500195324
        ],
        [
            -103963906.20759058,
            297146924.313049,
            -63391661.4014426
        ],
        [
            -114117036.93049926,
            295488509.84898025,
            -62607565.59480694
        ],
        [
            -124284412.21703252,
            293555360.9939923,
            -61760434.89922445
        ],
        [
            -134460115.26018932,
            291343972.7913115,
            -60849709.628823236
        ],
        [
            -144637973.70018864,
            288850844.93139464,
            -59874841.39939957
        ],
        [
            -154811547.57479584,
            286072492.9607228,
            -58835296.15992759
        ],
        [
            -164974117.3201509,
            283005460.5315488,
            -57730557.45871638
        ],
        [
            -175118671.8772354,
            279646332.7437415,
            -56560129.95363192
        ],
        [
            -185237896.96605927,
            275991750.6297072,
            -55323543.175486326
        ],
        [
            -195324163.59705687,
            272038426.8326776,
            -54020355.55324179
        ],
        [
            -205369516.89707443,
            267783162.52736723,
            -52650158.70906911
        ],
        [
            -215365665.33566836,
            263222865.6300394,
            -51212582.0305184
        ],
        [
            -225303970.44621903,
            258354570.34228292,
            -49707297.526086524
        ],
        [
            -235175437.14554864,
            253175458.06921002,
            -48134024.9692799
        ],
        [
            -244970704.76528144,
            247682879.74822676,
            -46492537.33485261
        ],
        [
            -254680038.91803598,
            241874379.61891082,
            -44782666.52922752
        ],
        [
            -264293324.3316331,
            235747720.45774147,
            -43004309.41515977
        ],
        [
            -273800058.7947314,
            229300910.29336736,
            -41157434.128459476
        ],
        [
            -283189348.3675834,
            222532230.60864872,
            -39242086.682030246
        ],
        [
            -292449904.0217867,
            215440266.0247764,
            -37258397.849585555
        ],
        [
            -301570039.88286036,
            208023935.45025128,
            -35206590.31816006
        ],
        [
            -310537673.2590141,
            200282524.66329792,
            -33086986.094919275
        ],
        [
            -319340326.64842105,
            192215720.28032294,
            -30900014.149783764
        ],
        [
            -327965131.92540956,
            183823645.04522657,
            -28646218.27101087
        ],
        [
            -336398836.91302615,
            175106894.35469443,
            -26326265.10612076
        ],
        [
            -344627814.5551028,
            166066573.91301662,
            -23940952.355418876
        ],
        [
            -352638074.9049954,
            156704338.38648912,
            -21491217.079864383
        ],
        [
            -360415280.1502114,
            147022430.902111,
            -18978144.07919001
        ],
        [
            -367944762.8918837,
            137023723.20815682,
            -16402974.290020097
        ],
        [
            -375211547.89508975,
            126711756.28541942,
            -13767113.14730781
        ],
        [
            -382200377.51999825,
            116090781.167655,
            -11072138.845772922
        ],
        [
            -388895741.03435117,
            105165799.69826137,
            -8319810.431239422
        ],
        [
            -395281907.9944847,
            93942604.9177816,
            -5512075.644930251
        ],
        [
            -401342965.8645559,
            82427820.74383093,
            -2651078.4369777553
        ],
        [
            -407062862.02154124,
            70628940.57192677,
            260833.94123496488
        ],
        [
            -412425450.2665603,
            58554364.39300406,
            3221104.3626382425
        ],
        [
            -417414541.9308738,
            46213433.99170995,
            6226959.870595228
        ],
        [
            -422013961.62728965,
            33616465.75958124,
            9275406.45353714
        ],
        [
            -426207607.65453523,
            20774780.629674584,
            12363224.660603896
        ],
        [
            -429979517.0133589,
            7700730.6149652,
            15486966.174338128
        ],
        [
            -433313934.93877184,
            -5592278.587253839,
            18642951.458867744
        ],
        [
            -436195388.7931201,
            -19089769.47772172,
            21827268.60302425
        ],
        [
            -438608766.0999043,
            -32776179.68596351,
            25035773.47727213
        ],
        [
            -440539396.4289546,
            -46634854.51296669,
            28264091.32096943
        ],
        [
            -441973136.77036273,
            -60648045.64314386,
            31507619.872146077
        ],
        [
            -442896459.9583466,
            -74796916.56785509,
            34761534.14549868
        ],
        [
            -443296545.62799335,
            -89061555.23789251,
            38020792.95551075
        ],
        [
            -443161373.1088395,
            -103420994.42692152,
            41280147.27038953
        ],
        [
            -442479815.5809075,
            -117853240.24135524,
            44534150.46879384
        ],
        [
            -441241734.7427162,
            -132335309.1540722,
            47777170.55507471
        ],
        [
            -439438075.1686439,
            -146843273.8696034,
            51003404.36999188
        ],
        [
            -437060957.4667157,
            -161352318.24695587,
            54206893.81269102
        ],
        [
            -434103769.28933764,
            -175836801.41348803,
            57381544.06629041
        ],
        [
            -430561253.20069635,
            -190270331.09984487,
            60521143.79395949
        ],
        [
            -426429590.3674347,
            -204625846.1129455,
            63619387.245187856
        ],
        [
            -421706479.0156956,
            -218875707.74271852,
            66669898.1834227
        ],
        [
            -416391206.5894364,
            -232991799.77042472,
            69666255.51685484
        ],
        [
            -410484714.5535822,
            -246945636.61403376,
            72602020.48438448
        ],
        [
            -403989654.81238043,
            -260708479.01157227,
            75470765.21928088
        ],
        [
            -396910436.75912607,
            -274251456.5092807,
            78266102.4844018
        ],
        [
            -389253264.03876597,
            -287545695.8906184,
            80981716.34571972
        ],
        [
            -381026160.1897978,
            -300562454.557654,
            83611393.52599907
        ],
        [
            -372238982.4358869,
            -313273257.7612098,
            86149055.15845333
        ],
        [
            -362903423.01974714,
            -325650038.4733511,
            88588788.64173889
        ],
        [
            -353032997.6105461,
            -337665278.6083184,
            90924879.28331181
        ],
        [
            -342643020.4693287,
            -349292150.22853416,
            93151841.40852204
        ],
        [
            -331750566.2221621,
            -360504655.32322526,
            95264448.60828212
        ],
        [
            -320374418.26488227,
            -371277762.7204962,
            97257762.79905812
        ],
        [
            -308535004.0030705,
            -381587540.6908389,
            99127161.7754887
        ],
        [
            -296254317.3125625,
            -391411283.8219838,
            100868364.94820479
        ],
        [
            -283555828.7854984,
            -400727632.7920032,
            102477456.97731486
        ],
        [
            -270464384.50075984,
            -409516685.73929524,
            103950909.03529492
        ],
        [
            -257006094.22171754,
            -417760100.02350754,
            105285597.4612973
        ],
        [
            -243208210.07482165,
            -425441183.28893995,
            106478819.60164143
        ],
        [
            -229098996.89632255,
            -432544972.8792153,
            107528306.66781637
        ],
        [
            -214707595.54828054,
            -439058302.8062388,
            108432233.48295656
        ],
        [
            -200063880.5965488,
            -444969857.64438266,
            109189225.02959897
        ],
        [
            -185198313.81066257,
            -450270212.89882034,
            109798359.75469314
        ],
        [
            -170141794.98728544,
            -454951861.5811114,
            110259169.6313826
        ],
        [
            -154925511.61447024,
            -459009226.91150904,
            110571637.0200759
        ],
        [
            -139580788.88356864,
            -462438661.252046,
            110736188.4128733
        ],
        [
            -124138941.5199605,
            -465238431.55337036,
            110753685.18466556
        ],
        [
            -108631128.84425917,
            -467408691.7679619,
            110625411.51040812
        ],
        [
            -93088214.39424765,
            -468951442.8394651,
            110353059.64052999
        ],
        [
            -77540631.33696544,
            -469870481.0196131,
            109938712.7546213
        ],
        [
            -62018254.78295231,
            -470171335.3882495,
            109384825.6370346
        ],
        [
            -46550281.98377037,
            -469861195.55650103,
            108694203.4365594
        ],
        [
            -31165121.252909422,
            -468948830.6170124,
            107869978.78574063
        ],
        [
            -15890290.302395046,
            -467444500.46769416,
            106915587.5637073
        ],
        [
            -752324.53621611,
            -465359860.6765853,
            105834743.58967116
        ],
        [
            14223304.30969426,
            -462707862.07566804,
            104631412.53278723
        ],
        [
            29012258.93978098,
            -459502646.2716994,
            103309785.31816377
        ],
        [
            43591396.585385025,
            -455759438.24372524,
            101874251.2988894
        ],
        [
            57938818.44247958,
            -451494437.1615609,
            100329371.45048669
        ],
        [
            72033908.62283531,
            -446724706.50915307,
            98679851.82772721
        ],
        [
            85857362.89449868,
            -441468064.53347313,
            96930517.50480482
        ],
        [
            99391207.5883739,
            -435742975.9657182,
            95086287.19902125
        ],
        [
            112618809.13510117,
            -429568445.87936497,
            93152148.75593784
        ],
        [
            125524874.76984203,
            -422963916.46130764,
            91133135.65092595
        ],
        [
            138095445.00199187,
            -415949167.38007796,
            89034304.6386951
        ],
        [
            150317878.49247918,
            -408544220.34102404,
            86860714.65915047
        ],
        [
            162180830.0136775,
            -400769248.32419395,
            84617407.0852302
        ],
        [
            173674222.18686926,
            -392644489.9081688,
            82309387.37654579
        ],
        [
            184789211.70051107,
            -384190168.99368834,
            79941608.18198673
        ],
        [
            195518150.71040303,
            -375426420.1558135,
            77518953.91519079
        ],
        [
            205854544.11139524,
            -366373219.77353954,
            75046226.80908924
        ],
        [
            215793003.35067832,
            -357050323.0120176,
            72528134.43975328
        ],
        [
            225329197.42627853,
            -347477206.6653455,
            69969278.69554842
        ],
        [
            234459801.6822826,
            -337673017.80764467,
            67374146.15519452
        ],
        [
            243182444.97576046,
            -327656528.146988,
            64747099.82770851
        ],
        [
            251495655.75045004,
            -317446093.93068403,
            62092372.19833587
        ],
        [
            259398807.51001257,
            -307059621.2113568,
            59414059.51738766
        ],
        [
            266892064.14005446,
            -296514536.250892,
            56716117.26329005
        ],
        [
            273976325.48392886,
            -285827760.813357,
            54002356.707020625
        ],
        [
            280653173.5333378,
            -275015692.07801145,
            51276442.502324894
        ],
        [
            286924819.5515962,
            -264094186.88902998,
            48541891.224540815
        ],
        [
            292794052.4055747,
            -253078550.04911348,
            45802070.780389264
        ],
        [
            298264188.3422951,
            -241983526.35918495,
            43060200.611561336
        ],
        [
            303339022.4082049,
            -230823296.10539854,
            40319352.61623466
        ],
        [
            308022781.67357206,
            -219611473.6971799,
            37582452.71464385
        ],
        [
            312320080.39141124,
            -208361109.1654685,
            34852282.987393424
        ],
        [
            316235877.1899515,
            -197084692.23831013,
            32131484.31823499
        ],
        [
            319775434.3699737,
            -185794158.72094512,
            29422559.476412296
        ],
        [
            322944279.353336,
            -174500898.9192099,
            26727876.57733491
        ],
        [
            325748168.30667573,
            -163215767.85797632,
            24049672.86417056
        ],
        [
            328193051.94449544,
            -151949097.0602057,
            21390058.756889015
        ],
        [
            330285043.49854046,
            -140710707.66666472,
            18751022.11927343
        ],
        [
            332030388.8254118,
            -129509924.69115746,
            16134432.69838223
        ],
        [
            333435438.611587,
            -118355592.2210953,
            13542046.694858797
        ],
        [
            334506622.624297,
            -107256089.38807793,
            10975511.426293608
        ],
        [
            335250425.9478622,
            -96219346.9478039,
            8436370.049527176
        ],
        [
            335673367.1379681,
            -85252864.32288417,
            5926066.311309136
        ],
        [
            335781978.22080094,
            -74363726.97588709,
            3445949.3000788093
        ],
        [
            335582786.45980245,
            -63558623.993153036,
            997278.1748030558
        ],
        [
            335082297.8098935,
            -52843865.77244963,
            -1418773.1502270885
        ],
        [
            334286981.9772185,
            -42225401.71941291,
            -3801111.3829671554
        ],
        [
            333203259.0016241,
            -31708837.868863136,
            -6148719.309316758
        ],
        [
            331837487.27909243,
            -21299454.35748218,
            -8460651.34033927
        ],
        [
            330195952.9420847,
            -11002222.684024721,
            -10736029.162226249
        ],
        [
            328284860.5170826,
            -821822.7021529078,
            -12974037.49825561
        ],
        [
            326110324.7804776,
            9237340.700793535,
            -15173919.990197238
        ],
        [
            323678363.7362306,
            19171121.27826923,
            -17334975.205003593
        ],
        [
            320994892.64134336,
            28975615.484589517,
            -19456552.771176036
        ],
        [
            318065719.00807226,
            38647146.94674249,
            -21538049.647903357
        ],
        [
            314896538.5149044,
            48182251.36854008,
            -23578906.528929394
        ],
        [
            311492931.7615559,
            57577661.882703364,
            -25578604.38210006
        ],
        [
            307860361.8065971,
            66830294.86203322,
            -27536661.124663804
        ],
        [
            304004172.42969537,
            75937236.19689517,
            -29452628.4336433
        ],
        [
            299929587.0638906,
            84895728.0427767,
            -31326088.689944863
        ],
        [
            295641708.3467179,
            93703156.03867732,
            -33156652.05432613
        ],
        [
            291145518.2423611,
            102357036.9944684,
            -34943953.67288162
        ],
        [
            286445878.690329,
            110855007.04314384,
            -36687651.00933452
        ],
        [
            281547532.7393763,
            119194810.25198574,
            -38387421.301121086
        ],
        [
            276455106.12854016,
            127374287.68509711,
            -40042959.136022985
        ],
        [
            271173109.28019214,
            135391366.9084782,
            -41653974.145934336
        ],
        [
            265705939.67294997,
            143244051.92778364,
            -43220188.81423198
        ],
        [
            260057884.56509674,
            150930413.54812643,
            -44741336.39315434
        ],
        [
            254233124.04185852,
            158448580.14471287,
            -46217158.92757064
        ],
        [
            248235734.36246386,
            165796728.8327148,
            -47647405.38153924
        ],
        [
            242069691.5853542,
            172973077.024593,
            -49031829.8641081
        ],
        [
            235738875.45225137,
            179975874.36302757,
            -50370189.95089123
        ],
        [
            229247073.51398644,
            186803395.0177258,
            -51662245.09806859
        ],
        [
            222597985.48308456,
            193453930.3345953,
            -52907755.14559092
        ],
        [
            215795227.80007315,
            199925781.82612222,
            -54106478.906529054
        ],
        [
            208842338.40232807,
            206217254.49224818,
            -55258172.83968562
        ],
        [
            201742781.6860262,
            212326650.46158248,
            -56362589.80277991
        ],
        [
            194499953.6533983,
            218252262.94342968,
            -57419477.88372873
        ],
        [
            187117187.23901418,
            223992370.4818289,
            -58428579.307770096
        ],
        [
            179597757.8102593,
            229545231.50359032,
            -59389629.41841385
        ],
        [
            171944888.83848608,
            234909079.15318647,
            -60302355.73045403
        ],
        [
            164161757.73856637,
            240082116.40827364,
            -61166477.05353667
        ],
        [
            156251501.87570095,
            245062511.4706196,
            -61981702.68504959
        ]
    ],
    "(2022 EQ6)": [
        [
            268891725.5677847,
            88238331.11955868,
            -63750685.14395224
        ],
        [
            265700159.0859945,
            96748173.34599784,
            -64886273.000160575
        ],
        [
            262287103.5472763,
            105180606.54260501,
            -65968412.96819177
        ],
        [
            258654081.61947277,
            113531397.83489737,
            -66996529.03505233
        ],
        [
            254802618.9619641,
            121796302.54564673,
            -67970043.36575685
        ],
        [
            250734247.11360726,
            129971058.76751556,
            -68888375.72579512
        ],
        [
            246450506.7099541,
            138051382.06463316,
            -69750942.98580186
        ],
        [
            241952951.02997905,
            146032960.31063926,
            -70557158.70995961
        ],
        [
            237243149.87313116,
            153911448.67133552,
            -71306432.82988647
        ],
        [
            232322693.76806027,
            161682464.7407882,
            -71998171.40599187
        ],
        [
            227193198.51483616,
            169341583.84051627,
            -72631776.47852151
        ],
        [
            221856310.06288144,
            176884334.49227598,
            -73206646.01075394
        ],
        [
            216313709.72716984,
            184306194.07591623,
            -73722173.92706062
        ],
        [
            210567119.74548447,
            191602584.68482777,
            -74177750.24878938
        ],
        [
            204618309.17969364,
            198768869.19264174,
            -74572761.33118442
        ],
        [
            198469100.16405988,
            205800347.54604614,
            -74906590.20480539
        ],
        [
            192121374.50355336,
            212692253.29988566,
            -75178617.0251581
        ],
        [
            185577080.62498552,
            219439750.4120828,
            -75388219.63449341
        ],
        [
            178838240.88348803,
            226037930.31736565,
            -75534774.23996812
        ],
        [
            171906959.22644842,
            232481809.3003108,
            -75617656.21259198
        ],
        [
            164785429.21644145,
            238766326.1897942,
            -75636241.01159963
        ],
        [
            157475942.41397205,
            244886340.39859617,
            -75589905.23908983
        ],
        [
            149980897.11994702,
            250836630.33361045,
            -75478027.8299563
        ],
        [
            142302807.47670776,
            256611892.20386094,
            -75299991.38229579
        ],
        [
            134444312.92517865,
            262206739.25532514,
            -75055183.63361377
        ],
        [
            126408188.01418547,
            267615701.46338132,
            -74742999.08825031
        ],
        [
            118197352.5562821,
            272833225.71553695,
            -74362840.80151802
        ],
        [
            109814882.12245369,
            277853676.51893276,
            -73914122.32606763
        ],
        [
            101264018.86584608,
            282671337.2689421,
            -73396269.82597744
        ],
        [
            92548182.66217588,
            287280412.11697584,
            -72808724.36398725
        ],
        [
            83670982.5516945,
            291675028.47733563,
            -72150944.36716166
        ],
        [
            74636228.46449871,
            295849240.21461797,
            -71422408.27606668
        ],
        [
            65447943.20758557,
            299797031.5547156,
            -70622617.38226417
        ],
        [
            56110374.68832864,
            303512321.76387644,
            -69751098.85856895
        ],
        [
            46628008.34499669,
            306988970.64152354,
            -68807408.98606059
        ],
        [
            37005579.750538215,
            310220784.8735665,
            -67791136.5812893
        ],
        [
            27248087.35110341,
            313201525.2937267,
            -66701906.6264536
        ],
        [
            17360805.295679167,
            315924915.10088754,
            -65539384.10454723
        ],
        [
            7349296.307758287,
            318384649.0806328,
            -64303278.040564485
        ],
        [
            -2780575.455826625,
            320574403.87890196,
            -62993345.7488094
        ],
        [
            -13022631.6199051,
            322487849.3749999,
            -61609397.285163015
        ],
        [
            -23370366.94725135,
            324118661.2000178,
            -60151300.101818934
        ],
        [
            -33816936.91032961,
            325460534.4449624,
            -58618983.90049054
        ],
        [
            -44355145.55968636,
            326507198.6005131,
            -57012445.67841633
        ],
        [
            -54977433.77739918,
            327252433.767255,
            -55331754.95963889
        ],
        [
            -65675868.011387825,
            327690088.1713974,
            -53577059.201999396
        ],
        [
            -76442129.5939124,
            327814097.01633734,
            -51748589.368075356
        ],
        [
            -87267504.75514525,
            327618502.69487214,
            -49846665.645887196
        ],
        [
            -98142875.45023096,
            327097476.3803653,
            -47871703.30261734
        ],
        [
            -109058711.1256546,
            326245341.00764734,
            -45824218.65182101
        ],
        [
            -120005061.55790429,
            325056595.6458465,
            -43704835.11167438
        ],
        [
            -130971550.90423548,
            323525941.25563174,
            -41514289.32870929
        ],
        [
            -141947373.11167687,
            321648307.8124842,
            -39253437.33824143
        ],
        [
            -152921288.83612123,
            319418882.7655573,
            -36923260.72933116
        ],
        [
            -163881624.0282633,
            316833140.7884262,
            -34524872.778643504
        ],
        [
            -174816270.3471022,
            313886874.76357126,
            -32059524.514031433
        ],
        [
            -185712687.5645451,
            310576227.92679524,
            -29528610.66508324
        ],
        [
            -196557908.12613785,
            306897727.0809963,
            -26933675.454297017
        ],
        [
            -207338544.03290406,
            302848316.77085954,
            -24276418.17901673
        ],
        [
            -218040796.20750427,
            298425394.29119295,
            -21558698.53083902
        ],
        [
            -228650466.50422096,
            293626845.38193136,
            -18782541.595937558
        ],
        [
            -239152972.5164255,
            288451080.4424235,
            -15950142.476716958
        ],
        [
            -249533365.32701224,
            282897071.07668877,
            -13063870.472471341
        ],
        [
            -259776350.33659154,
            276964386.76009804,
            -10126272.75435938
        ],
        [
            -269866311.29085577,
            270653231.39666444,
            -7140077.468098417
        ],
        [
            -279787337.6123422,
            263964479.51510707,
            -4108196.196405478
        ],
        [
            -289523255.12267286,
            256899711.83141652,
            -1033725.7124608234
        ],
        [
            -299057660.2192059,
            249461249.88615137,
            2080051.0443784073
        ],
        [
            -308373957.544832,
            241652189.44654447,
            5229664.83864411
        ],
        [
            -317455401.1614197,
            233476432.34708846,
            8411460.921021856
        ],
        [
            -326285139.2062225,
            224938716.42807955,
            11621600.786675133
        ],
        [
            -334846261.9765525,
            216044643.22004607,
            14856064.969923839
        ],
        [
            -343121853.35139525,
            206800703.01356065,
            18110656.930935934
        ],
        [
            -351095045.4196745,
            197214296.94909024,
            21381008.084343597
        ],
        [
            -358749076.1439247,
            187293755.76070306,
            24662584.01281266
        ],
        [
            -366067349.8456207,
            177048354.81107807,
            27950691.900559433
        ],
        [
            -373033500.2548655,
            166488325.06370103,
            31240489.212643348
        ],
        [
            -379631455.8231261,
            155624859.6517346,
            34526993.635595016
        ],
        [
            -385845506.9538847,
            144470115.7220791,
            37805094.28362988
        ],
        [
            -391660374.76316327,
            133037211.25777186,
            41069564.16243472
        ],
        [
            -397061280.94064295,
            121340216.61221728,
            44315073.86940961
        ],
        [
            -402034018.2433493,
            109394140.52477899,
            47536206.49544212
        ],
        [
            -406565021.1184386,
            97214910.42887604,
            50727473.67895383
        ],
        [
            -410641435.920345,
            84819346.91066901,
            53883332.74828072
        ],
        [
            -414251190.1612531,
            72225132.22832005,
            56998204.87364821
        ],
        [
            -417383060.21334136,
            59450772.858159766,
            60066494.13531348
        ],
        [
            -420026736.8672387,
            46515556.09426971,
            63082607.40012221
        ],
        [
            -422172888.14430207,
            33439500.791216075,
            66040974.88503295
        ],
        [
            -423813218.7612161,
            20243302.405095443,
            68936071.27336162
        ],
        [
            -424940525.6544697,
            6948272.554685503,
            71762437.2378646
        ],
        [
            -425548748.989776,
            -6423726.608722672,
            74514701.21456963
        ],
        [
            -425633018.1075912,
            -19850352.868428797,
            77187601.2627252
        ],
        [
            -425189691.89053833,
            -33308858.828315884,
            79776006.83959739
        ],
        [
            -424216393.08150667,
            -46776170.7393496,
            82274940.31429228
        ],
        [
            -422712036.1321072,
            -60228970.7323565,
            84679598.04248682
        ],
        [
            -420676848.21939373,
            -73643781.87261835,
            86985370.82402718
        ],
        [
            -418112383.13358825,
            -86997055.40824974,
            89187863.56788494
        ],
        [
            -415021527.8100103,
            -100265259.54834312,
            91282913.99396375
        ],
        [
            -411408501.3534644,
            -113424969.07930091,
            93266610.20871067
        ],
        [
            -407278846.48176473,
            -126452955.10926108,
            95135307.00131752
        ],
        [
            -402639413.3956028,
            -139326274.22154325,
            96885640.71938008
        ],
        [
            -397498336.16320837,
            -152022356.31888402,
            98514542.59703343
        ],
        [
            -391865001.788852,
            -164519090.45095664,
            100019250.42457654
        ],
        [
            -385750012.2127784,
            -176794907.93817604,
            101397318.46617772
        ],
        [
            -379165139.565302,
            -188828862.1347198,
            102646625.55111185
        ],
        [
            -372123275.0682651,
            -200600704.2125338,
            103765381.28379796
        ],
        [
            -364638372.04165465,
            -212090954.3951199,
            104752130.3383354
        ],
        [
            -356725383.5308892,
            -223280968.12423462,
            105605754.82392779
        ],
        [
            -348400195.120185,
            -234152996.70325935,
            106325474.72817665
        ],
        [
            -339679553.53882176,
            -244690242.0267849,
            106910846.46537851
        ],
        [
            -330580991.6995015,
            -254876905.07567903,
            107361759.57633668
        ],
        [
            -321122750.8310177,
            -264698227.92930496,
            107678431.64449595
        ],
        [
            -311323700.38099056,
            -274140529.1203514,
            107861401.51014954
        ],
        [
            -301203256.3685713,
            -283191232.2316354,
            107911520.87981299
        ],
        [
            -290781298.8620026,
            -291838887.707041,
            107829944.44141084
        ],
        [
            -280078089.24221015,
            -300073187.91928166,
            107618118.60752548
        ],
        [
            -269114187.89175785,
            -307884975.6043793,
            107277769.01850443
        ],
        [
            -257910372.9192551,
            -315266245.8356871,
            106810886.94464931
        ],
        [
            -246487560.49350238,
            -322210141.7681328,
            106219714.73200208
        ],
        [
            -234866727.32019156,
            -328710944.4354732,
            105506730.43942426
        ],
        [
            -223068835.74783462,
            -334764056.92919177,
            104674631.81580012
        ],
        [
            -211114761.93976957,
            -340365983.32690173,
            103726319.76538575
        ],
        [
            -199025227.49659097,
            -345514302.7705009,
            102664881.44670254
        ],
        [
            -186820734.85916808,
            -350207639.119819,
            101493573.1460945
        ],
        [
            -174521506.7674983,
            -354445626.6261499,
            100215803.06131086
        ],
        [
            -162147429.9958775,
            -358228872.0820801,
            98835114.12342864
        ],
        [
            -149718003.53108978,
            -361558913.9096937,
            97355166.97729628
        ],
        [
            -137252291.30824685,
            -364438178.6489604,
            95779723.23166291
        ],
        [
            -124768879.56918882,
            -366869935.3023503,
            94112629.08045955
        ],
        [
            -112285838.8615559,
            -368858247.98100483,
            92357799.38652174
        ],
        [
            -99820690.65315248,
            -370407927.2826874,
            90519202.30856758
        ],
        [
            -87390378.49645826,
            -371524480.8128339,
            88600844.54165787
        ],
        [
            -75011243.64229025,
            -372214063.2379341,
            86606757.2308207
        ],
        [
            -62699004.96985358,
            -372483426.23578125,
            84540982.60716727
        ],
        [
            -50468743.07283653,
            -372339868.6804397,
            82407561.3857929
        ],
        [
            -38334888.31773998,
            -371791187.37163496,
            80210520.95514764
        ],
        [
            -26311212.67126727,
            -370845628.5892049,
            77953864.37847176
        ],
        [
            -14410825.078162238,
            -369511840.72375417,
            75641560.21939456
        ],
        [
            -2646170.159181088,
            -367798828.2051453,
            73277533.19593884
        ],
        [
            8970970.009261578,
            -365715906.9213636,
            70865655.6600097
        ],
        [
            20429471.277152106,
            -363272661.29191536,
            68409739.8929814
        ],
        [
            31718860.209924906,
            -360478903.1325724,
            65913531.20225412
        ],
        [
            42829304.52900307,
            -357344632.42220145,
            63380701.798623234
        ],
        [
            53751601.4451843,
            -353880000.0577879,
            60814845.42997045
        ],
        [
            64477164.120953165,
            -350095272.6607565,
            58219472.74313781
        ],
        [
            74998006.4907737,
            -346000799.4763842,
            55598007.34283647
        ],
        [
            85306726.6598602,
            -341606981.3885805,
            52953782.51404993
        ],
        [
            95396489.09214857,
            -336924242.0546029,
            50290038.572567895
        ],
        [
            105261005.78745553,
            -331963001.14837617,
            47609920.80698632
        ],
        [
            114894516.63631938,
            -326733649.6869851,
            44916477.97469678
        ],
        [
            124291769.12904532,
            -321246527.40254897,
            42212661.31399987
        ],
        [
            133447997.58315569,
            -315511902.11100703,
            39501324.03448519
        ],
        [
            142358902.0410222,
            -309539951.0202693,
            36785221.24816081
        ],
        [
            151020626.97702414,
            -303340743.912613,
            34067010.304455996
        ],
        [
            159429739.94130972,
            -296924228.1300565,
            31349251.493114874
        ],
        [
            167583210.25524583,
            -290300215.2865772,
            28634409.080099024
        ],
        [
            175478387.8619951,
            -283478369.6274009,
            25924852.64290145
        ],
        [
            183112982.4244812,
            -276468197.9530108,
            23222858.67308734
        ],
        [
            190485042.75231224,
            -269279041.02395046,
            20530612.415405124
        ],
        [
            197592936.62910378,
            -261920066.36178097,
            17850209.914414223
        ],
        [
            204435331.1021088,
            -254400262.36161405,
            15183660.241227679
        ],
        [
            211011173.2871245,
            -246728433.63238764,
            12532887.874654792
        ],
        [
            217319671.73335123,
            -238913197.4823647,
            9899735.212715812
        ],
        [
            223360278.3851938,
            -230962981.4691554,
            7285965.1921842955
        ],
        [
            229132671.1709435,
            -222886021.9357984,
            4693263.995468661
        ],
        [
            234636737.24183917,
            -214690363.45700008,
            2123243.825760659
        ],
        [
            239872556.87915128,
            -206383859.1224883,
            -422554.26704823226
        ],
        [
            244840388.08166623,
            -197974171.5874821,
            -2942657.525672078
        ],
        [
            249540651.841222,
            -189468774.82349998,
            -5435658.60449595
        ],
        [
            253973918.1097452,
            -180874956.5060468,
            -7900212.681559883
        ],
        [
            258140892.4575429,
            -172199820.97909486,
            -10335034.575315356
        ],
        [
            262042403.4193548,
            -163450292.73969194,
            -12738895.87677285
        ],
        [
            265679390.52187747,
            -154633120.38941416,
            -15110622.10650732
        ],
        [
            269052892.9840684,
            -145754881.002747,
            -17449089.904909138
        ],
        [
            272164039.0795151,
            -136821984.86577612,
            -19753224.26306634
        ],
        [
            275014036.1484798,
            -127840680.541773,
            -22021995.800741635
        ],
        [
            277604161.24586034,
            -118817060.22338885,
            -24254418.09705268
        ],
        [
            279935752.4102425,
            -109757065.3341547,
            -26449545.078689557
        ],
        [
            282010200.53839624,
            -100666492.34487507,
            -28606468.469789866
        ],
        [
            283828941.84900355,
            -91550998.77323404,
            -30724315.30695362
        ],
        [
            285393450.9190303,
            -82416109.33754052,
            -32802245.522299543
        ],
        [
            286705234.27599025,
            -73267222.23800334,
            -34839449.596947804
        ],
        [
            287765824.5293384,
            -64109615.54122722,
            -36835146.28685741
        ],
        [
            288576775.0243804,
            -54948453.64580391,
            -38788580.42253927
        ],
        [
            289139655.00235754,
            -45788793.80887547,
            -40699020.783817135
        ],
        [
            289456045.2507622,
            -36635592.715427876,
            -42565758.05050349
        ],
        [
            289527534.22842515,
            -27493713.0738014,
            -44388102.82959957
        ],
        [
            289355714.65049607,
            -18367930.22247894,
            -46165383.75941641
        ],
        [
            288942180.51908475,
            -9262938.734673321,
            -47896945.69083603
        ],
        [
            288288524.5860425,
            -183359.00853042305,
            -49582147.94579792
        ],
        [
            287396336.2351184,
            8866256.168051153,
            -51220362.65299156
        ],
        [
            286267199.77153087,
            17881415.087934926,
            -52810973.160666876
        ],
        [
            284902693.10781974,
            26857680.63963464,
            -54353372.52643549
        ],
        [
            283304386.83570516,
            35790663.87480066,
            -55846962.08392348
        ],
        [
            281473843.6745427,
            44676017.63586189,
            -57291150.086151995
        ],
        [
            279412618.28785187,
            53509430.2508049,
            -58685350.42556108
        ],
        [
            277122257.46027166,
            62286619.30161591,
            -60028981.43065289
        ],
        [
            274604300.62818086,
            71003325.47257414,
            -61321464.73931568
        ],
        [
            271860280.75809175,
            79655306.4843276,
            -62562224.24898876
        ],
        [
            268891725.5677847,
            88238331.11955862,
            -63750685.143952236
        ]
    ],
    "(2024 YV1)": [
        [
            -335185835.40867263,
            169119198.15408546,
            67200082.21427894
        ],
        [
            -340345446.40919954,
            158255417.20711392,
            67805533.94635744
        ],
        [
            -345191520.089033,
            147243896.84875363,
            68348458.91540046
        ],
        [
            -349720188.4927405,
            136093141.66875517,
            68828414.71984006
        ],
        [
            -353927756.81691176,
            124811742.05619618,
            69244993.62281659
        ],
        [
            -357810704.29359436,
            113408373.8088186,
            69597822.70265265
        ],
        [
            -361365685.31792104,
            101891797.80099991,
            69886564.05022691
        ],
        [
            -364589530.82575387,
            90270859.69182165,
            70110915.01373203
        ],
        [
            -367479249.92637765,
            78554489.65434258,
            70270608.49114268
        ],
        [
            -370032031.79447275,
            66751702.10683538,
            70365413.27056059
        ],
        [
            -372245247.8247664,
            54871595.42640388,
            70395134.41844046
        ],
        [
            -374116454.05191845,
            42923351.62506002,
            70359613.7155326
        ],
        [
            -375643393.83731514,
            30916235.968014568,
            70258730.1402066
        ],
        [
            -376824000.82354903,
            18859596.513616413,
            70092400.39864445
        ],
        [
            -377656402.1564183,
            6762863.554070234,
            69860579.50120711
        ],
        [
            -378138921.97331524,
            -5364451.06422776,
            69563261.38409263
        ],
        [
            -378270085.1558595,
            -17512754.762171328,
            69200479.57520719
        ],
        [
            -378048621.3435849,
            -29672375.212929428,
            68772307.90296982
        ],
        [
            -377473469.2043954,
            -41833561.512349784,
            68278861.24656284
        ],
        [
            -376543780.95636964,
            -53986485.55689645,
            67720296.32592356
        ],
        [
            -375258927.13430387,
            -66121243.651399165,
            67096812.52954897
        ],
        [
            -373618501.5931577,
            -78227858.36902359,
            66408652.7779543
        ],
        [
            -371622326.7392731,
            -90296280.68595092,
            65656104.42038574
        ],
        [
            -369270458.9789113,
            -102316392.41329192,
            64839500.16214152
        ],
        [
            -366563194.3722576,
            -114278008.94873498,
            63959219.01959939
        ],
        [
            -363501074.479612,
            -126170882.37034388,
            63015687.299787164
        ],
        [
            -360084892.38498855,
            -137984704.89476445,
            62009379.601062015
        ],
        [
            -356315698.8808132,
            -149709112.72186816,
            60940819.83118917
        ],
        [
            -352194808.7958149,
            -161333690.28754193,
            59810582.23882634
        ],
        [
            -347723807.4465805,
            -172847974.94592437,
            58619292.454134196
        ],
        [
            -342904557.1915626,
            -184241462.10188013,
            57367628.53393844
        ],
        [
            -337739204.06461906,
            -195503610.81388187,
            56056322.00657469
        ],
        [
            -332230184.4634191,
            -206623849.8867374,
            54686158.911247894
        ],
        [
            -326380231.8662732,
            -217591584.4727355,
            53257980.82643846
        ],
        [
            -320192383.5491588,
            -228396203.19879276,
            51772685.88158927
        ],
        [
            -313669987.27289826,
            -239027085.83604413,
            50231229.746009625
        ],
        [
            -306816707.9086493,
            -249473611.52704245,
            48634626.58864091
        ],
        [
            -299636533.96805704,
            -259725167.58428198,
            46983950.00204183
        ],
        [
            -292133784.0026376,
            -269771158.87216705,
            45280333.88367304
        ],
        [
            -284313112.83521,
            -279601017.7827644,
            43524973.2672949
        ],
        [
            -276179517.58448213,
            -289204214.8137352,
            41719125.09703809
        ],
        [
            -267738343.44224387,
            -298570269.7547123,
            39864108.93647034
        ],
        [
            -258995289.1610453,
            -307688763.48607445,
            37961307.604765154
        ],
        [
            -249956412.20874533,
            -316549350.3915738,
            36012167.731883295
        ],
        [
            -240628133.5449378,
            -325141771.38358784,
            34018200.224508695
        ],
        [
            -231017241.97300732,
            -333455867.5368914,
            31980980.634340756
        ],
        [
            -221130898.0204562,
            -341481594.32379115,
            29902149.42023751
        ],
        [
            -210976637.29919952,
            -349209036.4402244,
            27783412.095633216
        ],
        [
            -200562373.29676935,
            -356628423.20900786,
            25626539.252622936
        ],
        [
            -189896399.5488134,
            -363730144.5428427,
            23433366.454118896
        ],
        [
            -178987391.14295316,
            -370504767.4459356,
            21205793.985543057
        ],
        [
            -167844405.5039909,
            -376943053.0292136,
            18945786.457630362
        ],
        [
            -156476882.41064975,
            -383035974.01008534,
            16655372.252081208
        ],
        [
            -144894643.19452178,
            -388774732.6635714,
            14336642.802023746
        ],
        [
            -133107889.07269192,
            -394150779.18739337,
            11991751.699527612
        ],
        [
            -121127198.56664073,
            -399155830.43931234,
            9622913.622757044
        ],
        [
            -108963523.96150053,
            -403781889.00065744,
            7232403.075761231
        ],
        [
            -96628186.76158188,
            -408021262.5156131,
            4822552.934378894
        ],
        [
            -84132872.10030898,
            -411866583.2514749,
            2395752.7922823057
        ],
        [
            -71489622.06531128,
            -415310827.8207712,
            -45552.89819506928
        ],
        [
            -58710827.90242712,
            -418347337.0018982,
            -2498866.89511339
        ],
        [
            -45809221.06580022,
            -420969835.5908044,
            -4961641.449767102
        ],
        [
            -32797863.085068524,
            -423172452.212276,
            -7431280.806383446
        ],
        [
            -19690134.22489044,
            -424949739.0156114,
            -9905143.920848358
        ],
        [
            -6499720.916695595,
            -426296691.1759231,
            -12380547.399659943
        ],
        [
            6759398.052412599,
            -427208766.119051,
            -14854768.659276571
        ],
        [
            20072966.60324374,
            -427681902.3851328,
            -17325049.304931507
        ],
        [
            33426467.68444407,
            -427712538.043309,
            -19788598.726835646
        ],
        [
            46805140.84646258,
            -427297628.5678774,
            -22242597.91048842
        ],
        [
            60194001.06080392,
            -426434664.08451056,
            -24684203.45657125
        ],
        [
            73577858.76906115,
            -425121685.8939329,
            -27110551.804613926
        ],
        [
            86941341.13922462,
            -423357302.17977744,
            -29518763.653312802
        ],
        [
            100268914.49955463,
            -421140702.807226,
            -31905948.569046196
        ],
        [
            113544907.91292879,
            -418471673.11953336,
            -34269209.77278818
        ],
        [
            126753537.84710002,
            -415350606.6406496,
            -36605649.09427873
        ],
        [
            139878933.88875002,
            -411778516.5939339,
            -38912372.080972426
        ],
        [
            152905165.44169086,
            -407757046.14939946,
            -41186493.24797672
        ],
        [
            165816269.34208804,
            -403288477.3150679,
            -43425141.45391158
        ],
        [
            178596278.3162327,
            -398375738.3918381,
            -45625465.386389464
        ],
        [
            191229250.1992326,
            -393022409.9158044,
            -47784639.13963885
        ],
        [
            203699297.8261119,
            -387232729.01717085,
            -49899867.86569198
        ],
        [
            215990619.50024194,
            -381011592.1307981,
            -51968393.47953364
        ],
        [
            228087529.93787724,
            -374364555.999966,
            -53987500.39768292
        ],
        [
            239974491.5818813,
            -367297836.92209935,
            -55954521.288858384
        ],
        [
            251636146.17257333,
            -359818308.19296277,
            -57866842.814674504
        ],
        [
            263057346.45907712,
            -351933495.7141313,
            -59721911.3377417
        ],
        [
            274223187.9306508,
            -343651571.73733556,
            -61517238.57410358
        ],
        [
            285119040.4442952,
            -334981346.7285042,
            -63250407.16665165
        ],
        [
            295730579.62251604,
            -325932259.34392595,
            -64919076.15601676
        ],
        [
            306043817.89348924,
            -316514364.52083695,
            -66520986.325452
        ],
        [
            316045135.04510814,
            -306738319.69485897,
            -68053965.39640158
        ],
        [
            325721308.16447544,
            -296615369.16695595,
            -69515933.05179195
        ],
        [
            335059540.8353771,
            -286157326.65288746,
            -70904905.76459008
        ],
        [
            344047491.4681609,
            -275376556.0584049,
            -72219001.409848
        ],
        [
            352673300.63920945,
            -264285950.53358436,
            -73456443.63928641
        ],
        [
            360925617.32087284,
            -252898909.86962694,
            -74615565.99846472
        ],
        [
            368793623.8872732,
            -241229316.31108934,
            -75694815.76773001
        ],
        [
            376267059.78678244,
            -229291508.86575192,
            -76692757.50942579
        ],
        [
            383336243.7781887,
            -217100256.2031011,
            -77608076.3052665
        ],
        [
            389992094.6345393,
            -204670728.24061581,
            -78439580.66933173
        ],
        [
            396226150.2263341,
            -192018466.52463216,
            -79186205.12379237
        ],
        [
            402030584.9040931,
            -179159353.51944008,
            -79847012.42624052
        ],
        [
            407398225.1092359,
            -166109580.9243879,
            -80421195.43933345
        ],
        [
            412322563.1516483,
            -152885617.14406425,
            -80908078.63537113
        ],
        [
            416797769.1021701,
            -139504174.04106563,
            -81307119.23038626
        ],
        [
            420818700.758433,
            -125982173.10438536,
            -81617907.9443182
        ],
        [
            424380911.65293026,
            -112336711.16905862,
            -81840169.38585293
        ],
        [
            427480657.0828149,
            -98585025.82435435,
            -81973762.06252053
        ],
        [
            430114898.15159833,
            -84744460.64849259,
            -82018678.01863353
        ],
        [
            432281303.823582,
            -70832430.40760982,
            -81975042.10560639
        ],
        [
            433978251.0023956,
            -56866386.355490774,
            -81843110.8911022
        ],
        [
            435204822.6553526,
            -42863781.76846239,
            -81623271.21529137
        ],
        [
            435960804.0153878,
            -28842037.84683034,
            -81316038.40426518
        ],
        [
            436246676.90201676,
            -14818510.110381395,
            -80922054.15230851
        ],
        [
            436063612.2119957,
            -810455.4108038843,
            -80442084.08629051
        ],
        [
            435413460.6390808,
            13165000.321528107,
            -79877015.02686892
        ],
        [
            434298741.6904274,
            27090893.485058874,
            -79227851.96250974
        ],
        [
            432722631.0746838,
            40950453.26421288,
            -78495714.75349654
        ],
        [
            430688946.5436616,
            54727131.038838685,
            -77681834.58413152
        ],
        [
            428202132.2755859,
            68404628.65629873,
            -76787550.18221225
        ],
        [
            425267241.8932831,
            81966925.48468894,
            -75814303.8255975
        ],
        [
            421889920.21526927,
            95398304.17411825,
            -74763637.15625535
        ],
        [
            418076383.84150255,
            108683375.06164673,
            -73637186.82261173
        ],
        [
            413833400.6785933,
            121807099.1643227,
            -72436679.97129422
        ],
        [
            409168268.5114929,
            134754809.71365657,
            -71163929.60949431
        ],
        [
            404088792.73014784,
            147512232.19379407,
            -69820829.85915588
        ],
        [
            398603263.3203043,
            160065502.85448593,
            -68409351.12404671
        ],
        [
            392720431.2276229,
            172401185.67866206,
            -66931535.19048601
        ],
        [
            386449484.20352304,
            184506287.7929243,
            -65389490.28209469
        ],
        [
            379800022.2397886,
            196368273.3175042,
            -63785386.08841665
        ],
        [
            372782032.6969311,
            207975075.66017884,
            -62121448.78663023
        ],
        [
            365405865.2287091,
            219315108.26619133,
            -60399956.074850544
        ],
        [
            357682206.60206723,
            230377273.8433863,
            -58623232.234715685
        ],
        [
            349622055.5081282,
            241150972.0885048,
            -56793643.24006696
        ],
        [
            341236697.45583487,
            251626105.94681686,
            -54913591.927589744
        ],
        [
            332537679.8354031,
            261793086.44304895,
            -52985513.24427963
        ],
        [
            323536787.23400116,
            271642836.1267972,
            -51011869.58555656
        ],
        [
            314246017.0810559,
            281166791.18034375,
            -48995146.23677443
        ],
        [
            304677555.6953417,
            290356902.2409998,
            -46937846.92977244
        ],
        [
            294843754.80062103,
            299205633.993745,
            -44842489.525004506
        ],
        [
            284757108.5710763,
            307705963.59308964,
            -42711601.82866369
        ],
        [
            274430231.2621968,
            315851377.9756921,
            -40547717.55310629
        ],
        [
            263875835.47717974,
            323635870.1273813,
            -38353372.42777989
        ],
        [
            253106711.11330163,
            331053934.36986303,
            -36131100.46677456
        ],
        [
            242135705.0272071,
            338100560.7335301,
            -33883430.39806336
        ],
        [
            230975701.4526023,
            344771228.48351336,
            -31612882.258469593
        ],
        [
            219639603.19854316,
            351061898.8663823,
            -29321964.157411978
        ],
        [
            208140313.65134817,
            356969007.1447857,
            -27013169.211531274
        ],
        [
            196490719.59817797,
            362489453.98684293,
            -24688972.65139761
        ],
        [
            184703674.8855631,
            367620596.27625376,
            -22351829.10064624
        ],
        [
            172791984.9215876,
            372360237.40796804,
            -20004170.027082317
        ],
        [
            160768392.0261309,
            376706617.1328163,
            -17648401.364546813
        ],
        [
            148645561.62948194,
            380658401.01284057,
            -15286901.303634858
        ],
        [
            136436069.31582814,
            384214669.54715335,
            -12922018.248716012
        ],
        [
            124152388.70457056,
            387374907.02606547,
            -10556068.938116983
        ],
        [
            111806880.15911019,
            390138990.16896063,
            -8191336.723790228
        ],
        [
            99411780.30974743,
            392507176.5989927,
            -5830070.006314371
        ],
        [
            86979192.37455997,
            394480093.205174,
            -3474480.820639994
        ],
        [
            74521077.25963937,
            396058724.4398146,
            -1126743.567619536
        ],
        [
            62049245.41782868,
            397244400.5966084,
            1211006.1139680967
        ],
        [
            49575349.44310363,
            398038786.11194867,
            3536672.3404698223
        ],
        [
            37110877.37601377,
            398443867.92931986,
            5848199.8472904675
        ],
        [
            24667146.694068193,
            398461943.96386635,
            8143574.729702406
        ],
        [
            12255298.959676057,
            398095611.7015135,
            10420825.066678867
        ],
        [
            -113704.90282568336,
            397347756.964302,
            12678021.434009224
        ],
        [
            -12429088.730409235,
            396221542.87093693,
            14913277.31303303
        ],
        [
            -24680264.67487988,
            394720399.0189325,
            17124749.401369587
        ],
        [
            -36856836.21723336,
            392848010.9121804,
            19310637.832035266
        ],
        [
            -48948600.67372835,
            390608309.65528405,
            21469186.307323564
        ],
        [
            -60945551.22474757,
            388005461.9335977,
            23598682.153781373
        ],
        [
            -72837878.49758592,
            385043860.29558146,
            25697456.304553036
        ],
        [
            -84615971.73421095,
            381728113.75185376,
            27763883.215275552
        ],
        [
            -96270419.57486959,
            378063038.7031765,
            29796380.71960815
        ],
        [
            -107792010.48810875,
            374053650.2075644,
            31793409.83035803
        ],
        [
            -119171732.87739034,
            369705153.59475833,
            33753474.4920304
        ],
        [
            -130400774.89402264,
            365022936.4344454,
            35675121.29048738
        ],
        [
            -141470523.98556915,
            360012560.8628597,
            37556939.125240974
        ],
        [
            -152372566.2083121,
            354679756.2707268,
            39397558.84974457
        ],
        [
            -163098685.33166647,
            349030412.35395867,
            41195652.88487231
        ],
        [
            -173640861.76175565,
            343070572.52702665,
            42949934.81060177
        ],
        [
            -183991271.31060445,
            336806427.6975548,
            44659158.9407329
        ],
        [
            -194142283.8366313,
            330244310.3993863,
            46322119.885291
        ],
        [
            -204086461.78133535,
            323390689.2801506,
            47937652.10507937
        ],
        [
            -213816558.6262403,
            316252163.93823546,
            49504629.46265554
        ],
        [
            -223325517.29334366,
            308835460.10300094,
            51021964.773822956
        ],
        [
            -232606468.51147068,
            301147425.15108716,
            52488609.36354085
        ],
        [
            -241652729.17009032,
            293195023.9507507,
            53903552.62997087
        ],
        [
            -250457800.68131742,
            284985335.02529997,
            55265821.62019791
        ],
        [
            -259015367.36996573,
            276525547.0259066,
            56574480.62097866
        ],
        [
            -267319294.91069573,
            267822955.5033193,
            57828630.76769643
        ],
        [
            -275363628.8304622,
            258884959.9673136,
            59027409.67452356
        ],
        [
            -283142593.0936402,
            249719061.22206104,
            60169991.088619955
        ],
        [
            -290650588.78640634,
            240332858.96498522,
            61255584.57102885
        ],
        [
            -297882192.91613185,
            230734049.63610935,
            62283435.2067615
        ],
        [
            -304832157.3407648,
            220930424.50435102,
            63252823.34640123
        ],
        [
            -311495407.84238267,
            210929867.9767142,
            64163064.38139479
        ],
        [
            -317867043.35832334,
            200740356.11584806,
            65013508.55504073
        ],
        [
            -323942335.3825414,
            190369955.3509696,
            65803540.81102886
        ],
        [
            -329716727.5490631,
            179826821.36671993,
            66532580.68122941
        ],
        [
            -335185835.4086726,
            169119198.15408555,
            67200082.21427894
        ]
    ],
    "(2024 YD2)": [
        [
            -183465266.75299683,
            221252823.714325,
            -137599911.25815198
        ],
        [
            -191586981.5671301,
            216715600.0643739,
            -133767807.49277854
        ],
        [
            -199556536.55011028,
            212001124.22314802,
            -129825908.78317164
        ],
        [
            -207370324.98934856,
            207111304.77054155,
            -125775843.28144674
        ],
        [
            -215024709.6375341,
            202048035.06299645,
            -121619231.19482934
        ],
        [
            -222516017.0818206,
            196813197.2358465,
            -117357688.03563368
        ],
        [
            -229840532.3374452,
            191408666.46712348,
            -112992828.03319925
        ],
        [
            -236994493.67057484,
            185836315.5047664,
            -108526267.70872203
        ],
        [
            -243974087.65629014,
            180098019.45984763,
            -103959629.61428756
        ],
        [
            -250775444.47882244,
            174195660.8690408,
            -99294546.23773456
        ],
        [
            -257394633.48245287,
            168131135.03009394,
            -94532664.07523842
        ],
        [
            -263827658.98286963,
            161906355.61453676,
            -89675647.87371185
        ],
        [
            -270070456.3502503,
            155523260.56223947,
            -84725185.04526041
        ],
        [
            -276118888.37690264,
            148983818.26274118,
            -79682990.25600791
        ],
        [
            -281968741.943948,
            142290034.02847576,
            -74550810.19161081
        ],
        [
            -287615725.00327134,
            135443956.86513284,
            -69330428.50170854
        ],
        [
            -293055463.8927911,
            128447686.54439285,
            -64023670.9254029
        ],
        [
            -298283501.0050094,
            121303380.98415887,
            -58632410.59961612
        ],
        [
            -303295292.8308041,
            114013263.941164,
            -53158573.55183893
        ],
        [
            -308086208.4024891,
            106579633.02044936,
            -47604144.37833819
        ],
        [
            -312651528.16232455,
            99004868.00567341,
            -41971172.10834077
        ],
        [
            -316986443.2848673,
            91291439.51351385,
            -36261776.25403787
        ],
        [
            -321086055.4838356,
            83441917.97454603,
            -30478153.045453086
        ],
        [
            -324945377.3364865,
            75458982.94190964,
            -24622581.848276556
        ],
        [
            -328559333.1608771,
            67345432.72779502,
            -18697431.761680186
        ],
        [
            -331922760.4837807,
            59104194.36627275,
            -12705168.391880006
        ],
        [
            -335030412.13943964,
            50738333.89923774,
            -6648360.795794547
        ],
        [
            -337876959.04174113,
            42251066.98022562,
            -529688.5875481516
        ],
        [
            -340456993.6747845,
            33645769.7885627,
            5648050.801222876
        ],
        [
            -342765034.3491315,
            24925990.24371645,
            11881934.718299136
        ],
        [
            -344795530.27327913,
            16095459.506795019,
            18168907.75828977
        ],
        [
            -346542867.49202734,
            7158103.752891064,
            24505774.11620991
        ],
        [
            -348001375.74539584,
            -1881943.8056477457,
            30889189.84557675
        ],
        [
            -349165336.30353534,
            -11020330.668929398,
            37315655.04229182
        ],
        [
            -350028990.8346335,
            -20252472.600496814,
            43781505.97874187
        ],
        [
            -350586551.36407447,
            -29573541.012652174,
            50282907.21597426
        ],
        [
            -350832211.3840311,
            -38978450.22441247,
            56815843.7254875
        ],
        [
            -350760158.1731709,
            -48461844.63601813,
            63376113.05612276
        ],
        [
            -350364586.3861878,
            -58018085.86999273,
            69959317.58575207
        ],
        [
            -349639712.972342,
            -67641239.93525723,
            76560856.90191849
        ],
        [
            -348579793.48103595,
            -77325064.47774726,
            83175920.36029369
        ],
        [
            -347179139.810579,
            -87062996.1883428,
            89799479.8747558
        ],
        [
            -345432139.45360565,
            -96848138.4466815,
            96426282.9980375
        ],
        [
            -343333276.2890341,
            -106673249.28757064,
            103050846.3572261
        ],
        [
            -340877152.9658572,
            -116530729.78518656,
            109667449.51387799
        ],
        [
            -338058514.9183753,
            -126412612.9590165,
            116270129.32409242
        ],
        [
            -334872276.04558694,
            -136310553.31449193,
            122852674.87953466
        ],
        [
            -331313546.07925016,
            -146215817.14040872,
            129408623.11603141
        ],
        [
            -327377659.6555306,
            -156119273.69443414,
            135931255.18192062
        ],
        [
            -323060207.09403414,
            -166011387.41716847,
            142413593.66373983
        ],
        [
            -318357066.875334,
            -175882211.32421875,
            148848400.77198273
        ],
        [
            -313264439.7937249,
            -185721381.73442623,
            155228177.5944448
        ],
        [
            -307778884.74583554,
            -195518114.50059858,
            161545164.52899432
        ],
        [
            -301897356.09784365,
            -205261202.91664797,
            167791343.01131132
        ],
        [
            -295617242.55433065,
            -214939017.48173752,
            173958438.65610278
        ],
        [
            -288936407.4303017,
            -224539507.7076545,
            180037925.93236113
        ],
        [
            -281853230.2045945,
            -234050206.15993658,
            186021034.49423537
        ],
        [
            -274366649.2078736,
            -243458234.9260123,
            191898757.28884998
        ],
        [
            -266476205.27176556,
            -252750314.70450848,
            197661860.560759
        ],
        [
            -258182086.1375785,
            -261912776.7086545,
            203300895.8694858
        ],
        [
            -249485171.39366,
            -270931577.5730765,
            208806214.23158333
        ],
        [
            -240387077.6800521,
            -279792317.44694006,
            214167982.49167758
        ],
        [
            -230890203.86798388,
            -288480261.4470799,
            219376202.01785994
        ],
        [
            -220997775.89030883,
            -296980364.6321766,
            224420729.8054114
        ],
        [
            -210713890.86764804,
            -305277300.6429347,
            229291302.0590243
        ],
        [
            -200043560.14426687,
            -313355494.1333758,
            233977560.30733865
        ],
        [
            -188992750.81814435,
            -321199157.09456843,
            238469080.08461916
        ],
        [
            -177568425.3219195,
            -328792329.1442483,
            242755402.19274545
        ],
        [
            -165778578.5860915,
            -336118921.8237456,
            246826066.5323501
        ],
        [
            -153632272.2937463,
            -343162766.9074174,
            250670648.46498477
        ],
        [
            -141139665.71794713,
            -349907668.6894534,
            254278797.63872537
        ],
        [
            -128312042.61953542,
            -356337460.16863906,
            257640279.17782867
        ],
        [
            -115161833.67526814,
            -362436063.0036932,
            260745017.10317296
        ],
        [
            -101702633.90473735,
            -368187551.0605148,
            263583139.81458175
        ],
        [
            -87949214.57014519,
            -373576217.3185684,
            266145027.4291462
        ],
        [
            -73917529.03646183,
            -378586643.847337,
            268421360.73181987
        ],
        [
            -59624712.10138011,
            -383203774.50599015,
            270403171.4564151
        ],
        [
            -45089072.33534637,
            -387412989.96103734,
            272081893.57733095
        ],
        [
            -30330077.01216224,
            -391200184.55871224,
            273449415.2555859
        ],
        [
            -15368329.260461658,
            -394551844.532246,
            274498131.0477809
        ],
        [
            -225537.12579756975,
            -397455126.97020257,
            275220993.9542918
        ],
        [
            15075525.698020399,
            -399897938.92187536,
            275611566.8541074
        ],
        [
            30511067.63173163,
            -401869015.97067255,
            275664072.8491485
        ],
        [
            46056335.544560045,
            -403357999.5677074,
            275373444.0214477
        ],
        [
            61685679.64232272,
            -404355512.3867199,
            274735368.0930269
        ],
        [
            77372626.79240754,
            -404853230.93919545,
            273746332.4714298
        ],
        [
            93089962.0629527,
            -404843954.6761914,
            272403665.1642673
        ],
        [
            108809818.14481464,
            -404321670.801913,
            270705572.0543638
        ],
        [
            124503772.21458814,
            -403281614.0342731,
            268651170.0435273
        ],
        [
            140142949.68705773,
            -401720320.5700873,
            266240515.5978333
        ],
        [
            155698134.19813132,
            -399635675.5475497,
            263474628.2606619
        ],
        [
            171139883.05675167,
            -397026953.3462147,
            260355508.74139842
        ],
        [
            186438647.30871788,
            -393894850.124683,
            256886151.2373517
        ],
        [
            201564895.46898568,
            -390241508.0679622,
            253070549.70348614
        ],
        [
            216489239.9039284,
            -386070530.899224,
            248913697.84824434
        ],
        [
            231182564.7831535,
            -381386990.303229,
            244421582.70307997
        ],
        [
            245616154.473478,
            -376197423.00961006,
            239601171.6871945
        ],
        [
            259761821.21695298,
            -370509818.3917988,
            234460393.1660801
        ],
        [
            273592030.92147106,
            -364333596.5497317,
            229008110.5814018
        ],
        [
            287080025.8971469,
            -357679576.95951974,
            223254090.3090149
        ],
        [
            300199943.3945938,
            -350559937.8887978,
            217208963.47995913
        ],
        [
            312926928.8422778,
            -342988166.89025927,
            210884182.07457152
        ],
        [
            325237242.73867166,
            -334979002.7956848,
            204291969.67090946
        ],
        [
            337108360.2299736,
            -326548369.7364296,
            197445267.2940678
        ],
        [
            348519062.49425364,
            -317713303.81181717,
            190357674.87143064
        ],
        [
            359449519.1562555,
            -308491873.1123705,
            183043388.84929514
        ],
        [
            369881361.0716686,
            -298903091.87869275,
            175517136.5677235
        ],
        [
            379797742.94312084,
            -288966829.63781303,
            167794108.0222209
        ],
        [
            389183395.359961,
            -278703716.2059312,
            159889885.66242856
        ],
        [
            398024665.9874739,
            -268135043.47911826,
            151820372.88925007
        ],
        [
            406309549.76587963,
            -257282664.95135647,
            143601721.91272417
        ],
        [
            414027708.11272055,
            -246168893.90240827,
            135250261.62377486
        ],
        [
            421170477.25157416,
            -234816401.18678796,
            126782426.11421104
        ],
        [
            427730865.91315,
            -223248113.53030038,
            118214684.45170106
        ],
        [
            433703542.76969457,
            -211487113.20318806,
            109563472.28077012
        ],
        [
            439084814.06845206,
            -199556539.89014906,
            100845125.77818158
        ],
        [
            443872592.02327585,
            -187479495.51877892,
            92075818.44247638
        ],
        [
            448066354.60419714,
            -175278952.740917,
            83271501.14414127
        ],
        [
            451667097.432101,
            -162977667.6876443,
            74447845.80609708
        ],
        [
            454677278.5391531,
            -150598097.53996074,
            65620193.02514452
        ],
        [
            457100756.795196,
            -138162323.37521702,
            56803503.884895876
        ],
        [
            458942724.8261739,
            -125691978.6658266,
            48012316.15067327
        ],
        [
            460209637.26323974,
            -113208183.72322866,
            39260704.97792947
        ],
        [
            460909135.1612822,
            -100731486.29795632,
            30562248.20888132
        ],
        [
            461049967.41410995,
            -88281808.46731591,
            21929996.278082654
        ],
        [
            460641909.97155124,
            -75878399.86671412,
            13376446.697275981
        ],
        [
            459695683.6324798,
            -63539797.25007191,
            4913523.043636903
        ],
        [
            458222871.1485779,
            -51283790.299797624,
            -3447441.6661268175
        ],
        [
            456235834.3278156,
            -39127393.54803884,
            -11695717.370142296
        ],
        [
            453747631.77551955,
            -27086824.21883422,
            -19821185.310255975
        ],
        [
            450771937.855836,
            -15177485.75552243,
            -27814342.548144758
        ],
        [
            447322963.3986157,
            -3413956.759475261,
            -35666302.88296431
        ],
        [
            443415378.6174511,
            8190014.965203077,
            -43368794.42156257
        ],
        [
            439064238.6448491,
            19621513.591117114,
            -50914154.06434268
        ],
        [
            434284912.0313123,
            30868452.01959625,
            -58295319.17751728
        ],
        [
            429093012.4972621,
            41919564.56607649,
            -65505816.72613241
        ],
        [
            423504334.17101705,
            52764395.94640711,
            -72539750.1421909
        ],
        [
            417534790.4930284,
            63393286.93336311,
            -79391784.19888833
        ],
        [
            411200356.91676277,
            73797357.04984686,
            -86057128.15580422
        ],
        [
            404517017.4903872,
            83968484.6584595,
            -92531517.43124916
        ],
        [
            397500715.3609911,
            93899284.79691851,
            -98811194.04729706
        ],
        [
            390167307.2046597,
            103583085.09568012,
            -104892886.0806821
        ],
        [
            382532521.5513613,
            113013900.09864672,
            -110773786.33910273
        ],
        [
            374611920.94329154,
            122186404.29050025,
            -116451530.46789035
        ],
        [
            366420867.83902097,
            131095904.11542338,
            -121924174.67676322
        ],
        [
            357974494.1533147,
            139738309.25223568,
            -127190173.2608093
        ],
        [
            349287674.3037254,
            148110103.3906095,
            -132248356.07414824
        ],
        [
            340375001.6197554,
            156208314.73241374,
            -137097906.0991452
        ],
        [
            331250767.95831025,
            164030486.42166528,
            -141738337.23878235
        ],
        [
            321928946.3600946,
            171574647.08627212,
            -146169472.44496825
        ],
        [
            312423176.5752213,
            178839281.65499887,
            -150391422.2813465
        ],
        [
            302746753.28240633,
            185823302.59399632,
            -154404564.0056159
        ],
        [
            292912616.8243735,
            192526021.68901277,
            -158209521.2436073
        ],
        [
            282933346.2822893,
            198947122.48211005,
            -161807144.31540352
        ],
        [
            272821154.71389836,
            205086633.455451,
            -165198491.26269093
        ],
        [
            262587886.38330597,
            210944902.03956544,
            -168384809.6163122
        ],
        [
            252245015.8148424,
            216522569.50944126,
            -171367518.9336362
        ],
        [
            241803648.50890255,
            221820546.8188806,
            -174148194.12688857
        ],
        [
            231274523.16392928,
            226839991.41176566,
            -176728549.59595215
        ],
        [
            220668015.25559798,
            231582285.03819662,
            -179110424.1723359
        ],
        [
            209994141.8315993,
            236049012.59386203,
            -181295766.87498713
        ],
        [
            199262567.38810357,
            240241941.9924248,
            -183286623.4733356
        ],
        [
            188482610.70184618,
            244163005.07313144,
            -185085123.84837997
        ],
        [
            177663252.49973404,
            247814279.53919864,
            -186693470.13869858
        ],
        [
            166813143.85582703,
            251197971.9167593,
            -188113925.6549455
        ],
        [
            155940615.21339804,
            254316401.51920295,
            -189348804.54363292
        ],
        [
            145053685.93750155,
            257171985.39753938,
            -190400462.178749
        ],
        [
            134160074.31096356,
            259767224.25392336,
            -191271286.25797564
        ],
        [
            123267207.89396372,
            262104689.29261097,
            -191963688.57890514
        ],
        [
            112382234.17433445,
            264187009.9803353,
            -192480097.46966344
        ],
        [
            101512031.44233376,
            266016862.68633196,
            -192822950.84769577
        ],
        [
            90663219.82996848,
            267596960.17095017,
            -192994689.8801106
        ],
        [
            79842172.4608846,
            268930041.89091814,
            -192997753.2188835
        ],
        [
            69055026.66245179,
            270018865.0888283,
            -192834571.78434992
        ],
        [
            58307695.19691071,
            270866196.6342381,
            -192507564.07074454
        ],
        [
            47605877.47332576,
            271474805.58389527,
            -192019131.94803745
        ],
        [
            36955070.70663422,
            271847456.4289548,
            -191371656.9349529
        ],
        [
            26360580.994252056,
            271986902.99763656,
            -190567496.91881192
        ],
        [
            15827534.284566224,
            271895882.9825226,
            -189608983.29869026
        ],
        [
            5360887.215155244,
            271577113.06260663,
            -188498418.52931318
        ],
        [
            -5034562.198194265,
            271033284.59124327,
            -187238074.04410017
        ],
        [
            -15354164.037686706,
            270267059.8222877,
            -185830188.5368112
        ],
        [
            -25593406.138323814,
            269281068.647936,
            -184276966.58231544
        ],
        [
            -35747903.93232447,
            268077905.8230699,
            -182580577.57809955
        ],
        [
            -45813390.49207413,
            266660128.65224198,
            -180743154.9892344
        ],
        [
            -55785706.77864222,
            265030255.11681336,
            -178766795.88063124
        ],
        [
            -65660792.10126318,
            263190762.42114604,
            -176653560.7215192
        ],
        [
            -75434674.79176377,
            261144085.93815804,
            -174405473.44817203
        ],
        [
            -85103463.09667635,
            258892618.53595492,
            -172024521.77198833
        ],
        [
            -94663336.28875943,
            256438710.2686531,
            -169512657.7210884
        ],
        [
            -104110535.99877767,
            253784668.41589317,
            -166871798.404622
        ],
        [
            -113441357.76770276,
            250932757.85691643,
            -164103826.9899908
        ],
        [
            -122652142.81897125,
            247885201.7664131,
            -161210593.88416064
        ],
        [
            -131739270.05003321,
            244644182.62067497,
            -158193918.1111875
        ],
        [
            -140699148.24219367,
            241211843.50386557,
            -155055588.8789898
        ],
        [
            -149528208.48762012,
            237590289.70547077,
            -151797367.32927346
        ],
        [
            -158222896.83240068,
            233781590.6012106,
            -148420988.46536058
        ],
        [
            -166779667.13467053,
            229787781.81085962,
            -144928163.25346762
        ],
        [
            -175194974.13704944,
            225610867.62756374,
            -141320580.8937504
        ],
        [
            -183465266.75299677,
            221252823.71432504,
            -137599911.258152
        ]
    ],
    "(2024 YY4)": [
        [
            -76572076.34966318,
            -311381696.55173445,
            18743193.513120253
        ],
        [
            -66765231.27133511,
            -313709321.1884591,
            17621761.10346302
        ],
        [
            -56895712.009602636,
            -315750443.05763817,
            16484028.65865602
        ],
        [
            -46970896.29451658,
            -317503425.2572824,
            15330843.297088176
        ],
        [
            -36998197.803554244,
            -318966774.1895143,
            14163060.849125594
        ],
        [
            -26985066.603786364,
            -320139140.09745336,
            12981545.927124593
        ],
        [
            -16938989.604336478,
            -321019317.8566085,
            11787172.004408527
        ],
        [
            -6867491.00215669,
            -321606248.02270687,
            10580821.50120334
        ],
        [
            3221867.296030998,
            -321899018.1372321,
            9363385.875486007
        ],
        [
            13321485.292957962,
            -321896864.29128057,
            8135765.71665776
        ],
        [
            23423724.578708038,
            -321599172.9476563,
            6898870.8399114255
        ],
        [
            33520908.084989563,
            -321005483.0204243,
            5653620.379118161
        ],
        [
            43605319.933660686,
            -320115488.2104025,
            4400942.876014294
        ],
        [
            53669205.39757255,
            -318929039.5943216,
            3141776.363423789
        ],
        [
            63704770.9919734,
            -317446148.46458286,
            1877068.440206021
        ],
        [
            73704184.71488827,
            -315666989.415724,
            607776.3355726618
        ],
        [
            83659576.45505087,
            -313591903.67283547,
            -665133.0396283045
        ],
        [
            93563038.58611211,
            -311221402.6562669,
            -1940683.0571088344
        ],
        [
            103406626.76597857,
            -308556171.77601296,
            -3217887.353309227
        ],
        [
            113182360.96024254,
            -305597074.4481804,
            -4495749.832073614
        ],
        [
            122882226.70874372,
            -302345156.3248899,
            -5773264.690408757
        ],
        [
            132498176.65435052,
            -298801649.72788095,
            -7049416.469941156
        ],
        [
            142022132.3530579,
            -294967978.274947,
            -8323180.136723032
        ],
        [
            151445986.38446215,
            -290845761.6871317,
            -9593521.192069674
        ],
        [
            160761604.7815867,
            -286436820.7633781,
            -10859395.817137627
        ],
        [
            169960829.79888976,
            -281743182.50802124,
            -12119751.053975249
        ],
        [
            179035483.03707433,
            -276767085.3951709,
            -13373525.02579231
        ],
        [
            187977368.94304004,
            -271510984.75262874,
            -14619647.199203635
        ],
        [
            196778278.7029568,
            -265977558.24654433,
            -15857038.691201797
        ],
        [
            205429994.54598802,
            -260169711.44651848,
            -17084612.62360418
        ],
        [
            213924294.47564894,
            -254090583.44933075,
            -18301274.527700186
        ],
        [
            222252957.44513464,
            -247743552.53789902,
            -19505922.801793
        ],
        [
            230407768.99219143,
            -241132241.85047624,
            -20697449.224286057
        ],
        [
            238380527.34821996,
            -234260525.03345865,
            -21874739.524906628
        ],
        [
            246163050.03529018,
            -227132531.84953701,
            -23036674.016585656
        ],
        [
            253747180.9635943,
            -219752653.71126258,
            -24182128.290423647
        ],
        [
            261124798.0405749,
            -212125549.1084417,
            -25309973.97606518
        ],
        [
            268287821.30151266,
            -204256148.89612734,
            -26419079.56967882
        ],
        [
            275228221.5697574,
            -196149661.4083448,
            -27508311.331593245
        ],
        [
            281938029.6530121,
            -187811577.361103,
            -28576534.255473442
        ],
        [
            288409346.0801353,
            -179247674.5066925,
            -29622613.110731132
        ],
        [
            294634351.380815,
            -170464021.99979708,
            -30645413.55965173
        ],
        [
            300605316.9081627,
            -161466984.43454304,
            -31643803.35048233
        ],
        [
            306314616.2018021,
            -152263225.51031068,
            -32616653.58746423
        ],
        [
            311754736.8863668,
            -142859711.282945,
            -33562840.07850578
        ],
        [
            316918293.0974755,
            -133263712.956956,
            -34481244.7608774
        ],
        [
            321798038.4242343,
            -123482809.17340297,
            -35370757.204970784
        ],
        [
            326386879.35412097,
            -113524887.74744429,
            -36230276.19579753
        ],
        [
            330677889.2027365,
            -103398146.80901584,
            -37058711.39150876
        ],
        [
            334664322.50739145,
            -93111095.2998073,
            -37854985.057798386
        ],
        [
            338339629.859816,
            -82672552.77965537,
            -38618033.87660738
        ],
        [
            341697473.1494784,
            -72091648.49568689,
            -39346810.82707718
        ],
        [
            344731741.1850655,
            -61377819.66804899,
            -40040287.13620781
        ],
        [
            347436565.6576556,
            -50540808.94687942,
            -40697454.2961618
        ],
        [
            349806337.4050015,
            -39590660.99631143,
            -41317326.14462148
        ],
        [
            351835722.93218887,
            -28537718.162807353,
            -41898941.004056014
        ],
        [
            353519681.1397392,
            -17392615.18697624,
            -42441363.87518921
        ],
        [
            354853480.20604956,
            -6166272.920281112,
            -42943688.679382265
        ],
        [
            355832714.56691,
            5130108.989308864,
            -43405040.54406152
        ],
        [
            356453321.9307641,
            16485060.475608245,
            -43824578.12473272
        ],
        [
            356711600.264412,
            27886850.525857598,
            -44201495.95653634
        ],
        [
            356604224.680043,
            39323497.77122253,
            -44535026.82771627
        ],
        [
            356128264.1508539,
            50782782.21733275,
            -44824444.16680244
        ],
        [
            355281197.97913104,
            62252258.13129182,
            -45069064.43475303
        ],
        [
            354060931.93756294,
            73719268.09642623,
            -45268249.512767196
        ],
        [
            352465814.0017762,
            85170958.24047911,
            -45421409.07597396
        ],
        [
            350494649.5896826,
            96594294.63700187,
            -45528002.94272968
        ],
        [
            348146716.2212439,
            107976080.87338673,
            -45587543.38882489
        ],
        [
            345421777.51074487,
            119302976.77233967,
            -45599597.41551542
        ],
        [
            342320096.4026539,
            130561518.24664861,
            -45563788.959959716
        ],
        [
            338842447.5617045,
            141738138.25989544,
            -45479801.03637105
        ],
        [
            334990128.82795906,
            152819188.85834658,
            -45347377.79598494
        ],
        [
            330764971.64838076,
            163790964.23167044,
            -45166326.49380463
        ],
        [
            326169350.3978671,
            174639724.75243992,
            -44936519.35002823
        ],
        [
            321206190.5047943,
            185351721.9366436,
            -44657895.29408092
        ],
        [
            315878975.2989407,
            195913224.2597012,
            -44330461.57928505
        ],
        [
            310191751.5031835,
            206310543.75485253,
            -43954295.25639735
        ],
        [
            304149133.2946236,
            216530063.313309,
            -43529544.49453435
        ],
        [
            297756304.8657772,
            226558264.5983177,
            -43056429.738393165
        ],
        [
            291019021.4221807,
            236381756.4783555,
            -42535244.69115862
        ],
        [
            283943608.55916023,
            245987303.87813026,
            -41966357.11306787
        ],
        [
            276536959.96760845,
            255361856.93998265,
            -41350209.42628131
        ],
        [
            268806533.42634135,
            264492580.38274965,
            -40687319.11748031
        ],
        [
            260760345.04694283,
            273366882.94022536,
            -39978278.93047629
        ],
        [
            252406961.7458926,
            281972446.7571139,
            -39223756.84206742
        ],
        [
            243755491.92814904,
            290297256.6168878,
            -38424495.81541294
        ],
        [
            234815574.3761648,
            298329628.8732802,
            -37581313.32630644
        ],
        [
            225597365.34846127,
            306058239.9553315,
            -36695100.658907056
        ],
        [
            216111523.90231085,
            313472154.3150073,
            -35766821.96872795
        ],
        [
            206369195.46567112,
            320560851.6864463,
            -34797513.11196991
        ],
        [
            196381993.69420445,
            327314253.52691716,
            -33788280.24161837
        ],
        [
            186161980.65988588,
            333722748.5115773,
            -32740298.172079705
        ],
        [
            175721645.42827308,
            339777216.95712906,
            -31654808.515508775
        ],
        [
            165073881.0918606,
            345469054.0534833,
            -30533117.594359055
        ],
        [
            154231960.33698517,
            350790191.78751856,
            -29376594.13605821
        ],
        [
            143209509.63137683,
            355733119.448958,
            -28186666.757062368
        ],
        [
            132020482.12856954,
            360290902.61524093,
            -26964821.244858168
        ],
        [
            120679129.393905,
            364457200.5199686,
            -25712597.64775072
        ],
        [
            109199972.06468542,
            368226281.718021,
            -24431587.18348458
        ],
        [
            97597769.5640893,
            371593037.96968436,
            -23123428.978882633
        ],
        [
            85887488.99467237,
            374552996.2760255,
            -21789806.653742373
        ],
        [
            74084273.34257467,
            377102329.0082063,
            -20432444.763190046
        ],
        [
            62203409.12789636,
            379237862.0843627,
            -19053105.11355189
        ],
        [
            50260293.64002872,
            380957081.1589649,
            -17653582.96754825
        ],
        [
            38270401.89902164,
            382258135.80113876,
            -16235703.155245297
        ],
        [
            26249253.485298492,
            383139841.6501376,
            -14801316.107703619
        ],
        [
            14212379.380189642,
            383601680.547913,
            -13352293.830638839
        ],
        [
            2175288.958861053,
            383643798.66042703,
            -11890525.835654838
        ],
        [
            -9846562.724740416,
            383267002.61086524,
            -10417915.046721699
        ],
        [
            -21837807.224268496,
            382472753.65915596,
            -8936373.699550938
        ],
        [
            -33783194.425980076,
            381263159.97305757,
            -7447819.251369253
        ],
        [
            -45667623.58453393,
            379640967.04646534,
            -5954170.318313817
        ],
        [
            -57476173.5475177,
            377609546.33041394,
            -4457342.657269929
        ],
        [
            -69194132.05318753,
            375172882.1514284,
            -2959245.2084537484
        ],
        [
            -80807023.99319871,
            372335557.00034267,
            -1461776.2144127004
        ],
        [
            -92300638.54003648,
            369102735.2823911,
            33180.56961482391
        ],
        [
            -103661055.04734951,
            365480145.62623316,
            1523759.5598633587
        ],
        [
            -114874667.64035583,
            361474061.8555586,
            3008116.909519393
        ],
        [
            -125928208.4228223,
            357091282.73200214,
            4484433.943287082
        ],
        [
            -136808769.23674268,
            352339110.5822599,
            5950920.449855879
        ],
        [
            -147503821.92063898,
            347225328.92552954,
            7405817.822178487
        ],
        [
            -158001237.02230805,
            341758179.2196982,
            8847402.036600746
        ],
        [
            -168289300.93172872,
            335946336.84608793,
            10273986.46304555
        ],
        [
            -178356731.40965784,
            329798886.45305085,
            11683924.499631045
        ],
        [
            -188192691.4970769,
            323325296.7783333,
            13075612.026285406
        ],
        [
            -197786801.80004835,
            316535395.068912,
            14447489.67309978
        ],
        [
            -207129151.15360886,
            309439341.21501565,
            15798044.90032319
        ],
        [
            -216210305.67701644,
            302047601.7123173,
            17125813.888042226
        ],
        [
            -225021316.2409187,
            294370923.56287605,
            18429383.23469448
        ],
        [
            -233553724.37475526,
            286420308.2213906,
            19707391.46462745
        ],
        [
            -241799566.6499411,
            278206985.688748,
            20958530.34593306
        ],
        [
            -249751377.5810202,
            269742388.8497933,
            22181546.02074842
        ],
        [
            -257402191.09303853,
            261038128.14677134,
            23375239.951115645
        ],
        [
            -264745540.60883045,
            252105966.67404896,
            24538469.684332952
        ],
        [
            -271775457.8147239,
            242957795.77362835,
            25670149.44249826
        ],
        [
            -278486470.1673589,
            233605611.20461494,
            26769250.54164847
        ],
        [
            -284873597.20786655,
            224061489.95332557,
            27834801.64652539
        ],
        [
            -290932345.7525893,
            214337567.7441499,
            28865888.867555346
        ],
        [
            -296658704.03185344,
            204446017.30465272,
            29861655.70711318
        ],
        [
            -302049134.8500377,
            194399027.4318354,
            30821302.86255128
        ],
        [
            -307100567.84135765,
            184208782.89994103,
            31744087.893815145
        ],
        [
            -311810390.8964171,
            173887445.24380147,
            32629324.763737194
        ],
        [
            -316176440.83469987,
            163447134.44548965,
            33476383.25930447
        ],
        [
            -320196993.39783126,
            152899911.54599175,
            34284688.30233715
        ],
        [
            -323870752.6376363,
            142257762.19782764,
            35053719.15809305
        ],
        [
            -327196839.7718387,
            131532581.16898575,
            35783008.5503374
        ],
        [
            -330174781.5786705,
            120736157.80328745,
            36472141.69138561
        ],
        [
            -332804498.399777,
            109880162.43733859,
            37120755.23554761
        ],
        [
            -335086291.8186211,
            98976133.7695741,
            37728536.164277986
        ],
        [
            -337020832.0791461,
            88035467.17260551,
            38295220.61116979
        ],
        [
            -338609145.3068156,
            77069403.9360851,
            38820592.63472942
        ],
        [
            -339852600.59130526,
            66089021.423680514,
            39304482.94663426
        ],
        [
            -340752896.9871436,
            55105224.1244352,
            39746767.60291378
        ],
        [
            -341312050.4855056,
            44128735.5758363,
            40147366.66520751
        ],
        [
            -341532381.0071797,
            33170091.133274987,
            40506242.83894725
        ],
        [
            -341416499.46349543,
            22239631.558259748,
            40823400.09498751
        ],
        [
            -340967294.92873937,
            11347497.39575769,
            41098882.28087262
        ],
        [
            -340187921.96431357,
            503624.109317556,
            41332771.7275833
        ],
        [
            -339081788.1316503,
            -10282262.058776543,
            41525187.85725367
        ],
        [
            -337652541.72768086,
            -21000647.53621839,
            41676285.79699424
        ],
        [
            -335904059.7735054,
            -31642234.21305734,
            41786255.00360007
        ],
        [
            -333840436.2838306,
            -42197941.61317,
            41855317.90356875
        ],
        [
            -331465970.84174424,
            -52658908.4806996,
            41883728.55250111
        ],
        [
            -328785157.5004975,
            -63016493.81754452,
            41871771.31761246
        ],
        [
            -325802674.0311788,
            -73262277.40800917,
            41819759.58674373
        ],
        [
            -322523371.53247863,
            -83388059.86659719,
            41728034.50693202
        ],
        [
            -318952264.4162,
            -93385862.24461387,
            41596963.75528087
        ],
        [
            -315094520.77972823,
            -103247925.23082046,
            41426940.344561346
        ],
        [
            -310955453.17438096,
            -112966707.98081276,
            41218381.46567902
        ],
        [
            -306540509.7763841,
            -122534886.60912177,
            40971727.36885686
        ],
        [
            -301855265.96517843,
            -131945352.37728041,
            40687440.28511344
        ],
        [
            -296905416.3118546,
            -141191209.61023512,
            40366003.38935769
        ],
        [
            -291696766.97872734,
            -150265773.3725804,
            40007919.80617706
        ],
        [
            -286235228.5294069,
            -159162566.93511385,
            39613711.659165084
        ],
        [
            -280526809.1471933,
            -167875319.0611897,
            39183919.1644176
        ],
        [
            -274577608.25819826,
            -176397961.14130914,
            38719099.76862231
        ],
        [
            -268393810.55430654,
            -184724624.20328838,
            38219827.33197619
        ],
        [
            -261981680.40989152,
            -192849635.82427493,
            37686691.35598712
        ],
        [
            -255347556.68511757,
            -200767516.96975562,
            37120296.25605065
        ],
        [
            -248497847.90766823,
            -208472978.78361657,
            36521260.67853909
        ],
        [
            -241439027.82384768,
            -215960919.35220128,
            35890216.86199794
        ],
        [
            -234177631.30919516,
            -223226420.4642249,
            35227810.041913666
        ],
        [
            -226720250.62801754,
            -230264744.3873338,
            34534697.898395
        ],
        [
            -219073532.0306034,
            -237071330.68103123,
            33811550.04599978
        ],
        [
            -211244172.67628682,
            -243641793.0646634,
            33059047.56483554
        ],
        [
            -203238917.87001607,
            -249971916.35814208,
            32277882.571969345
        ],
        [
            -195064558.59961963,
            -256057653.51209763,
            31468757.832095798
        ],
        [
            -186727929.36054188,
            -261895122.74320194,
            30632386.406332683
        ],
        [
            -178235906.25446826,
            -267480604.78946504,
            29769491.33794205
        ],
        [
            -169595405.3479225,
            -272810540.2994198,
            28880805.37370709
        ],
        [
            -160813381.2766392,
            -277881527.36823505,
            27967070.719634093
        ],
        [
            -151896826.08125508,
            -282690319.23295486,
            27029038.829592396
        ],
        [
            -142852768.25962764,
            -287233822.1382611,
            26067470.225451685
        ],
        [
            -133688272.02088869,
            -291509093.383358,
            25083134.34722807
        ],
        [
            -124410436.72614327,
            -295513339.5598335,
            24076809.43170321
        ],
        [
            -115026396.50055158,
            -299243914.9896077,
            23049282.41793783
        ],
        [
            -105543320.0013717,
            -302698320.3713736,
            22001348.878059562
        ],
        [
            -95968410.32637303,
            -305874201.64324105,
            20933812.971664127
        ],
        [
            -86308905.0468951,
            -308769349.068622,
            19847487.422131635
        ],
        [
            -76572076.34966326,
            -311381696.55173445,
            18743193.51312026
        ]
    ],
    "(2024 YY8)": [
        [
            223400953.60692894,
            162763447.50789514,
            -27533523.11966508
        ],
        [
            218161236.62116265,
            169792228.40041846,
            -27288735.873572446
        ],
        [
            212731938.31908223,
            176676448.67946383,
            -27020345.291576143
        ],
        [
            207116168.72559145,
            183411931.9004476,
            -26728496.49946909
        ],
        [
            201317079.8755709,
            189994521.94753778,
            -26413339.420651365
        ],
        [
            195337868.90810215,
            196420080.1865928,
            -26075028.968882184
        ],
        [
            189181781.40957254,
            202684482.8450556,
            -25713725.273392588
        ],
        [
            182852114.99872172,
            208783618.629356,
            -25329593.93608072
        ],
        [
            176352223.1466319,
            214713386.59066677,
            -24922806.320516635
        ],
        [
            169685519.2245491,
            220469694.25020134,
            -24493539.872485217
        ],
        [
            162855480.7722323,
            226048455.9956034,
            -24041978.47179088
        ],
        [
            155865653.9792789,
            231445591.76038408,
            -23568312.815038785
        ],
        [
            148719658.37154296,
            236657025.9987826,
            -23072740.8290907
        ],
        [
            141421191.6943552,
            241678686.96887183,
            -22555468.114871223
        ],
        [
            133974034.983765,
            246506506.33718282,
            -22016708.421169337
        ],
        [
            126382057.81644453,
            251136419.11858934,
            -21456684.148041878
        ],
        [
            118649223.72822721,
            255564363.96565482,
            -20875626.8793783
        ],
        [
            110779595.79048811,
            259786283.82210106,
            -20273777.94412917
        ],
        [
            102777342.33270843,
            263798126.9555003,
            -19651389.00563394
        ],
        [
            94646742.79860155,
            267595848.38471264,
            -19008722.67840615
        ],
        [
            86392193.72210327,
            271175411.71797395,
            -18346053.17164495
        ],
        [
            78018214.80834845,
            274532791.41788995,
            -17663666.958640866
        ],
        [
            69529455.10346133,
            277663975.50987875,
            -16961863.471129972
        ],
        [
            60930699.235580996,
            280564968.7508388,
            -16240955.817523474
        ],
        [
            52226873.70802005,
            283231796.2749658,
            -15501271.523798833
        ],
        [
            43423053.22381714,
            285660507.7337153,
            -14743153.295683295
        ],
        [
            34524467.01919104,
            287847181.94686055,
            -13966959.800590161
        ],
        [
            25536505.181535408,
            289787932.08144784,
            -13173066.4675828
        ],
        [
            16464724.925614148,
            291478911.37516075,
            -12361866.303440008
        ],
        [
            7314856.799528778,
            292916319.42017156,
            -11533770.722679047
        ],
        [
            -1907189.2101623118,
            294096409.0229553,
            -10689210.38915953
        ],
        [
            -11195317.707083032,
            295015493.6547619,
            -9828636.066641752
        ],
        [
            -20543242.082721934,
            295669955.50645536,
            -8952519.475407965
        ],
        [
            -29944478.920902,
            296056254.1602247,
            -8061354.151773762
        ],
        [
            -39392342.64929955,
            296170935.8892329,
            -7155656.307020915
        ],
        [
            -48879940.480847955,
            296010643.59456426,
            -6235965.681972304
        ],
        [
            -58400167.69046746,
            295572127.3868602,
            -5302846.393105488
        ],
        [
            -67945703.27517818,
            294852255.81775534,
            -4356887.765765572
        ],
        [
            -77509006.04826526,
            293848027.7636435,
            -3398705.1496908115
        ],
        [
            -87082311.22073364,
            292556584.96138215,
            -2428940.711709163
        ],
        [
            -96657627.52579883,
            290975225.1922801,
            -1448264.2001015805
        ],
        [
            -106226734.94456676,
            289101416.1070825,
            -457373.6747618858
        ],
        [
            -115781183.09332997,
            286932809.680666,
            543003.8030838585
        ],
        [
            -125312290.335005,
            284467257.28076553,
            1552111.5282000545
        ],
        [
            -134811143.67912006,
            281702825.3302728,
            2569162.5626660343
        ],
        [
            -144268599.5363767,
            278637811.537471,
            3593339.208508949
        ],
        [
            -153675285.3951151,
            275270761.6629926,
            4623792.549283611
        ],
        [
            -163021602.487951,
            271600486.78632873,
            5659642.068548534
        ],
        [
            -172297729.51736364,
            267626081.0283719,
            6699975.353471352
        ],
        [
            -181493627.5090551,
            263346939.67977318,
            7743847.892048382
        ],
        [
            -190599045.86139065,
            258762777.67784768,
            8790282.97263448
        ],
        [
            -199603529.65812823,
            253873648.36741766,
            9838271.694644872
        ],
        [
            -208496428.30987623,
            248679962.47335857,
            10886773.099401942
        ],
        [
            -217266905.58722436,
            243182507.20478144,
            11934714.430149483
        ],
        [
            -225903951.10521948,
            237382465.4027763,
            12980991.53023763
        ],
        [
            -234396393.3147396,
            231281434.6355503,
            14024469.388384242
        ],
        [
            -242732914.05130777,
            224881446.1366676,
            15063982.839736175
        ],
        [
            -250902064.68593222,
            218184983.47404873,
            16098337.431178108
        ],
        [
            -258892283.91561794,
            211195000.82949036,
            17126310.45895971
        ],
        [
            -266691917.22323275,
            203914940.76084238,
            18146652.186227307
        ],
        [
            -274289238.0274085,
            196348751.31173244,
            19158087.247446757
        ],
        [
            -281672470.5330921,
            188500902.3269917,
            20159316.2459841
        ],
        [
            -288829814.28224844,
            180376400.8258335,
            21149017.550265692
        ],
        [
            -295749470.39205396,
            171980805.27950913,
            22125849.292965055
        ],
        [
            -302419669.4547541,
            163320238.63576227,
            23088451.57655856
        ],
        [
            -308828701.059233,
            154401399.9290567,
            24035448.887355305
        ],
        [
            -314964944.879326,
            145231574.31342676,
            24965452.71873869
        ],
        [
            -320816903.2580942,
            135818641.35402715,
            25877064.40286313
        ],
        [
            -326373235.2007791,
            126171081.41419157,
            26768878.148432814
        ],
        [
            -331622791.6721029,
            116297979.97717091,
            27639484.280459847
        ],
        [
            -336554652.0761298,
            106209029.74585687,
            28487472.67606567
        ],
        [
            -341158161.7792377,
            95914530.36978662,
            29311436.38846657
        ],
        [
            -345422970.51906466,
            85425385.65669233,
            30109975.44928635
        ],
        [
            -349339071.5248066,
            74753098.13585979,
            30881700.837285288
        ],
        [
            -352896841.1572004,
            63909760.85264456,
            31625238.599506382
        ],
        [
            -356087078.8601674,
            52908046.28769237,
            32339234.108739022
        ],
        [
            -358901047.2006909,
            41761192.31069434,
            33022356.43911557
        ],
        [
            -361330511.7593299,
            30482985.09685251,
            33673302.83961248
        ],
        [
            -363367780.6211014,
            19087738.9545393,
            34290803.28325721
        ],
        [
            -365005743.20557153,
            7590273.0348008275,
            34873625.06797313
        ],
        [
            -366237908.1661655,
            -3994115.082793653,
            35420577.44326252
        ],
        [
            -367058440.08215916,
            -15649678.908093572,
            35930516.23535988
        ],
        [
            -367462194.662844,
            -27360255.615629494,
            36402348.442121
        ],
        [
            -367444752.1821153,
            -39109301.60311973,
            36835036.76777365
        ],
        [
            -367002448.863461,
            -50879930.93086758,
            37227604.06677628
        ],
        [
            -366132405.94013065,
            -62654956.511076644,
            37579137.665435836
        ],
        [
            -364832556.12327814,
            -74416933.88752015,
            37888793.52965032
        ],
        [
            -363101667.2221343,
            -86148207.4178282,
            38155800.247185215
        ],
        [
            -360939362.67480385,
            -97830958.64330202,
            38379462.79328162
        ],
        [
            -358346138.7660389,
            -109447256.60503781,
            38559166.04913819
        ],
        [
            -355323378.3292213,
            -120979109.84066163,
            38694378.04391509
        ],
        [
            -351873360.75363386,
            -132408519.773538,
            38784652.89237547
        ],
        [
            -347999268.14469427,
            -143717535.18630186,
            38829633.40210096
        ],
        [
            -343705187.5139071,
            -154888307.45335004,
            38829053.32638259
        ],
        [
            -338996108.90651935,
            -165903146.19282368,
            38782739.24137485
        ],
        [
            -333877919.40790224,
            -176744574.98791802,
            38690612.02888669
        ],
        [
            -328357393.00408167,
            -187395386.82029983,
            38552687.94923615
        ],
        [
            -322442176.30719656,
            -197838698.85517332,
            38369079.29188002
        ],
        [
            -316140770.19247,
            -208058006.21824774,
            38139994.59500548
        ],
        [
            -309462507.42907184,
            -218037234.40956503,
            37865738.42889149
        ],
        [
            -302417526.4225248,
            -227760790.00784087,
            37546710.741566576
        ],
        [
            -295016741.22056496,
            -237213609.33158866,
            37183405.76905571
        ],
        [
            -287271807.9671347,
            -246381204.739664,
            36776410.516269706
        ],
        [
            -279195088.01999855,
            -255249708.27381188,
            36326402.81829564
        ],
        [
            -270799607.97589916,
            -263805912.3690198,
            35834148.9954433
        ],
        [
            -262099016.8728323,
            -272037307.38366765,
            35300501.11884199
        ],
        [
            -253107540.86156037,
            -279932115.73024726,
            34726393.90661733
        ],
        [
            -243839935.65763855,
            -287479322.4183726,
            34112841.273666434
        ],
        [
            -234311437.10074663,
            -294668701.85448265,
            33460932.560753044
        ],
        [
            -224537710.15985945,
            -301490840.7765776,
            32771828.47102915
        ],
        [
            -214534796.73064446,
            -307937157.2370357,
            32046756.744129896
        ],
        [
            -204319062.57541198,
            -313999915.581558,
            31287007.59966111
        ],
        [
            -193907143.75600636,
            -319672237.4070937,
            30493928.983192235
        ],
        [
            -183315892.90630597,
            -324948108.515744,
            29668921.64877094
        ],
        [
            -172562325.6836539,
            -329822381.9146982,
            28813434.112490598
        ],
        [
            -161663567.72778225,
            -334290776.94380116,
            27928957.511771835
        ],
        [
            -150636802.4418831,
            -338349874.6420281,
            27017020.404776663
        ],
        [
            -139499219.89370477,
            -341997109.4916241,
            26079183.54377432
        ],
        [
            -128267967.11527199,
            -345230757.70367223,
            25117034.6553455
        ],
        [
            -116960100.05836722,
            -348049922.23117197,
            24132183.259069808
        ],
        [
            -105592537.43967952,
            -350454514.71516097,
            23126255.55482282
        ],
        [
            -94182016.68487993,
            -352445234.58588445,
            22100889.40704459
        ],
        [
            -82745052.15523225,
            -354023545.5544466,
            21057729.452367302
        ],
        [
            -71297895.81405258,
            -355191649.74075794,
            19998422.354840934
        ],
        [
            -59856500.46377933,
            -355952459.6909457,
            18924612.230710644
        ],
        [
            -48436485.65793729,
            -356309568.54182065,
            17837936.26231285
        ],
        [
            -37053106.366217256,
            -356267218.5915943,
            16740020.518206175
        ],
        [
            -25721224.445535183,
            -355830268.53498554,
            15632475.994172245
        ],
        [
            -14455282.945545018,
            -355004159.61731684,
            14516894.88724137
        ],
        [
            -3269283.2539122105,
            -353794880.956396,
            13394847.112452373
        ],
        [
            7823234.935133606,
            -352208934.2731278,
            12267877.069667049
        ],
        [
            18809210.86564669,
            -350253298.2621489,
            11137500.665457578
        ],
        [
            29676077.233408093,
            -347935392.8225602,
            10005202.592887308
        ],
        [
            40411772.03990105,
            -345263043.3563136,
            8872433.869930046
        ],
        [
            51004747.87362626,
            -342244445.3282236,
            7740609.635338372
        ],
        [
            61443978.71860008,
            -338888129.2671668,
            6611107.198983617
        ],
        [
            71718964.40101469,
            -335202926.37303674,
            5485264.342062999
        ],
        [
            81819732.79434691,
            -331197934.878659,
            4364377.861105131
        ],
        [
            91736839.91072491,
            -326882487.3003326,
            3249702.348406147
        ],
        [
            101461368.01213907,
            -322266118.69515955,
            2142449.2003990114
        ],
        [
            110984921.87925379,
            -317358536.02800137,
            1043785.8444904741
        ],
        [
            120299623.37818818,
            -312169588.73592186,
            -45164.82590516284
        ],
        [
            129398104.4668292,
            -306709240.5634775,
            -1123324.8190574674
        ],
        [
            138273498.7821395,
            -300987542.7282864,
            -2189661.226763732
        ],
        [
            146919431.94861406,
            -295014608.4630766,
            -3243186.232135604
        ],
        [
            155330010.74570274,
            -288800588.96791786,
            -4282956.955355897
        ],
        [
            163499811.26872528,
            -282355650.7946647,
            -5308075.1495475415
        ],
        [
            171423866.21371776,
            -275689954.6748159,
            -6317686.758903258
        ],
        [
            179097651.41188398,
            -268813635.7920387,
            -7310981.351133592
        ],
        [
            186517071.73397195,
            -261736785.49155524,
            -8287191.436109936
        ],
        [
            193678446.4791099,
            -254469434.41041258,
            -9245591.682324354
        ],
        [
            200578494.3564722,
            -247021537.0053754,
            -10185498.04246338
        ],
        [
            207214318.16174695,
            -239402957.44874525,
            -11106266.7990148
        ],
        [
            213583389.24379385,
            -231623456.8568169,
            -12007293.540399043
        ],
        [
            219683531.85021812,
            -223692681.8108866,
            -12888012.077652542
        ],
        [
            225512907.43391228,
            -215620154.1266762,
            -13747893.311197244
        ],
        [
            231069998.99598077,
            -207415261.82472596,
            -14586444.056713782
        ],
        [
            236353595.5339458,
            -199087251.2516362,
            -15403205.838606969
        ],
        [
            241362776.65776053,
            -190645220.30001163,
            -16197753.659013482
        ],
        [
            246096897.42997766,
            -182098112.67348844,
            -16969694.749761015
        ],
        [
            250555573.48048472,
            -173454713.14227226,
            -17718667.314151682
        ],
        [
            254738666.4405191,
            -164723643.73414758,
            -18444339.26491084
        ],
        [
            258646269.73527175,
            -155913360.805847,
            -19146406.964124784
        ],
        [
            262278694.76927048,
            -147032152.93999863,
            -19824593.970485598
        ],
        [
            265636457.53391838,
            -138088139.61350995,
            -20478649.79867391
        ],
        [
            268720265.6620709,
            -129089270.58417428,
            -21108348.695243645
        ],
        [
            271531005.95034146,
            -120043325.94347031,
            -21713488.434924826
        ],
        [
            274069732.36595917,
            -110957916.78489503,
            -22293889.14083776
        ],
        [
            276337654.5514382,
            -101840486.43873025,
            -22849392.131710824
        ],
        [
            278336126.837057,
            -92698312.22583047,
            -23379858.798817724
        ],
        [
            280066637.768186,
            -83538507.6848061,
            -23885169.514998883
        ],
        [
            281530800.15181684,
            -74368025.22886385,
            -24365222.57780325
        ],
        [
            282730341.6242453,
            -65193659.19048011,
            -24819933.18848475
        ],
        [
            283667095.73970604,
            -56022049.2140495,
            -25249232.46830769
        ],
        [
            284342993.5778647,
            -46859683.95862293,
            -25653066.513359763
        ],
        [
            284760055.8663987,
            -37712905.07480101,
            -26031395.488838427
        ],
        [
            284920385.6134496,
            -28587911.421805978,
            -26384192.763564244
        ],
        [
            284826161.2434865,
            -19490763.49264331,
            -26711444.085285246
        ],
        [
            284479630.22905684,
            -10427388.017137095,
            -27013146.7971649
        ],
        [
            283883103.2100191,
            -1403582.7144090831,
            -27289309.095695157
        ],
        [
            283038948.5911311,
            7574978.831886992,
            -27539949.33014234
        ],
        [
            281949587.6082845,
            16502742.200602606,
            -27765095.343515888
        ],
        [
            280617489.8532352,
            25374267.085858032,
            -27964783.85494966
        ],
        [
            279045169.2463526,
            34184222.19747335,
            -28139059.883297823
        ],
        [
            277235180.44669485,
            42927380.12960918,
            -28287976.21167486
        ],
        [
            275190115.68859017,
            51598612.216826916,
            -28411592.89260805
        ],
        [
            272912602.0338737,
            60192883.39554371,
            -28509976.79342168
        ],
        [
            270405299.02895725,
            68705247.08772418,
            -28583201.18143342
        ],
        [
            267670896.75601375,
            77130840.12258476,
            -28631345.348513894
        ],
        [
            264712114.26770672,
            85464877.7111404,
            -28654494.274539523
        ],
        [
            261531698.39509332,
            93702648.48754412,
            -28652738.32925574
        ],
        [
            258132422.91856372,
            101839509.6303879,
            -28626173.012060937
        ],
        [
            254517088.0919372,
            109870882.07644778,
            -28574898.72922116
        ],
        [
            250688520.5101195,
            117792245.83873472,
            -28499020.608029928
        ],
        [
            246649573.3110186,
            125599135.4401995,
            -28398648.34743679
        ],
        [
            242403126.70271376,
            133287135.4739864,
            -28273896.104680073
        ],
        [
            237952088.80718124,
            140851876.30076754,
            -28124882.41747556
        ],
        [
            233299396.81216174,
            148289029.8934035,
            -27951730.16132957
        ],
        [
            228448018.42304838,
            155594305.8389503,
            -27754566.54156456
        ],
        [
            223400953.60692897,
            162763447.50789508,
            -27533523.11966508
        ]
    ],
    "(2024 YZ8)": [
        [
            223400953.60692894,
            162763447.50789514,
            -27533523.11966508
        ],
        [
            218161236.62116265,
            169792228.40041846,
            -27288735.873572446
        ],
        [
            212731938.31908223,
            176676448.67946383,
            -27020345.291576143
        ],
        [
            207116168.72559145,
            183411931.9004476,
            -26728496.49946909
        ],
        [
            201317079.8755709,
            189994521.94753778,
            -26413339.420651365
        ],
        [
            195337868.90810215,
            196420080.1865928,
            -26075028.968882184
        ],
        [
            189181781.40957254,
            202684482.8450556,
            -25713725.273392588
        ],
        [
            182852114.99872172,
            208783618.629356,
            -25329593.93608072
        ],
        [
            176352223.1466319,
            214713386.59066677,
            -24922806.320516635
        ],
        [
            169685519.2245491,
            220469694.25020134,
            -24493539.872485217
        ],
        [
            162855480.7722323,
            226048455.9956034,
            -24041978.47179088
        ],
        [
            155865653.9792789,
            231445591.76038408,
            -23568312.815038785
        ],
        [
            148719658.37154296,
            236657025.9987826,
            -23072740.8290907
        ],
        [
            141421191.6943552,
            241678686.96887183,
            -22555468.114871223
        ],
        [
            133974034.983765,
            246506506.33718282,
            -22016708.421169337
        ],
        [
            126382057.81644453,
            251136419.11858934,
            -21456684.148041878
        ],
        [
            118649223.72822721,
            255564363.96565482,
            -20875626.8793783
        ],
        [
            110779595.79048811,
            259786283.82210106,
            -20273777.94412917
        ],
        [
            102777342.33270843,
            263798126.9555003,
            -19651389.00563394
        ],
        [
            94646742.79860155,
            267595848.38471264,
            -19008722.67840615
        ],
        [
            86392193.72210327,
            271175411.71797395,
            -18346053.17164495
        ],
        [
            78018214.80834845,
            274532791.41788995,
            -17663666.958640866
        ],
        [
            69529455.10346133,
            277663975.50987875,
            -16961863.471129972
        ],
        [
            60930699.235580996,
            280564968.7508388,
            -16240955.817523474
        ],
        [
            52226873.70802005,
            283231796.2749658,
            -15501271.523798833
        ],
        [
            43423053.22381714,
            285660507.7337153,
            -14743153.295683295
        ],
        [
            34524467.01919104,
            287847181.94686055,
            -13966959.800590161
        ],
        [
            25536505.181535408,
            289787932.08144784,
            -13173066.4675828
        ],
        [
            16464724.925614148,
            291478911.37516075,
            -12361866.303440008
        ],
        [
            7314856.799528778,
            292916319.42017156,
            -11533770.722679047
        ],
        [
            -1907189.2101623118,
            294096409.0229553,
            -10689210.38915953
        ],
        [
            -11195317.707083032,
            295015493.6547619,
            -9828636.066641752
        ],
        [
            -20543242.082721934,
            295669955.50645536,
            -8952519.475407965
        ],
        [
            -29944478.920902,
            296056254.1602247,
            -8061354.151773762
        ],
        [
            -39392342.64929955,
            296170935.8892329,
            -7155656.307020915
        ],
        [
            -48879940.480847955,
            296010643.59456426,
            -6235965.681972304
        ],
        [
            -58400167.69046746,
            295572127.3868602,
            -5302846.393105488
        ],
        [
            -67945703.27517818,
            294852255.81775534,
            -4356887.765765572
        ],
        [
            -77509006.04826526,
            293848027.7636435,
            -3398705.1496908115
        ],
        [
            -87082311.22073364,
            292556584.96138215,
            -2428940.711709163
        ],
        [
            -96657627.52579883,
            290975225.1922801,
            -1448264.2001015805
        ],
        [
            -106226734.94456676,
            289101416.1070825,
            -457373.6747618858
        ],
        [
            -115781183.09332997,
            286932809.680666,
            543003.8030838585
        ],
        [
            -125312290.335005,
            284467257.28076553,
            1552111.5282000545
        ],
        [
            -134811143.67912006,
            281702825.3302728,
            2569162.5626660343
        ],
        [
            -144268599.5363767,
            278637811.537471,
            3593339.208508949
        ],
        [
            -153675285.3951151,
            275270761.6629926,
            4623792.549283611
        ],
        [
            -163021602.487951,
            271600486.78632873,
            5659642.068548534
        ],
        [
            -172297729.51736364,
            267626081.0283719,
            6699975.353471352
        ],
        [
            -181493627.5090551,
            263346939.67977318,
            7743847.892048382
        ],
        [
            -190599045.86139065,
            258762777.67784768,
            8790282.97263448
        ],
        [
            -199603529.65812823,
            253873648.36741766,
            9838271.694644872
        ],
        [
            -208496428.30987623,
            248679962.47335857,
            10886773.099401942
        ],
        [
            -217266905.58722436,
            243182507.20478144,
            11934714.430149483
        ],
        [
            -225903951.10521948,
            237382465.4027763,
            12980991.53023763
        ],
        [
            -234396393.3147396,
            231281434.6355503,
            14024469.388384242
        ],
        [
            -242732914.05130777,
            224881446.1366676,
            15063982.839736175
        ],
        [
            -250902064.68593222,
            218184983.47404873,
            16098337.431178108
        ],
        [
            -258892283.91561794,
            211195000.82949036,
            17126310.45895971
        ],
        [
            -266691917.22323275,
            203914940.76084238,
            18146652.186227307
        ],
        [
            -274289238.0274085,
            196348751.31173244,
            19158087.247446757
        ],
        [
            -281672470.5330921,
            188500902.3269917,
            20159316.2459841
        ],
        [
            -288829814.28224844,
            180376400.8258335,
            21149017.550265692
        ],
        [
            -295749470.39205396,
            171980805.27950913,
            22125849.292965055
        ],
        [
            -302419669.4547541,
            163320238.63576227,
            23088451.57655856
        ],
        [
            -308828701.059233,
            154401399.9290567,
            24035448.887355305
        ],
        [
            -314964944.879326,
            145231574.31342676,
            24965452.71873869
        ],
        [
            -320816903.2580942,
            135818641.35402715,
            25877064.40286313
        ],
        [
            -326373235.2007791,
            126171081.41419157,
            26768878.148432814
        ],
        [
            -331622791.6721029,
            116297979.97717091,
            27639484.280459847
        ],
        [
            -336554652.0761298,
            106209029.74585687,
            28487472.67606567
        ],
        [
            -341158161.7792377,
            95914530.36978662,
            29311436.38846657
        ],
        [
            -345422970.51906466,
            85425385.65669233,
            30109975.44928635
        ],
        [
            -349339071.5248066,
            74753098.13585979,
            30881700.837285288
        ],
        [
            -352896841.1572004,
            63909760.85264456,
            31625238.599506382
        ],
        [
            -356087078.8601674,
            52908046.28769237,
            32339234.108739022
        ],
        [
            -358901047.2006909,
            41761192.31069434,
            33022356.43911557
        ],
        [
            -361330511.7593299,
            30482985.09685251,
            33673302.83961248
        ],
        [
            -363367780.6211014,
            19087738.9545393,
            34290803.28325721
        ],
        [
            -365005743.20557153,
            7590273.0348008275,
            34873625.06797313
        ],
        [
            -366237908.1661655,
            -3994115.082793653,
            35420577.44326252
        ],
        [
            -367058440.08215916,
            -15649678.908093572,
            35930516.23535988
        ],
        [
            -367462194.662844,
            -27360255.615629494,
            36402348.442121
        ],
        [
            -367444752.1821153,
            -39109301.60311973,
            36835036.76777365
        ],
        [
            -367002448.863461,
            -50879930.93086758,
            37227604.06677628
        ],
        [
            -366132405.94013065,
            -62654956.511076644,
            37579137.665435836
        ],
        [
            -364832556.12327814,
            -74416933.88752015,
            37888793.52965032
        ],
        [
            -363101667.2221343,
            -86148207.4178282,
            38155800.247185215
        ],
        [
            -360939362.67480385,
            -97830958.64330202,
            38379462.79328162
        ],
        [
            -358346138.7660389,
            -109447256.60503781,
            38559166.04913819
        ],
        [
            -355323378.3292213,
            -120979109.84066163,
            38694378.04391509
        ],
        [
            -351873360.75363386,
            -132408519.773538,
            38784652.89237547
        ],
        [
            -347999268.14469427,
            -143717535.18630186,
            38829633.40210096
        ],
        [
            -343705187.5139071,
            -154888307.45335004,
            38829053.32638259
        ],
        [
            -338996108.90651935,
            -165903146.19282368,
            38782739.24137485
        ],
        [
            -333877919.40790224,
            -176744574.98791802,
            38690612.02888669
        ],
        [
            -328357393.00408167,
            -187395386.82029983,
            38552687.94923615
        ],
        [
            -322442176.30719656,
            -197838698.85517332,
            38369079.29188002
        ],
        [
            -316140770.19247,
            -208058006.21824774,
            38139994.59500548
        ],
        [
            -309462507.42907184,
            -218037234.40956503,
            37865738.42889149
        ],
        [
            -302417526.4225248,
            -227760790.00784087,
            37546710.741566576
        ],
        [
            -295016741.22056496,
            -237213609.33158866,
            37183405.76905571
        ],
        [
            -287271807.9671347,
            -246381204.739664,
            36776410.516269706
        ],
        [
            -279195088.01999855,
            -255249708.27381188,
            36326402.81829564
        ],
        [
            -270799607.97589916,
            -263805912.3690198,
            35834148.9954433
        ],
        [
            -262099016.8728323,
            -272037307.38366765,
            35300501.11884199
        ],
        [
            -253107540.86156037,
            -279932115.73024726,
            34726393.90661733
        ],
        [
            -243839935.65763855,
            -287479322.4183726,
            34112841.273666434
        ],
        [
            -234311437.10074663,
            -294668701.85448265,
            33460932.560753044
        ],
        [
            -224537710.15985945,
            -301490840.7765776,
            32771828.47102915
        ],
        [
            -214534796.73064446,
            -307937157.2370357,
            32046756.744129896
        ],
        [
            -204319062.57541198,
            -313999915.581558,
            31287007.59966111
        ],
        [
            -193907143.75600636,
            -319672237.4070937,
            30493928.983192235
        ],
        [
            -183315892.90630597,
            -324948108.515744,
            29668921.64877094
        ],
        [
            -172562325.6836539,
            -329822381.9146982,
            28813434.112490598
        ],
        [
            -161663567.72778225,
            -334290776.94380116,
            27928957.511771835
        ],
        [
            -150636802.4418831,
            -338349874.6420281,
            27017020.404776663
        ],
        [
            -139499219.89370477,
            -341997109.4916241,
            26079183.54377432
        ],
        [
            -128267967.11527199,
            -345230757.70367223,
            25117034.6553455
        ],
        [
            -116960100.05836722,
            -348049922.23117197,
            24132183.259069808
        ],
        [
            -105592537.43967952,
            -350454514.71516097,
            23126255.55482282
        ],
        [
            -94182016.68487993,
            -352445234.58588445,
            22100889.40704459
        ],
        [
            -82745052.15523225,
            -354023545.5544466,
            21057729.452367302
        ],
        [
            -71297895.81405258,
            -355191649.74075794,
            19998422.354840934
        ],
        [
            -59856500.46377933,
            -355952459.6909457,
            18924612.230710644
        ],
        [
            -48436485.65793729,
            -356309568.54182065,
            17837936.26231285
        ],
        [
            -37053106.366217256,
            -356267218.5915943,
            16740020.518206175
        ],
        [
            -25721224.445535183,
            -355830268.53498554,
            15632475.994172245
        ],
        [
            -14455282.945545018,
            -355004159.61731684,
            14516894.88724137
        ],
        [
            -3269283.2539122105,
            -353794880.956396,
            13394847.112452373
        ],
        [
            7823234.935133606,
            -352208934.2731278,
            12267877.069667049
        ],
        [
            18809210.86564669,
            -350253298.2621489,
            11137500.665457578
        ],
        [
            29676077.233408093,
            -347935392.8225602,
            10005202.592887308
        ],
        [
            40411772.03990105,
            -345263043.3563136,
            8872433.869930046
        ],
        [
            51004747.87362626,
            -342244445.3282236,
            7740609.635338372
        ],
        [
            61443978.71860008,
            -338888129.2671668,
            6611107.198983617
        ],
        [
            71718964.40101469,
            -335202926.37303674,
            5485264.342062999
        ],
        [
            81819732.79434691,
            -331197934.878659,
            4364377.861105131
        ],
        [
            91736839.91072491,
            -326882487.3003326,
            3249702.348406147
        ],
        [
            101461368.01213907,
            -322266118.69515955,
            2142449.2003990114
        ],
        [
            110984921.87925379,
            -317358536.02800137,
            1043785.8444904741
        ],
        [
            120299623.37818818,
            -312169588.73592186,
            -45164.82590516284
        ],
        [
            129398104.4668292,
            -306709240.5634775,
            -1123324.8190574674
        ],
        [
            138273498.7821395,
            -300987542.7282864,
            -2189661.226763732
        ],
        [
            146919431.94861406,
            -295014608.4630766,
            -3243186.232135604
        ],
        [
            155330010.74570274,
            -288800588.96791786,
            -4282956.955355897
        ],
        [
            163499811.26872528,
            -282355650.7946647,
            -5308075.1495475415
        ],
        [
            171423866.21371776,
            -275689954.6748159,
            -6317686.758903258
        ],
        [
            179097651.41188398,
            -268813635.7920387,
            -7310981.351133592
        ],
        [
            186517071.73397195,
            -261736785.49155524,
            -8287191.436109936
        ],
        [
            193678446.4791099,
            -254469434.41041258,
            -9245591.682324354
        ],
        [
            200578494.3564722,
            -247021537.0053754,
            -10185498.04246338
        ],
        [
            207214318.16174695,
            -239402957.44874525,
            -11106266.7990148
        ],
        [
            213583389.24379385,
            -231623456.8568169,
            -12007293.540399043
        ],
        [
            219683531.85021812,
            -223692681.8108866,
            -12888012.077652542
        ],
        [
            225512907.43391228,
            -215620154.1266762,
            -13747893.311197244
        ],
        [
            231069998.99598077,
            -207415261.82472596,
            -14586444.056713782
        ],
        [
            236353595.5339458,
            -199087251.2516362,
            -15403205.838606969
        ],
        [
            241362776.65776053,
            -190645220.30001163,
            -16197753.659013482
        ],
        [
            246096897.42997766,
            -182098112.67348844,
            -16969694.749761015
        ],
        [
            250555573.48048472,
            -173454713.14227226,
            -17718667.314151682
        ],
        [
            254738666.4405191,
            -164723643.73414758,
            -18444339.26491084
        ],
        [
            258646269.73527175,
            -155913360.805847,
            -19146406.964124784
        ],
        [
            262278694.76927048,
            -147032152.93999863,
            -19824593.970485598
        ],
        [
            265636457.53391838,
            -138088139.61350995,
            -20478649.79867391
        ],
        [
            268720265.6620709,
            -129089270.58417428,
            -21108348.695243645
        ],
        [
            271531005.95034146,
            -120043325.94347031,
            -21713488.434924826
        ],
        [
            274069732.36595917,
            -110957916.78489503,
            -22293889.14083776
        ],
        [
            276337654.5514382,
            -101840486.43873025,
            -22849392.131710824
        ],
        [
            278336126.837057,
            -92698312.22583047,
            -23379858.798817724
        ],
        [
            280066637.768186,
            -83538507.6848061,
            -23885169.514998883
        ],
        [
            281530800.15181684,
            -74368025.22886385,
            -24365222.57780325
        ],
        [
            282730341.6242453,
            -65193659.19048011,
            -24819933.18848475
        ],
        [
            283667095.73970604,
            -56022049.2140495,
            -25249232.46830769
        ],
        [
            284342993.5778647,
            -46859683.95862293,
            -25653066.513359763
        ],
        [
            284760055.8663987,
            -37712905.07480101,
            -26031395.488838427
        ],
        [
            284920385.6134496,
            -28587911.421805978,
            -26384192.763564244
        ],
        [
            284826161.2434865,
            -19490763.49264331,
            -26711444.085285246
        ],
        [
            284479630.22905684,
            -10427388.017137095,
            -27013146.7971649
        ],
        [
            283883103.2100191,
            -1403582.7144090831,
            -27289309.095695157
        ],
        [
            283038948.5911311,
            7574978.831886992,
            -27539949.33014234
        ],
        [
            281949587.6082845,
            16502742.200602606,
            -27765095.343515888
        ],
        [
            280617489.8532352,
            25374267.085858032,
            -27964783.85494966
        ],
        [
            279045169.2463526,
            34184222.19747335,
            -28139059.883297823
        ],
        [
            277235180.44669485,
            42927380.12960918,
            -28287976.21167486
        ],
        [
            275190115.68859017,
            51598612.216826916,
            -28411592.89260805
        ],
        [
            272912602.0338737,
            60192883.39554371,
            -28509976.79342168
        ],
        [
            270405299.02895725,
            68705247.08772418,
            -28583201.18143342
        ],
        [
            267670896.75601375,
            77130840.12258476,
            -28631345.348513894
        ],
        [
            264712114.26770672,
            85464877.7111404,
            -28654494.274539523
        ],
        [
            261531698.39509332,
            93702648.48754412,
            -28652738.32925574
        ],
        [
            258132422.91856372,
            101839509.6303879,
            -28626173.012060937
        ],
        [
            254517088.0919372,
            109870882.07644778,
            -28574898.72922116
        ],
        [
            250688520.5101195,
            117792245.83873472,
            -28499020.608029928
        ],
        [
            246649573.3110186,
            125599135.4401995,
            -28398648.34743679
        ],
        [
            242403126.70271376,
            133287135.4739864,
            -28273896.104680073
        ],
        [
            237952088.80718124,
            140851876.30076754,
            -28124882.41747556
        ],
        [
            233299396.81216174,
            148289029.8934035,
            -27951730.16132957
        ],
        [
            228448018.42304838,
            155594305.8389503,
            -27754566.54156456
        ],
        [
            223400953.60692897,
            162763447.50789508,
            -27533523.11966508
        ]
    ],
    "(2024 YJ9)": [
        [
            82354958.1618789,
            302537156.5077198,
            3134074.4937036675
        ],
        [
            72809020.37107688,
            304981549.39957064,
            4090140.759099153
        ],
        [
            63196355.75272572,
            307155702.5477673,
            5042784.411884376
        ],
        [
            53523370.8881527,
            309058026.7760242,
            5991365.611142328
        ],
        [
            43796502.85820001,
            310687023.9499462,
            6935244.938028907
        ],
        [
            34022222.08401721,
            312041287.0700354,
            7873783.140111195
        ],
        [
            24207035.207163453,
            313119500.69835585,
            8806340.88385785
        ],
        [
            14357487.992572911,
            313920441.72227466,
            9732278.516900938
        ],
        [
            4480168.237689182,
            314442980.45842355,
            10650955.841701388
        ],
        [
            -5418291.329214588,
            314686082.09975135,
            11561731.902267063
        ],
        [
            -15331210.178848758,
            314648808.50822693,
            12463964.785592016
        ],
        [
            -25251857.156550705,
            314330320.35542846,
            13357011.439508684
        ],
        [
            -35173447.721876115,
            313729879.61289084,
            14240227.508670166
        ],
        [
            -45089141.27071802,
            312846852.3936808,
            15112967.190407837
        ],
        [
            -54992038.559033364,
            311680712.14622325,
            15974583.11223936
        ],
        [
            -64875179.247795075,
            310231043.200905,
            16824426.232833795
        ],
        [
            -74731539.58935799,
            308497544.6694222,
            17661845.768272616
        ],
        [
            -84554030.27602695,
            306480034.69621783,
            18486189.14547867
        ],
        [
            -94335494.47224472,
            304178455.06066376,
            19296801.98471772
        ],
        [
            -104068706.05246237,
            301592876.12786806,
            20093028.11310916
        ],
        [
            -113746368.06742072,
            298723502.1451359,
            20874209.611112975
        ],
        [
            -123361111.46224426,
            295570676.8801678,
            21639686.89398823
        ],
        [
            -132905494.07042585,
            292134889.59603554,
            22388798.83024329
        ],
        [
            -142371999.9084521,
            288416781.35683346,
            23120882.89911917
        ],
        [
            -151753038.79647762,
            284417151.6566523,
            23835275.389163192
        ],
        [
            -161040946.33109468,
            280136965.36315507,
            24531311.63996039
        ],
        [
            -170227984.23684618,
            275577359.96555525,
            25208326.329092838
        ],
        [
            -179306341.12369233,
            270739653.1151886,
            25865653.80639174
        ],
        [
            -188268133.67814624,
            265625350.44514173,
            26502628.47753234
        ],
        [
            -197105408.31622893,
            260236153.65353924,
            27118585.238995988
        ],
        [
            -205810143.3267505,
            254573968.83309984,
            27712859.966386106
        ],
        [
            -214374251.53368118,
            248640915.02744907,
            28284790.058033407
        ],
        [
            -222789583.5065204,
            242439332.99242258,
            28833715.035759944
        ],
        [
            -231047931.34758848,
            235971794.13820618,
            29358977.204588752
        ],
        [
            -239141033.0850354,
            229241109.6256469,
            29859922.37308581
        ],
        [
            -247060577.70006323,
            222250339.58743268,
            30335900.63590124
        ],
        [
            -254798210.81638432,
            215002802.44208437,
            30786267.21993622
        ],
        [
            -262345541.07925057,
            207502084.26584095,
            31210383.3953993
        ],
        [
            -269694147.2504898,
            199752048.18455637,
            31607617.452829167
        ],
        [
            -276835586.04483443,
            191756843.74468228,
            31977345.746949248
        ],
        [
            -283761400.73142105,
            183520916.21928692,
            32318953.807981383
        ],
        [
            -290463130.5226463,
            175049015.8018921,
            32631837.520779885
        ],
        [
            -296932320.7705703,
            166346206.63770252,
            32915404.37185307
        ],
        [
            -303160533.98874414,
            157417875.63858706,
            33169074.764014788
        ],
        [
            -309139361.71468586,
            148269741.02496994,
            33392283.398054745
        ],
        [
            -314860437.2252177,
            138907860.53463832,
            33584480.72043047
        ],
        [
            -320315449.11350214,
            129338639.23539454,
            33745134.43556835
        ],
        [
            -325496155.73285383,
            119568836.87551738,
            33873731.0809138
        ],
        [
            -330394400.50824916,
            109605574.70318842,
            33969777.66239343
        ],
        [
            -335002128.1119097,
            99456341.6834166,
            34032803.34744516
        ],
        [
            -339311401.49437594,
            89129000.03861806,
            34062361.21223692
        ],
        [
            -343314419.75714076,
            78631790.03690878,
            34058030.03913302
        ],
        [
            -347003536.84715503,
            67973333.95040548,
            34019416.15988109
        ],
        [
            -350371281.0473887,
            57162639.104454696,
            33946155.33938463
        ],
        [
            -353410375.2311197,
            46209099.937765755,
            33837914.69430048
        ],
        [
            -356113757.84077555,
            35122498.99297849,
            33694394.640059985
        ],
        [
            -358474604.54497784,
            23913006.757290453,
            33515330.859262384
        ],
        [
            -360486350.5199854,
            12591180.273463428,
            33300496.28373383
        ],
        [
            -362142713.2940343,
            1167960.4428786635,
            33049703.08189127
        ],
        [
            -363437716.0851874,
            -10345332.055642039,
            32762804.642403655
        ],
        [
            -364365711.555277,
            -21937002.30473374,
            32439697.544509754
        ],
        [
            -364921405.8944419,
            -33594988.21499097,
            32080323.504741278
        ],
        [
            -365099883.142661,
            -45306869.18454014,
            31684671.289217893
        ],
        [
            -364896629.6466913,
            -57059876.411852375,
            31252778.580137607
        ],
        [
            -364307558.5429743,
            -68840904.91578452,
            30784733.784589067
        ],
        [
            -363329034.1495111,
            -80636527.30974737,
            30280677.773371883
        ],
        [
            -361957896.1424935,
            -92433009.36889338,
            29740805.537135333
        ],
        [
            -360191483.38674116,
            -104216327.42030069,
            29165367.746845305
        ],
        [
            -358027657.2828259,
            -115972187.576315,
            28554672.205372218
        ],
        [
            -355464824.4882836,
            -127686046.8205341,
            27909085.17686875
        ],
        [
            -352501958.8656329,
            -139343135.94440323,
            27229032.580584332
        ],
        [
            -349138622.50613916,
            -150928484.32011774,
            26515001.03585051
        ],
        [
            -345374985.6755055,
            -162426946.4825443,
            25767538.74517695
        ],
        [
            -341211845.52603537,
            -173823230.47927368,
            24987256.202726267
        ],
        [
            -336650643.41938895,
            -185101927.93381256,
            24174826.715894215
        ],
        [
            -331693480.70495474,
            -196247545.75240117,
            23330986.728313852
        ],
        [
            -326343132.80113333,
            -207244539.3901663,
            22456535.93332981
        ],
        [
            -320603061.430576,
            -218077347.57740155,
            21552337.16785471
        ],
        [
            -314477424.86566997,
            -228730428.3918835,
            20619316.0775217
        ],
        [
            -307971086.04736054,
            -239188296.5484273,
            19658460.54518398
        ],
        [
            -301089618.4487628,
            -249435561.76255834,
            18670819.876078293
        ],
        [
            -293839309.564942,
            -259456968.03137505,
            17657503.734359488
        ],
        [
            -286227161.9217073,
            -269237433.66162014,
            16619680.827217735
        ],
        [
            -278260891.5092187,
            -278762091.8628133,
            15558577.334398398
        ],
        [
            -269948923.5605932,
            -288016331.71224135,
            14475475.082645018
        ],
        [
            -261300385.61140597,
            -296985839.2888099,
            13371709.466361925
        ],
        [
            -252325097.79291597,
            -305656638.76440465,
            12248667.117630495
        ],
        [
            -243033560.32984948,
            -314015133.23466575,
            11107783.330591286
        ],
        [
            -233436938.2325021,
            -322048145.0660626,
            9950539.247105839
        ],
        [
            -223547043.19258103,
            -329742955.5330181,
            8778458.8125145
        ],
        [
            -213376312.71241406,
            -337087343.5176553,
            7593105.512189364
        ],
        [
            -202937786.5176785,
            -344069623.0456307,
            6396078.901421466
        ],
        [
            -192245080.32444018,
            -350678679.43449855,
            5189010.942957086
        ],
        [
            -181312357.05178687,
            -356904003.8361856,
            3973562.1681858026
        ],
        [
            -170154295.59147,
            -362735725.962411,
            2751417.6795623186
        ],
        [
            -158786057.26548257,
            -368164644.79125196,
            1524283.013293427
        ],
        [
            -147223250.1211575,
            -373182257.06445444,
            293879.88262104103
        ],
        [
            -135481891.23095343,
            -377780783.3984389,
            -938058.1768347239
        ],
        [
            -123578367.1803591,
            -381953191.847126,
            -2169790.237259639
        ],
        [
            -111529392.94210796,
            -385693218.7715532,
            -3399572.4611910465
        ],
        [
            -99351969.34795135,
            -388995386.88960344,
            -4625662.612714789
        ],
        [
            -87063339.38042463,
            -391855020.39881754,
            -5846324.573274584
        ],
        [
            -74680943.51622719,
            -394268257.085989,
            -7059832.837946763
        ],
        [
            -62222374.35988928,
            -396232057.35882044,
            -8264476.968149427
        ],
        [
            -49705330.81125481,
            -397744210.1570948,
            -9458565.977092443
        ],
        [
            -37147572.01289996,
            -398803335.72333235,
            -10640432.624830414
        ],
        [
            -24566871.3239163,
            -399408885.23550296,
            -11808437.600547528
        ],
        [
            -11980970.564533845,
            -399561137.32678324,
            -12960973.57066971
        ],
        [
            592465.2281321585,
            -399261191.5393361,
            -14096469.072554931
        ],
        [
            13135892.299264252,
            -398510958.7803904,
            -15213392.234839235
        ],
        [
            25631931.704900667,
            -397313148.86929554,
            -16310254.306998499
        ],
        [
            38063411.65462808,
            -395671255.2834801,
            -17385612.982303035
        ],
        [
            50413408.46525459,
            -393589537.2291745,
            -18438075.50007467
        ],
        [
            62665285.935982585,
            -391072999.17918944,
            -19466301.514979925
        ],
        [
            74802732.9706873,
            -388127368.0348107,
            -20469005.72298778
        ],
        [
            86809799.28918466,
            -384759068.08187604,
            -21444960.235561203
        ],
        [
            98670929.08662899,
            -380975193.92222726,
            -22392996.695616346
        ],
        [
            110370992.51820676,
            -376783481.57092416,
            -23312008.130749293
        ],
        [
            121895314.90483664,
            -372192277.91683024,
            -24200950.5411748
        ],
        [
            133229703.57445656,
            -367210508.7494138,
            -25058844.2217254
        ],
        [
            144360472.27242935,
            -361847645.55788016,
            -25884774.819101818
        ],
        [
            155274463.0934369,
            -356113671.3101004,
            -26677894.127329946
        ],
        [
            165959065.90574646,
            -350019045.41828966,
            -27437420.62604943
        ],
        [
            176402235.25675425,
            -343574668.09611255,
            -28162639.76782117
        ],
        [
            186592504.76604098,
            -336791844.30795413,
            -28852904.02208232
        ],
        [
            196518999.02869642,
            -329682247.50561106,
            -29507632.68469032
        ],
        [
            206171443.06721798,
            -322257883.34077907,
            -30126311.463172805
        ],
        [
            215540169.38477284,
            -314531053.53356874,
            -30708491.848834045
        ],
        [
            224616122.68592995,
            -306514320.06803805,
            -31253790.287757196
        ],
        [
            233390862.343037,
            -298220469.87554514,
            -31761887.16348352
        ],
        [
            241856562.69721937,
            -289662480.1557441,
            -32232525.60474814
        ],
        [
            250006011.29242942,
            -280853484.47345245,
            -32665510.132105548
        ],
        [
            257832605.14910656,
            -271806739.7575574,
            -33060705.157594956
        ],
        [
            265330345.19080785,
            -262535594.31573045,
            -33418033.351779632
        ],
        [
            272493828.94263893,
            -253053456.96618372,
            -33737473.89255167
        ],
        [
            279318241.6245279,
            -243373767.3750961,
            -34019060.61003448
        ],
        [
            285799345.76534617,
            -233509967.67584592,
            -34262880.04174591
        ],
        [
            291933469.46567416,
            -223475475.43389705,
            -34469069.41191598
        ],
        [
            297717493.43770796,
            -213283658.00919348,
            -34637814.548495315
        ],
        [
            303148836.9504438,
            -202947808.3563535,
            -34769347.75095079
        ],
        [
            308225442.8070011,
            -192481122.29184592,
            -34863945.62143771
        ],
        [
            312945761.47877324,
            -181896677.24679288,
            -34921926.8713698
        ],
        [
            317308734.5181646,
            -171207412.51410693,
            -34943650.11479091
        ],
        [
            321313777.368055,
            -160426110.98936927,
            -34929511.65929629
        ],
        [
            324960761.68189895,
            -149565382.39626488,
            -34879943.30456259
        ],
        [
            328249997.26364946,
            -138637647.97947186,
            -34795410.15783765
        ],
        [
            331182213.7315261,
            -127655126.64072514,
            -34676408.47501729
        ],
        [
            333758542.00415504,
            -116629822.48730923,
            -34523463.53520837
        ],
        [
            335980495.7018424,
            -105573513.7564717,
            -34337127.55594907
        ],
        [
            337849952.54978234,
            -94497743.0742162,
            -34117977.65553712
        ],
        [
            339369135.8639297,
            -83413809.00255048,
            -33866613.86820932
        ],
        [
            340540596.19412583,
            -72332758.825578,
            -33583657.21722572
        ],
        [
            341367193.19293046,
            -61265382.52173125,
            -33269747.850244556
        ],
        [
            341852077.77252305,
            -50222207.86698118,
            -32925543.24073184
        ],
        [
            341998674.6060496,
            -39213496.61194665,
            -32551716.458536755
        ],
        [
            341810665.02393436,
            -28249241.674433157,
            -32148954.512181204
        ],
        [
            341291970.3499965,
            -17339165.2880508,
            -31717956.76486311
        ],
        [
            340446735.71673506,
            -6492718.047096863,
            -31259433.425657626
        ],
        [
            339279314.39388686,
            4280921.212141648,
            -30774104.11692004
        ],
        [
            337794252.65936136,
            14972844.753182203,
            -30262696.518449903
        ],
        [
            335996275.2369068,
            25574414.563107997,
            -29725945.088565692
        ],
        [
            333890271.3203916,
            36077260.31620307,
            -29164589.861865662
        ],
        [
            331481281.2003863,
            46473276.73418322,
            -28579375.323109686
        ],
        [
            328774483.50482684,
            56754620.39831483,
            -27971049.356351238
        ],
        [
            325775183.0619069,
            66913706.067109495,
            -27340362.268173717
        ],
        [
            322488799.39000463,
            76943202.55153318,
            -26688065.88364262
        ],
        [
            318920855.81638354,
            86836028.19777422,
            -26014912.713371765
        ],
        [
            315076969.22360396,
            96585346.02564782,
            -25321655.18991587
        ],
        [
            310962840.42005384,
            106184558.56865868,
            -24609044.971543476
        ],
        [
            306584245.1287234,
            115627302.45964433,
            -23877832.311309785
        ],
        [
            301947025.5863076,
            124907442.80380611,
            -23128765.489237536
        ],
        [
            297057082.74291456,
            134019067.37878826,
            -22362590.305324975
        ],
        [
            291920369.0510628,
            142956480.69935253,
            -21580049.63102862
        ],
        [
            286542881.8312653,
            151714197.98208773,
            -20781883.01681678
        ],
        [
            280930657.20030534,
            160286939.0435264,
            -19968826.353353497
        ],
        [
            275089764.54728174,
            168669622.16303143,
            -19141611.58384968
        ],
        [
            269026301.54166037,
            176857357.93984103,
            -18300966.4651111
        ],
        [
            262746389.65684998,
            184845443.17177945,
            -17447614.374813437
        ],
        [
            256256170.19226882,
            192629354.7812993,
            -16582274.16254912
        ],
        [
            249561800.77641457,
            200204743.81278908,
            -15705660.042210225
        ],
        [
            242669452.3331255,
            207567429.5234011,
            -14818481.52330115
        ],
        [
            235585306.49299157,
            214713393.5880722,
            -13921443.3788096
        ],
        [
            228315553.4317235,
            221638774.43791896,
            -13015245.647303037
        ],
        [
            220866390.11723214,
            228339861.74976468,
            -12100583.666962847
        ],
        [
            213244018.94715947,
            234813091.1032399,
            -11178148.139313651
        ],
        [
            205454646.75866592,
            241055038.8206548,
            -10248625.220454816
        ],
        [
            197504484.1923777,
            247062417.0036806,
            -9312696.63765097
        ],
        [
            189399745.39253443,
            252832068.77981782,
            -8371039.8291881215
        ],
        [
            181146648.02555323,
            258360963.7706231,
            -7424328.1054532835
        ],
        [
            172751413.59940392,
            263646193.79276153,
            -6473230.829243809
        ],
        [
            164220268.0664029,
            268684968.8021089,
            -5518413.613361377
        ],
        [
            155559442.69223917,
            273474613.0903561,
            -4560538.533591835
        ],
        [
            146775175.1742528,
            278012561.74287415,
            -3600264.3552150205
        ],
        [
            137873710.992201,
            282296357.36595035,
            -2638246.7712313547
        ],
        [
            128861304.97493061,
            286323647.0909368,
            -1675138.6505285655
        ],
        [
            119744223.06656241,
            290092179.86231846,
            -711590.2942477525
        ],
        [
            110528744.27595302,
            293599804.0162384,
            251750.3013608395
        ],
        [
            101221162.79332553,
            296844465.15558743,
            1214237.1772754272
        ],
        [
            91827790.2580828,
            299824204.3273715,
            2175226.140891745
        ],
        [
            82354958.16187897,
            302537156.5077198,
            3134074.49370366
        ]
    ],
    "(2024 YV10)": [
        [
            -234382219.88190532,
            -348323287.6643636,
            -20534349.221586525
        ],
        [
            -223295006.09312162,
            -355591726.84309983,
            -19920589.222039197
        ],
        [
            -212004709.57361552,
            -362541605.06793135,
            -19288784.74713728
        ],
        [
            -200519211.17586195,
            -369167877.2848335,
            -18639373.88897539
        ],
        [
            -188846483.35045475,
            -375465626.2768506,
            -17972802.639764242
        ],
        [
            -176994592.5749188,
            -381430062.2307591,
            -17289525.043736268
        ],
        [
            -164971701.94818905,
            -387056522.67263013,
            -16590003.365413196
        ],
        [
            -152786073.9304819,
            -392340472.7833413,
            -15874708.273079418
        ],
        [
            -140446073.2078033,
            -397277506.1045966,
            -15144119.036266297
        ],
        [
            -127960169.65981895,
            -401863345.6455316,
            -14398723.736011403
        ],
        [
            -115336941.40924886,
            -406093845.3994695,
            -13639019.486612272
        ],
        [
            -102585077.93034776,
            -409964992.27987576,
            -12865512.667547312
        ],
        [
            -89713383.19338602,
            -413472908.48399794,
            -12078719.1641857
        ],
        [
            -76730778.8213585,
            -416613854.292094,
            -11279164.615854714
        ],
        [
            -63646307.234420985,
            -419384231.3095168,
            -10467384.669775765
        ],
        [
            -50469134.75678572,
            -421780586.158243,
            -9643925.239319997
        ],
        [
            -37208554.66000062,
            -423799614.6236937,
            -8809342.764970718
        ],
        [
            -23873990.11569637,
            -425438166.26188487,
            -7964204.476312796
        ],
        [
            -10474997.030013293,
            -426693249.4710731,
            -7109088.653299037
        ],
        [
            2978733.2689813673,
            -427562037.0310929,
            -6244584.884970419
        ],
        [
            16477371.520496398,
            -428041872.112535,
            -5371294.323730912
        ],
        [
            30010948.22739038,
            -428130274.75676906,
            -4489829.933199286
        ],
        [
            43569351.59121561,
            -427824948.82655406,
            -3600816.7275792547
        ],
        [
            57142325.71838373,
            -427123789.4256204,
            -2704892.0004068445
        ],
        [
            70719469.13084781,
            -426024890.7841177,
            -1802705.540449893
        ],
        [
            84290233.61562803,
            -424526554.6052103,
            -894919.8324494138
        ],
        [
            97843923.44840723,
            -422627298.8663556,
            17789.75969230756
        ],
        [
            111369695.02729058,
            -420325867.0669134,
            934734.8297571037
        ],
        [
            124856556.95363644,
            -417621237.911705,
            1855213.78865356
        ],
        [
            138293370.59761122,
            -414512635.4179555,
            2778511.749102287
        ],
        [
            151668851.18679735,
            -410999539.4307231,
            3703900.438288316
        ],
        [
            164971569.4567497,
            -407081696.5294229,
            4630638.141279722
        ],
        [
            178189953.9028611,
            -402759131.3054081,
            5557969.678081712
        ],
        [
            191312293.67322546,
            -398032157.9877605,
            6485126.417259108
        ],
        [
            204326742.14236698,
            -392901392.3914803,
            7411326.329116594
        ],
        [
            217221321.20571065,
            -387367764.1591464,
            8335774.081473412
        ],
        [
            229983926.33449137,
            -381432529.26384866,
            9257661.181106847
        ],
        [
            242602332.4303981,
            -375097282.73778707,
            10176166.16396401
        ],
        [
            255064200.51862305,
            -368363971.5873822,
            11090454.837254073
        ],
        [
            267357085.31709474,
            -361234907.85208404,
            11999680.576529916
        ],
        [
            279468443.7185037,
            -353712781.76027954,
            12902984.680849092
        ],
        [
            291385644.22025985,
            -345800674.9318442,
            13799496.78906588
        ],
        [
            303095977.335713,
            -337502073.5729332,
            14688335.360248141
        ],
        [
            314586667.0178263,
            -328820881.60462713,
            15568608.22113251
        ],
        [
            325844883.12396866,
            -319761433.66302717,
            16439413.18342783
        ],
        [
            336857754.94757986,
            -310328507.9043901,
            17299838.733646702
        ],
        [
            347612385.8391491,
            -300527338.5449208,
            18148964.797988933
        ],
        [
            358095868.9351967,
            -290363628.06093997,
            18985863.58461464
        ],
        [
            368295304.00976425,
            -279843558.97135895,
            19809600.505428914
        ],
        [
            378197815.4582839,
            -268973805.1207563,
            20619235.179252308
        ],
        [
            387790571.418596,
            -257761542.37791982,
            21413822.51797038
        ],
        [
            397060804.0283257,
            -246214458.66152424,
            22192413.896940984
        ],
        [
            405995830.8118041,
            -234340763.20172837,
            22954058.410588533
        ],
        [
            414583077.18323404,
            -222149194.94393563,
            23697804.213729512
        ],
        [
            422810100.04586565,
            -209649029.99882585,
            24422699.948753506
        ],
        [
            430664612.45958596,
            -196850088.04110402,
            25127796.258328747
        ],
        [
            438134509.34154445,
            -183762737.55825812,
            25812147.382810913
        ],
        [
            445207894.1562836,
            -170397899.85005388,
            26474812.84101082
        ],
        [
            451873106.5433392,
            -156767051.67956454,
            27114859.19242043
        ],
        [
            458118750.82147086,
            -142882226.47729877,
            27731361.878411252
        ],
        [
            463933725.2996317,
            -128756014.00150177,
            28323407.13930563
        ],
        [
            469307252.31553805,
            -114401558.36002675,
            28890094.003583454
        ],
        [
            474228908.9133332,
            -99832554.30233243,
            29430536.34482804
        ],
        [
            478688658.062418,
            -85063241.69422486,
            29943865.001339477
        ],
        [
            482676880.31013536,
            -70108398.09294903,
            30429229.952656016
        ],
        [
            486184405.75172704,
            -54983329.34617898,
            30885802.546530433
        ],
        [
            489202546.1919323,
            -39703858.14538658,
            31312777.76921323
        ],
        [
            491723127.36386585,
            -24286310.47198668,
            31709376.55120606
        ],
        [
            493738521.06250393,
            -8747499.883571923,
            32074848.09997223
        ],
        [
            495241677.0423349,
            6895290.402553618,
            32408472.250435345
        ],
        [
            496226154.52160466,
            22624327.66046518,
            32709561.82346855
        ],
        [
            496686153.12922883,
            38421452.06147316,
            32977464.981984593
        ],
        [
            496616543.12495434,
            54268101.342216134,
            33211567.573688187
        ],
        [
            496012894.7188641,
            70145337.72897705,
            33411295.449056182
        ],
        [
            494871506.31292343,
            86033877.09799922,
            33576116.74267563
        ],
        [
            493189431.4850793,
            101914120.33670163,
            33705544.10570303
        ],
        [
            490964504.53553635,
            117766186.85530153,
            33799136.8769184
        ],
        [
            488195364.4153357,
            133569950.18252438,
            33856503.17964245
        ],
        [
            484881476.85933566,
            149305075.56297818,
            33877301.93167083
        ],
        [
            481023154.5491867,
            164951059.45752028,
            33861244.75536309
        ],
        [
            476621575.1369753,
            180487270.83172244,
            33808097.775110945
        ],
        [
            471678796.9668956,
            195892994.1014836,
            33717683.289604634
        ],
        [
            466197772.3406213,
            211147473.5891563,
            33589881.306622446
        ],
        [
            460182358.1819798,
            226229959.3283862,
            33424630.928487655
        ],
        [
            453637323.96805096,
            241119754.04141733,
            33221931.576870963
        ],
        [
            446568356.80687994,
            255796261.09906363,
            32981844.046265025
        ],
        [
            438982063.5565324,
            270239033.26105225,
            32704491.3762177
        ],
        [
            430885969.8961462,
            284427821.9832115,
            32390059.533280276
        ],
        [
            422288516.27682334,
            298342627.06813323,
            32038797.894600153
        ],
        [
            413199050.6985389,
            311963746.4276625,
            31651019.52615861
        ],
        [
            403627818.27855736,
            325271825.71898854,
            31227101.249814898
        ],
        [
            393585947.5969675,
            338247907.61135423,
            30767483.49455906
        ],
        [
            383085433.8257052,
            350873480.4375553,
            30272669.92868663
        ],
        [
            372139118.66859615,
            363130525.98357725,
            29743226.870976917
        ],
        [
            360760667.1613462,
            375001566.17093873,
            29179782.480370138
        ],
        [
            348964541.4017691,
            386469708.3896327,
            28583025.72508254
        ],
        [
            336765971.3016919,
            397518689.2449866,
            27953705.133559693
        ],
        [
            324180922.4726483,
            408132916.4892528,
            27292627.331129644
        ],
        [
            311226061.37746257,
            418297508.9182879,
            26600655.367665112
        ],
        [
            297918717.89890873,
            427998334.0251687,
            25878706.842981927
        ],
        [
            284276845.4945926,
            437222043.21594095,
            25127751.838073593
        ],
        [
            270318979.12385064,
            445956104.40778536,
            24348810.661594734
        ],
        [
            256064191.1476075,
            454188831.8465436,
            23542951.422245488
        ],
        [
            241532045.415611,
            461909412.9986302,
            22711287.438860033
        ],
        [
            226742549.76713702,
            469107932.3916524,
            21854974.501054633
        ],
        [
            211716107.18099803,
            475775392.29838395,
            20975207.994232073
        ],
        [
            196473465.81839615,
            481903730.17985475,
            20073219.90356012
        ],
        [
            181035668.20779514,
            487485832.8250226,
            19150275.71223582
        ],
        [
            165423999.82445413,
            492515547.14652514,
            18207671.209905718
        ],
        [
            149659937.318607,
            496987687.6141714,
            17246729.227533124
        ],
        [
            133765096.64546168,
            500898040.32985,
            16268796.315282326
        ],
        [
            117761181.34729186,
            504243363.7692193,
            15275239.380127104
        ],
        [
            101669931.23295623,
            507021386.23664665,
            14267442.299886493
        ],
        [
            85513071.6933111,
            509230800.10020584,
            13246802.530249033
        ],
        [
            69312263.88227412,
            510871252.892902,
            12214727.72107031
        ],
        [
            53089055.98290095,
            511943335.3845204,
            11172632.357824901
        ],
        [
            36864835.76589811,
            512448566.7454152,
            10121934.443569968
        ],
        [
            20660784.63466698,
            512389376.9390371,
            9064052.236141387
        ],
        [
            4497833.336461484,
            511769086.4939414,
            8000401.054566693
        ],
        [
            -11603380.496308863,
            510591883.81830454,
            6932390.167849813
        ],
        [
            -27622552.8269535,
            508862800.23056865,
            5861419.778375164
        ],
        [
            -43539751.586878926,
            506587682.88867384,
            4788878.111202722
        ],
        [
            -59335452.82622293,
            503773165.80739534,
            3716138.6194952764
        ],
        [
            -74990574.54718652,
            500426639.15860474,
            2644557.315245008
        ],
        [
            -90486508.14223543,
            496556217.0528226,
            1575470.2333634906
        ],
        [
            -105805147.37698531,
            492170704.0022744,
            510191.03607607447
        ],
        [
            -120928914.87492064,
            487279560.2658675,
            -549991.2365659978
        ],
        [
            -135840786.0780185,
            481892866.27514887,
            -1603814.2653666548
        ],
        [
            -150524310.6736845,
            476021286.3374617,
            -2650044.396278601
        ],
        [
            -164963631.49403444,
            469676031.80832595,
            -3687478.427811116
        ],
        [
            -179143500.90839282,
            462868823.91960096,
            -4714945.240104141
        ],
        [
            -193049294.743783,
            455611856.44339585,
            -5731307.265226681
        ],
        [
            -206667023.7811111,
            447917758.3640969,
            -6735461.799215425
        ],
        [
            -219983342.88664192,
            439799556.7223887,
            -7726342.157273183
        ],
        [
            -232985557.84912986,
            431270639.78593576,
            -8702918.674387809
        ],
        [
            -245661630.00265104,
            422344720.69153285,
            -9664199.554412216
        ],
        [
            -258000178.7236907,
            413035801.693214,
            -10609231.571356496
        ],
        [
            -269990481.89841616,
            403358139.1401192,
            -11537100.627285399
        ],
        [
            -281622474.46232367,
            393326209.2969744,
            -12446932.171787329
        ],
        [
            -292886745.11956227,
            382954675.10899764,
            -13337891.488480905
        ],
        [
            -303774531.35330683,
            372258354.0019424,
            -14209183.854458023
        ],
        [
            -314277712.8415641,
            361252186.7969954,
            -15060054.57892396
        ],
        [
            -324388803.3948196,
            349951207.8094057,
            -15889788.927590705
        ],
        [
            -334100941.53304285,
            338370516.18911654,
            -16697711.939611591
        ],
        [
            -343407879.81977594,
            326525248.5514147,
            -17483188.14401336
        ],
        [
            -352303973.07046694,
            314430552.9357026,
            -18245621.182694208
        ],
        [
            -360784165.5508733,
            302101564.12104475,
            -18984453.34711177
        ],
        [
            -368843977.2793771,
            289553380.31816405,
            -19699165.035790414
        ],
        [
            -376479489.5444665,
            276801041.24907774,
            -20389274.13973669
        ],
        [
            -383687329.7455067,
            263859507.61765543,
            -21054335.36276621
        ],
        [
            -390464655.66135925,
            250743641.966992,
            -21693939.4836243
        ],
        [
            -396809139.2474166,
            237468190.91270947,
            -22307712.566624284
        ],
        [
            -402718950.05733,
            224047768.73506346,
            -22895315.127341546
        ],
        [
            -408192738.3811343,
            210496842.30709782,
            -23456441.259687845
        ],
        [
            -413229618.1866889,
            196829717.33101302,
            -23990817.730454907
        ],
        [
            -417829149.9464381,
            183060525.8503861,
            -24498203.04716357
        ],
        [
            -421991323.4264445,
            169203215.0019248,
            -24978386.50478526
        ],
        [
            -425716540.50957924,
            155271536.9669682,
            -25431187.21662383
        ],
        [
            -429005598.1196378,
            141279040.0800094,
            -25856453.13435661
        ],
        [
            -431859671.30809176,
            127239061.04904614,
            -26254060.06194055
        ],
        [
            -434280296.56017023,
            113164718.2405303,
            -26623910.667792875
        ],
        [
            -436269355.3720492,
            99068905.98011124,
            -26965933.499358762
        ],
        [
            -437829058.1461299,
            84964289.81914404,
            -27280082.003883973
        ],
        [
            -438961928.44673145,
            70863302.71610811,
            -27566333.558919214
        ],
        [
            -439670787.65402514,
            56778142.08157885,
            -27824688.515797064
        ],
        [
            -439958740.04972434,
            42720767.6351842,
            -28055169.259044256
        ],
        [
            -439829158.3639108,
            28702900.02307731,
            -28257819.284420863
        ],
        [
            -439285669.80845016,
            14736020.144762456,
            -28432702.29801719
        ],
        [
            -438332142.6187266,
            831369.1386736631,
            -28579901.338587813
        ],
        [
            -436972673.12190753,
            -13000051.023355603,
            -28699517.925061584
        ],
        [
            -435211573.34665096,
            -26747476.381694168,
            -28791671.230937686
        ],
        [
            -433053359.18607676,
            -40400379.3224746,
            -28856497.287060037
        ],
        [
            -430502739.1229372,
            -53948466.445847034,
            -28894148.214056633
        ],
        [
            -427564603.52325433,
            -67381676.01436728,
            -28904791.485537037
        ],
        [
            -424244014.5022143,
            -80690175.0256029,
            -28888609.222959075
        ],
        [
            -420546196.3638313,
            -93864355.95163521,
            -28845797.5229062
        ],
        [
            -416476526.6138057,
            -106894833.18664506,
            -28776565.81735816
        ],
        [
            -412040527.5430912,
            -119772439.24230102,
            -28681136.26739107
        ],
        [
            -407243858.37794954,
            -132488220.7291272,
            -28559743.190606494
        ],
        [
            -402092307.990697,
            -145033434.16053507,
            -28412632.522463754
        ],
        [
            -396591788.1639235,
            -157399541.61467943,
            -28240061.31157428
        ],
        [
            -390748327.399693,
            -169578206.28780347,
            -28042297.248910986
        ],
        [
            -384568065.26408464,
            -181561287.9712852,
            -27819618.23078882
        ],
        [
            -378057247.25641644,
            -193340838.48314106,
            -27572311.955384623
        ],
        [
            -371222220.19158435,
            -204909097.0833656,
            -27300675.55248405
        ],
        [
            -364069428.08314764,
            -216258485.9011245,
            -27005015.24607074
        ],
        [
            -356605408.5140816,
            -227381605.40051162,
            -26685646.049306702
        ],
        [
            -348836789.48148656,
            -238271229.91034567,
            -26342891.491393443
        ],
        [
            -340770286.7010007,
            -248920303.2422628,
            -25977083.375749163
        ],
        [
            -332412701.3561654,
            -259321934.42024314,
            -25588561.568888426
        ],
        [
            -323770918.27757037,
            -269469393.5436102,
            -25177673.819346372
        ],
        [
            -314851904.5362205,
            -279356107.80451894,
            -24744775.605949223
        ],
        [
            -305662708.4352183,
            -288975657.67998827,
            -24290230.014695443
        ],
        [
            -296210458.8835546,
            -298321773.3176025,
            -23814407.643478412
        ],
        [
            -286502365.135502,
            -307388331.13316596,
            -23317686.533849258
        ],
        [
            -276545716.8788403,
            -316169350.6377732,
            -22800452.128989
        ],
        [
            -266347884.654888,
            -324658991.51100576,
            -22263097.257030845
        ],
        [
            -255916320.59304288,
            -332851550.93625927,
            -21706022.13884561
        ],
        [
            -245258559.44229704,
            -340741461.21352905,
            -21129634.419377074
        ],
        [
            -234382219.8819054,
            -348323287.66436356,
            -20534349.22158653
        ]
    ],
    "(2025 AG1)": [
        [
            -335185835.40867263,
            169119198.15408546,
            67200082.21427894
        ],
        [
            -340345446.40919954,
            158255417.20711392,
            67805533.94635744
        ],
        [
            -345191520.089033,
            147243896.84875363,
            68348458.91540046
        ],
        [
            -349720188.4927405,
            136093141.66875517,
            68828414.71984006
        ],
        [
            -353927756.81691176,
            124811742.05619618,
            69244993.62281659
        ],
        [
            -357810704.29359436,
            113408373.8088186,
            69597822.70265265
        ],
        [
            -361365685.31792104,
            101891797.80099991,
            69886564.05022691
        ],
        [
            -364589530.82575387,
            90270859.69182165,
            70110915.01373203
        ],
        [
            -367479249.92637765,
            78554489.65434258,
            70270608.49114268
        ],
        [
            -370032031.79447275,
            66751702.10683538,
            70365413.27056059
        ],
        [
            -372245247.8247664,
            54871595.42640388,
            70395134.41844046
        ],
        [
            -374116454.05191845,
            42923351.62506002,
            70359613.7155326
        ],
        [
            -375643393.83731514,
            30916235.968014568,
            70258730.1402066
        ],
        [
            -376824000.82354903,
            18859596.513616413,
            70092400.39864445
        ],
        [
            -377656402.1564183,
            6762863.554070234,
            69860579.50120711
        ],
        [
            -378138921.97331524,
            -5364451.06422776,
            69563261.38409263
        ],
        [
            -378270085.1558595,
            -17512754.762171328,
            69200479.57520719
        ],
        [
            -378048621.3435849,
            -29672375.212929428,
            68772307.90296982
        ],
        [
            -377473469.2043954,
            -41833561.512349784,
            68278861.24656284
        ],
        [
            -376543780.95636964,
            -53986485.55689645,
            67720296.32592356
        ],
        [
            -375258927.13430387,
            -66121243.651399165,
            67096812.52954897
        ],
        [
            -373618501.5931577,
            -78227858.36902359,
            66408652.7779543
        ],
        [
            -371622326.7392731,
            -90296280.68595092,
            65656104.42038574
        ],
        [
            -369270458.9789113,
            -102316392.41329192,
            64839500.16214152
        ],
        [
            -366563194.3722576,
            -114278008.94873498,
            63959219.01959939
        ],
        [
            -363501074.479612,
            -126170882.37034388,
            63015687.299787164
        ],
        [
            -360084892.38498855,
            -137984704.89476445,
            62009379.601062015
        ],
        [
            -356315698.8808132,
            -149709112.72186816,
            60940819.83118917
        ],
        [
            -352194808.7958149,
            -161333690.28754193,
            59810582.23882634
        ],
        [
            -347723807.4465805,
            -172847974.94592437,
            58619292.454134196
        ],
        [
            -342904557.1915626,
            -184241462.10188013,
            57367628.53393844
        ],
        [
            -337739204.06461906,
            -195503610.81388187,
            56056322.00657469
        ],
        [
            -332230184.4634191,
            -206623849.8867374,
            54686158.911247894
        ],
        [
            -326380231.8662732,
            -217591584.4727355,
            53257980.82643846
        ],
        [
            -320192383.5491588,
            -228396203.19879276,
            51772685.88158927
        ],
        [
            -313669987.27289826,
            -239027085.83604413,
            50231229.746009625
        ],
        [
            -306816707.9086493,
            -249473611.52704245,
            48634626.58864091
        ],
        [
            -299636533.96805704,
            -259725167.58428198,
            46983950.00204183
        ],
        [
            -292133784.0026376,
            -269771158.87216705,
            45280333.88367304
        ],
        [
            -284313112.83521,
            -279601017.7827644,
            43524973.2672949
        ],
        [
            -276179517.58448213,
            -289204214.8137352,
            41719125.09703809
        ],
        [
            -267738343.44224387,
            -298570269.7547123,
            39864108.93647034
        ],
        [
            -258995289.1610453,
            -307688763.48607445,
            37961307.604765154
        ],
        [
            -249956412.20874533,
            -316549350.3915738,
            36012167.731883295
        ],
        [
            -240628133.5449378,
            -325141771.38358784,
            34018200.224508695
        ],
        [
            -231017241.97300732,
            -333455867.5368914,
            31980980.634340756
        ],
        [
            -221130898.0204562,
            -341481594.32379115,
            29902149.42023751
        ],
        [
            -210976637.29919952,
            -349209036.4402244,
            27783412.095633216
        ],
        [
            -200562373.29676935,
            -356628423.20900786,
            25626539.252622936
        ],
        [
            -189896399.5488134,
            -363730144.5428427,
            23433366.454118896
        ],
        [
            -178987391.14295316,
            -370504767.4459356,
            21205793.985543057
        ],
        [
            -167844405.5039909,
            -376943053.0292136,
            18945786.457630362
        ],
        [
            -156476882.41064975,
            -383035974.01008534,
            16655372.252081208
        ],
        [
            -144894643.19452178,
            -388774732.6635714,
            14336642.802023746
        ],
        [
            -133107889.07269192,
            -394150779.18739337,
            11991751.699527612
        ],
        [
            -121127198.56664073,
            -399155830.43931234,
            9622913.622757044
        ],
        [
            -108963523.96150053,
            -403781889.00065744,
            7232403.075761231
        ],
        [
            -96628186.76158188,
            -408021262.5156131,
            4822552.934378894
        ],
        [
            -84132872.10030898,
            -411866583.2514749,
            2395752.7922823057
        ],
        [
            -71489622.06531128,
            -415310827.8207712,
            -45552.89819506928
        ],
        [
            -58710827.90242712,
            -418347337.0018982,
            -2498866.89511339
        ],
        [
            -45809221.06580022,
            -420969835.5908044,
            -4961641.449767102
        ],
        [
            -32797863.085068524,
            -423172452.212276,
            -7431280.806383446
        ],
        [
            -19690134.22489044,
            -424949739.0156114,
            -9905143.920848358
        ],
        [
            -6499720.916695595,
            -426296691.1759231,
            -12380547.399659943
        ],
        [
            6759398.052412599,
            -427208766.119051,
            -14854768.659276571
        ],
        [
            20072966.60324374,
            -427681902.3851328,
            -17325049.304931507
        ],
        [
            33426467.68444407,
            -427712538.043309,
            -19788598.726835646
        ],
        [
            46805140.84646258,
            -427297628.5678774,
            -22242597.91048842
        ],
        [
            60194001.06080392,
            -426434664.08451056,
            -24684203.45657125
        ],
        [
            73577858.76906115,
            -425121685.8939329,
            -27110551.804613926
        ],
        [
            86941341.13922462,
            -423357302.17977744,
            -29518763.653312802
        ],
        [
            100268914.49955463,
            -421140702.807226,
            -31905948.569046196
        ],
        [
            113544907.91292879,
            -418471673.11953336,
            -34269209.77278818
        ],
        [
            126753537.84710002,
            -415350606.6406496,
            -36605649.09427873
        ],
        [
            139878933.88875002,
            -411778516.5939339,
            -38912372.080972426
        ],
        [
            152905165.44169086,
            -407757046.14939946,
            -41186493.24797672
        ],
        [
            165816269.34208804,
            -403288477.3150679,
            -43425141.45391158
        ],
        [
            178596278.3162327,
            -398375738.3918381,
            -45625465.386389464
        ],
        [
            191229250.1992326,
            -393022409.9158044,
            -47784639.13963885
        ],
        [
            203699297.8261119,
            -387232729.01717085,
            -49899867.86569198
        ],
        [
            215990619.50024194,
            -381011592.1307981,
            -51968393.47953364
        ],
        [
            228087529.93787724,
            -374364555.999966,
            -53987500.39768292
        ],
        [
            239974491.5818813,
            -367297836.92209935,
            -55954521.288858384
        ],
        [
            251636146.17257333,
            -359818308.19296277,
            -57866842.814674504
        ],
        [
            263057346.45907712,
            -351933495.7141313,
            -59721911.3377417
        ],
        [
            274223187.9306508,
            -343651571.73733556,
            -61517238.57410358
        ],
        [
            285119040.4442952,
            -334981346.7285042,
            -63250407.16665165
        ],
        [
            295730579.62251604,
            -325932259.34392595,
            -64919076.15601676
        ],
        [
            306043817.89348924,
            -316514364.52083695,
            -66520986.325452
        ],
        [
            316045135.04510814,
            -306738319.69485897,
            -68053965.39640158
        ],
        [
            325721308.16447544,
            -296615369.16695595,
            -69515933.05179195
        ],
        [
            335059540.8353771,
            -286157326.65288746,
            -70904905.76459008
        ],
        [
            344047491.4681609,
            -275376556.0584049,
            -72219001.409848
        ],
        [
            352673300.63920945,
            -264285950.53358436,
            -73456443.63928641
        ],
        [
            360925617.32087284,
            -252898909.86962694,
            -74615565.99846472
        ],
        [
            368793623.8872732,
            -241229316.31108934,
            -75694815.76773001
        ],
        [
            376267059.78678244,
            -229291508.86575192,
            -76692757.50942579
        ],
        [
            383336243.7781887,
            -217100256.2031011,
            -77608076.3052665
        ],
        [
            389992094.6345393,
            -204670728.24061581,
            -78439580.66933173
        ],
        [
            396226150.2263341,
            -192018466.52463216,
            -79186205.12379237
        ],
        [
            402030584.9040931,
            -179159353.51944008,
            -79847012.42624052
        ],
        [
            407398225.1092359,
            -166109580.9243879,
            -80421195.43933345
        ],
        [
            412322563.1516483,
            -152885617.14406425,
            -80908078.63537113
        ],
        [
            416797769.1021701,
            -139504174.04106563,
            -81307119.23038626
        ],
        [
            420818700.758433,
            -125982173.10438536,
            -81617907.9443182
        ],
        [
            424380911.65293026,
            -112336711.16905862,
            -81840169.38585293
        ],
        [
            427480657.0828149,
            -98585025.82435435,
            -81973762.06252053
        ],
        [
            430114898.15159833,
            -84744460.64849259,
            -82018678.01863353
        ],
        [
            432281303.823582,
            -70832430.40760982,
            -81975042.10560639
        ],
        [
            433978251.0023956,
            -56866386.355490774,
            -81843110.8911022
        ],
        [
            435204822.6553526,
            -42863781.76846239,
            -81623271.21529137
        ],
        [
            435960804.0153878,
            -28842037.84683034,
            -81316038.40426518
        ],
        [
            436246676.90201676,
            -14818510.110381395,
            -80922054.15230851
        ],
        [
            436063612.2119957,
            -810455.4108038843,
            -80442084.08629051
        ],
        [
            435413460.6390808,
            13165000.321528107,
            -79877015.02686892
        ],
        [
            434298741.6904274,
            27090893.485058874,
            -79227851.96250974
        ],
        [
            432722631.0746838,
            40950453.26421288,
            -78495714.75349654
        ],
        [
            430688946.5436616,
            54727131.038838685,
            -77681834.58413152
        ],
        [
            428202132.2755859,
            68404628.65629873,
            -76787550.18221225
        ],
        [
            425267241.8932831,
            81966925.48468894,
            -75814303.8255975
        ],
        [
            421889920.21526927,
            95398304.17411825,
            -74763637.15625535
        ],
        [
            418076383.84150255,
            108683375.06164673,
            -73637186.82261173
        ],
        [
            413833400.6785933,
            121807099.1643227,
            -72436679.97129422
        ],
        [
            409168268.5114929,
            134754809.71365657,
            -71163929.60949431
        ],
        [
            404088792.73014784,
            147512232.19379407,
            -69820829.85915588
        ],
        [
            398603263.3203043,
            160065502.85448593,
            -68409351.12404671
        ],
        [
            392720431.2276229,
            172401185.67866206,
            -66931535.19048601
        ],
        [
            386449484.20352304,
            184506287.7929243,
            -65389490.28209469
        ],
        [
            379800022.2397886,
            196368273.3175042,
            -63785386.08841665
        ],
        [
            372782032.6969311,
            207975075.66017884,
            -62121448.78663023
        ],
        [
            365405865.2287091,
            219315108.26619133,
            -60399956.074850544
        ],
        [
            357682206.60206723,
            230377273.8433863,
            -58623232.234715685
        ],
        [
            349622055.5081282,
            241150972.0885048,
            -56793643.24006696
        ],
        [
            341236697.45583487,
            251626105.94681686,
            -54913591.927589744
        ],
        [
            332537679.8354031,
            261793086.44304895,
            -52985513.24427963
        ],
        [
            323536787.23400116,
            271642836.1267972,
            -51011869.58555656
        ],
        [
            314246017.0810559,
            281166791.18034375,
            -48995146.23677443
        ],
        [
            304677555.6953417,
            290356902.2409998,
            -46937846.92977244
        ],
        [
            294843754.80062103,
            299205633.993745,
            -44842489.525004506
        ],
        [
            284757108.5710763,
            307705963.59308964,
            -42711601.82866369
        ],
        [
            274430231.2621968,
            315851377.9756921,
            -40547717.55310629
        ],
        [
            263875835.47717974,
            323635870.1273813,
            -38353372.42777989
        ],
        [
            253106711.11330163,
            331053934.36986303,
            -36131100.46677456
        ],
        [
            242135705.0272071,
            338100560.7335301,
            -33883430.39806336
        ],
        [
            230975701.4526023,
            344771228.48351336,
            -31612882.258469593
        ],
        [
            219639603.19854316,
            351061898.8663823,
            -29321964.157411978
        ],
        [
            208140313.65134817,
            356969007.1447857,
            -27013169.211531274
        ],
        [
            196490719.59817797,
            362489453.98684293,
            -24688972.65139761
        ],
        [
            184703674.8855631,
            367620596.27625376,
            -22351829.10064624
        ],
        [
            172791984.9215876,
            372360237.40796804,
            -20004170.027082317
        ],
        [
            160768392.0261309,
            376706617.1328163,
            -17648401.364546813
        ],
        [
            148645561.62948194,
            380658401.01284057,
            -15286901.303634858
        ],
        [
            136436069.31582814,
            384214669.54715335,
            -12922018.248716012
        ],
        [
            124152388.70457056,
            387374907.02606547,
            -10556068.938116983
        ],
        [
            111806880.15911019,
            390138990.16896063,
            -8191336.723790228
        ],
        [
            99411780.30974743,
            392507176.5989927,
            -5830070.006314371
        ],
        [
            86979192.37455997,
            394480093.205174,
            -3474480.820639994
        ],
        [
            74521077.25963937,
            396058724.4398146,
            -1126743.567619536
        ],
        [
            62049245.41782868,
            397244400.5966084,
            1211006.1139680967
        ],
        [
            49575349.44310363,
            398038786.11194867,
            3536672.3404698223
        ],
        [
            37110877.37601377,
            398443867.92931986,
            5848199.8472904675
        ],
        [
            24667146.694068193,
            398461943.96386635,
            8143574.729702406
        ],
        [
            12255298.959676057,
            398095611.7015135,
            10420825.066678867
        ],
        [
            -113704.90282568336,
            397347756.964302,
            12678021.434009224
        ],
        [
            -12429088.730409235,
            396221542.87093693,
            14913277.31303303
        ],
        [
            -24680264.67487988,
            394720399.0189325,
            17124749.401369587
        ],
        [
            -36856836.21723336,
            392848010.9121804,
            19310637.832035266
        ],
        [
            -48948600.67372835,
            390608309.65528405,
            21469186.307323564
        ],
        [
            -60945551.22474757,
            388005461.9335977,
            23598682.153781373
        ],
        [
            -72837878.49758592,
            385043860.29558146,
            25697456.304553036
        ],
        [
            -84615971.73421095,
            381728113.75185376,
            27763883.215275552
        ],
        [
            -96270419.57486959,
            378063038.7031765,
            29796380.71960815
        ],
        [
            -107792010.48810875,
            374053650.2075644,
            31793409.83035803
        ],
        [
            -119171732.87739034,
            369705153.59475833,
            33753474.4920304
        ],
        [
            -130400774.89402264,
            365022936.4344454,
            35675121.29048738
        ],
        [
            -141470523.98556915,
            360012560.8628597,
            37556939.125240974
        ],
        [
            -152372566.2083121,
            354679756.2707268,
            39397558.84974457
        ],
        [
            -163098685.33166647,
            349030412.35395867,
            41195652.88487231
        ],
        [
            -173640861.76175565,
            343070572.52702665,
            42949934.81060177
        ],
        [
            -183991271.31060445,
            336806427.6975548,
            44659158.9407329
        ],
        [
            -194142283.8366313,
            330244310.3993863,
            46322119.885291
        ],
        [
            -204086461.78133535,
            323390689.2801506,
            47937652.10507937
        ],
        [
            -213816558.6262403,
            316252163.93823546,
            49504629.46265554
        ],
        [
            -223325517.29334366,
            308835460.10300094,
            51021964.773822956
        ],
        [
            -232606468.51147068,
            301147425.15108716,
            52488609.36354085
        ],
        [
            -241652729.17009032,
            293195023.9507507,
            53903552.62997087
        ],
        [
            -250457800.68131742,
            284985335.02529997,
            55265821.62019791
        ],
        [
            -259015367.36996573,
            276525547.0259066,
            56574480.62097866
        ],
        [
            -267319294.91069573,
            267822955.5033193,
            57828630.76769643
        ],
        [
            -275363628.8304622,
            258884959.9673136,
            59027409.67452356
        ],
        [
            -283142593.0936402,
            249719061.22206104,
            60169991.088619955
        ],
        [
            -290650588.78640634,
            240332858.96498522,
            61255584.57102885
        ],
        [
            -297882192.91613185,
            230734049.63610935,
            62283435.2067615
        ],
        [
            -304832157.3407648,
            220930424.50435102,
            63252823.34640123
        ],
        [
            -311495407.84238267,
            210929867.9767142,
            64163064.38139479
        ],
        [
            -317867043.35832334,
            200740356.11584806,
            65013508.55504073
        ],
        [
            -323942335.3825414,
            190369955.3509696,
            65803540.81102886
        ],
        [
            -329716727.5490631,
            179826821.36671993,
            66532580.68122941
        ],
        [
            -335185835.4086726,
            169119198.15408555,
            67200082.21427894
        ]
    ],
    "(2025 AC4)": [
        [
            -76572076.34966318,
            -311381696.55173445,
            18743193.513120253
        ],
        [
            -66765231.27133511,
            -313709321.1884591,
            17621761.10346302
        ],
        [
            -56895712.009602636,
            -315750443.05763817,
            16484028.65865602
        ],
        [
            -46970896.29451658,
            -317503425.2572824,
            15330843.297088176
        ],
        [
            -36998197.803554244,
            -318966774.1895143,
            14163060.849125594
        ],
        [
            -26985066.603786364,
            -320139140.09745336,
            12981545.927124593
        ],
        [
            -16938989.604336478,
            -321019317.8566085,
            11787172.004408527
        ],
        [
            -6867491.00215669,
            -321606248.02270687,
            10580821.50120334
        ],
        [
            3221867.296030998,
            -321899018.1372321,
            9363385.875486007
        ],
        [
            13321485.292957962,
            -321896864.29128057,
            8135765.71665776
        ],
        [
            23423724.578708038,
            -321599172.9476563,
            6898870.8399114255
        ],
        [
            33520908.084989563,
            -321005483.0204243,
            5653620.379118161
        ],
        [
            43605319.933660686,
            -320115488.2104025,
            4400942.876014294
        ],
        [
            53669205.39757255,
            -318929039.5943216,
            3141776.363423789
        ],
        [
            63704770.9919734,
            -317446148.46458286,
            1877068.440206021
        ],
        [
            73704184.71488827,
            -315666989.415724,
            607776.3355726618
        ],
        [
            83659576.45505087,
            -313591903.67283547,
            -665133.0396283045
        ],
        [
            93563038.58611211,
            -311221402.6562669,
            -1940683.0571088344
        ],
        [
            103406626.76597857,
            -308556171.77601296,
            -3217887.353309227
        ],
        [
            113182360.96024254,
            -305597074.4481804,
            -4495749.832073614
        ],
        [
            122882226.70874372,
            -302345156.3248899,
            -5773264.690408757
        ],
        [
            132498176.65435052,
            -298801649.72788095,
            -7049416.469941156
        ],
        [
            142022132.3530579,
            -294967978.274947,
            -8323180.136723032
        ],
        [
            151445986.38446215,
            -290845761.6871317,
            -9593521.192069674
        ],
        [
            160761604.7815867,
            -286436820.7633781,
            -10859395.817137627
        ],
        [
            169960829.79888976,
            -281743182.50802124,
            -12119751.053975249
        ],
        [
            179035483.03707433,
            -276767085.3951709,
            -13373525.02579231
        ],
        [
            187977368.94304004,
            -271510984.75262874,
            -14619647.199203635
        ],
        [
            196778278.7029568,
            -265977558.24654433,
            -15857038.691201797
        ],
        [
            205429994.54598802,
            -260169711.44651848,
            -17084612.62360418
        ],
        [
            213924294.47564894,
            -254090583.44933075,
            -18301274.527700186
        ],
        [
            222252957.44513464,
            -247743552.53789902,
            -19505922.801793
        ],
        [
            230407768.99219143,
            -241132241.85047624,
            -20697449.224286057
        ],
        [
            238380527.34821996,
            -234260525.03345865,
            -21874739.524906628
        ],
        [
            246163050.03529018,
            -227132531.84953701,
            -23036674.016585656
        ],
        [
            253747180.9635943,
            -219752653.71126258,
            -24182128.290423647
        ],
        [
            261124798.0405749,
            -212125549.1084417,
            -25309973.97606518
        ],
        [
            268287821.30151266,
            -204256148.89612734,
            -26419079.56967882
        ],
        [
            275228221.5697574,
            -196149661.4083448,
            -27508311.331593245
        ],
        [
            281938029.6530121,
            -187811577.361103,
            -28576534.255473442
        ],
        [
            288409346.0801353,
            -179247674.5066925,
            -29622613.110731132
        ],
        [
            294634351.380815,
            -170464021.99979708,
            -30645413.55965173
        ],
        [
            300605316.9081627,
            -161466984.43454304,
            -31643803.35048233
        ],
        [
            306314616.2018021,
            -152263225.51031068,
            -32616653.58746423
        ],
        [
            311754736.8863668,
            -142859711.282945,
            -33562840.07850578
        ],
        [
            316918293.0974755,
            -133263712.956956,
            -34481244.7608774
        ],
        [
            321798038.4242343,
            -123482809.17340297,
            -35370757.204970784
        ],
        [
            326386879.35412097,
            -113524887.74744429,
            -36230276.19579753
        ],
        [
            330677889.2027365,
            -103398146.80901584,
            -37058711.39150876
        ],
        [
            334664322.50739145,
            -93111095.2998073,
            -37854985.057798386
        ],
        [
            338339629.859816,
            -82672552.77965537,
            -38618033.87660738
        ],
        [
            341697473.1494784,
            -72091648.49568689,
            -39346810.82707718
        ],
        [
            344731741.1850655,
            -61377819.66804899,
            -40040287.13620781
        ],
        [
            347436565.6576556,
            -50540808.94687942,
            -40697454.2961618
        ],
        [
            349806337.4050015,
            -39590660.99631143,
            -41317326.14462148
        ],
        [
            351835722.93218887,
            -28537718.162807353,
            -41898941.004056014
        ],
        [
            353519681.1397392,
            -17392615.18697624,
            -42441363.87518921
        ],
        [
            354853480.20604956,
            -6166272.920281112,
            -42943688.679382265
        ],
        [
            355832714.56691,
            5130108.989308864,
            -43405040.54406152
        ],
        [
            356453321.9307641,
            16485060.475608245,
            -43824578.12473272
        ],
        [
            356711600.264412,
            27886850.525857598,
            -44201495.95653634
        ],
        [
            356604224.680043,
            39323497.77122253,
            -44535026.82771627
        ],
        [
            356128264.1508539,
            50782782.21733275,
            -44824444.16680244
        ],
        [
            355281197.97913104,
            62252258.13129182,
            -45069064.43475303
        ],
        [
            354060931.93756294,
            73719268.09642623,
            -45268249.512767196
        ],
        [
            352465814.0017762,
            85170958.24047911,
            -45421409.07597396
        ],
        [
            350494649.5896826,
            96594294.63700187,
            -45528002.94272968
        ],
        [
            348146716.2212439,
            107976080.87338673,
            -45587543.38882489
        ],
        [
            345421777.51074487,
            119302976.77233967,
            -45599597.41551542
        ],
        [
            342320096.4026539,
            130561518.24664861,
            -45563788.959959716
        ],
        [
            338842447.5617045,
            141738138.25989544,
            -45479801.03637105
        ],
        [
            334990128.82795906,
            152819188.85834658,
            -45347377.79598494
        ],
        [
            330764971.64838076,
            163790964.23167044,
            -45166326.49380463
        ],
        [
            326169350.3978671,
            174639724.75243992,
            -44936519.35002823
        ],
        [
            321206190.5047943,
            185351721.9366436,
            -44657895.29408092
        ],
        [
            315878975.2989407,
            195913224.2597012,
            -44330461.57928505
        ],
        [
            310191751.5031835,
            206310543.75485253,
            -43954295.25639735
        ],
        [
            304149133.2946236,
            216530063.313309,
            -43529544.49453435
        ],
        [
            297756304.8657772,
            226558264.5983177,
            -43056429.738393165
        ],
        [
            291019021.4221807,
            236381756.4783555,
            -42535244.69115862
        ],
        [
            283943608.55916023,
            245987303.87813026,
            -41966357.11306787
        ],
        [
            276536959.96760845,
            255361856.93998265,
            -41350209.42628131
        ],
        [
            268806533.42634135,
            264492580.38274965,
            -40687319.11748031
        ],
        [
            260760345.04694283,
            273366882.94022536,
            -39978278.93047629
        ],
        [
            252406961.7458926,
            281972446.7571139,
            -39223756.84206742
        ],
        [
            243755491.92814904,
            290297256.6168878,
            -38424495.81541294
        ],
        [
            234815574.3761648,
            298329628.8732802,
            -37581313.32630644
        ],
        [
            225597365.34846127,
            306058239.9553315,
            -36695100.658907056
        ],
        [
            216111523.90231085,
            313472154.3150073,
            -35766821.96872795
        ],
        [
            206369195.46567112,
            320560851.6864463,
            -34797513.11196991
        ],
        [
            196381993.69420445,
            327314253.52691716,
            -33788280.24161837
        ],
        [
            186161980.65988588,
            333722748.5115773,
            -32740298.172079705
        ],
        [
            175721645.42827308,
            339777216.95712906,
            -31654808.515508775
        ],
        [
            165073881.0918606,
            345469054.0534833,
            -30533117.594359055
        ],
        [
            154231960.33698517,
            350790191.78751856,
            -29376594.13605821
        ],
        [
            143209509.63137683,
            355733119.448958,
            -28186666.757062368
        ],
        [
            132020482.12856954,
            360290902.61524093,
            -26964821.244858168
        ],
        [
            120679129.393905,
            364457200.5199686,
            -25712597.64775072
        ],
        [
            109199972.06468542,
            368226281.718021,
            -24431587.18348458
        ],
        [
            97597769.5640893,
            371593037.96968436,
            -23123428.978882633
        ],
        [
            85887488.99467237,
            374552996.2760255,
            -21789806.653742373
        ],
        [
            74084273.34257467,
            377102329.0082063,
            -20432444.763190046
        ],
        [
            62203409.12789636,
            379237862.0843627,
            -19053105.11355189
        ],
        [
            50260293.64002872,
            380957081.1589649,
            -17653582.96754825
        ],
        [
            38270401.89902164,
            382258135.80113876,
            -16235703.155245297
        ],
        [
            26249253.485298492,
            383139841.6501376,
            -14801316.107703619
        ],
        [
            14212379.380189642,
            383601680.547913,
            -13352293.830638839
        ],
        [
            2175288.958861053,
            383643798.66042703,
            -11890525.835654838
        ],
        [
            -9846562.724740416,
            383267002.61086524,
            -10417915.046721699
        ],
        [
            -21837807.224268496,
            382472753.65915596,
            -8936373.699550938
        ],
        [
            -33783194.425980076,
            381263159.97305757,
            -7447819.251369253
        ],
        [
            -45667623.58453393,
            379640967.04646534,
            -5954170.318313817
        ],
        [
            -57476173.5475177,
            377609546.33041394,
            -4457342.657269929
        ],
        [
            -69194132.05318753,
            375172882.1514284,
            -2959245.2084537484
        ],
        [
            -80807023.99319871,
            372335557.00034267,
            -1461776.2144127004
        ],
        [
            -92300638.54003648,
            369102735.2823911,
            33180.56961482391
        ],
        [
            -103661055.04734951,
            365480145.62623316,
            1523759.5598633587
        ],
        [
            -114874667.64035583,
            361474061.8555586,
            3008116.909519393
        ],
        [
            -125928208.4228223,
            357091282.73200214,
            4484433.943287082
        ],
        [
            -136808769.23674268,
            352339110.5822599,
            5950920.449855879
        ],
        [
            -147503821.92063898,
            347225328.92552954,
            7405817.822178487
        ],
        [
            -158001237.02230805,
            341758179.2196982,
            8847402.036600746
        ],
        [
            -168289300.93172872,
            335946336.84608793,
            10273986.46304555
        ],
        [
            -178356731.40965784,
            329798886.45305085,
            11683924.499631045
        ],
        [
            -188192691.4970769,
            323325296.7783333,
            13075612.026285406
        ],
        [
            -197786801.80004835,
            316535395.068912,
            14447489.67309978
        ],
        [
            -207129151.15360886,
            309439341.21501565,
            15798044.90032319
        ],
        [
            -216210305.67701644,
            302047601.7123173,
            17125813.888042226
        ],
        [
            -225021316.2409187,
            294370923.56287605,
            18429383.23469448
        ],
        [
            -233553724.37475526,
            286420308.2213906,
            19707391.46462745
        ],
        [
            -241799566.6499411,
            278206985.688748,
            20958530.34593306
        ],
        [
            -249751377.5810202,
            269742388.8497933,
            22181546.02074842
        ],
        [
            -257402191.09303853,
            261038128.14677134,
            23375239.951115645
        ],
        [
            -264745540.60883045,
            252105966.67404896,
            24538469.684332952
        ],
        [
            -271775457.8147239,
            242957795.77362835,
            25670149.44249826
        ],
        [
            -278486470.1673589,
            233605611.20461494,
            26769250.54164847
        ],
        [
            -284873597.20786655,
            224061489.95332557,
            27834801.64652539
        ],
        [
            -290932345.7525893,
            214337567.7441499,
            28865888.867555346
        ],
        [
            -296658704.03185344,
            204446017.30465272,
            29861655.70711318
        ],
        [
            -302049134.8500377,
            194399027.4318354,
            30821302.86255128
        ],
        [
            -307100567.84135765,
            184208782.89994103,
            31744087.893815145
        ],
        [
            -311810390.8964171,
            173887445.24380147,
            32629324.763737194
        ],
        [
            -316176440.83469987,
            163447134.44548965,
            33476383.25930447
        ],
        [
            -320196993.39783126,
            152899911.54599175,
            34284688.30233715
        ],
        [
            -323870752.6376363,
            142257762.19782764,
            35053719.15809305
        ],
        [
            -327196839.7718387,
            131532581.16898575,
            35783008.5503374
        ],
        [
            -330174781.5786705,
            120736157.80328745,
            36472141.69138561
        ],
        [
            -332804498.399777,
            109880162.43733859,
            37120755.23554761
        ],
        [
            -335086291.8186211,
            98976133.7695741,
            37728536.164277986
        ],
        [
            -337020832.0791461,
            88035467.17260551,
            38295220.61116979
        ],
        [
            -338609145.3068156,
            77069403.9360851,
            38820592.63472942
        ],
        [
            -339852600.59130526,
            66089021.423680514,
            39304482.94663426
        ],
        [
            -340752896.9871436,
            55105224.1244352,
            39746767.60291378
        ],
        [
            -341312050.4855056,
            44128735.5758363,
            40147366.66520751
        ],
        [
            -341532381.0071797,
            33170091.133274987,
            40506242.83894725
        ],
        [
            -341416499.46349543,
            22239631.558259748,
            40823400.09498751
        ],
        [
            -340967294.92873937,
            11347497.39575769,
            41098882.28087262
        ],
        [
            -340187921.96431357,
            503624.109317556,
            41332771.7275833
        ],
        [
            -339081788.1316503,
            -10282262.058776543,
            41525187.85725367
        ],
        [
            -337652541.72768086,
            -21000647.53621839,
            41676285.79699424
        ],
        [
            -335904059.7735054,
            -31642234.21305734,
            41786255.00360007
        ],
        [
            -333840436.2838306,
            -42197941.61317,
            41855317.90356875
        ],
        [
            -331465970.84174424,
            -52658908.4806996,
            41883728.55250111
        ],
        [
            -328785157.5004975,
            -63016493.81754452,
            41871771.31761246
        ],
        [
            -325802674.0311788,
            -73262277.40800917,
            41819759.58674373
        ],
        [
            -322523371.53247863,
            -83388059.86659719,
            41728034.50693202
        ],
        [
            -318952264.4162,
            -93385862.24461387,
            41596963.75528087
        ],
        [
            -315094520.77972823,
            -103247925.23082046,
            41426940.344561346
        ],
        [
            -310955453.17438096,
            -112966707.98081276,
            41218381.46567902
        ],
        [
            -306540509.7763841,
            -122534886.60912177,
            40971727.36885686
        ],
        [
            -301855265.96517843,
            -131945352.37728041,
            40687440.28511344
        ],
        [
            -296905416.3118546,
            -141191209.61023512,
            40366003.38935769
        ],
        [
            -291696766.97872734,
            -150265773.3725804,
            40007919.80617706
        ],
        [
            -286235228.5294069,
            -159162566.93511385,
            39613711.659165084
        ],
        [
            -280526809.1471933,
            -167875319.0611897,
            39183919.1644176
        ],
        [
            -274577608.25819826,
            -176397961.14130914,
            38719099.76862231
        ],
        [
            -268393810.55430654,
            -184724624.20328838,
            38219827.33197619
        ],
        [
            -261981680.40989152,
            -192849635.82427493,
            37686691.35598712
        ],
        [
            -255347556.68511757,
            -200767516.96975562,
            37120296.25605065
        ],
        [
            -248497847.90766823,
            -208472978.78361657,
            36521260.67853909
        ],
        [
            -241439027.82384768,
            -215960919.35220128,
            35890216.86199794
        ],
        [
            -234177631.30919516,
            -223226420.4642249,
            35227810.041913666
        ],
        [
            -226720250.62801754,
            -230264744.3873338,
            34534697.898395
        ],
        [
            -219073532.0306034,
            -237071330.68103123,
            33811550.04599978
        ],
        [
            -211244172.67628682,
            -243641793.0646634,
            33059047.56483554
        ],
        [
            -203238917.87001607,
            -249971916.35814208,
            32277882.571969345
        ],
        [
            -195064558.59961963,
            -256057653.51209763,
            31468757.832095798
        ],
        [
            -186727929.36054188,
            -261895122.74320194,
            30632386.406332683
        ],
        [
            -178235906.25446826,
            -267480604.78946504,
            29769491.33794205
        ],
        [
            -169595405.3479225,
            -272810540.2994198,
            28880805.37370709
        ],
        [
            -160813381.2766392,
            -277881527.36823505,
            27967070.719634093
        ],
        [
            -151896826.08125508,
            -282690319.23295486,
            27029038.829592396
        ],
        [
            -142852768.25962764,
            -287233822.1382611,
            26067470.225451685
        ],
        [
            -133688272.02088869,
            -291509093.383358,
            25083134.34722807
        ],
        [
            -124410436.72614327,
            -295513339.5598335,
            24076809.43170321
        ],
        [
            -115026396.50055158,
            -299243914.9896077,
            23049282.41793783
        ],
        [
            -105543320.0013717,
            -302698320.3713736,
            22001348.878059562
        ],
        [
            -95968410.32637303,
            -305874201.64324105,
            20933812.971664127
        ],
        [
            -86308905.0468951,
            -308769349.068622,
            19847487.422131635
        ],
        [
            -76572076.34966326,
            -311381696.55173445,
            18743193.51312026
        ]
    ]
}